webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/cjPYrX/%3F1737195673599&title=If%20I%20Told%20You%20Once&summary=In%20her%20utterly%20original%20novel%20about%20mothers%2C%20daughters%2C%20and%20love%2C%20Judy%20Budnitz%20gives%20the%20traditional%20folktale%20an%20electrifying%20twist%20as%20she%20follows%20four%20generations%20of%20women%20from%20an%20Eastern%20European%20village%20to%20the%20tenements%20of%20an%20American%20city.%20Elena%2C%20b&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/cjPYrX/%3F1737195673599",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=In%20her%20utterly%20original%20novel%20about%20mothers%2C%20daughters%2C%20and%20love%2C%20Judy%20Budnitz%20gives%20the%20traditional%20folktale%20an%20electrifying%20twist%20as%20she%20fo%0Dhttps://textcafe.co/books/cjPYrX/%3F1737195673599&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/cjPYrX/%3F1737195673599&posttype=link&caption=In%20her%20utterly%20original%20novel%20about%20mothers%2C%20daughters%2C%20and%20love%2C%20Judy%20Budnitz%20gives%20the%20traditional%20folktale%20an%20electrifying%20twist%20as%20she%20follows%20four%20generations%20of%20women%20from%20an%20Eastern%20European%20village%20to%20the%20tenements%20of%20an%20American%20city.%20Elena%2C%20b",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/cjPYrX/%3F1737195673599&description=In%20her%20utterly%20original%20novel%20about%20mothers%2C%20daughters%2C%20and%20love%2C%20Judy%20Budnitz%20gives%20the%20traditional%20folktale%20an%20electrifying%20twist%20as%20she%20follows%20four%20generations%20of%20women%20from%20an%20Eastern%20European%20village%20to%20the%20tenements%20of%20an%20American%20city.%20Elena%2C%20b&media=https://textcafe.co/books/cjPYrX/tc-custom/9781466835658.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781466835658&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=iUsoHIsUcAYC&amp;rdid=book-iUsoHIsUcAYC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781466835658').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/cjPYrX/tc-custom/9781466835658.jpg?1737195673599',
        alt: 'If I Told You Once'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/contents", "xhtml/ded", "xhtml/chapter1", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/cjPYrX/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyrightnotice__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyrightnotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyrightnotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_ded__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_ded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_ded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_chapter1__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_chapter1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_chapter1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_ack__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_ack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_ack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_adcard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_adcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_adcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_praise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_praise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_praise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_copyright__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_last__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_last__);
/*jshint esversion: 6 */

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/contents",
    "name": "xhtml/contents",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents___default.a
  }, {
    "path": "/xhtml/ded",
    "name": "xhtml/ded",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_ded___default.a
  }, {
    "path": "/xhtml/chapter1",
    "name": "xhtml/chapter1",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_chapter1___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Judy Budnitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Judy Budnitz")]), _vm._v("'s stories have appeared in "), _c('I', [_vm._v("Story, The Paris Review, Glimmer Train, ")]), _vm._v("and "), _c('I', [_vm._v("25")]), _vm._v(" And Under. She lives in Manhattan.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cjPYrX/tc-custom/9781466835658.jpg?1737195673599",
      "alt": "This image is the cover for the book If I Told You Once"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("If I Told You Once\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In her utterly original novel about mothers, daughters, and love, Judy Budnitz gives the traditional folktale an electrifying twist as she follows four generations of women from an Eastern European village to the tenements of an American city. Elena, born into a family ruled by a formidable mother, embarks on an epic journey to the New World, met along the way by evil, magic, and good fortune. The daughter, grand-daughter, and great-granddaughter who follow each share her special powers of observation and, often, destruction. The result is a family saga unlike any other: a hilarious, heartbreaking story of family ties that bind.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Picador\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#acd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Judy Budnitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/praise#praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Praise for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("If I Told You Once")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("For my grandparents, Samuel and Phyllis Robbins and Max and Rose Budnitz")])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Ilana")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("My family had lived in the same village for as long as anyone could remember. It was a place that lay buried in snow for nine months out of the year followed by three months of mud. It was the most desolate spot on earth and my family did not even realize it, because for generations they never ventured more than forty kilometers from the place. They were stubborn people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a place where someone had forgotten to add the color: low gray clouds, crooked houses of weather-beaten wood, coils of smoke rising up from cookstoves and rubbish heaps. All the wives of the village cut from the same dull cloth to make clothes for their families. We ate gray bread. The men made a fermented liquor so colorless it was invisible, nothing but a raging headache stoppered in a jar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People were simpler then. They kept their desires within reach. They had few possessions: a goat, a half-dozen chickens, a brass teapot, a cat so ugly it could kill mice merely by looking at them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was enough. After days cutting wood in the black forest with ice clogging their nostrils, the smell of a goat was a welcome thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a place like that, the color of an egg yolk was something of a miracle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My people were a clutching, clinging people. They had to be. What little they had, someone was always trying to snatch away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was born in violent times.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am told I was a breach birth. My mother was in labor for more than thirty hours. I was her first child. All through her labor a winter storm ripped shingles from the roof. My father wanted to go for the midwife, but the violence of the storm kept him in. He could hear the evil spirits in the wind waiting to trick him, lead him in endless circles in the snow. People had been known to freeze to death just meters from their homes after getting lost on their way to the outhouse. My father paced in an agony of frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In those times childbirth was the realm of midwives and women-friends. Men were forbidden to witness it, they were bad luck; they were kept out of the birthing room, often out of the house altogether. My mother writhed and moaned on the bed while my father stumped from window to window, caged and frantic. The house had only one room. He crouched in corners, tried to make himself invisible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the storm grew worse, so did my mother’s pains. My father put his fingers in his ears but could not bear it any longer. He went to the bedside and found my mother thrashing and screeching like one possessed, her long hair pasted to her face in sweaty scribbles. He knelt and rolled his sleeves, he put his blunt hands tentatively on her belly; he nudged and prodded, thinking he could shift the little body into position the way he did with unborn lambs. He tried to look only at the tight belly, not at my mother’s hectic face, her fingers tearing at his shirt, the pulpy strangeness between her legs. He pushed. Something burst with a wet pop. The bed was suddenly soaked with hot blood and my mother screamed with renewed vigor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just then there came a knock at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The midwife! my father thought with relief, and flung the door open.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Two heavy figures filled the doorway and half a dozen more darkened the snow behind them. The men were shapeless in snow-stiffened clothes, their faces wrapped against the wind. But my father knew them immediately and his heart froze. He knew by their fur hats, the knives in their belts, their rank smell of raw meat and stolen horses. They were the bandits who haunted the black forests and roadways. They attacked indiscriminately, rich and poor alike.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bandit leader slouched in the doorway as snow swirled past him into the room. He held out his hands, stepped closer to my father, smiled at him through his face-wraps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Greetings, neighbor, he said, we wondered if you might extend your hospitality to such weary travelers as ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My father stood out of the wind, in the shadow cast by the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bandit leader pulled his knife from its sheath, casually wiped it on his sleeve, and said: You wouldn’t turn anyone away on a night like this, would you? That would be too cruel, wouldn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He cocked his head; his ferrety eyes sought out my father’s. His band crowded closer. Their smell swept into the room like a foul breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then my father stepped full into the light. He stood drenched in sweat, shirt torn, his beard standing up on his face in wild tufts, eyes bulging, and his arms wet to the elbows with blood. My mother’s squeals flew about him in a fury, a windstorm of shrieks and venom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He held his hands out to them. Gentlemen, he said softly, as soon as I finish killing my wife, I will be glad to oblige you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They looked at the blood, his crazed eyes, the scratches my mother’s nails had left on his chest. But it was my mother’s wrenching, inhuman cries that drove them back out into the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was born soon after, I slid out feet first and blue, the umbilical cord looped around my throat. Later people said it was an evil omen and I was destined for the gallows. My father caught me up, a slimy horrible thing, and shook me frantically like a defective toy until I screamed in indignation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother, who had more right than anyone to call me an evil omen, instead declared that I was a lucky child, twice blessed and twice stubborn, destined to make my own way in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later she would go on to bear eight more children. At the start of her labors my father would walk seven kilometers into the forest and cut wood for hours, until my mother sent me to tell him it was safe to come home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They loved each other very much, my parents. But love was different then. People didn’t talk about it, didn’t even think of the word, but it was there in every mouthful of food they shared. It was a simple thing, certain, it needed no discussion. Certain as blowing out a candle. Do you need to discuss whether the room will be dark?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My father was an enormous bearish man, hairy and dark, with a beard that enveloped half his face and seemed to trap more food than reached his mouth. People used to say that if my father got lost in the woods, he could survive two months or more with his beard to sustain him. My mother was small, less than half his size. She wore endless skirts and petticoats that billowed around her and made her seem as wide as she was tall. The skirts disguised her figure so completely that she looked the same whether she was nine months pregnant or not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My growing-up years were a dark time. The bandits lurked in the woods. The timber wolves came down from the north. They mated for life and hunted in pairs; they were the size of calves, with ice-blue eyes. They were temperamental as children. Sometimes they came right into our yards, playing like puppies; other times they could snap a man’s leg in their jaws with no provocation. They were not pack wolves; they cared only for their mates and pups. In times of hunger she-wolves had been known to eat the pups of other wolves to gain the strength to nurse their own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And there were bands of soldiers, too, who raided the villages periodically. They were more unpredictable than the wolves: they might demand livestock, or liquor, they might set homes ablaze for the sake of warming their hands, to melt the frost off their spurs. They took the young men off for the army, dragged them away in carts as the mothers ran alongside screaming good-byes to their sons and heaping curses on the soldiers. Such men were never heard from again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes the bandits attacked the soldiers and stole their military boots and jackets for themselves. Sometimes the soldiers wore shaggy fur cloaks to keep out the cold. Sometimes the wolves walked on their hind legs like men.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the dark they were indistinguishable from one another.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once a week during the long winters people crowded into the village meetinghouse to pray. We were not particularly fervent; we came for the change of scene. People said that being trapped in one room with the same family members for months on end could drive a person mad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People liked to tell of one couple who lived in the village before I was born. The two were newlyweds, and they decided to avoid the weekly services and live out the winter with no one but each other. They spent the entire cold season sitting side by side on the same bench before the fire. They stayed there so long they grew together, flesh to flesh. Like rolls running together in the oven, their skins melted and became one. When the spring came, they could not fit themselves through the door. People who peeked through their windows saw a single broad, monstrous figure scuttling madly about the room, sideways like a crab, the two faces cleaved cheek to cheek, the hands grabbing at bits of food and stuffing them indeterminately in either mouth, the hair of both heads grown together in an impenetrable mass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All the men and women of the village came together. They broke down the wall of the little house, dragged the couple into the street. Eleven men and an ax were required to pry the two apart. There was blood in the snow and screaming. When the man found himself free he spun himself around three times and staggered off into the forest, bloody and torn down his left side. He was never seen again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The woman stayed in the village. Her screams eventually faded to a constant low muttering, but she was never again whole. Her right arm and leg atrophied; she hobbled on a crutch. People took pity on her, they brought her firewood and rags. She dug clay from a corner of her yard and made soup from it. When I was a child I saw her often, wandering the forest or the village streets, singing and gathering stones, checking over her shoulder every few paces as if expecting someone. She was harmless, and some said holy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was three my mother gave birth to my brother Ari.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He arrived in a snowstorm, as I did. The women say he crept from the womb unaided, took air without crying. They looked at the two bony knobs on his forehead, the wiry hair on his legs, and said he was a changeling, a goblin child. The women drew back from the bed, covering their mouths with their hands and pulling their skirts tight about them. They feared the changeling spirit would corrupt their bodies as well. The midwife, who was past childbearing age, wrapped the baby tightly and volunteered to carry him deep into the woods and leave him there. This was the practice in such cases, so that in the night the forest imps could take the child underground to his rightful home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But my mother frowned and held the baby’s head to her breast. Stroking the thick dark hair, she said she would do the chore herself. She could not be dissuaded; as soon as the storm slackened she left me in the care of my father. Weak and bowlegged from her labor, she waddled into the forest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother returned two days later, with the child asleep in her shawl. She was pale and resolute and my father did not question her. He held her in complete awe. Also he was glad to relinquish his responsibilities. My father could kill timber wolves with a wooden club or face down outlaws, but the cries of a three-year-old child drove him to distraction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People said Ari seemed unchanged by the excursion, except that he had grown three teeth. My mother never offered an explanation but resumed her work and nursed the child without a word. No one dared confront her; she was known throughout the village for her fierceness. Rumors spread that she had marched into the forest and demanded an audience with the goblin king himself, then haggled with him relentlessly, as if he were a shopkeeper, until he agreed to exchange the goblin child for an identical human one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari was quick to crawl but slow to walk. As he grew he loved to watch dancing and the fall of my father’s ax. He loved hair—he liked to pluck out bits of my father’s beard or the hair on his arms. Ari early developed a taste for raw meat. He infuriated my mother by sneaking raw scraps from the storeroom, and trying to sink his teeth into chickens before they had stopped twitching.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I grew up slowly. In that place many things grew slowly, the cold caused plants and people alike to shrink, contract, conserve their energy. My brother Ari soon grew taller than me, but his size was a liability; he was constantly hungry and cried through the night. My mother nursed him until the third child was born, and then she put him to sleep with me. At first I let him suck on my fingers, for comfort, but I soon discovered the sharpness of his teeth. He gnawed in his sleep. So I went down to the river and found smooth stones for him to suck, and he liked that. I gave him stones that I thought were too large for him to choke on, but I would sometimes wake up late at night and hear him crunching and swallowing them, his baby face smooth and serene.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As Ari grew older his forehead lost some of its knobbiness; he had my father’s strength and black hair. He was quick in his movements, but slow in speech. When people spoke to him, when he demanded explanations, I was the one to help him. He seemed to understand the words better in my voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My parents were constantly on the lookout for the soldiers who tried for years to catch my father and force him into the army. He was older than the usual conscripts, but famous for his strength. My parents knew that if he were taken away it was likely he would never return. Whenever soldiers came into the village searching for him, he would have liked to meet them with his fists, but my mother subjected him to her methods instead. She hid him: under the eaves, in a feather bed, in a rain barrel, once in her own voluminous skirts. When the soldiers came to call that day they found her placidly sewing beside the fire. After they left my father rolled from beneath her skirts gasping for air. He was flushed and embarrassed by his proximity to her legs; he fled the house, shamefaced. In those days people were intimate only at night, in darkness, under the covers and in the strictest privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So my father evaded conscription year after year, and my mother produced more children, at yearly intervals. Practiced at labor, she learned to predict the time of birth and would lie darning stockings, peeling potatoes, until the last possible moment. My father had to add on to the house to make room for the children. He built us a kind of shed in the backyard, as if we were livestock. We slept on hay.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother taught me to knit and crochet, she taught me her knowledge of roots and herbs: plants for sickness, for cleansing, for visions. Ari was my constant companion. He was monstrously strong for his age, but thoughtless; he crashed into walls, tumbled down wells. Wherever he went in the village I had to accompany him to keep him from damaging our neighbors’ property. When I saw him reaching out to touch geese or lambs I had to grab him by the ear and pull him away. Soon he grew so large that when I did this he could jerk me off my feet by shaking his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People in the village whispered that he had a tail like an ox rolled up inside his trousers. I had seen no such tail when he was a baby; but then perhaps it sprouted when he entered adolescence, which began early in him. The villagers’ gossip did not affect him, but when my mother scolded he buried his head in her skirts and howled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He often went on rampages in the forest. We did not know what he did there; he would disappear for hours and return with his hair full of burrs, his clothes in shreds, a brown crust on his lips, peaceful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only once did I lose my temper with him. It was one evening as I sat mending his padded jacket for the tenth time in as many days. The fire was low, and I pricked my finger again and again, and the hay padding was full of the small creatures my brother liked to collect, they rustled and squeaked horribly. Finally I flung the jacket at him, as he squatted humming in his usual corner, and cried: What is "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("wrong")]), _vm._v(" with you? Have you no sense at all? Why can’t you act like other people?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He hugged the jacket to him, rocked back and forth on his heels humming in the back of his throat and staring glassy-eyed into the fire. My mother looked up sharply from the child she was nursing and said: There’s nothing wrong with him, he’s perfect, he belongs here. The look on her face, as she stroked Ari’s hair and held the child to her breast, made me feel I was the strange one.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("When I was twelve my father killed a she-wolf and my mother sewed the hide into a cape for me. The wolf’s head made the hood, with the ears still intact; the front legs draped my shoulders, the tail dragged on the ground. It was a heavy, coarse thing with a rank smell, but it was warm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That winter my mother sent me out often to gather the medicinal plants that grew under the snow. She could not go herself, she was expecting her fifth child and could not bend. So I put on the fur hood and spent hours in the woods. The trees there were dark skinned, broad limbed; even without their leaves they blocked the sunlight so that the forest was dim even at noon. The air was always deathly still except for the hush and slide of shifting snow, the trees moaning softly in the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Each time I went I pushed deeper into the forest. I kept my ears pricked for the muffled crunch of footsteps in the snow. I hung a drawstring bag around my neck, crawled on my knees, and dug through the snow with my bare hands to find the plants my mother requested. My fingers grew red while my back and arms ran with sweat. I dug, warmed my hands in my armpits, dug again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One afternoon as I knelt resting with my hands inside my blouse I heard a branch snap. It was early yet, but the light in the forest was like dusk, the snow glowed intensely blue. I had the sense of trees crowding around on all sides as if watching.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ho there, young lady, said a voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I glanced around, pushed back my hood, and looked up. I saw dangling boots. A man sat perched on a branch high above my head. I wanted to run, but my knees were locked from kneeling in the cold so long, and I couldn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: It’s a lovely day, isn’t it? and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stared. I knew he was a bandit, I could tell by his clothes, and the soft leather boots that came to his knees. The people in my village swaddled themselves against the cold, they wrapped themselves in layers of wool and burlap. But this man was dressed in clothes that cleaved to his body, tight trousers and short jacket, leaving his arms and legs free. He lounged there loose limbed and catlike.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ve been quite busy, haven’t you? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I managed to stand up. Now I could see his face more clearly. It was a clean-shaven, sharp-featured face, blotched red and white from the cold. He smiled; there was something strained in the smile, in the way the sore-chapped lips stretched back from the teeth. His eyes were extraordinarily bright and piercing, I had never seen anything like them, little chips of ice in his face; even from that distance I could feel them drilling at me. His hair lay over his brow in long heavy tangles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked so foreign to me; I had seen so few young men in my life. In my village adolescent boys were forced into the army the moment they began to lose their boyish figures, and the older men were like my father: bearded and barrel-chested with hair in their noses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He tossed his head like a horse to shake the hair from his face. I saw the hunting knife in its sheath slung across his chest. I longed to run, my throat ached with it; but I could not look away from him, I was painfully fascinated by him, as by a mad dog, so that I was afraid to turn my back on him even to run away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What have you got there, young lady? he said. His voice was the strangest thing of all, as if what he said was not at all what he meant. My knees creaked. I showed him the dirt-colored mushroom in my palm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Give it here, he said. I gave it a toss; he swung out and caught it. I looked at him in that moment, stretched against the sky. I saw the straining cords of his throat, the delicate underside of jawbone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought: he should wear a scarf, he will catch cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He held the mushroom between thumb and forefinger, inspected it with disgust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What’s it for? he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could feel myself flushing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Speak up he said, what will happen to me if I eat it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is for easing your birthing pains, I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He barked a short laugh, then said, I’ll keep it, since you found it near my tree. It’s my favorite tree, you see, because it has a face like my old granny. Do you see her nose, where that branch is broken off, and these two knotholes are eyes, and the rotted hollow down below just like her pruned-up mouth. Come closer and look. Come closer, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had never thought about things in such a way before, but suddenly when he described the face I could see it, as if something hidden had been swiftly revealed by his words, and I realized with a kind of sickening jolt that there was more than one way of seeing the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since you gave me this, I should give "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" something in trade, he said. He slipped his hand into his shirt, pulled something out, and dropped it carelessly in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should not have picked it up, but I did. It was shaped like an egg, but covered in stones that glittered like fire and ice, and shiny metal etched with tiny curling designs like lace. It glowed there in my cupped hands. I had never seen such colors before in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look inside, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I peered into the peephole at the small end of the egg and saw a walled city with turnip-shaped towers, a garden, a sparkling frozen fountain, a domed sky full of stars.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I said. I raised it to my eye again. Such green, such gold, such unearthly blue. When I looked up at him once more the outside world had gone dull.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You like it, do you? he said. He was cleaning his nails with a knife as long as his forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded. His eyes moved in his face like insects.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Aren’t you a pretty girl? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. I was not being insolent. I did not understand what he meant. In my village we knew only big and small, strong and weak, alive and dead. Any further distinctions were unnecessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ha, he said. The pink tongue curled around his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly he straightened and slid the knife in its sheath. He reached into his shirt for the mushroom and with one smooth movement threw it far into the trees, so far I could not hear it land.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look at that, he said. I seem to have lost your mushroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw the muscles tensing up beneath his trousers; the branch creaked a warning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I suppose, he said, to be fair, you ought to give me something else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw him preparing to leap. I spun and ran.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I staggered wildly, panting, limping on my stiff knees; I ran in a nightmare, the air thick as water, the afternoon light dying moment by moment. My breath crashed so loud in my ears I could hear nothing; I stumbled, fell, gathered up an armful of skirts and flailed on. I glanced over my shoulder expecting to see him just behind me, laughing with his little pointed teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But he was not. I was light enough to run on the hard upper crust of snow, but the man had broken through it with his leap. I could see him far in the distance, wallowing and thrashing waist-deep in soft snow. Faintly I could hear his curses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran home breathless, dragging my heavy soaked clothes. My mother looked at my slick face and asked what was the matter. I told her about the man in the forest, the tree like a face, his leap from the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not tell her about the egg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The egg! I should have flung it away when I ran, but I had been too frightened to think. So I kept it in my pocket, told no one; it was my first secret.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother knit her brow. She warned me not to tell my father. His solution would be to go bellowing off to the bandits’ camp in the woods, swinging his fists, cursing and brawling until they cut him to pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She told me she would take care of it and said nothing further. Late that night I heard a stirring in the house. I crept to the window and saw her in the moonlight, waddling heavily toward the dark trees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A week later she told me to go back to the forest to finish gathering the plants she needed. Her time was near. I did not want to go, I looked at her pleadingly, but she brushed me away and told me it was all right.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I dressed as before and trudged back to the forest. The sky was dark and lowering, thick clouds scurried across the sky as if fleeing something just over the horizon. I jumped at every noise; darkness seemed to tease at the corners of my eyes. I did not want to go there, and yet I went there, I was drawn back to the same place I had been before, drawn by a kind of dread and a dreadful curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I approached the familiar tree. I saw a dark shape in the snow at its base and hesitated. It did not move. An abrupt hush fell over the woods, no wind stirred. I paused in my tracks and then a horrible cawing rose up all around me as hundreds of black crows launched themselves from the surrounding trees and took to the air. There were hundreds of them, flapping in their clumsy way like black rags jerked aloft on strings, beaks open with their harsh croaking. I felt droppings splatter on my cheek. I knew crows liked to travel alone or in pairs, they were not flocking birds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their cries faded away. I reached the tree and there, in a trampled place beneath its branches, lay my bandit. I knelt beside him. His throat was torn open. The blood had frozen before it dried; bright red smears colored the snow. I could study him closely now. His eyes were open and congealing; the irises were green, they looked crystallized, faceted, hard as glass. The skin on his face was smooth. I could not have said how old he was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His hair fell back from his brow as if he had tossed his head back a moment before. His body lay stretched out loosely, as if he were napping, but all was cold and hard. His lip turned up; he seemed to be smiling. I could not be sure that he was dead. In that winter country the cold slowed the dying just as it slowed the living.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I learned later that my mother had gone to the forest at night carrying the scent glands from the she-wolf my father had killed; she had used them to leave wolf scent on all the trees in the area. This drew the she-wolf’s grieving mate, he came following the smell and seeking her; and as he nosed about whimpering like a child at the roots of trees, smelling her scent and unable to find her, he must have looked in the uncertain dusky light like something he was not. Perhaps to someone sitting in the trees above, he might have looked like a girl, kneeling, dressed in fur. Perhaps he had looked like me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Imagine him jumping down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man and the wolf must both have been disappointed to see each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat a long time in the snow, looking at the face, holding the sparkling cold hand of a man preserved in ice; and for the first time I saw that I was not of that country, I did not have my mother’s fierceness in me, I did not have that fierceness of love that had kept my family alive for generations in that harsh place. It was a blind devotion, a vicious bloody animal love, and I wanted no part of it; for the first time I knew that I would leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I feared my mother, who pushed out child after child with her athletic loins, and seemed to grow stronger with each one, and clung to her children more tightly with each passing year. I grew in secret. I waited.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("There were three of them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were always there, in the village where I grew up. With their milky eyes and incessant hissing, their hands tugging at invisible strings and weaving them all together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Three old women.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They sat in a row on a single bench in the center of the village. Three women with the same face. People said they were sisters, or mother and daughters, cousins, no one knew for sure. In winter they huddled in their shawls with snow up to their knees. In summer the flies hung back from them at a respectful distance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They had the same face, skin delicate with age, soft and threatening to tear like wet paper. The same face three times over, same violet-colored eyes sunk in purple-veined pouches of skin. People said if you watched closely you’d see them blink and breathe in unison. The pulses beating together in their temples.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In their hair insects wove their cocoons and greasy silk tents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They had the same face but different mouths. One woman had an overabundance of teeth, two rows of them, overlapping each other like shingles. Another had no teeth at all, and a mouth that seemed to lead nowhere, a shallow wet impression in her face. The third had only one tooth. It was three inches long and pointed, a long yellow tusk, protruding from the corner of her mouth like a crafty cigar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They worked as they jabbered. They sewed in unison, as if one brain led their six hands. One would unspool the thread, the second would measure it, the third would cut it. Or they would knit, weaving their way inward from three different directions, meeting in the middle to make sweaters designed for hunchbacks or armless giants. They could pluck a chicken in a matter of seconds, their hands swarming over the limp body like ants.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had forgotten their names and were embarrassed to ask. They never moved from their bench. Their debris—the feathers, the ends of thread, the wads of phlegm they coughed up and spat into bits of paper, the crusts of bread—piled up around them year after year. Some said they were the grandmothers, or great-grandmothers or great-aunts, of everyone in the village. No one could remember. Their faces were indistinct with age, their features had run together like melted wax; no eyebrows, noses flattened and ridgeless, earlobes stretched long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Talking, gossiping. Day and night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their voices were identical, and shrill, birds scolding. They interrupted and spoke over each other, a sharp irritating music, almost in harmony. Sometimes sweet and wet, mixed with harshness, like the sound of a mother crooning a lullaby to her child and bickering with her husband between verses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were telling each other stories, those three. Telling each other everything that had ever happened since time began.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We did not like to go near them. But still we could feel their eyes, hear their hissing and know they were speaking of us. The words they said would sound familiar, as if they had been eavesdropping on our dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They recounted their version of history for anyone who would listen. We did not like to listen. We tried to ignore them, or drown them out. They spoke of things too terrible to bear. Like a mother who needs to forget the pain of childbirth so that she can go on to bear more children, the people I lived among needed to forget so they could go on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The three women wove together threads of dark brown and red-gold and black; they were the hairs of everyone in the village, people said. We all felt the tug. We felt it when hesitating at a crossroads, we would feel a pressure on our scalps, and then later we would blame our decisions, good or bad, on the three women whom we thought of as witches or saints but were careful to never dignify with a spoken name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dreamt of them sometimes, and woke with my hands pressed to my ears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There came a time when they began to speak, more vehemently than before, about a darkness rising up, a dark tide turning and coming to wash over us. Of atrocities beyond our comprehension, bodies piled high as haystacks, blood flowing like rivers through the streets, fire that would roll across the earth, blotting out the sun and making everything black. They spoke urgently of these things, gesturing, their spit flying in our faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But we ignored them, we told ourselves the darkness they spoke of was merely the next nightfall, or their own encroaching senility and approaching deaths which we secretly hoped for, to be rid of them. They’re mad, we said. Don’t listen, we told each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And it happened that it all came to pass, everything, just as they had said, with biblical accuracy. By then I had left the village, I had sought to escape their wagging tongues, the tugging of their crabbed fingers, the gossip they told of a future that was written, sealed, inescapable. As irrevocable as the past.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told you so, they must have said when everything did come to pass. When the walls came down and the fire burst forth and the people raised their hands above their heads in supplication and swayed like a field of wheat in the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not there to hear their voices ring out yet I heard the words anyway, those words followed me long afterward like a shadow, a slug trail, a mocking school yard chant: I told you so I told you so I told you so.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My mother taught me everything she knew, and for a long time I thought it was all I would ever need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sometimes saw the mother-love in her face, that animal fierceness, when she gathered my brothers and sisters to her, crushing them against her belly as if she wanted to swallow them whole. I saw it in her when they fell ill with fevers, when they were late coming home and she scanned the darkening forest for them, calling their names like a holy summons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw it when Ari came to her and lay his head in her lap, his legs folded beneath him like a dog’s, nuzzling against her. She could trace his wanderings by the scars on his back. I saw how she wanted to fold her wings over him, conceal him, though he was bigger than she was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That smell of his when he came back from the woods. The crust beneath his long yellow nails. He was unnatural.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew better than to say anything more about it in front of my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our neighbors came complaining of him, of animals he had fondled and stroked so roughly they collapsed. My mother looked at them and said: He’s only a child, he knows not what he does.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some of the neighbors gave up when they saw my mother’s stubborn chin. But others persisted, pounding on our door every evening, demanding restitution. One called: Send your son over to pull my plow, seeing as how he killed my donkey. My mother ignored them, though their pounding made the bowls of soup jump on the table. Nails popped from the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those neighbors who persisted woke up several mornings later to find their beds infested with fat white worms, worms that burrowed into the crevices of their bodies as if seeking warmth. The worms bored into the flesh of their legs and bellies, as if they were corpses, leaving oozing tunnels to mark their progress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They stopped bothering us; I suppose they decided to take their complaints elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother instructed me to watch when she next gave birth. The cold room gradually grew hot as a furnace from the heat of her body and the windows steamed up. It was strange to see her lying down, splayed out like an overturned beetle. Her hair escaped her braid, it clung to her face and the bedclothes and wrapped itself around my hands as I wiped the sweat on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She glared at me. I can wipe my own face, she said. I don’t need you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("here,")]), _vm._v(" I need you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("there,")]), _vm._v(" to see what I can’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to, but I lifted her skirt; she had not even undressed, she had stopped her sweeping only moments before. Her breath gusted through the room, lifted the hair from my damp forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw her legs which I had never seen before and they looked just like mine, thin with knobby knees, fine dark hairs. Then I looked between her legs, and that was a sight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was something swollen, juicy, turned inside out. I thought I saw the scar, the place where her flesh had torn when I was born and then grown together again. I felt guilty for the damage I had done her. She was straining at the seams. I could see already the bulge of a skull, mottled white, a tracing of veins under skin, pushing outward larger and larger like a boil about to burst.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Remember, remember, this is what it is like, I told myself over and over, and I saw my mother’s hand tighten into a fist, heard her breath catch and crackle in her throat, and then the head came out, followed by the anticlimactic scrawny body, soft limp arms and legs, smeared with blood and white scum, and I took it, and shook it, and it screamed, and my mother sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was another girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother was up and at the stove within hours, feeding the other children, smiling at my father, her breasts hanging heavy and leaking dampness on her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said I would never have children. Said it to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon after that, red wetness bloomed for the first time like poppies in my underclothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was terrified, I did not know what it meant; I thought of my mother giving birth, the blood, the bulbous baby’s head nudging its way out of her body. The smell of blood, her smell and mine, was the same.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of a baby coming out of me, a small one, perhaps the size of a rat, or a sparrow. Somehow I was certain it would be dark, hairy like Ari, with a wrinkled ancient face and tiny needle-sharp teeth. It would have whiskers, claws; it would gnaw disappointedly at my nipples which still lay flat on my chest, it would cling to me like a monkey. I imagined it crying, that abrasive baby-cry that cannot be ignored, but I also heard it berating me, in a deep petulant voice like the voices of our neighbors complaining. Can’t a man get a decent meal around here? it would say, pinching my breast with pygmy fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could already feel the thing moving inside me, shifting and cramping in my lower belly. How did it get there? I did not want it. I refused. I bent, clamped my legs together. I would not let it out. I would hold it inside me until it smothered. No one would know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I folded myself small, I thought I was invisible, but my mother saw me crouched against the wall and asked what my trouble was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m going to have a baby, I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her eyes widened, her lips drew back from her teeth. She said: How do you know? Did you meet someone else in the forest?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her about the little man I could feel trying to scratch his way out. I told her about the blood dripping. Just like yours, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I see, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did not laugh at me. She explained to me what it was and why, and then she told me how to make a child, and how to unmake a child right after it has been made, and how to keep from making a child in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not as stupid as you must think. For years I had watched animals do it. But for some reason I had thought people were different from animals.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know how I could have thought so. Look at my mother. Look at Ari. Look at my father, toiling in endless circles like the ox hitched to the millstone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then I thought of the dead man in the woods, the man made of ice, his skin blue and white, his delicate features and shattered eyes. He was different, I thought; and inside his egg I thought I saw a picture of life more refined, more considered, a world where people had found a way to distinguish themselves from animals, a difference far beyond a two-legged stance or a knack for forks and spoons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to find my way there.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My grandmother and grandfather lived in a one-room house within sight of ours. I did not know how old my grandmother was. She did not know herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She and my grandfather were so accustomed to each other that a single word or gesture between them carried the meaning of whole conversations. They had shared a pillow for so long they had begun to look alike. They even seemed to have exchanged some of their aspects. My grandfather’s hair was long and white and hung in ringlets like a schoolgirl’s. My grandmother had once had hair like that. Now it was nearly gone, it covered her head in a thin soft down and she had a man’s thick strong hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their trade was the preparation of leather, and it seemed the chemicals they used to preserve the animal hides had worked to preserve their skin as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother had taught my mother her knowledge of herbs. Sometimes they went gathering together. My grandmother always walked first and my mother followed behind her, placing her feet in the prints my grandmother had made in the snow. When I went with them I walked behind my mother, stepping in the footprints that my grandmother had made and my mother had deepened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember that my grandfather had a high ridged nose, narrow and red. My grandmother always washed his feet for him, every evening before they went to sleep. His circulation was so slow that he could no longer feel it, but she performed the nightly ritual anyway. It had become a habit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandfather died suddenly one day in spring, simply froze up at the table, spoon in midair, soup dripping from his chin. Wipe your mouth, my grandmother told him sharply. It was the first complete sentence she had spoken to him in twenty years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What, do you mean to say you don’t like it? my grandmother asked when he did not move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After all these years? Too salty? she asked. Why didn’t you tell me, she said and the tears began to trickle down her face and that was how we discovered them hours later, salty soup and tears dripping down their faces and plinking back in their bowls with a sound like rain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother brought my grandmother to live in the house with us. Our house did not seem to agree with her; she spent her time running around the kitchen and yard barefoot in her nightgown, hurling stones and insults at imaginary foes. She’s grieving, she misses your grandfather, my mother told me. She’s ill, my mother said. But I had seen my grandmother lift my father’s ax and hack chunks out of the walls of our house. She did not seem sick at all, she was stronger than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My father tried to keep her shut in the house, for her own protection. She scampered about the rafters and kept company with the rooster. She told the rooster long garbled stories as she stroked his red drooping comb. Stories of how she had been forced to marry at the age of nine; stories of her nineteen children and the deaths of eleven of them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s not true, is it? She’s making it up, isn’t she? I asked my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How would you know? my mother sniffed. Were you there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother became afraid of the floor and would not leave her perch in the rafters. My mother tossed food up to her. My grandmother hoarded bread and kept the rooster tucked beneath her arm, sometimes vanishing for days at a time in dark places under the eaves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One evening she unexpectedly descended, went to the door, and released the rooster. He misses his flock, she announced and watched him strutting and preening in the yard for a long while before she joined us at the table. She perched on a chair and I saw that her toes had grown as long and grasping as a monkey’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at me then, seized my fist in her own, and said: You don’t believe me now, but one day you will. You’ll see. You’ll see what it’s like.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pretended I did not know what she meant, though I did. Apparently she had missed nothing from her perch above our heads. I tried to talk of other things and drown her out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spoke calmly and lucidly all evening and helped scrape the dishes, and afterward she stretched out on the table to sleep, declaring that a hard bed was best for an old back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I slept with my hands over my ears that night to shut out her snores.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning we woke to find that she had barricaded herself into a corner of the room. She had taken her cache of bread, stale, weeks old, hard as stone, and stacked the loaves up like bricks all around her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We could hear her within, the tiniest of breaths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We tried to dismantle her cairn, chipped away at the hard gray bread for hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By the time we reached her she was no longer breathing, just a curled-up mass of arms and legs, a dry husk. Clutched in her lap we found the rooster, his claws clenched in her nightgown, one red eye frozen and empty.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("It was a winter years later when I made my decision. I must have been about sixteen then, I think, about your age. My mother and I were wringing wet clothes, hanging them out to dry in the cold air, my mother hugely pregnant as usual. Snow gritty as dust stung our faces. I saw her pause, sniff her fingers, then inhale deeply. She looked around wildly and ran. She had smelled the gunpowder stink of approaching soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We followed, my brothers and sisters and I. We were all so occupied with helping our mother hide our father that we neglected Ari.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We forgot Ari, so the first thing the soldiers saw when they entered the village was my brother tearing a live sheep apart with his bare hands, not for sport but simply out of his rough love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The soldiers on their recruiting mission had heard rumors of a boy with impossible brutelike strength, and they had searched far and wide for him. Though nothing was said about it we knew it was our disgruntled, worm-racked neighbors who must have told them where to find him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The soldier captain watched Ari rip the sheep piece from piece, till it was nothing but bloody meat, and then Ari laid the pieces out, carefully lined them up. He was trying to put the animal back together, licking his fingers and crooning, cramming the limbs back into their sockets, breathing into the nostrils, trying to divine the clockwork that made it all move and bleat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The captain watched, and his eyes gleamed; he clapped his hands, one of which was made of wood. His company of soldiers circled, and they wrapped my brother in iron chains which on his massive wrists and throat looked like flimsy jewelry, and they loaded him bawling into a cart to take him away to hone his special skills for the grand art of war, or so they said, and they tossed the chunks of sheep in after him, hoping to quiet him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother ran from the house and chased after the departing cart, flinging curses at the soldiers, heaping them tenfold on their heads. The soldiers leaned down and jeered at her, with her swollen belly and waddling run. She spat at them, and one leaned down and dealt her such a blow that she fell in the mud and went into premature labor, right there in the street, before the eyes of all the men in the village.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a single man to witness a birth was bad luck; for all the village men to witness it was such a bad omen that all the ensuing trouble that later befell the village was heaped on my mother; everyone said she was to blame for all that happened after and the village women never spoke to her again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When all these things happened I knew it was time to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Once upon a time, on a night when the houses lay buried to the eaves in snowdrifts and bits of ice danced on the wind, I left my village intending never to return.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Earlier that evening I had gone to bed in the back room with my brothers and sisters as usual. The others sighed and slept. I felt the warmth leave my fingers and feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I listened to my parents in their room. The bed frame creaked as my father sank down on it. I could picture him, his feet hanging off the end of the frame, head tipped back and the coarse beard sticking straight up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Light seeped through the crack beneath their door. My mother was awake, I pictured her finishing some mending or nursing the latest child. She kept her hair covered during the day, and at night she put it in a single tight braid that reached past her waist in a thick, vicious-looking rope.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I listened to the sounds of the other room, my ears yearning toward the door: the whisper of candle flame, the creak of her chair, the chilling click of teeth as she bit off the thread. I hoarded the warm patch I had made in the sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A strip of moonlight slanted through the window. I could see arms, fingers, ears: my younger brothers and sisters, sleeping in a heap like puppies. Some sucked their fingers as they slept; some sucked each other’s fingers. I could not distinguish between them in the dimness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari had been my dear one, my favorite. He had absorbed my attentions, and now he was gone. I missed his rank warmth. When he was restless in the night I used to stroke his head, his hair so thick I could not see his scalp when I parted the hair with my fingers. He always slept with his eyes half open, the whites glowing and shifting like iridescent fish. His back made a graceful curve as he lay on his side, he clenched his teeth in what might have been a smile; in the dark you could not see how the thick hair grew down low on his neck, ending in a point between his shoulder blades. He roamed in his dreams, legs twitching like a sleeping dog’s. In the mornings when I drew the sheets back to air them I often found dry leaves, night crawlers, double-tailed insects waving their feelers in the sudden light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered where he slept now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wind thrashed around the house, the boards creaked; I heard the softest of breaths as my mother blew out the candle. One of my brothers cried out in his sleep: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Look out—the fire!")]), _vm._v(" and then subsided. My father let out a businesslike grunt as he hoisted himself over my mother and began the task of creating yet another child. There came a sound I never heard from my mother during the day: a cooing, like mourning doves. The dim light from the window grew even softer; it began to snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was falling thickly and steadily. It was the sort of snow that could hide a person’s tracks completely in a matter of hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was time to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dressed in underclothes, flannel petticoats, skirts, jackets, woolen stockings. My mother had knitted the stockings so tightly they could almost stand up by themselves. Last I put on the boots, which would have fit half the people in the village. The local cobbler made boots in only two sizes, for the sake of convenience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wrapped my head in a shawl. My brothers and sisters were quiet, their faces blissful in sleep. They lay in a tangle of curves and bulges, whorled shapes, like vines in the garden patch. I suppose they looked like me, their hair, their eyes, but I had never bothered to notice. For too long I had thought of them only as annoyances that asked impossible questions and demanded breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dug beneath my mattress and pulled out my secret, the egg I had kept warm under my body for years. It was still as deep and glittering as ever, with the city inside: the pointed towers, the starry sky, the carriages pulled by white horses with feathered headdresses, footmen with velvet trousers and mustaches like wings. I thought I saw them move. Perhaps it was my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I left by the window and set out, the air prickling my face, the snow swirling around, white clouds against a darker sky. I tried to step lightly, but my footsteps crunched rudely in the snow, like cows chewing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not look back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the only home I had ever known. I could feel it behind me, hunched and glowering, its shoulders frosted with snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt a cold breath on the back of my neck, a sharp twinge that ran down my spine. I tried to run, but like a dream my steps seemed to grow even slower as my heart raced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew my mother was watching from the window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Standing with her arms folded beneath her breasts, chin out, her braid swaying pendulously behind her. She was at the window, or perhaps she was in the yard, heedless and barefoot in the snow, her eyes raising the hairs on the back of my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could feel her drawing me to her; like a spider she was sending out her threads, I could feel their tug in the small of my back. They drew tauter with every step I took. I knew if I paused, those threads would tighten, they would snap me back, I would be pulled home gliding so smoothly over the snow like an errant sled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, how she pulled at my hair. My scalp smarted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she was rolling up her sleeves, stretching out her arms; she was pursing her lips kisslike to draw in such a breath that my clothes streamed out behind me; she was undulating her fingers in the entrancing way she used to hypnotize the chickens before she chopped off their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept walking, I knew not to look back. My mother had taught me nearly everything she knew, so I knew what she was up to, I was wise enough not to look at her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And yet if she had called out my name then, I think I would have gone running back to bury my face in her lap. The warmth of her body through her clothes, a smell like fields of wheat. Her voice could do that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she did not call out. Perhaps she was too proud for that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I forged on, forcing stiff marionette knees. Her eyes nipped at the backs of my legs so that I stepped faster, and faster. I glanced over my shoulder and saw that the village looked no bigger than the magic city inside my egg, and my mother was too small to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was free of my mother at last. The threads snapped. I had beaten her. My body was my own; I felt something melt inside me, a hot jelly, sliding loose and shifting downward, pulsing. It was a frightening feeling, not unpleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To the east, a faint glow paled and spread; the bare trees were thrown into stark black silhouettes against the paling sky. And I was very, very cold.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I tramped for hours as the snowfall abated. My nose and lips were numb, they were blunt stupid things stuck to my face; I wished I could knock them off the way you knock icicles from the eaves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my mother. I supposed she had cursed me, cursed me the way I had seen her curse soldiers: with words too dangerous to utter aloud, so that she had to draw their shapes with her fingers in the air, with her own face carefully averted. The venom of her curses was so powerful it could sometimes rebound and scald her, like drops of boiling oil bouncing off the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The thought of my mother’s curses brought on a stitch in my side and a blurry, sticky cloud in my right eye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had no idea where I was going, I only knew I was lengthening the distance between myself and home. Between myself and a life like my mother’s, a path worn deep in the dirt, a path packed so hard no grass could ever grow there, much less flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had never been outside my village, but I knew there were places that were different. I had glimpsed them in the egg, and in the words of the bandit in the woods. I thought of him, my bandit, with his sharp face and strange talk. I saw him lying in the snow, sunk deep as if in a feather mattress, his throat necklaced with blood and the marks of wolf’s teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After I had found him so, I went home and burned my wolf hood. It made an awful stink. My mother watched but said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would never have to feel her eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The thought should have made me happy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked on. Once I heard an ax biting into wood, echoing through the trees. It reminded me of my father. From the sound alone I could judge the weight of the ax. I hurried on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Twilight was falling, swiftly creeping up behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told myself I would keep traveling until I found a city, a place like the one I had seen in the egg. I would give myself a new name, walk among a different sort of people. I wanted to walk slowly in gardens, carelessly snapping twigs off branches as I passed, tossing pebbles in a fountain, watching the surface of the water break apart and, quivering, come together again to show me my face. That seemed the most perfect kind of luxury.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stuck my hands in my jacket pockets. They should have been empty. I had brought nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And yet I drew from my pockets several chunks of bread, some large leathery mushrooms, a carved wooden comb.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gifts from my mother. She must have known all along.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In another pocket I found a pouch filled with my mother’s favorite herbs, the ones without names, dried and tied in bundles. There were plants like miniature trees, like tangled pubic hair, seaweed, bird feathers, crumpled paper. The smells rose up from the bag and fought each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My egg was knotted in my petticoat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How stupid of me to think I could leave home without my mother knowing. She had known I would leave before I did. She had allowed me to leave. Perhaps she had watched, and tugged at me with her eyes merely to test my resolve. It seemed no matter how I tried to escape, I was still entangled in my mother’s plans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw her braid swinging.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw her figure plowing smoothly through the snow before me, as if she had cart wheels beneath her skirts instead of legs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked for five days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the evening of the fifth day I saw smoke in the distance. As I came closer I came upon a village, not unlike the one I had left. I wanted to go to one of those houses, ask for a place to sleep. But I couldn’t; they were too familiar. I had the sensation that whichever house I called at my mother would open the door. She’d fill the doorway, dusted with flour, sleeves rolled, arms folded, children clinging constantly to her skirts as if they’d been sewn there as ornaments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I skirted the village as night fell. I smelled bread baking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How ugly the trees were now. Behind me the lights of the village glowed like warm embers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then, like a granted wish, I came abruptly to a clearing in the woods, and a small house with a peaked roof and smoke curling from two chimneys. A stone path led to the door, and I found myself knocking on it before I’d had a chance to think.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hear rustling inside, the crackle of fire. The doorstep on which I stood was worn, and the spot on the door where I’d rapped my knuckles was a silky smooth depression in the wood, as if countless hands had knocked before me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes? said a voice and the door opened slightly. I stared into eyes that were a disturbing yellow, lashless and unblinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked me up and down. The eyebrows rose in crafty peaks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you in trouble? she asked sharply. She wore shoes tipped with iron.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well then, she said briskly, come inside, though you should have known to come to the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The room inside was small and familiar. Wooden chairs, a low bed, a stone floor. Bunches of herbs hung drying near the fire. A piece of knitting lay interrupted on a chair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She helped me remove my clothes. What I had at first thought was a hat perched on her head was in fact a dense mass of silvery gray braids wound together, a huge round loaf of hair. Her hands were spotted with age.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She hung my clothes on a chair to dry and said: Why don’t you sit and warm yourself for a minute? I opened my mouth to speak but she clicked her tongue at me and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a smell in the air, musty, faintly sickishly sweet; I could not place it. On shelves nearby stood stoppered jars and bottles of the sort people used for pickles and preserves. I looked closer and saw stored there twisted roots suspended in brine, the pale floating bodies of frogs, the milky globes of cows’ eyes, and jars and jars of a viscous liquid, reddish brown, with a dry crust on top.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A kettle stood on the hearth, and two mugs. Had she been expecting me? No, the mugs had been recently used; dregs of tea clung to the insides.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard the woman scrubbing her hands vigorously in a tub of water. Did you happen to bring anything to give me? she asked, peering over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I shrugged, shook my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, they never do, she said to herself. She turned then and came toward me. I quickly backed away. Are you ready, then? she said. Her bared arms were terribly thin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t be changing your mind now, after you came all this way, she said. Hop up on the chair now, there you go. Her voice was firm; she grasped my arm and I found myself standing on the chair. Strands of my hair hung before my eyes like the bars of a cage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked up at me with those yellow eyes, she put a hand on my thigh to still its trembling. The smell in the room was strange and terrible, a sweet rottenness; I could taste it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My tongue seemed to have gone to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw that she held in her hand a bit of metal, like a piece of twisted wire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lift your skirts dearie, she said, you know it has to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her voice carried such command that I automatically gathered my skirts in my hands; I had lifted them nearly to my knees before I came to my senses and pushed her away and tumbled off the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hush, hush, she said and reached out to me, but I scuttled away from her on all fours. Hush, she said as I tried to explain myself at the top of my voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I quieted when the woman put away her horrible wire. She did not seem amused by the misunderstanding, but she gave me a bowl of soup and said I could sleep in the shed. I asked for her name; she told me to call her Baba.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night as I lay in the shed, warming myself beside Baba’s yellow-eyed goat, I wondered about this strange woman. I thought about the house, how it had appeared as I approached with the stone path and the two chimneys. I realized there must be a second room, a second fireplace I had not seen.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I woke thinking of Ari, and found the goat nibbling my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I would move on that morning, but Baba came to me with a cool assessing look and said she could give me work if I cared to stay on for a few days. She had wood that needed splitting, and there were errands I could do for her since she did not like to go down to the village. In return she offered me a place to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I accepted, though I did not like or trust her. In the daylight her eyes took on a thick muddy color, like pus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like to admit to myself that I had left my mother only to find another. A grim substitute. I tried not to think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I spent days chopping. My father had taught me how to swing an ax. I worked myself into a rhythm and Baba stood by the back fence, watching.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She needed a great deal of wood; it seemed she kept both fireplaces burning much of the time. By now I had noticed the door that led to the room I had never seen. Although Baba entered it several times a day, she never invited me in. She sometimes emerged with dirty dishes, stale bed linen. I sometimes heard her voice through the wall, mingled with another’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the village gossip I learned that Baba was the local herb woman, both midwife and doctor. There were whispers that she was a witch: some swore they had seen her flying through the air in a bucket; others insisted her house could raise itself up and walk about, on a pair of giant chicken legs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And they whispered about the girls from neighboring villages who came to Baba secretly in the night, hoping she could save them from disgrace with that piece of wire that made me think of a rabbit snare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One day a girl my own age beckoned me aside and told me something more, about the men of the village going to Baba in the dark hour before dawn, but her breath was so heavy in my ear that I could not understand what she said, and when I asked her to repeat it she blushed deeply and ran away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the evenings, sometimes, Baba combed my hair. I did not like the way she gathered my hairs from the comb, so carefully, then balled them and slipped them in her pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like her much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("During the day I saw sick villagers come to her door for ointments and tonics. Sometimes at night there would come a knock at the door to the shed where I slept, and I would find a pale nervous girl shivering outside. I’d bring the girl through the connecting passage to the main room, to Baba, who would immediately send me back to bed. I sometimes lay awake listening for the cries, the sobs, and Baba’s stern, soothing tones. In the mornings the floor would be scrubbed and clean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Also at night came the older women worn out by childbirth. Baba gave them herbs to toughen their wombs, keep a new child from taking root. These women seemed more ashamed than the girls; they bowed their heads and gulped, these women who had borne ten or twelve children and felt guilty for calling a halt to it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched all these things and stored them away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One day in the village I heard rumors of a soldiers training camp nearby. The people spoke of a new recruit, a monstrous man of unnatural size and animal appetites, who ate flesh raw, wrestled bulls to the ground, and howled at the moon. The army officers hoped to train him, he would make a marvelous killing machine. The officers were having difficulty teaching him, he seemed not to understand their words and would sit moaning and scratching for hours. When provoked he went on rampages. People said he had already killed two men during one of his panics. But the officers would not give up, they would break him like a wild horse if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As I heard the story, my heart leaped up, then dropped like a stone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Ari. I was sure of it. I would find him if I could, and take him with me wherever I went. It seemed an easy plan, in my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like the way people spoke of him. He was not the monster they made him out to he. The things they said were true and not true at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon after, I was awakened late in the night by footsteps. The house was full of the heavy bumbling sounds of men. Their smell, manure and iron, reached my nostrils. I opened the door that connected the shed to the main room of the house, and peered in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than a dozen men from the village crowded the room. Baba stood among them, yellow eyes unblinking. No one spoke. Each man handed her something: a bag of sugar, silver coins, a basket of eggs. The men seemed restless, shifting their feet, with sweat standing out on their faces and necks. When Baba had received all the gifts she went to the door of the secret room, unlocked it, and led the men inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("About fifteen minutes later they emerged. They seemed even more agitated than before and did not want to leave. But Baba herded them out and locked the door behind her. The men filed out into the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On subsequent nights I awoke more and more often, to hear the shuffling of heavy feet and to witness the silent ceremony of gifts and visits to the secret room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next time I passed through the village I overheard the men talking in the blacksmith’s shop. They were talking in hushed tones of a love sickness, they spoke of going to Baba’s house to get the cure. It was a dangerous addiction, they said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of these men passed me later in the street. He was black haired and red skinned; he gave me a mocking smile, touched his cap. and went on his way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I recognized him. He was one of Baba’s nighttime guests; his wife had borne him fourteen children and had recently come to Baba for an herb to stop a fifteenth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I chopped wood and great horny calluses rose up on my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One morning Baba was called away early to assist at a premature birth. When I was sure she had gone I began exploring her shelves, peering in boxes, holding jars up to the light. I heard a faint tune; at first I assumed it was something in my own head. But it did not go away, it went on and on and grew faintly annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was coming from the secret room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the same voice I had heard many times before. But today it was clearer than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned to look and nearly dropped the bottle I was holding. She had forgotten to lock the door, it was slightly ajar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I put the bottle back on a shelf and walked toward the door as softly as I could, which was not soft at all, considering my cloddish shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pushed at the door and stepped inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The room was swathed in lace, yards and yards of it, the sort Baba spent hours knitting in the evenings. It draped the walls, hung in festoons from the ceiling. A fire burned brightly in a stone fireplace. The room was so warm I felt the sweat pop out on my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An enormous bed filled most of the room, a high bed covered in more lace, finely woven shawls, and quilts. And on this bed lounged such a girl as I had never seen before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She lay sprawled in a loose robe, regarding me with unconcerned green eyes. She had the softest, whitest flesh I had ever seen; her face, her throat, her hands were smooth and unblemished. Her robe had fallen open in the front; I could see one of her breasts, a pale perfect mound. It looked like something rich and creamy you could eat with a spoon. Most extraordinary of all was her hair: somewhere between red and gold, it hung loose from her head, cascaded over the pillows, her shoulders, lay on the floor in a thick shining carpet. I was nearly stepping on it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That rotten sweet smell was even stronger here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her face was pale and flowerlike; the cheeks were two spots of pink that I suspected were painted on. I gaped. She did not seem human; I wondered if she was something Baba had created: carved out of soap, baked in the oven, cultivated in the dark like a mushroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Close the door, cow-eyes, there’s a draft, she said. Her voice was that annoying singsong that had faintly haunted the house since I arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I closed the door and stepped closer. I knelt beside her and studied her. I could not resist poking her arm; her flesh was as cushiony as it looked. It was flesh that had never worked or sweated under the sun. I poked her again. I fingered a thick handful of hair. She was a fascinating plaything. She lay there limply, regarding me indifferently.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Baba said there was a girl here, but she did not want you to see me, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why? I said, watching the hair slide and shimmer like water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said in her grating voice: I hate it here, I’m going mad in this room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How long have you been here?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than two years, I think. I’m not sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why don’t you leave then? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At that she raised herself up and began tossing aside the blankets that covered her lower body. Her legs entranced me: smooth, white, hairless. And then I saw that she had no feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She leaned back and sighed. She told me how a man had gotten her into trouble, a married man her father’s age who pushed her down in the forest without a word and held her there. She had been in trouble and had heard Baba could help her out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: I used to live in a village far away, I had to walk all night to get here, it was terribly cold and by the time I arrived my feet were frostbitten. Baba got rid of the baby, and I hardly felt it, for the pain in my feet. I got terribly sick and she took care of me for weeks, and when I came out of the fever I found myself here, in this room, and Baba told me my feet had turned black and fallen off, she hadn’t been able to save them from the frostbite. I couldn’t go home, after the trouble with the man, so she has kept me here, all this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your hair, I said. Has it always been like this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, she said, it’s Baba’s doing, she rubs a horrible green paste into my scalp every night, and then it grows like weeds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Those men, why do they come here at night?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed shrilly and said: They like to look. All they do is stand around and stare, with their mouths hanging open and their hands in their pockets. They stink, and they say the stupidest things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do they touch you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Baba won’t let them, she has told them I am some kind of ridiculous fairy creature, and if they touch me I’ll shrivel up and turn to dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And they believe that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Men are foolish, she said, they believe what they want to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They only look?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, Baba tells them that what they feel is an illness that requires a cure. Whether they believe that or not, they keep coming back. And bringing friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you like it? I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said scornfully: Men are like cattle, easily led.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fingered her hair. She let me. I wondered if Baba did the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When you leave Baba, will you take me with you? she said suddenly. I’ll go mad if I stay here much longer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her eyes traveled over my face. I felt myself flushing. I was conscious as never before of the sallowness of my skin, the narrowness of my face, the pink birthmark at the corner of my lips like a dribble of wine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said her name was Anya.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("During the following days I visited her room often.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How I hated her whining voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But her body was a white smooth thing that I wanted to swallow whole. Even the blunt stubs of her legs were beautiful to me, there was something so naked and helpless about them. I split wood into smaller and smaller pieces and let the sweat run down my face to burn my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Baba watched us both and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men continued their secret visits. As the winter dragged on they came more and more often, red eyed, distracted; they could not really see me, or Baba. They saw only the milky smooth skin, the red-gold hair that grew over the floor and climbed the walls like ivy. They looked and wiped their mouths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya said scornful things to them, yet she seemed to luxuriate beneath their gazes like a cat being stroked. She kept her legs discreetly covered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men began coming every night. There were more than two dozen of them now. They shuffled into Anya’s room in shifts for their precious minutes. They began to come earlier in the night, some even came at dusk and lurked among the trees waiting for Baba to admit them. These men were burly with bushy beards like my father. But there was a desperation about them that made them slack mouthed and helpless. They seemed not to understand it themselves; I saw them shaking their heads over nothing, clucking their tongues.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now when I went down to the village I heard muttering among the women. They had noticed the change in their husbands. They knew their men were visiting Baba’s house late at night, but none of them knew about the footless girl hidden there. Some women suspected Baba was offering herself to the men. That old hag? Impossible. How could they? the women asked each other. No man would touch her, they reassured themselves. But there were a few who said: She has bewitched them all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Night after night they came.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On a night when the men were more frantic than ever, one of them refused to leave Anya’s room when his allotted time was up. Baba spoke sharply; he ignored her. She tugged his arm, but he brushed her away and swiftly knelt by the bedside, reaching out to touch Anya’s face as she recoiled in disgust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Baba cried out angrily; the other men reluctantly dragged their friend from the room. Baba herded the men onto the doorstep, told them never to return, and turned the lock after them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She watched from the window as they wandered back to the village, hanging their heads, sullen in the moonlight. Go to sleep, she told me. She went into Anya’s room and locked the door behind her. I lay awake thinking of her brown spotted hands touching Anya’s white ones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The days that followed were queer silent ones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One evening I heard the wail of a rising wind. The trees moaned and scraped against each other. A storm was brewing. I heard footsteps, glimpsed a dark figure darting among the trunks. I whirled about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A branch snapped and I saw one of the village men approaching, his eyes cold and thoughtless. I ran to the house and he lurched behind me. Men were emerging from the wood on all sides, swaying and staggering up to the doorstep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I slipped into the house from behind and barred the back door. I saw Baba standing in the front doorway, facing the men gathered there. Their bodies were dark and indistinct, their eyes glowing, like wandering spirits. They were demanding entrance, bellowing and snorting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw Baba refusing, saw her hands brushing them away. The men’s faces fell. Like spiteful schoolboys they kicked each other, spat, began hurling small stones that flew past Baba and tocked on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then a stone the size of a fist struck her on the temple and she fell back. I caught her under the arms and pulled her into the house. Her heavy head lay against my shoulder. The men looked shocked, suddenly ashamed, and they backed away, melting into the trees. I barred the door behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dragged Baba to the bed. There was no blood, but her breathing was shallow and a greenish bruise was rapidly forming over her temple.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a matter of hours the bruise had deepened and spread over her entire face, as if her head were a rotten melon. In the dark hour before dawn her breathing stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wiped her mouth, pressed her lids shut. I held her head, touched the dense loaf of hair. I realized with a shock that it was not a mass of braids, or a knotted bun. Her gray hair was only the outer covering of a hard bony knob—an outgrowth of the skull itself. It was some sort of malignancy, some evil tumor, and most likely the blow had broken some membrane, freed the evil juices to seep through her head. Already her face was unrecognizable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched the body settle and shrink, the skin drawing more tightly over the bones. Her body became a dry, light, tidy thing, almost childlike. She looked quite peaceful. Except for the violently discolored face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took the key from her pocket and went to Anya’s room. I told her Baba was gone and we made plans to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the men were back, circling the house like wild dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Night fell. We heard them, they were running, circling, howling at the moon. We saw their eyes glowing green as they raised their heads, flaring their nostrils, scenting the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They can smell you, I told Anya.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t let them in, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They circled, scratching at the walls, pounding at the door, wailing and chewing their lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe if they could just come in and see you, they’d go home satisfied, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No they wouldn’t, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They waited all through the next day. They pressed their faces against the window, their eyes red and wild, their beards matted and sticky. They licked the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon they would begin tearing the walls down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my mother, felt my eyes darting and jumping like hers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went to Anya and said: I have a plan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I helped her dress. Then I put my arms around her and tried to lift her from the bed. She was not much taller than me. But her body was impossibly heavy and limp. Her flesh was so soft in my arms, like a down mattress; I thought that if I slit her white skin, she’d spill out feathers. My knees buckled; I saw sparks, and I collapsed on the floor with her warm, flaccid, bedridden body on top of me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your hair, I panted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her abundant hair accounted for at least part of the weight. It was many meters long, and tangled and twined around the sheets, the bed frame, the oceans of lace that surrounded her like a cocoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to free her hair, to gather it up like an armful of wheat. She lay uselessly on the floor as I tried to bind it up. Massy and bright, it slid from my fingers. I tripped over it, it was caught in my teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It has to go, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She screamed in protest as I went looking for scissors. She thrashed on the floor like a beached mermaid. Her hair resisted me; soon the scissors were blunted. The cries of the men outside made me frantic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It has to be done, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fetched the ax from the shed and stood above her, her hair pinned beneath my feet; I raised the ax above my head, and as she cursed and her sideways face contorted in anger I let it fall. Again and again I chopped through the lush growth, severing it from its roots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I caught my breath and smiled. Anya continued to heap her curses on me, even as she ran her fingers through her cropped hair savoring the new weightless freedom of her head and neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lifted Anya, propped her outside the back door. Then I went to Baba’s bed, wrapped her brittle body in a sheet, and carried it into Anya’s room. I covered it in lace, arranged the armfuls of Anya’s red-gold hair around the head as if it grew there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I blew out the candles. Moonlight from the one narrow window fell across Baba’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men had gathered again at the front door; they smashed their fists against it. The whole house shook. Their voices rose in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I opened the door. The faces, thirty or more, filled the doorway, a single creature with many heads and countless hands. They reeked of musk and sweat and foul saliva held too long in the mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you want to see her? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They closed their mouths and nodded; I held the door open and they tramped past me. Heedlessly they stumbled into Anya’s room, pressing around the bed, all of them packing in at once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I locked the bedroom door behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I went outside, hoisted Anya across my back, and staggered out into the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon we heard the screams, the blows, the breaking of glass, the splintering of wood. I tried to hasten my steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had nearly reached the trees when I heard the crash of the door being broken down. Men were pouring from the house. Anya gripped my ear. I longed to fling her down in the snow and run, but she was so heavy I was rooted to the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the men did not come after us, though my tracks were clearly visible in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were brawling with each other, hurling accusations, trampling the snow, staining the clearing with blood, beating each other with their fists. Each was accusing the other of touching the fairy-girl, as they had been warned not to do. Each blamed the others for turning their dream-woman into a rotting bag of bones and dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All of them held skeins of red-gold hair wrapped around their fists, or balled in their mouths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I set out again, with Anya bouncing on my back like a sack of grain. Far away, down in the village, I saw a line of lights steadily approaching. It was the women of the village, who had finally decided to take matters into their own hands. They came carrying torches and kitchen knives, some with babies bound to their breasts. They were coming to burn out the witch, break her enchantments and end her filthy practices, and bring their husbands home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hear them singing.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I walked for hours in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Near dawn I let Anya slide from my shoulder. Her skin was blotchy from the cold, her lips blue, her patchy hair disheveled. Looking at her flabby face, her piggish black nostrils, I remembered the strange desire I had once felt for her and wondered when exactly I had left it behind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She rubbed her hands, glared at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I cleared a space in the snow, gathered dry sticks, lit a match. We huddled together, our breaths making clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard a footstep and my heart froze.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A huge shape darted from among the trees, paused in the early-morning light, and squatted before our fire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari picked at his teeth and watched us warily, crouching on his heels. He had grown a great deal in the months since I had seen him. He was broad shouldered, bulky, shaggy as a bear. His beard had begun, though he was still a child. Some clumsy past attempts at shaving had left scabs on his face. But his eyes were the same, and the curve of his spine graceful as a horse’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh Ari, I said. I went to him and cradled his head in my arms, stroking the stiff hair. He looked up at me, sighed, and curled his lip in the grimace that was as close as he came to a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother, I told Anya. He can carry you, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari’s lips were chapped and bleeding, and he licked at them hungrily. Did you escape? I asked him. Although it was obvious, from the coarse uniform he wore. The cheap army-issue boots were falling to pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to hold his hands. He shook me away as he always did. Then I noticed the leg iron, rusted with dried blood, on his left ankle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya was watching us, fascination and disgust on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew the soldiers would be looking for him. I had to bring him to a safe place. I knew we should have started walking right then. Ari could have taken Anya off my back. We might have gone a good distance before night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I fell asleep, my head pillowed on my arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometime later I struggled out of sleep to see Ari and Anya staring at each other across the fire. Ari looked at her with a kind of wide-eyed wonder, the way he looked at a new animal he had never seen before. His mouth worked; his fingers plucked at each other nervously. He ducked his head, then looked back at her and laughed. His laugh was a harsh sound, like choking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya was pleased by his attention, I could tell. I could see the familiar, languid, lazy expression creep over her face. Ari held her eyes and eased slowly, fluidly closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya smiled. And then she ever so slightly loosened her coat, showed him a patch of white skin at her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari reached out slowly to touch a stray bit of hair. She laughed nervously. And then Ari grunted, leaped, pounced. Suddenly she was splayed out in the snow. Ari had his mouth at her throat and was tearing insistently at her clothes, twisting her head this way and that, pressing and tugging at her limbs, sniffing in her ears and eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was just a child. He was only trying to see how she worked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She screamed and screamed and would not stop screaming, not when I pulled Ari away from her, not when I slapped her face, not when the company of soldiers in their ugly brown uniforms came running stiffly through the trees, barking orders to each other and surrounding my brother with their guns.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They had been tracking my brother for two days; they had recently lost his trail but Anya’s voice led them back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood and watched as my brother was taken away. The officer of the company stood beside me and barked orders. He wore tall shiny boots and carried a riding crop which he flicked impatiently against his leg. Between orders he ground his teeth; I could hear the rasp and squeak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sent one of his subordinates to fetch a horse and bring Anya back to the army camp. The other officers will be very glad to make her acquaintance, he said. I told him about her feet; he shrugged and said she would not need them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not look at her as she was taken away. Her screams still echoed in my head. That gaping mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now I stood alone with the officer. I was not afraid of him. I could see his viciousness, it was something I understood. I had seen it before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should give up on my brother, I told him. He will never learn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m not yet convinced of that, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s too old, I said, he has been the way he is for too long for you to change him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are ways, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What if there were others just like him? I said. Other ones, as big as him, and as strong, but young enough to teach the way you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What are you saying?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We have younger brothers, I told him. Take one of them, take all three of them, train them, and give up on Ari.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The officer chewed over the idea. I heard his teeth clicking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is the name of your village? he asked finally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My village was too small to have a name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So he said I would have to show him. He hoisted me up behind him on his horse, and we rode, to the jangling of bit and spurs, over hills and through forests, and I clung to his belt and felt immense hatred for the layer of red, bristly flesh that bulged over the collar of his uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know what would happen next. My younger brothers were not at all like Ari; they were ordinary, big headed, knobby kneed little boys with runny noses. I did not want to give them up to this officer. In my desperation I had been thinking only of my mother. I thought somehow that if I brought this man back to my mother, she would find a way to make everything all right. This man’s viciousness was no match for my mother’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As we jolted and galloped over hard-packed snow, I thought of her and wanted to crawl into her lap. She had managed to bring me home after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she would smell us coming, with her nose for soldiers. I thought of her eyes snapping, skirts whirling as she formulated plans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We rode until we came to a place that I knew so well, I knew the shape of the hills and the bend in the river. I felt a pang as I thought of home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We crossed the last rise, emerged from the trees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The village was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a black scar in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We rode slowly down the only street. The houses were blackened skeletons, still smoking. A bloated cow lay in the road, legs in the air. Dogs, cats, goats lay in frozen twisted shapes in the gutters, daubed with red.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The smoke made black smudges in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw blotches and blooms of blood flowering on walls. I saw a boy’s cap in the road, cupping something dark and gelatinous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a familiar skirt. I saw a fork, a spoon. I saw a pair of severed feet, lined up as neatly as shoes beside a doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of Anya and how she could use them, and I heard myself laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pressed my face against the officer’s sour back so I would not see any more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We are too late, the officer said musingly. He was riding slowly, looking about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Such a pity, he said, such a waste.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I heard a softness in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To think—three more just like your brother, he said. That would have been amazing. Our company would have been the best in the division.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He clucked his tongue at the horse as it shied at a child’s dress blowing on the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I held myself stiffly away from him all the way back to the army camp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told myself that my mother had escaped, of course she had, she must have scented the impending disaster, certainly at this very moment she and my father were hiding in the woods with my brothers and sisters gathered around, roasting potatoes over a fire, my mother a whirlwind of activity and foresight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I still felt hope, I did, I held my chin like my mother always did. I told myself I would be brave like her, and resourceful, and I would do what I had to do to save them all.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I ought to skip the next part of the story, you are too young to hear it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I won’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When we returned to the soldiers’ camp, the officer offered me another bargain, a trade. Your brother’s release in exchange for the pleasure of your company, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just a little while, he said. It won’t take long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We stood in the mud, among tents and milling horses and the jangle of harnesses and spurs. A subordinate came to take the officer’s horse; as it was led away I saw that its legs were still flecked with the soot and debris that had once been my village.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at the officer whose eyes were set too close together, pinching his nose. Hair in his nostrils. I thought of my mother, her power over men, men meaning my father, the way my father jumped to do her bidding and cowered from her though she was half his size. And I thought of Anya, who could make men act like fools or grunting animals simply by rolling her eyes at them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I was stronger than Anya. I had carried her on my back, I had dragged her through the snow. She was weak, I thought, and stupid, and not even whole, and yet she had driven a townful of men to madness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If she had that sort of power, I reasoned, then surely I did too. I looked at the officer, who was tapping his riding crop against his boots, flicking away flecks of mud, admiring them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought: surely I can get the better of him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought: I will drive him mad, he will do whatever I say. Because that is what women do to men.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought: that is what Anya did, and I am far better than her, look at my two perfect feet. Cold but lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was my reasoning. I thought it sound at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded and the officer took me by the arm, not companionably, he grasped me near the armpit and jerked me toward the inn where the officers had their rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And in that room, which was low ceilinged and too warm, I saw how his body drooped without the stiff uniform, saw the flabby ring of flesh at his waist that matched the one on his neck. And he laid his hands on me, hands that looked like disease, with their knobby joints and yellow nails. He began pulling off my clothes and I wanted to change my mind but the door was locked and it was already too late, I was backed into a corner behind the bed, a high bed with an iron frame made of bars like a prison cell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He pulled off my clothes, layer after layer, and it took a long time, and I was aware suddenly of how my clothes reeked of goat and ash and the tart sweat of panic, and I was momentarily ashamed. But he kept pulling and tugging and did not notice, hardly seemed to see me at all, I was a service, less to him than his horse or the subordinate who had taken it away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was all happening too fast; I was not having the expected effect on him but it was too late, he snapped a cord and the last of my clothing fell and pooled at my feet. I felt as if he had gone too far, as if he had gone beyond my clothes and stripped off a layer of skin, my body felt raw and sensitive all over like a fresh cut, a hangnail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was the moment when he was supposed to grovel at my feet, look up at me with worshipful eyes like the men in Anya’s room. Instead he muttered something about chicken bones and boosted me onto the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He threw himself upon me, and I undid my hair and let it fall all around so at least he would not see my face as he did what he did. He puffed and groaned and breathed his sour breath into me, and dug out the deep places in my body and scraped and chafed against them so long I thought I would develop calluses before he was done, and as he did this I looked up at the ceiling at a crack in the plaster that seemed to be branching and spreading even as I watched it, like the crack in an egg as the chick begins to peck its way out into a harsh new world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When he was finished he lost no time in getting back into his trousers. He put on his tunic, polished his boots with a cloth and then put them on, gazing down at them fondly. He was brisk, efficient, on his way to a fine dinner, no doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I asked him when I would see my brother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He laughed into the mirror. He was smoothing his mustache with oil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ll never see your brother again, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You promised, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you want a promise kept you should get it in writing, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your brother’s no better than a horse, he added, if they can’t train him they’ll take him out back and shoot him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I leaped from the bed, landed on his back, sank my teeth into his neck. I could not inflict much, his flesh was leathery tough meat, my teeth could not pierce it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smashed the handle of his pistol down on my fingers and I fell from him. He raised his foot to kick, but the polished perfection of the boot made him reconsider. He did not want to soil it, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stepped around me, put on his coat, paused at the door. I expect you to leave here before nightfall, he said. And he added: Rinse the sheets before you leave. There’s water in the basin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened the door, paused, and said in a fatherly tone: You should be careful in the forest at night. There are timber wolves, they are unpredictable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood a long time before the mirror; it was black speckled, rip pled with age, looking into it was like looking into a deep pool that sucked up most light and only gave a little back as reflection. But I could see enough. I saw how my bones stuck out like scaffolding, and the skin was sallow and rough. The officer had left bruises shaped like fingerprints all over my shoulders. There was nothing in my face that could tempt or intrigue; my hair was long but it looked only like hair, not like precious metals or sunsets or fires. Worthless merchandise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How foolish of me to bargain with this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How foolish to think I could move mountains just by being a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood looking at the girl in the mirror who held her breasts in her hands and cried. Stupid girl, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had never seen my mother cry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Outside the sky was crowded with clouds dark as smoke, or smoke thick as clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I washed and dressed and went to the stables and stole a horse because although I may have been ignorant of men, I understood animals and knew how to win their complicity. I ached between my legs and each step the horse took sent a jolt of pain a little farther up, a little deeper in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother was nowhere to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I rode away from that ugly place.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Those three old women who used to plague my village told me a story once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was a child then, their ancient faces frightened me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to listen to them. I turned my face away and pretended that I was very busy thinking of other things, the way "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" do sometimes. But their words bored in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The story went like this:")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There once lived in the village a girl who was so spirited, so lighthearted her feet barely touched the ground. Her mother had to sew stones into the hems of her daughter’s skirts, knot clothes irons and horseshoes into her hair to prevent a strong wind from blowing her away. But the girl was irrepressible, she could run fast as a deer and all day long she flitted through the village, her bright sharp voice spangling the air around her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone in the village knew her. As a small child she had been inquisitive, appearing unexpectedly at people’s elbows to ask them questions. She pestered the blacksmith at his anvil, dodging the sparks; she floated through the clouds of flour at the baker’s, dug through the cobbler’s greasy leather. She might show up in any house, at any time of day or night, regardless of locks or manners. She would simply "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("be")]), _vm._v(" there suddenly, an extra face at the dinner table. You might see her nose pressed against your window, feel her breath on your neck as you squatted on a stool milking into the bucket between your feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As she grew older she became taller but lost none of her lightness. Her mother often kept her inside now to work. But when she could get away she wandered through the village as before, stopping where she pleased. The villagers were used to her now; some anticipated her questions and answered them, while others good-naturedly ignored her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had a vitality they could not understand. They looked at her and thought she was happy, but in a way that made no sense to them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She took to wandering the fields and forests, singing to herself, sticking weeds and flowers alike in her hair. The villagers saw her from afar; some liked to romanticize her, saying that her singing brought birds and butterflies flocking to her, perching on her shoulders and joining their voices to hers. Others said she had a low, rough voice, couldn’t sing a note, she just wandered aimlessly, dragging a stick over the ground, shamelessly idle while everyone else gathered vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But they all agreed, later, that this was when the forest spirit first saw her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was walking among the trees, her light feet barely rustling the dry leaves, when she reached a clearing and came face-to-face with one of the spirits. He had yellow eyes, antlers sprouting from his forehead, thick legs ending in huge hairy hooves. He wore a white shirt and a soldier’s braid-trimmed jacket above, and nothing at all below.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was spitting through his teeth; as the wet drops fell they pattered like rain, and where they touched the ground the grass withered and died in rust-colored patches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl paused and stared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The spirit smiled lecherously and unrolled a tongue that reached to his waist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl saw that he was balding, and that his nails were bitten to the quick like a nervous child’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was afraid then, for she had heard the old people in the village speaking of imps and spirits, of the forest, of the river, of stone, and of the hearth. They said young spirits were harmless, stupid; it was only the older spirits who were clever and malicious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But this spirit did nothing, merely looked her up and down, and then trotted back into the trees. The two tiny wings that grew from his shoulder blades flapped feebly as he went.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She ran home, and thought no more about the incident, except now and then, when she seemed to feel someone watching her, or when she saw a reflection not her own in the distorting bowl of a spoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was months later that she heard a beat drawing her to the woods, a regular pounding that matched her own heart. She followed the sound, gliding among the trees, and came upon a young man, his shoulders nearly as broad as two men put together. He was splitting wood, in a regular rhythm, using an ax that matched his girth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She watched as he worked, his back and shoulders so graceful yet so heavy. She saw in him a solidity that matched her lightness, and for once she could not think of a question to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She returned again and again to watch him at his work. He was so practiced in his movements that he could stare back at her, lining up the chunks and letting the ax fall without ever looking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Watching him she felt as she did when she saw the moon clearly reflected in a pool of water, or rain dimpling the surface of a river, or a young sapling sprouting from the rot of a decaying stump. It was a sense of symmetry and completeness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She made her feelings known, without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The young man came to the village to speak with her father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl’s parents were pleased with his request. They had assumed no one would want to marry their daughter; she was flighty, an indifferent worker, and they had expected her to remain a light but troublesome burden the rest of their lives. The father was happy enough with her suitor, and the two laid plans and conditions and sealed it all with a firm handshake, both men testing the other’s grip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("During the months and weeks before the wedding the girl became lighter than ever. She was not permitted to be alone with her prospective husband, so she watched him from a distance, savoring the musical sway of his body. She drifted through the woods, rose to the level of the treetops, and watched him from above. She swooped and tumbled in the sky, dove to earth and rose again, climbing the air as if it were a staircase. At night she darted batlike against a backdrop of stars, all the while humming her tuneless nothings or clucking her tongue like a falling ax.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The villagers saw her skimming the treetops and muttered: Silly girl, she’ll break her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And: She should be home helping her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While she flew carelessly above, trouble came to the village down below. First it was flies, thick dark clouds of them. They settled everywhere, attacking with their stinging bites, feasting on anything left uncovered, burrowing into the hides of animals to lay their eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then the yard behind the girl’s home began to collect water from an unknown source. The ground became sodden, the garden plants rotted, the earth sank. Within days the yard had become a swamp, and lugubrious black frogs had taken up residence. They moved lazily, their skins as slimy-black as oil. White clusters of their eggs made a scum on the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thick clouds lumbered in, clogging the sky. For a week day was as dark as night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These were bad omens, and the villagers eyed each other suspiciously, wondering who was to blame.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A week before the wedding, the girl woke in the night to find her window open, a sour breeze licking at her forehead. And then she saw the close-bitten fingers on the sill, two yellow eyes glowing in the dark, and a long pink tongue unrolling and creeping along the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The tongue reached the foot of her bed, lifted the sheet, and burrowed underneath. She felt the rough tip as it nudged its way up her legs, creeping upward to help itself to the thing she was saving for her future husband. She tried to scream, slapped at it with her hands, leaped up in bed. She snatched up a hairbrush and struck again and again, but the pink worm seemed to be everywhere, writhing and soiling the sheets. So she shot upward, toward the ceiling, and fluttered there mothlike, seeking an escape.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The spirit let out a roar with his tender tongue. He sprang into the room, filled with a jealous rage. He had hoped to lure her into the spirit world with him, he had brought her a crown of hemlock and mistletoe, a wedding veil of spiderwebs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now he snatched at her as she bobbed just out of reach. She sought an exit but the window had disappeared, as if it were a wound that had healed; the door was gone and even the cracks between the floorboards had sealed themselves. The walls drew in closer, and closer, and closer, the spirit nibbled greedily at his fingers, and she covered her eyes and screamed and screamed, and the spirit leaped up and dove into her body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If he could not have her himself, he would prevent anyone else from having her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now the girl wandered through the village day and night, her eyes glazed, her face strangely slack. She did not float, she staggered and crashed into fences, she clawed at windows, plucked at her own hair. She spun like a top, her skirts rising to her waist, her hair hanging loose, streaming behind her, a dark streak. She sank her teeth into her own arm, and drank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The voice that came from her was not her own. It was deep, hoarse, a man’s voice, it came from deep within her and flowed out her mouth, spilled out over her unmoving lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She wallowed in mud. She rent her clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wherever she went, dogs, cats, children fled. But she was followed by chickens, a flock of them, all watching her with their pink eyes and dodging her drunken feet. Wherever she stepped, worms rose from the ground and the chickens pecked at them greedily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The villagers recognized the signs. They barred their doors. The girl beat at their walls, calling and cursing in her harsh voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her betrothed tried to restrain her and she turned on him savagely, clawing his face to the bone with her fingernails. He stumbled away, blinded by blood. Forever afterward he wore a beard, to hide the scars.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When it began to rain, the girl looked up, slaver coating her chin. She limped to the village meetinghouse to take shelter. The villagers watched from their windows; her father crept out and barred the door behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The villagers met in the street, rain soaking their clothes, to decide what to do. Many had seen girls possessed by dybbuks before, but they were divided as to the identity of this invader. The future husband was quick to suggest forest spirits; he feared they were revenging themselves on him for killing so many trees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Other villagers thought the dybbuk was the spirit of a girl who had died ten years earlier, three days before her own wedding day. Such spirits were jealous of living girls who would soon know the pleasures of marriage. These spirits were childish and petty, more lonely than malicious. They could be coaxed out of their victim’s bodies with gifts, white dresses, music, cake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some said the girl had been strange from the start, there was no helping her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The villagers listened as the hoarse, choking voice rose up inside the meetinghouse. They heard pounding, crashes; they saw a tortured silhouette flashing past the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They knew they would have to act quickly, or the girl would be lost to the human world forever. But they could not agree on the method: some said fire, some said prayer, some suggested a drink of lye, others wanted to sweep out her insides as one might a clogged chimney. As the rain poured down the villagers armed themselves with hoes and paring knives and prayer books. They straightened their shoulders, prepared for battle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As they approached the door, they heard again the hoarse guttural voice, raised in anger. It bawled and faded, gibbering, arguing with itself; it rose into hysteria, and exploded. The windows glowed orange, the rain falling on the roof hissed and boiled. A section of the roof blew apart, showering shingles and sparks. A dark and howling shadow swirled up into the sky and disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Inside, the room was filled with smoke and the smell of goat. The villagers found the girl crouched on the floor, her clothes charred and her face sooty. But she stretched her arms out to them, gave them a familiar smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had forced the dybbuk out of her body herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had drawn in her sides and forced him out with one violent breath, as she had seen the blacksmith force air from his bellows. She had rolled and kneaded him out, as she had seen the baker knead the air bubbles out of his dough. She had plucked him from her body, as she had seen her future husband pull free his blade from a stubborn block of wood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All the things she knew she used, to return to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone could see the dybbuk was gone. The proof was in the small bloody spot, the size of a pinprick, on the smallest toe of her right foot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But afterward she was not the same.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had lost her lightness. Her body now clung to the earth like anyone else’s. She felt a new strength, but also the kind of tiredness she had never known before: the longing to lie down and stay there, as close to the earth as possible, the desire to close her eyes and sink down, down, down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before she had known only lightness. And then she had known the claustrophobia, the smothering feeling of the alien spirit cramming itself into her body. And with the trespasser gone, she came to know earthly heaviness, the ties that anchored her to people and places and things that needed to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She felt the heaviness when she looked at her parents’ weary faces, and when she looked into the face of her future husband and saw the scars her own fingernails had left, and a lingering fear that never went away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She could still recall the lightness. But it required some effort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some villagers said that for years afterward she bore traces of the dark spirit that had inhabited her. She saw things no one else could see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On her wedding night, her new husband drove himself into her, just as he drove his ax into logs; and her thighs fell open, like the cleft wood that fell apart from his ax in two clean white halves; and she felt a heaviness that had nothing to do with her husband’s weight on her belly. It was a new kind of happiness, a contentment, filling her like bricks, anchoring her, laying its foundations and rising up like a fortress to the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And when she became pregnant she felt more secure than ever before, as if the baby anchored her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People used to say that girl was my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was what the three old women told me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was only a story they liked to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I rode back to my village for the second time, or to the place it had been. Perhaps it would still be there, perhaps I had led the officer to the wrong spot. Perhaps the earlier visit had been a bad dream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I reached the place that I recognized from the shape of the hills and the narrow frozen river. The village was gone, there was only a burnt scar in the snow. Peaceful now; smoke no longer rose from the ruins.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a long time I sifted the ashes through my fingers. I wanted to find evidence, a bowl, a pipe, a needle, a ring. Any proof that would show that people had been here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I found nothing. The place was picked clean, as if vultures and maggots had swept through and done their work and left.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not a bone, not a shoelace. Only charred bricks and ashes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if no one had ever been there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I spent the night there, picking up stones from the riverbank, and because there were no graves to place them on I laid them where houses had once stood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I heard the voices of the three women who had been a more permanent part of the village than the houses, I thought I heard their hisses on the wind and their keening, mourning the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My hands were frozen, the fingernails a lovely blue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon, I thought, the forest will stretch out its arms and spread over this place and it will be as if this clearing had never been here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("However far I had traveled, I always found myself in a forest, and in a disturbing way it seemed to be the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("same")]), _vm._v(" forest, as if I had not gotten anywhere but had only been walking in circles. That forest trailed me, fastened to my heels like my own shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to recall how the village had once looked, but already my memory had faded. I looked around that empty place and I began to wonder if it had ever really been there at all. Perhaps the village had only existed in my head, the way the miniature city existed inside my treasured egg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Could a thing exist without witnesses? Without proof?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It occurred to me that there was not much difference between a real thing that existed in memory, and something that was horn in the mind from the start.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sky was now the pale expectant color that preceded sunrise. Where was the horse? I looked around and heard it scream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw it in the distance, rearing and frothing. Three skinny scarecrow figures sat jammed together on the saddle. They raised their arms and shrieked, in terror or delight, as the horse reared again, panicking. Three sets of bony heels stuck out from the sides of the animal, kicked against it impatiently. It began to run, and the women clutched each other with their tattered shawls and long unbound skeins of hair streaming out behind them. I thought I could almost see their cries trailing in the cold air like ragged banners.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I could even see the red of their mouths, but it must have been the first red light of the rising sun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I would not catch up to them. Yet I walked after the shrinking shape, black against the sun. They veered, and now they were driving directly toward it as if the sun were a tunnel they could enter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I came to the top of a rise of earth and looked down, and there in a hollow on the other side of the hill I found all the proof I could have wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were stacked in a mound, piled high as a haystack, all of them, and frozen in a way that was familiar. Some were in pieces, most were not; all had the whitest skin. They were cold and hard as statues, fuzzed with frost, saliva frozen in the corners of their mouths. The blood on them was beaded red and smeared purple and crusted, clotted black.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw the mass of backflung heads, angled this way and that as if in conversation, and the feet laid together, some shod, some bare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not have moved any of the bodies even if I had wanted to, they were all frozen together in one solid mass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can I explain how peaceful they looked, their eyes unblinking, perfectly silent as the sun rose and the soft light touched their faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Too silent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother, my father. Lying side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t want to hear a sound out of you, I ordered them. Not a peep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one stirred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t move, don’t even breathe, I told them. Play dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I crouched near them and said: They’ll never find you now. They’re stupid that way. As long as you all stay quiet like this, they’ll never find you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They obliged.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re safe here, I said, as long as you stay here and don’t ever move and don’t ever breathe, you’ll always be safe, do you understand?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned my back then and started walking and did not look back. I had the proof I needed, there was no more reason to stay. Solid proof that you can touch, that you can see—that’s all the proof you need to believe in something. Sometimes it is too much.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I came to a town ten times larger than the village where I grew up. The streets were paved with stones and lit by lamps at night. The people spoke differently here. I saw women with stuffed birds and fruit on their hats, and children dressed in white like angels.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found work here with a woman who lived in a house on a cliff high above the town.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was very tall, with red hair in crinkly waves and a white immobile face like a mask. Her eyebrows were arched so high they must have been painted on; there was a beauty mark, like brown velvet, absolutely round, perfectly centered on one cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said she liked me because I did not talk much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I first came to her she showed me around the vast drafty house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come meet my husbands, she said and led me down a long gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Aren’t they beautiful? she said with a wave of her hand. All of them dead so young. Sad, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A row of framed portraits hung on the wall; I counted seven. Heads and shoulders, nearly life-size. They all had puffed-out chests and a kind of barnyard cockiness, in spite of their elaborate clothes and carefully manicured hair and beards. They all had eyes that met yours, that seemed to follow you as you moved.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I never wanted to marry so often, she was saying, but what could I do? They kept dying. Unlucky in love, I am.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I spent my days lighting candles, cutting the pages of books. I mended her shoes, dozens and dozens of them, high heeled and jewel toed, and I went to the roof to feed the pigeons, but most of my work revolved around hers, for she was a painter. Her hands were always smeared with colors; the portraits of her husbands she had painted herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She taught me to mix her paints and clean the brushes and to cut wood into frames, though she stretched the canvas on them herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sometimes spent hours looking at a stone or a piece of cloth with the sun shining on it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I learned that she was a well-respected artist, much in demand to paint portraits of the aristocracy. She traveled to far places for commissions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I liked to watch her work, the way she could give a picture such depth that the canvas seemed merely a portal to a deep and distant world. Yet I didn’t trust it, it was all trickery, wasn’t it? It fooled the eyes. And the paintings were lies, they showed you a moment that was gone. Those husbands, who looked so hearty and red cheeked in their portraits, were all dead. It seemed a cruel deception.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course I did not say so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One day she told me she wanted to paint me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just for practice, she said, just to keep my hand in tune.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. I pointed to a blank canvas and said: I don’t want to be caught there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you afraid I’ll capture your soul? she laughed. Is that another one of your superstitions? When are you people going to come out of the dark?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: I’ll give you a dress, you can pretend to be someone else, you won’t even recognize yourself when it’s finished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I agreed, and she brought out a dress and for a moment I was thrilled. I pictured myself all sweeping skirts and dancing grace and icy grandeur. Like her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She held it against me and I saw that it was all a sham, it was not a dress, only the front of a dress, to be draped conveniently across any posing sitter. It was unlined, unfinished inside, embroidery unraveling, threads dangling. She made me sit on a small gilt chair, and turned my face, and pinned up my hair with ornaments that even to my untrained eye looked false, with the greasy iridescence of oil on water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she was satisfied, she went to her easel and ordered me not to move and to fix my eyes on the distant doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was many days at it and when she was finished she showed it to me. I took one long look and did not look again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can see from your face that I’ve done well, she laughed. You look exactly like the portrait right now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Looking at the portrait was not like looking in a mirror, for a mirror was only surface. The portrait showed me from the inside: she had captured the tension in my jaw from clenching my teeth, and that shameful pink drool—the birthmark at the corner of my mouth, and the hairs of my eyebrows all in disarray, and the eyes. The eyes were both fearful and calculating, the eyes of an animal deciding whether to flee or attack.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had not known I looked like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My face made the fine clothes look all the more ridiculous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon after she told me she had been commissioned to paint a countess. She asked me to look after her house while she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t think I’m getting fond of you, she said. We understand each other, that’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at me shrewdly, then sent me down to the stables to summon a coachman I had not known existed. Perhaps it was a trick of the light, but as I entered the stalls I thought I saw the coachman with his head in the manger, licking up oats alongside the horses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Back in the studio I packed up her brushes. I heard her step and turned. She stood in the doorway in trousers and boots and a greatcoat that fell to her knees. Her face, which had always seemed painted on, now looked to be sketched in with rougher charcoal strokes. How broad her shoulders looked. Perhaps the coat was padded. She had a mustache and beard painted on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t look so disturbed, she said. I get many more commissions this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She took the box from me and left. I heard her boots echoing a long time. I watched from the window as the carriage rolled down the long winding road to the town, and then beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered which of her clothes were the charade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The house was even larger than I’d thought. There were many locked doors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went down to the town, to the marketplace. I heard people gossiping about her: her wealth, her isolation, the husbands who went with her to the dark house on the hill and never returned. She loves them to death, wears them out, they said, her body is unnatural. Bluebeard, the men called her, and made obscene gestures.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men never come out alive, people said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She eats them up, they said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Cuts off their things and eats them with a vodka cream sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They pointed to the house, whispered as if she would overhear them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept the fires burning to keep the chill out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was gone many weeks and returned with a new husband.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was young and fresh and gallant, with pale hair like flax and gaudy clothes. He held himself proudly, though he was slightly shorter than her. He rubbed his hands together and looked about at rugs and lamps and the rooms so long you could not see the end of them, and there was a bit of greed in him, you could see it in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was dressed in her long clinging gowns again, her hair loose, her face perfect. He put his arm around her waist, caressed her neck. Over his head she gave me her shrewd look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night they were loud and vigorous in her bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next day when I was alone with her in her studio I asked how she had found him, when she’d been dressed as a man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: Some men like an adventurous woman. Besides, she said, nodding toward the bedroom, he is a third son and will inherit nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She painted his portrait but kept it in her studio.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a short time she announced she had been offered another commission. She could not take her husband with her. I have to preserve my reputation, she told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She handed him a ring of keys and told him he could enter any room in the house but one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I trust you completely, she told him. Please honor my request.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He nodded but he was not paying attention; he had his hands on her breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then she left and we were alone in the house, he and I. We seldom spoke and he spent his days riding a black horse through the fields, hacking at the bushes with his sword and shouting like a child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a night when he fell asleep in a chair in the library, a book open across his lap, and I slipped the keys from his jacket pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had never forbidden "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("me")]), _vm._v(" from entering the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found it, high in one of the towers at the top of a spiraling staircase. I had only a candle, it threw my shadow wild-haired on the walls. I fit the key to the lock; the door swung open. I stepped inside, cringing, expecting to spring some hideous trap but too curious to stop. All was silent, the room was empty save a bed, and on the bed lay a woman. It was a young woman, pale and beautiful and stretched out on her back, arms extended as if awaiting an embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought suddenly of Baba’s house, and wondered if "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("all")]), _vm._v(" unusual women kept young girls hidden away in secret rooms. As if they were trying to cling to a younger version of themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I breathed on the woman’s face, I touched her arm. She was cool, didn’t move. I jostled her. She was not real at all; she was made of soft wax or clay and her skin, I saw now, had a hard waxy sheen. I could see that her mouth led nowhere, there was nothing beneath her eyelids. I punched her stomach, my fist drove right through her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From a distance, though, she had been convincing. Lifelike. A work of art.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pulled the sheets away to see more. I saw a flash of steel and quickly jumped away. There, set between the legs, were jagged metal jaws, like a monstrous bear trap.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I snatched my candle, raced away from the strange thing. Locked the door, crept down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I considered keeping the keys, to avoid any possible accidents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But when the husband cornered me the next day, asked me if I’d seen the keys, accused me of stealing them in his loud pompous voice, I handed them over.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was no need to worry, I reasoned. If he kept his promise to my painter, and stayed away from the room, then there was nothing to fear. And even if he "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("did")]), _vm._v(" break her trust, and make his way to the secret room, I was sure he would not be so foolish to mistake a waxen girl for a real one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And even if he "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("did,")]), _vm._v(" I thought, he would not be so unfaithful to his wife as to do the thing that men seemed always intent on doing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was my reasoning. I did not think he would come to any harm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Although it was true I did not like the gleam of ownership in his eye, or the way he shouted and spit in my face and called me a country cow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not think he would do anything foolish, but the very next night I was awakened by a metallic snap, followed by the most unbearable screams I had ever heard. I ran to the tower room, pounded on the door but it had locked behind him. I could hear him gasping, I shouted to him to throw the keys underneath the door, but there was no room for them to slip through even if he had.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is unpleasant to hear, I know. It sounds like the kind of story people tell children to frighten them into good behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But that’s not why I am telling it to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am telling you because it is what happened. It is the truth. No other reason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dawn broke and pink light seeped into the studio where I stood, and then I heard a horse’s footsteps far away but coming closer. It was the painter, returning as if she had known all that had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She strode in, still in her man’s clothes, looking windswept and happy. She gave me a list of errands as long as her arm and sent me to town. She had forgotten that I did not know how to read, but I knew enough to stay away from the house until nightfall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I returned all was quiet. She greeted me serenely, and in answer to my look she said: He failed the test, you see. It’s a pity, it’s impossible to find a man who can remain faithful these days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She touched my shoulder with a hand that was sticky, smeared as usual. You should not feel responsible, she said. It was his own fault, he should not have gone poking into forbidden places.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He broke my trust, she said, and then she hung his portrait on the wall beside the others. I could not look at it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stayed with her a while longer. I loved to watch her paint but could not look her in the face. She went away again and returned with her ninth husband. When I saw him I knew I would have to leave because he was a soft mild man who walked with a limp. He looked at her with worshipful eyes and touched her gently and he helped me light the lamps in the evenings. I could not bear the thought of him ending up with his head hung on the wall with all the others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So when she announced she was leaving, and handed him the key ring, I stole the keys from his pocket while he slept and went to the tower room and set off the trap with my candle and then I locked the door and threw the keys down a well for good measure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I left. I did not want to be there when she returned to find only a candle snapped in half, instead of the disappointment she anticipated. She would know I was responsible and I could not guess what she would do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew the new husband was not completely safe; I knew she could easily give him another set of keys and again disappear and let him succumb to curiosity and temptation. But I hoped he would not. Perhaps he would pass her grisly test and win her trust and they would live happily together and he would teach her gentleness and they would fill that great house with children and leave that waxen doll to rot in her tower.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I left.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like the thought of the portrait she had done of me, I had wanted to destroy it, but she had hidden it away somewhere. I did not like to think of her keeping my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she had paid me well for my time with her and the money jangled inside my dress. I had heard people talking of a place, far away and across an ocean, where people stayed young forever and there was room to breathe and everything was hopeful and new and run by machines. They said the streets were paved with gold. I wanted to go there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The streets of gold, I knew that was just a story. But the rest rang true.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I passed through villages and larger towns and as I traveled farther from home I noticed changes. The lengths of men’s beards. The sound of their voices. More iron and steel, coal instead of wood, engines and machines that moved and steamed of their own accord as if they were alive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These things amazed me, but as I traveled farther and wonders piled on wonders, I began to anticipate them and ceased to be amazed. I think if I had seen men walking up the sides of buildings like spiders or flying through the air with dragonfly wings I would not have been surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I walked through these towns I heard people speak of a Great War and when I asked where this war was they laughed and called me a yokel. They asked where I had been hiding all this time, and stared at my hair which had never been cut and now fell past my knees, and they laughed at my wooden-soled shoes. I ran away but heard them shouting after me: The war’s over, little fool, and there will never be another.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept going, for this was not the place I was looking for. These people, for all their fine clothes, were as violent as all the others. Their faces were greasy and lewd. I saw a man beating a yellow horse that would not move because the cart behind it was too heavy, piled to the sky with cast-off furniture. The man beat and beat it, cursing til he ran out of breath and still the horse would not move. He beat until the horse sank to its knees, pink foam running from its nose, and only then did he stop to wipe his brow. And then the top-heavy cart tipped and a clattering shower of broken chairs and legless tables rained down upon him and buried him utterly and no one passing by on their daily business paused to help him. Or the horse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The towns were full of glittering surfaces and engines of convenience, but in the surrounding fields nothing had changed. On the country roads I passed women bent like harps, with burdens on their backs twice as large as themselves and babies strapped to their breasts. And at night I saw harpies circling in the sky just as they had over my village. Harpies had the bodies of hawks and the heads of women, and sometimes they borrowed the faces of the dead to frighten passersby. Once I thought I saw one wearing my mother’s face like a mask, and I quickly looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("By now my hair reached my heels and was tangled with twigs and colored thread. Sometime earlier I had spent the night in a stable among the horses, and in the morning I found that some local boys had tied bells in my hair while I slept. Tiny bells the size of thimbles that jangled faintly when I shook my head. I found many of the bells and pulled them from my hair, but there were some I could never find though I searched through my hair strand by strand. So I made music now when I walked, though it was a cheap tinkling sort, and people thought I was a gypsy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I came to a new town one evening. The people on the streets took no notice of me as they went hurrying past, their faces bright and expectant. Children darted among their elders; women carried babies cradled in their arms or slung over their shoulders, or balanced on their hips. They were all streaming in the same direction, so I followed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were heading toward the large meetinghouse in the center of the town, and I realized they were going to pray together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were three old women collecting money at the entrance. I thought they were beggars and gave each a coin before I went in and sat with the others. Rows of benches filled the room, it became closely packed, the air warm as breath, and noisy as the people jabbered to one another and babies cried. I had never been to a prayer service like this, where men and women sat together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The room grew dim, and the flow of voices ceased as all the people looked to the brightly lit platform at the front of the room. In the hush a man leaped on to the platform, followed by another, and they began speaking in loud strident voices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More people joined them on the platform, men and women too, and they all seemed excited and wrought up about one thing or another, and they clasped their hands and wept. I was shocked, for they were speaking of very private personal matters, but doing so in such loud voices that everyone in the room could hear. And the people sitting around me, instead of politely turning aside and pretending not to notice, were watching intently and drinking in every word. I felt I was eavesdropping; it seemed wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The people on the platform ignored us even when we laughed or gasped; they were too intent on their own troubles. They seemed detached from us, in their own brightly lit little world, and yet at the same time they seemed more real, more intensely alive than anyone I had ever seen. Their faces betrayed every thought, their bodies were eloquent with suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered when the praying would start.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was one man in particular who held my attention. He paced the platform, clutching at his hair, he seemed tormented by inner demons. I gathered that he was grieving for his dead father. His suffering made sense to me. After a particularly long rant, with much arm waving and foot stamping, he paused and his eyes swept the room. I could have sworn he looked at me for a moment. His eyes were the most unnatural blue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Much later I discovered there were tears on my face. Around me babies squalled and sucked loudly at their mothers’ breasts, men lit their pipes, restless children crawled between the benches and butted against people’s knees, but all I saw was the brightly lit platform and the young man’s exquisite agony and I wanted so badly to comfort him that I could barely sit still.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Something holy was happening here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Time must have passed; the faces around me were slick with sweat, the air was hazy with smoke, babies lay sleeping, their faces slack. But the action on the platform continued, seemed to be building to its breaking point. I could not understand all they were saying, but I felt the tension increasing like threads being gathered up and drawn tight. The platform was crowded now, voices raised shrilly, and then there was an expectant hush, and I saw the flash of long knives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was some kind of ceremonial killing, I realized. A sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man with the blue eyes, my poor man who had already suffered so much, now had sweat running down his temples and his eyes rolled upward, the veins leaped out of his throat; he knew he was going to die, I saw, it was inevitable, he was giving himself up to the ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those seated around me leaned forward eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What grisly ritual was this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a great flurry of action then, a confusion of cries and limbs and blows, the knives dove like hawks and I saw my man fall and suddenly great gouts of blood spurted everywhere. Help him, someone. I leaped out of my seat, I went flailing toward him, he was lying on the boards covered in blood, but all around me hands snatched at me and pushed me back down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t see, muttered voices behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We missed the best part, they said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Surely, I thought, these were the most barbaric people I had ever known.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I was even more horrified for they rose from their seats, clapping and shouting their approval. Even the children had the bloodlust; the boys were whistling, standing on benches to see better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was surrounded by madmen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Feeling ill, I stood on my toes so I could see the platform over the sea of shoulders and shawl-bound heads. And I gasped for I saw the man with the brilliant eyes rise up, his clothes all spattered with blood, and he smiled and faced the crowd and bowed his thanks. He had risen from the dead, and yet he smiled as if it were all a game. I stood amazed, but no one else seemed to acknowledge the miracle, it was mine alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I was frightened. I realized the crowd pushing around me would be disappointed. They had been cheated out of their sacrifice; now they would demand that he be killed again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But they only roared their approval, and I looked around and saw tears on the faces of some of the women; they had been as engrossed as I, their babies draped forgotten over their arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the other people on the stage came forward and bowed their heads, and I saw the tension run out of their bodies, they sagged and their faces relaxed and lost their sharpness, and suddenly they looked as ordinary as the people around me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had to have it explained to me that they were actors, that it was an entertainment, that it was all fancy words and foil swords and chicken’s blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I understood this and felt foolish, but a part of me refused to understand, a part of me clung to the sight of him opening his eyes, rising to his knees and standing and mocking death with a smile and I knew it had been something miraculous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People poured out the doors and into the night. The sky had cleared and the stars were sharp and piercing and seemed close enough to touch. Women walked homeward pressed closer to their husbands than before; small boys made swordplay with sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I paced in circles that night, wearing a path deep in the snow, and in the morning I watched the actors packing up their wagons. They were a traveling theater company, and were on their way to the next town.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I happened to see the young man, black hair falling over his forehead as he washed the blood from his clothes. He looked smaller than he had seemed on stage, but the color of his eyes had not changed. He hung the clothes from the back of one of the wagons to dry, then rubbed his hands together, flexed his fingers. He opened a black case and drew out an instrument; I later learned it was a violin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He tucked it beneath his chin and began to play. The other actors shouted and whistled at him; and three women, they were the three beggar-women who had collected money at the doors the night before, they began to snap their fingers, and they straightened up against the humps in their spines and lifted their skirts high above their bony knees and laughing wildly they began to whirl and dance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then all was ready, wagons piled high and horses puffing in the cold. The actors climbed in and they set out, passing a bottle of liquor around and talking loudly. The young man jumped up onto the back of the last wagon without ceasing his playing for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The music trailed after them a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And after the music faded, the wagon tracks were clear in the snow to show where they had been.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed after.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only because they were heading in the same direction as me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No other reason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked as quickly as I could. Only because of the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When they stopped in the next town I did too, and that night I sat in a crowded hot room that reeked of wet wool and watched their performance. I thought the luster would be gone now that I knew it was all artifice. But instead it was better than before. The young man raved and tore at his hair and I could not take my eyes off him. He was familiar, he touched something deep in me. This time I followed the story more closely, I saw how he was alone and suspicious in a world that conspired against him, how he argued with the queen his mother and cast longing looks at a lady with a thick curtain of golden hair and fluttering hands. I felt a guilty satisfaction when she died.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And at the end, when the stage erupted in noise and confusion and he fell amid flashing swords in a most graceful death, I gasped in shock though I had been expecting it all along. For agonizing moments he lay there, unmoving, and I thought this time, surely, he will not get up. He will not get up. I tried to accustom myself to the thought. It was unbearable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But he did rise, and smile, and it was more miraculous than before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I clapped and clapped, but it was not enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afterward I walked outside and looked at the stars. My cheeks were wet again and I could not understand why I felt so happy and so sad at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People passed me on the way to their houses, eyes thoughtful and faces slack.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Women balanced babies on their hips in that universal posture. I had seen it a thousand times, but tonight it seemed noble and beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Little boys, jousting with sticks. Some things were the same everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt a touch on my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You must have liked it very much to see it twice, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here he was. I could not stop looking at him, it was almost unbearable to have him so close, like staring at a very bright light. The blue eyes were calm, quizzical; he worked his eyebrows up and down until I laughed. He looked so young to me, I was accustomed to seeing men with beards. I looked at his jaw, the cords standing out on his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His black hair hung long in his face and around his ears, his features were sharp and pale from the cold. His clothes were still gaudy with blood from the performance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I like to watch you come back to life, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could do it again if you like, he said. As many times as you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He clutched his heart and collapsed at my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And as he lay there in the snow, spattered with blood, his head tipped back, I saw that he was like the bandit I had met in the woods, years ago, who was perhaps even now lying there buried in the snow with teeth marks on his throat like a ruby necklace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hey there, hey now, he said jumping up. Why are you crying now? he said. I’m all right, see?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took my hands. His were impossibly warm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was looking away, trying to shake my hair forward to hide my face. I felt safe in the thicket, it was dark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He pushed my hair back. The bells tinkled faintly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He grasped my hands again and held them to his chest. I almost jerked them away in surprise for I could feel his heart thumping so strongly it felt like a bird trapped beneath the cloth of his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Snow was falling, again. I could see the black forest, beyond the town, creeping subtly closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where are you from? he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know how to answer that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Have you been in school? he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the way he asked I thought "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("school")]), _vm._v(" was the name of a town. I shook my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried then to tell him the places I had been. It took a long time. Snow clung to his black hair and gave his jacket white epaulettes. It buried our feet. He waited until I was finished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think you have been to school, after all, he said finally. It sounds more difficult than the usual kind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took my arm then, and we went to the rooms where the actors were sleeping for the night. It was too cold to remove our clothes and I slept with my head tucked beneath his chin, where he had rested his violin. I could feel his heart beating through his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning I woke with a start and sat up. I looked at the white vulnerable curve of his neck, his hand cupped beside his face. I did not like to see him with his eyes closed, so still. I touched him and felt the slow thud of his heart and was reassured.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened his eyes then, saw my hands pressed against his chest, and he reached up and pressed his against mine. He smiled. Then the actors came shouting and pounding the walls: it was time to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We rode in the back of the last wagon, lurching and jerking from side to side, our legs dangling. He cradled the violin against his belly, plucking tiny tunes from it with his fingers. His hands were as callused as mine, but in different places.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His name was Shmuel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He asked me where I was headed. I told him about the place across the ocean, the golden gates, the wide avenues and long warm days and the machines that swept and polished the streets of gold every day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyebrows jumped. He laughed and said, yes, those are good stories, I love those stories.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re not just stories, I said. Are they?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is possible to go there, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, yes, he said. I’m going there myself. My sister and I. We are going quite soon, in fact, and we will find work there and set up a home and send for our parents as soon as we can.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My heart leaped up, though I could not say why.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where are you sailing from? he asked, and then spoke of a port city I had never heard of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I’ll leave from there too, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Have you booked a passage yet? he asked curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you have money?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you have papers? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Papers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Identification papers, he said, you can’t go without them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll get some, I said vaguely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened his mouth, but said no more, and we rocked together with the motion of the wagon, it was like waves on a stormy sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Night after night, in town after town, I watched the play. Night after night I waited in dread, gasping and then sighing as he died and came back to life. After each performance it was a relief to see his smile, his crooked teeth, touch his warm skin and feel the blood thrumming through him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every night he rubbed his thumbs under my eyes, wiping away tears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He could not understand it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: How can this frighten you? This show is child’s play compared to all the things you’ve seen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could I explain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We slept in side by side, or back to back as I had with Ari long ago. Until the night when he laid his head on my chest and tentatively slipped his hand under my skirt. Then I laughed so hard his head rode up and down on my breast, because I knew I was wearing such a multitude of clothing, so many layers of skirts and petticoats and underclothes that it was a maze down there and he would never find his way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pushed his head away and stood up, and he thought I was angry but I only wanted to help him. I began to strip it all off, as I had one time before but this time there was no shame in it and I could not do it fast enough. He stared amazed as the rough woolen clothes began to pile up on the floor. The mound rose as high as the bed and still I was struggling with buttons and clasps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally I was free of it all, I could feel my hair brushing against my back and legs, and I felt wondrously light. Air touched me everywhere like a bath. Goose bumps raised up all over my skin but I was not cold, simply alert at every pore. I knelt beside him again and took his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My God but you’re a tiny thing, he said. I would have never guessed. You must carry your own weight in clothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was cold, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He undressed then, and I saw that his body was as finely made and tightly strung as his violin; when I touched him in one place he vibrated elsewhere. I fingered the bones of his back, one by one, and as he pressed hard against me I looked into his ear as if I had never seen one before and it was perfect, whorled and many-chambered like some sea creature.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night I felt something I had never felt before, a pulsing warmth that began low but soon swelled and swelled until it filled me entirely and crowded out all other feeling, and finally when it could not swell anymore it popped like a bubble and died back down and I felt again his hands on my back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought then about the people I had seen, men and women both, and the strange things that women had driven men to do, and that men had driven women to do, all in the name of desire, and for the first time I began to understand it a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afterward when he lay beside me breathing slow and even (his eyes were closed, so I could not bear to look at him) I glanced down and saw that I was sprinkled with hair. Dark curly hairs from his chest that had stuck to my chest and belly. They looked as if they had taken root there, a new field in springtime, as if he had planted a part of himself in me and it was growing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He raised his head then, and looked too, and smiled and said: Be fruitful and multiply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he slept.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the night I heard a trio of voices, screeching like owls and lisping like babies, and I covered my ears with my hands to block out the sound. I was afraid Shmuel would hear them but he slept deeply, with a smile on his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In daylight he said: You must get the papers. You must book a passage. You have to come with us when we sail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said I would. I said I needed to leave him for a while, there were things I needed to do before I went so far away. I said I would meet him later, in the port city he had spoken of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said he would come with me. I said I had to go alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He did not like that, and slept that night with two handfuls of my hair wrapped around his fists.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But you see I had to try once again to find Ari. He was all that was left of my family, I wanted to bring him with me. If he was alive. And I could not bring Shmuel to search for Ari. Strangers frightened Ari, there was no knowing what he would do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I parted ways with the acting company the next morning. I stood by the road as their wagons creaked away and Shmuel sat in the last one angry and disheveled with dark shadows around his eyes. When he saw me watching he stretched out on his back, stiff as a corpse, contorted his face and closed his eyes and didn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That still had the power to disturb me, and I was a moment away from running after them when he broke the pose and sat up and waved to me, and pointed to his eyes as his way of warning me not to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I walked into the forest which grew close on either side of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the same forest I had known all along. I crunched along, calling Ari’s name over and over. My voice knocked against the trees, it rode along the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew he would hear me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, the forest was like a body of water. My voice was a pebble thrown in a pool, sending ripples outward. Wherever Ari was in the forest, my voice would reach him and he would be able to find me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You think this makes no sense. But that is only because you have never been in a forest like this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew he was among trees somewhere. The forest was his home. He could not survive anywhere else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked and I called his name for three days, and on the evening of the third day I heard a crashing in the underbrush and a hoarse animal grunting that was dear to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was approaching. My summons must have reached him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat very still and waited. I did not want to startle him. I wondered suddenly if he knew what had happened to our parents, our brothers and sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He burst into the clearing then and even I who had known him and slept beside him for years was surprised. He had grown enormously in the time since I had seen him, and he stood squinting in the light from the fire, pausing on bent knees as if prepared to spring. The bones of his face had thickened, and an uneven beard grew on his chin and neck. Shaggy gray hair covered his shoulders and upper back. The worst were his feet, they were bare, gray and blue and dead looking, so damaged by frostbite they were solid as hooves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His brows were ferocious now, a thick line across his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But his eyes were the same as they had always been. He knew me, his eyes softened as he studied me intently. I saw a sadness there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I suppose I had changed a great deal as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I beckoned to him then, so I could scratch his head the way I used to. He stepped closer to my fire, and I saw that he had not given up his liking for raw meat—he cradled several large wet chunks in his arms. His mouth was smeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then his smell struck me, massive and musky like a bear’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He knelt beside me and obediently bowed his head. I began to scratch; his hair was now stiff as bristles, and as I scratched I stirred up all manner of things which burrowed in deeper. He closed his eyes contentedly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I began to plan how I would coax Ari onto a ship (I had never seen one myself but I could imagine it), and how I would keep him quiet and fed during a long journey. It would be difficult, but it could be done. If I could explain it to him. If I could make him understand. See how quiet he was now, how serene.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Think how happy he would be in a new land, how free.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I happened to look down and I saw what he held in his arms. There was a large haunch, torn and bloody on one end, but it was not from any animal I knew. It still wore the remains of a trouser leg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sank down beside Ari and watched him. He tore into the meat, chewing contentedly. My stomach knotted suddenly, for I recognized that leg, that shiny shiny black boot. A boot still so well polished that I could see my face reflected darkly while Ari sank his teeth in the other end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw among the pieces of flesh scraps of a uniform, even medals, and if I had any doubts they were quelled when I spotted the riding crop, broken in half and tangled in the debris.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I crouched a long time by the fire as Ari finished his meal. My insides fought among themselves; my gorge rose in revulsion, and yet my spirit rejoiced in sweet revenge and my heart ached with a tenacious love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remembered a thick bulge of flesh above a uniform collar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Remembered how rough it was. How coarse and thick, that skin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even Ari seemed to be having trouble biting through the leathery flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ari was finished, he tossed bones over his shoulder and sucked his fingers then lay down with his head against my thigh. Such a heavy head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could I take him with me? How could I lead him through a city, shut him up in a ship? Shmuel had told me that the promised land was gated and guarded, and you were only allowed to pass through the gates if you had the correct papers. If you did not you would be sent back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could I say to the guard at the gate: No, I don’t have any identification papers, but I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("do")]), _vm._v(" have my brother here, and he has a taste for men in uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not take him out of the forest. The forest was his home, he could not exist outside it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stayed with him through the night, watching him twitch and snarl in his dreams. I remembered him as a baby, how I had held him on my hip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the morning when the first light broke through the trees, sending long shadows across his face, Ari arose and staggered to his feet. He gave me a long last glance, as if he understood, and then lumbered into the woods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard him crashing and grunting for a long time. Then I heard nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not admit to myself then, and do not like to admit now, that I was ashamed of him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was Shmuel, you see. I did not want him to think my family were monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I traveled day and night and made my way to the city on the coast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The air grew warmer the farther I went. I removed layers of clothing and rather than carry them I left them on the wayside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the fields the brown earth showed through the snow. The roads ran with mud.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Spring was coming. I was entering a new place and new season at the same time. Or perhaps it was always spring here. The way it was always winter where I had been.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was feeling hopeful, you see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now and then I took the egg from my pocket and held it to my eye. It felt always warm, as if there were something alive within; and the scene inside sparkled and grew sharper in focus every time I looked. That miniature magical city was the one I was traveling toward; I knew I would find it in the land across the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was getting closer to it with every step. That was why the scene inside the egg grew clearer, more detailed. I could see curtains in the tiny windows, fish in the lake, I could see leaves on the trees, and dragonflies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Making footprints in mud was not the same as footprints in snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw men plowing in the fields. I saw women bent double under great loads of dry branches; they looked like dead trees with legs, creeping along.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of Shmuel, and wondered how I was going to conjure up some papers, and wondered what his sister would think of me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was past midnight when I spotted the city in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I reached it near dawn. I walked in its streets, among the tightly packed buildings. Steep shingled roofs, crooked chimneys, narrow staircases that led nowhere. I could hear my heart beating because the place was so utterly silent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not a single shutter creaking on its hinges.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dust lay in the streets, so thick I left footprints in it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A rustling made me jump. Only a scrap of paper blowing down the street. I saw a face but it was mine, reflected in a shop window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My footsteps echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a wagon without wheels, propped on bricks. Broken shoes here and there in the streets. The great bells in the bell tower had no clappers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No garbage in the gutters except smashed clocks and spools of thread all unwound. A wooden toy dog with a red tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It doesn’t matter, I said. As long as the ship is here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried a door, it would not budge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe I was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel, I said. And I started to run.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Down one street, up another. The dust so thick it muffled my steps. The gutters full of wooden spoons and combs with broken teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw stronger light ahead. I thought it must be the docks, the sea, light reflecting off the water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Would they be waiting? Or was I too late?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I could hear the water, now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Buildings blocking me at every turn. The sun getting ever higher in the sky. It’s a trial; if I can’t navigate a few city blocks, why should I be allowed to go halfway around the world?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I was running toward the brightness, the street straight and empty. I left the gloom of the buildings and plunged into the open air. My feet now were pounding on the wooden boards of the docks, louder than my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Racing to the edge, seeing nothing but the end of the dock, a mad dash to reach it before I took another breath. And going so fast I nearly went over, and caught myself at the last moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked down. And down. And down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Head spinning. Feet kicking out over endless empty space.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Such a vast terrible sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My love. How could you leave without me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had never seen such a limitless sky. So empty, not a cloud in it. And yet the light was tainted, soured, like the light during an eclipse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked down, and the dry updraft blew in my eyes but I looked again because I could not believe it; looked down, and down and down at the dry ocean bed hundreds of meters below.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For there was no water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only an endless deep canyon. The dock I stood on jutted out over the emptiness like an unfinished bridge. I could not see the end of it, the horizon was a dusty haze. I could not take it all in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You would need eyes on either side of your head, like a fish, to see it all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Looking down I saw the ships, far below on the canyon’s floor, listing and broken like fallen birds, tattered sails still hung from some of the masts. Their hulls were pointed toward the horizon, as if they might still sail away. But great holes had been torn in their sides and the wooden innards spilled out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Skeletons, some of them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I glanced back, at the long wooden dock leading to the dark city clinging to the side of the cliff.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If I had seen birds flying over it, that at least would have given me hope.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No birds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You could not imagine crossing such a void. There was not even a crossing cloud to hitch your fancy to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dock swayed beneath my feet. It rested on impossibly long spindly pylons, like spider’s legs, sunk in the ocean bed far below. I saw now how rickety it was, hastily knocked together as if by children. I looked between my feet and saw the old boards bending and giving beneath my weight, nails tearing through the wood like it was flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dock sagged, and below, the pylons were slowly kneeling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran then, feet pounding, and the dock softly collapsed behind me and fell into the abyss below. The canyon was so deep, and the dust so thick, that I did not hear the pieces when they struck the ocean floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I reached solid ground and turned hack, there was nothing left.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I ran then, in a blind panic. I thought I would be trapped in that hateful place forever. The promises I had heard about the land across the sea were all lies. False hopes and an eggshell full of misread visions. A mirage on the horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The land I had seen so clearly existed only in my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran, bells jangling in my hair, my eyes nearly closed, until a farmer driving a wagon full of hay drew up even with me. He offered me a ride but I flailed on, unheeding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He rode beside me, staring. Finally with a decisive grunt he leaned from the seat and his massive arm came swinging down like a scythe, and back up, and I found myself facedown in the hay.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I must have slept.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I woke I opened my eyes to a riot of color, to the frenzy and noise at the heart of a city. The narrow streets were crowded, masses of people moving about, their voices rising in a babbling wave. I had never seen so many people in one place, so many faces, all different, peering over the sides of the wagon. The gutters here were crammed with refuse, rotting vegetables. Buildings rose on either side, confining the din, and women leaned shouting from windows, and I could not keep my eyes on any one thing, there was too much to see as the wagon kept jerking forward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I smelled bread baking, and smoke; I smelled fish, I smelled spices and garbage. Pale-faced boys ran by, whacking each other with sticks and shouting. Dirty water rained down on the street from dishpans, a girl drew on a wall with chalk, flies buzzed, and nearby a horse raised its tail and released a golden load.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What relief.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I jumped from the wagon at its next pause and my knees ached. I wandered through the marketplace, and merchants thrust potatoes and carrots under my nose. Long underwear and stockings fluttered in the breeze. Through these streets I walked for hours, circling, and then I looked up and saw that I was near an open space, an expanse of air and light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And as I made my way toward the light I smelled salt, and fish, and saw gulls circling, heard their cries and the shouts of sailors and the slap of water, and the creaking and rubbing of the boats against the dock. And then I could feel the very ground beneath my feet thrumming from the pounding of the water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stepped out finally to where I could see the harbor, and I could see the sea stretching out into the distance. Nothing can prepare you for that. It was a vast shining plain, a sparkling desert, it was the sky made corporeal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Far on the horizon the sea met the sky in a thin blue line. I had never seen anything so perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The ships were enormous, hulking, they were not the graceful winged things I had expected. The docks were swarming with activity, men loading and unloading goods, running about and shouting. I walked among them dodging elbows and great splashes of water. I saw people walking up the gangway of one of the ships and I ran to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People were calling out to one another, waving, crying, holding children tightly by the wrist. I saw no familiar faces. I watched the ship fill, scanned the crowds packed on the decks. I shouted, but my voice drowned in the others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched as it set out over the shining waters. The sun had laid down a golden path for it to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had not expected everything to be so big. There were so many people, too many, always in motion, always changing; how could two ever find each other?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of wolves in the forest, marking the trees with their scent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited three days by the harbor. I walked up and down the many docks, watching the sailors and the rats. I sat on coiled rope as thick as my arm. I watched people streaming past, coming and going with their luggage and plans. Every time I looked at the water, at the horizon line, my heart leaped up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then on the fourth day I saw a face I knew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was so far away down the dock I could have blotted him out with my thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He turned and saw me and his eyes widened; and then he was nearly knocked flat by a flood of flopping silver fish that poured from one of the fishing boats next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He came running, slipping, his boots covered in fish scales.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here was his face now, what a shock to see it again, black hair standing up on his head. I had to touch that face, it was hot and damp with sweat and his eyes were red. The pulse pounded visibly in the side of his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was puffing too hard to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His familiar smell. How tall he was. I had carried his image in my head so long I’d forgotten how he was in life. How tall, and how long his hands were, hard calluses on the fingertips. His head blocked the sun, he blotted out everything, the rest of the world shrank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve been here looking for you for two weeks, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is the right place then?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes. Of course.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I must have gone to the wrong place at first. I must have gotten lost, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: But earlier you told me you knew this place, you knew exactly where to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said nothing. I did not want him to know how ignorant I was. I had my face against his jacket, a button digging into my eye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should not have gone off by yourself, he said, it’s a miracle we found each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could feel his voice buzzing in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found your clothes scattered all along the road, he said, I was afraid to think what had happened to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He put his hands on my shoulders then, held me at arm’s length.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Did you get the right papers? he said. Did you buy a ticket, like I told you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at his eyes. I was thinking: they are bluer than the sea. But then the sea is not blue at all, is it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You didn’t, did you? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyes hardened then, more metal than blue. He turned, took my hand and pulled me along. He hurried me back to the city streets while behind us the ships rained forth boxes and barrels and bales of foreign things, and sailors swung from the rigging like monkeys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We stopped in a square, before a bronze statue of a short fat man in ruffled clothes. Pigeons clung to his head and shoulders. He stood in droppings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Listen here, Shmuel said. Do you want to come with me, or not?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then why didn’t you get the papers like you told me you would?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I whispered: I don’t know how.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sighed. That’s what I thought, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look here, he said finally. I have my sister’s papers, here, and her ticket, already bought. But she can’t go now. Why don’t you come in her place?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why can’t she come? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s … she’s ill, he said. She’ll be all right, but she can’t make the journey now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What kind of sickness?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: I don’t know. I don’t know. But she can come later, with my parents.… I’ll write to them. I’ll send them the money. When I write to them they’ll understand …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When did she get sick?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know! She’s sick! It doesn’t matter! All that matters is that her papers are here, and you are here, and you’re coming with me. Yes?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at him. His jaw was clenched, he grabbed at his hair. It was not at all like the graceful distress he suffered on the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Can I do that? Isn’t it a lie? Isn’t it wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wrong? he said. That depends on what laws you’re going by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: I’m coming. But your sister—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My sister! Here, take this, he cried and pressed the envelope to my chest and let go; I caught it before it fell. They’re yours now, he said, you’re my sister now. How does it feel?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He caught my arm, and whirled me around in a desperate gaiety. How does it feel to be my sister, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was looking only at his mouth now, his teeth so fine and white, shining like smooth stones in moonlight; stones laid down in a path I would follow anywhere, whether deeper into the forest or all the way home.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Again and again I tried to tell him about the city of dust, the grounded ships like wounded birds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You must have imagined it, he said. You must have been dreaming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: No. Impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There is no such place, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I insisted. I don’t know why. In that city my worst fears had been realized, they had sprung to life all around me. In my frantic dash through those dusty streets I had hoped and prayed that it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("was")]), _vm._v(" all a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it had not been. My throat was still sore, I still found pockets of dust in my clothes. The terrible empty sky was not something I could have imagined on my own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now that I had left it behind I should have been able to forget it. But I couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt I had been granted a reprieve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to forget this gratitude. Did not want to get fat on my good fortune, complacent as a cow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sailed on one of the enormous dark ships we had seen in the harbor. It was utterly crammed with people, hardly a breath of air between. An entire village packed like summer vegetables preserved for storage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the ship pulled away from the dock I stood on the deck, pressed against the railing so tightly I could not raise my arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard a hoarse cry and a splash as the ship slid out to the open sea. Heads turned, people pointed and shouted incomprehensibly. Behind us by the docks I saw arms thrashing, water churned to white. Above or below or in spite of the noise, the ship’s engines, gulls’ cries, waves, voices all around, through it all I heard the swimmer’s grunts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Familiar, perhaps. I could not be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I saw a massive dark head, slick dark hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The figure was growing smaller every second; I would never know for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel standing behind me said: Look, someone’s trying to race the boat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stared out to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Guess he didn’t want to pay for a ticket, Shmuel said. He was waiting for me to laugh. When I did not he said: Not out there, back "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("there.")]), _vm._v(" He raised his arm beside my cheek and pointed to the white foamy spot in the water, tiny now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t want to look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel said: Didn’t you see him? A great tall fellow, he comes running down the docks, knocking people down, he saw the ship leaving and jumped right in. You can still see him, barely, he’s not swimming back. He’s following us out to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t look, I said, it’s making me ill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I turned my back as the land slipped away, I took no final ceremonial look as the continent where I had been born slipped out of sight. Shmuel watched, and waved for the both of us but I turned my back and looked only at him, at the frayed collar of his shirt and the underside of his jaw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to see that spot of white in the water, that last reminder of what I was leaving behind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not get ill on that voyage though most of the passengers did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found the rocking motion of the ship soothing. It was like a child’s cradle, an old woman’s rocking chair. Rhythmic and endless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel did not fare so well. Sitting together in our tiny berth I watched his face turn ashen, then greenish. I brought him water and did what I could. We were traveling as brother and sister, and we were never alone, so I could not do many of the things I wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One early morning he sat up and said abruptly: My sister was not sick.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My sister. I lied. She was never sick, she was ready to make the trip, but when I went home to collect her, I took her papers and left without telling anyone in the middle of the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why? Why did you do that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took my face in his hands, roughly. I felt the calluses on his fingertips all up and down my temples.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why do you think? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He turned his head to the wall then, and closed his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went out on deck, which I did as often as possible to check our progress. No one else came out, the wind was fierce and cold and during choppy weather showers of spray rained down. But I liked to go out, and get my bearings as the wind pushed me back against the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every day looked the same: no land to be seen behind us, and none before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only the same gray flatness, with our ship in the exact middle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After a week of this I said: I think I should tell the captain. We’re not moving. The ship is stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel laughed and stroked my hair. The room was so clamorous you could not hear the bells. Day and night there were loud voices, laughter, babies crying, sounds of love, sounds of retching. Men gambled and smoked their pipes and the haze rose to the low ceiling and curled in corners.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He spoke again of his family, saying: I’ll write to them as soon as we arrive and explain. I’ll work like a dog, I’ll raise the money and send it and arrange for them all to come. Where we’re going the people love music and they love to throw their money away, there are theaters, dancing-places, I’ll play in the streets if I have to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Will your parents be angry? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He laughed bitterly. What do you think?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He mentioned them again and again, sometimes even in his sleep. This was the only way, he begged in the night, it had to be done, there was no other way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So you see we both had ghosts from the old world following us to the new one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Happiness touched by guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We held each other as the ship rolled and dipped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We tried to hold each other as a brother and sister would. That was difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was impatient all through the long hours. I wanted to learn English. Shmuel tried to teach me a few words. But all the words he knew came from songs and love poems, so they were of little use. Later I could use them in the bedroom, that was the first place I became fluent. In our new bedroom I recited the words to him over and over until he cried "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("yes, yes, that’s it, that’s perfect, oh yes")]), _vm._v(" and the floorboards shook.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But on the ship the most powerful words he taught me were "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("yes")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("no")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("thank you")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("America the Beautiful.")])]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("By the time we arrived Shmuel was a skeleton with a ruffian’s hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were no great golden gates to welcome us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Instead there were endless rooms, hordes of people as confused as us clutching their possessions and trying to shape their mouths around questions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were long lines in which we waited endlessly, only to be told to wait in other lines. People assigned numbers to us, pinned paper tags to us as if we were animals or packages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was inspected by a doctor who peered into my eyes and mouth and was mystified by the jingling in my hair. He said he had never in his life seen anything like my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took this to be a compliment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An inspector spent an hour shaking Shmuel’s violin, peering inside, holding it up to the light. He thought there might be something smuggled inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing but music, Shmuel said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later we stood before two inspectors who peered at our papers through thick glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You do not look twenty-seven years old, one said to me suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s kept her youth well, hasn’t she? Shmuel said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The other inspector said: Is she really your sister?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course. Unless my parents have been lying to me all these years, Shmuel said and worked his eyebrows up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not think it was a time for joking, but the inspectors only glared and waved us on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We spent four days waiting in lines. We were given new papers, with strange new names written on them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then we were taken outside and set free.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The apartment was two narrow rooms in a tall crooked building on a street that was crowded day and night. There were only two windows, each the width of a single pane of glass. But every afternoon the sunlight fell through those windows and lay in golden liquid bars on the floor. I loved it, I wanted to sweep it up and save it for another day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sounds of the city crept in everywhere, street traffic and horns and the cries of vendors and children, and a deep subterranean rumbling that seemed to arise from the cobblestones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The stairs were impossibly steep, you had to lift your knees to your chin to climb them; they moaned and reeked of garbage. At first I felt uneasy living so high off the ground, but I grew accustomed to it quickly, as I did to so many things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone in the building had come here from elsewhere, like us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many spoke a language that was familiar to us, and the cooking smells that wafted in the alleyways smelled of home. I saw women who wore their skirts as I did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then there were those others who spoke in fantastic tongues, who had eyes and skin like I had never seen before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where are the Americans? Which ones are they? I asked Shmuel every day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And every day he said: Look around you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The city was far too vast to see all at once. I had to concentrate on one corner at a time. The street where we lived, the neighborhood around it, occupied me for years. The shops and bicycles and men on stoops and women calling in the night. Stray cats that screeched like children, children who bit and scratched like cats. Bread baking. Blood from the butcher shop running red in the street. Ash bins and organ grinders and laundry strung high across the street. Buildings like ours full of apartments, each window wearing a different set of curtains, each window pouring forth different music, a different conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the summers we slept outside on the fire escape. The black struts and beams were like tree branches against the sky. They cut the sunset into pieces so that it looked like a stained glass window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one knew us when we moved there; we lived as man and wife and no one questioned it. Why should they?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later, when we had settled and Shmuel was working, he told me he wanted to get married. Officially.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But how? There was the matter of our identification papers which declared us brother and sister. How would we get around that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They might send me back, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: Don’t be ridiculous. Then: Don’t you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("want")]), _vm._v(" to marry me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said. That was all I could say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He knelt right there in the kitchen and pulled me closer and buried his face in my dress. Marry me, he said. My hands were covered with flour. I looked down at his dark tousled hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: All our neighbors already think we’re married. What will they think if they see us getting married again?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’ll think we’re mad, he said and lifted me up, spun. My head grazed the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I gasped: If we say we’re married, then we are. We don’t need papers. Saying so makes it real. We don’t need to do any more than that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had my floury hands on his head now to keep from falling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was waltzing us around in the narrow space between stove and table. Up, down, up, like a stormy sea. He knocked over a chair. I was laughing too hard to breathe. Our neighbor below knocked at her ceiling with a broom for the tenth time that day and shouted for us to be quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We’re married, I said, it’s done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stopped his spinning and let me slip suddenly so that we were face-to-face. But what will we do when we have children? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I guess we’ll just "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("have")]), _vm._v(" them, I said. And enjoy having them. And have more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at him and saw that his hair was dusted with flour from my hands so that it looked gray. This is how he will look as an old man, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To see him as an old man. That was all I wanted anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Those years all blur together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That golden light everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a roundness, a fullness to things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I forgot the egg, it lay deep in a drawer. I did not need to look inside it to see happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is only with bad times that you remember every detail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those good years do not make for good stories. You are bored already, I can tell. You like to hear about the friction between people, the heat. It’s the harsh words and rough edges that snag your attention.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel found work in the theaters. He accompanied musicals, vaudeville acts, ballets, anything he could find. He learned the music quickly, practiced in the apartment in the afternoons before heading out to the shows. He had no proper suit; I had to piece one together from cheap cloth thin as paper. From a distance you could not tell the difference. We covered his brown boots with black paint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These theaters were gaudy as palaces, everything gold, red plush seats, fat cherubs holding up the stage, heavy velvet curtains. I did not like them; the finery was false, the gilt paint I could chip off with a fingernail and beneath was plaster. The red plush of the seats was worn thin in the shape of people’s hindquarters. And I could not see Shmuel, he sat in the pit and I could not pick out the sounds he made from the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I liked to go to the tiny theater in our neighborhood where plays were performed in the old language. Shmuel acted in these when he could. The closely packed benches, the heat, the crying babies and smell of wet wool, all so familiar. The man I knew became a stranger then, he was a king and a pauper and an angry father and once, in an emergency, a vain stepsister in paper curls and a purple gown. I saw him sing and dance and weep, I watched him take a woman in his arms and speak words of love. I saw him die, over and over. I knew it was a play, it was all artifice and tricks, and yet I thought there was something real in it, something more pure and true than the life outside on the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I slept with my ear to his chest at night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He grew a mustache. He still looked like a boy to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He still left his curly dark hairs scattered on my belly after he had lain against me. Whenever he noticed this, my belly like a field sprouting in spring, he would say as he had before: Be fruitful and multiply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He liked to say that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And soon I was. And soon we did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My belly swelled and my skirts grew tight. I hitched the waistbands higher and higher to accommodate the ballooning, until the day I realized I was wearing a skirt with the waistband just beneath my breasts, the hem barely reaching my knees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I made adjustments then but still my body expanded like dough rising. I recalled my mother’s indiscernible pregnancies, and I could not understand it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my mother when my back ached and my feet swelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remembered the time I had seen her give birth. I remembered it too clearly; I wished I had forgotten that. It was one of the many memories I wished I could pluck out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At least I would not have to watch it this time, I would have my eyes on the ceiling above my bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My belly was enormous. I had to stay in the apartment, I could not manage the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was summer, and I had never known heat like this. Drops of sweat crept over my skin like insects. I was baking bread, the kitchen was like a furnace. I had knotted up my hair but half of it had escaped and lay plastered to my face and neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not imagine a world of snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Strange how we adapt so quickly to a new climate, and the old becomes a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Earlier in the pregnancy I had thought of my mother’s punctual certainty, the way she laid down her work and headed for the bedroom moments before birth. How had she known? I had worried that I wouldn’t know when my time was about to come. An idle fear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When the time came I knew, I have never been more sure of anything in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was lowering myself to the bed when Shmuel came home. He rushed to my side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I screamed at him to get out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m going to stay right here with you, he said. I’ll hold your hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get out, get out, it’s bad luck, I cried.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s an old wives’ tale, he said, stroking my head unconcernedly. When are you going to give up those old superstitions? You’re living in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t stay here, I said. We’ll be cursed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can you prove that? he laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother giving birth in the street. Frozen bodies piled up like cordwood, the village a black scar in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To him I said: No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll help, he said and went to the stove to boil water. He did not know what to do with it, only remembered from his own childhood that boiling water always accompanied a birth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He boiled pots and pots of it, lined them up on the floor beside the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get out, I said when he staggered in with the laundry tub filled with hot water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Out, I screamed and hurled one of the pots at him. Steaming water splashed the floor and the pot clattered against the wall beside his head. He stared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Out, I said again and heaved another pot. This one glanced off his knee. He let out a bark of pain then pressed his lips together. Why couldn’t he see that I was trying to save his life?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I picked up a third pot and then dropped it with a cry because the contractions had begun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: I’m not having it until you leave, I swear. I’ll hold it in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at me, and for a moment I saw an expression on his face that reminded me of my father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m going to find the doctor, he said, I’ll send in one of the neighbor women.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He backed away and I heard his running feet on the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was glad when he was gone. I could scream as much as I liked without frightening him. Screaming felt very fine. My lungs felt strong. The floor was awash in hot water; the uneven floorboards sent the water rolling to one corner of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The neighbors both above and below were knocking with their brooms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My belly had a life of its own. It bubbled and boiled. It was a sackful of puppies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Things were shifting, sliding around. Things were not lining up correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, there were two of them. I should have guessed before now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were two of them, and each was fighting with the other to be the first out of my womb.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The struggle went on a long time, and as no doctor appeared and no Shmuel either I saw no reason to stop screaming, since it seemed to clear my head. Water rolled from one corner to another, as if the entire building were swaying. As long as I kept up the noise, my neighbors up and down kept up their knocking, and I watched a hairline crack appear and grow in the ceiling plaster above my bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the afternoon passed the sun fell through the windows and lay across my belly, and I thought it turned my skin translucent, I was sure I saw two heads within and the tiny raised fists.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Incredible pressure then and my hipbones creaking in protest. I felt their heads. Side by side, they were trying to butt their way out of my body. Simultaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Such pain then that I thought it could not go on. It could not go on. It was not possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it did. For quite a while.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am telling you these things just as my mother told me when I was your age. I can see that it repulses you, just as it did me. You are making a sour-lemon face. But I am telling you for your own good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched the crack widen and branch out across the ceiling, like something about to hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The two heads battled for entrance to the channel. They were at a stalemate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly there was enormous pain and then relief, as the first shot out of my body with the second on his heels. The two of them were lying in a stew of juices between my legs, and chunks of plaster began raining from the ceiling, and just then there were drumming footsteps and Shmuel burst into the apartment with the midwife from a nearby neighborhood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had dark skin and a deep voice that was like music though she spoke too quickly for me to follow. But her hands were wise and capable, they smacked the babies and made them squall and then cleaned them with brisk efficiency. She laid cool hands on me, and did what she could with the soaked, plaster-strewn bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lord, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She bundled the babies in blankets and laid them both in Shmuel’s arms. He stood amazed and terrified as first one and then the other began to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took them then, and my arms were full.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In all the confusion no one had seen which was born first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were black-haired boys, and we named one Eliahu after Shmuel’s grandfather, and we named the other Wolf, which was my father’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One named for animals, one named for prophets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One for the body, one for the spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were identical in appearance but opposites in everything else. They had entered the world wrestling each other and never stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When one cried, the other cried louder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whomever I nursed first would drink all the milk and leave nothing for his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Time passes quickly when you are watching children grow up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While I’d been pregnant I’d pictured myself doing my work with my future child propped on my hip, as my mother had done, as women have always done. But I had not planned on there being two of them. I did my best to hold them both, one on either hip, a balancing act. By the time I mastered this trick they had grown too big for me to manage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed Eli and Wolf went from sitting to crawling in the time it took to blink, went from crawling to walking before I could catch my breath. I turned my head for a moment and when I looked back I found them in short pants and button shoes, shouting and dueling with sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were fierce, my boys. They had thick black hair at birth; it fell out the next day and grew back even thicker, hair like a crow’s wing. They had dark eyes like mine and Shmuel’s sharp features. How quickly they grew. I would piece together a shirt for one of them, and by the time I finished sewing it he would have outgrown it. Great hairy wrists sticking out of the sleeves. Brand-new jackets, straining at the shoulders. I grew accustomed to the sound of ripping cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How they ate. They devoured everything like wildfire. I did what I could, but it seemed they were always hungry. There were many evenings when I had not prepared enough, and Wolf and Eli prowled about scraping the bottoms of pans and licking their fingers to trap the last crumbs, and casting dissatisfied glances all around, and Shmuel would joke that he feared for his life. Don’t bother with me, boys, I’m all bones, he would say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They grew so quickly. Sometimes in the night I would hear them moaning because of the growing pains in their arms and legs, their growling stomachs. First one would shoot up, then the other. It was as if they were racing, to see who would be the first to bump his head against the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel could not understand it. He was a slight man, narrowly built. Me, I had stopped growing early. And here we had two sons who towered over us. Shmuel often said: Where in the world did they come from?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my family, my father and brother. It all made sense to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel said: It’s because we’re in America. Everything is bigger here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he said: We should have another child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said this often.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the beginning he played his violin for the boys and they would listen enraptured. He played theater music, waltzes and dance tunes, and when he played fast jigs and reels the boys danced for him, jumping up and down imitating the organ grinder’s monkey with their caps held out for coins. Even when they grew much older, and forceful in their opinions and impatient with everything, the music still had the power to tame them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They adored their father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Partly, I think, because they saw him so little. He had to work so hard then. Every moment he was home was an occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want a house full of little monkeys, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The boys were still small then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another time, apropos of nothing: Are you ready yet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And later he said nothing, simply asked with his eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At night we shared our bed as we always had, and his body seemed to grow more beautiful to me as time passed and the years polished his bones. We were happy with each other, and regular in our habits; night after night he emptied himself and then half jokingly addressed my belly, imploring it to be fruitful and multiply. So he could not understand why I did not conceive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew why. My mother had taught me well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want another child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, I did not want to have to share my attentions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to give all I had to my sons. I did not want to divide my love among a horde of children so that each got only a splinter. I did not want a houseful, a shoeful of children, children whose needs would overwhelm me, whose names I would forget.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to know my children. I did not want a faceless litter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to explain this to Shmuel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let’s just have "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("one,")]), _vm._v(" then, he said. One more won’t make a difference.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel’s eyes were unfaded, still that startling blue. I had hoped our sons would inherit them, but no.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just one more, he said. Eli and Wolf should have a sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said nothing more, and I knew he was thinking of his own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A month after our arrival in this city, and every month thereafter, Shmuel had written to his parents and sister. He had sent them money regularly, had begged them in the letters to come join us. He offered to arrange everything if they would give their consent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a year they did not answer his letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He continued to write, and to send money though there were times when we could have used it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eventually he received a note from his sister. In two blunt sentences she informed him that she had married a local man, and that her parents wanted to live near her rather than with their irresponsible former son in an unknown land.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At the bottom of the page she had added as an afterthought that she was expecting her first child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel read me the letter and then never mentioned it again. But he continued to send money to his parents, and perhaps also wrote to them, and in his sleep he argued with them endlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had photographs made of our boys, uncomfortable and scowling in their best clothes. I had seen photographs in the newspapers, but never seen photos of people I knew, never held them in my hands like this. Shmuel took them all from me and sent them to his parents.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("There was no forest here, no snow like that all-encompassing snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were no journeys to be made.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We never left the city. This city was all of America to us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We began to accumulate things: cast-off furniture from our neighbors. A radio that almost worked sometimes. Shmuel saved for years to buy a violin, all golden wood and graceful curves and smooth varnish, though he still cherished the old one and played it sometimes so it would not feel left out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My hair. I trimmed it. You could still hear the bells, now and then. Though that part of my hair should have grown out long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I grew herbs in little pots that I lined up on the windowsill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the summer evenings women gathered on stoops and fire escapes to gossip. I never thought to join them, but their voices were comforting; I remembered my village and the women talking over fences, whispered confidences.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel and Eli and Wolf were my whole world then, and it was all I wanted. I still looked at my sons sometimes with awe and wonder; to think that I made these amazing creatures, they came out of my body. Look how they run and jump and think for themselves. Never mind that their faces were dirty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My boys had made the city their playground. They ran with other boys in packs, shouted and fought and stole rides on the streetcars. Nine years old and they were smoking cigarettes and picking fights with boys twice their size. Shmuel forbade them to do these things, but I knew they did them anyway and I was secretly proud.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted my boys to be ready.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ready for what?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They spoke one language in the streets and another to their parents and did not think it strange. I was trying to learn but slipped back into the old language when the new one failed me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Watch me, watch this! Wolf said as he balanced on the railing of the fire escape, and then hung by his knees, six stories above the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I applauded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daredevil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, watch "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("this,")]), _vm._v(" Eli said. He stood on his head till his face turned a rich mahogany color, legs pedaling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Very good, I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had always been the more cerebral of the two.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hug Wolf, briefly, perhaps kiss his brow before he ducked. Wolf liked to be touched. Eli was more aloof in that way. I could hug him only at bedtime, lights off. Both were stiff and manly in their father’s presence, brushed off my caresses. Out in the streets I was not allowed to hold their hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would have smothered them if they had let me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I was also proud of their pride, their uplifted chins and boxer’s stances.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At home they argued incessantly, pummeled each other. But on the streets they were inseparable, they were each other’s staunchest defenders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were like that from the start. When they were a few weeks old Eli began choking, turning blue in the middle of the night, and Wolf screamed and screamed until I woke and came running to help. By the next morning Eli had recovered and his brother was kicking him in the head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was so happy then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps the contentment made me less vigilant. Perhaps I let down my guard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps I was careless with my mother’s preventive medicine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whatever the reason, I discovered I was pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The boys were nine years old then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could have gotten rid of it, but I did not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to have the baby, but I wanted to be able to tell Shmuel and see his face light up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I did, and Shmuel, who had given up hope, was beside himself with joy. I had never before seen tears in his eyes. He brought out his violin, tucked it under his chin, but was too overcome to play.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wished there was a way to give him the pleasure of the good news without actually giving birth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But there was not, so I had to proceed with a pregnancy I did not want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did it for him. It seemed a small thing to do, in exchange for his happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would have done much greater things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My belly swelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My boys. I knew I would be distracted, I would neglect them, they would despise me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But all through the pregnancy they went blithely about their business, did not seem to care that I had less time for them. In fact they seemed happier with their increased freedom, they roamed farther afield, came home smiling with slingshots and black eyes and enormous appetites.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This pregnancy was so easy compared to the last. The unborn baby so docile I wondered if it was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My feet swelled again, and I craved foods I could not name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went to the marketplace in the Chinese neighborhood and passed among the stalls staring in wonder at fantastic fish, bright orange ducks, skeins of noodles, seaweed and mushrooms in nightmare shapes, incense and sandals, searching for something to satisfy the craving.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The streets were loud with voices and I could not understand a word. I was used to that, I had felt it before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was studying the painted kites shaped like fish and dragons, wondering how much they would cost and how my sons would love them, when I heard my name spoken, felt a hand on my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The voice was soft but in that place full of foreign tongues my name pierced like a scream. The hand on my arm was a pure ungodly white. Like snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned and saw a woman with a face as pale as the hand, her head bound tightly in a scarf though I saw strands of red-gold hair escaping and blowing across her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She pressed close, peered at my mouth. I smelled her breath. She would have pressed closer but my belly stopped her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Snow and trees and men baying like hounds in the night. Here it was again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood there surrounded by Chinese matrons and vegetable stalls and the heat and stink and traffic of a summer afternoon, but I was not there at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya. Her face had sagged, her flesh grown heavy. She looked human now, no longer the ethereal creature trapped in a room of lace like a butterfly in a spider’s web.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The last time I had seen her was when the soldiers had carried her away. To press her into service, they said. She had not looked back; her stumpy legs had bounced against the horse’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She followed my gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I bought these, she said, lifting her skirt to show me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re not perfect, I’m no dancer, she said and showed me her cane.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I wanted to be able to buy pretty shoes, you see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not meet her eyes. I looked at her hair and remembered how I had hacked at it with the ax.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m glad to see you still alive, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, she said, I’m alive and I’m here. Double happiness, as the Chinese say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her voice was harsh, the color of her clothes a bit too bright. I could not look at her without squinting. She wore rings on every finger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You are doing all right, I see, she said and touched my belly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A chill ran through me. I thought I had left my home behind me forever, traveled over land and over sea, beyond the barrier of papers and visas that was higher than any gate. I thought I had escaped that place. And now a piece of the past had caught up with me, was breathing my air, was touching my future child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ve found yourself a man, she said. Good for you. I never would have thought …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at her fully then and saw that she had a shrewdness she had not had before. She had learned something, and it had hardened her. I looked again at her clothes, at the sweat running down between her breasts, and I saw that she was a woman who used men for business. I saw she had nothing but contempt for them, sought only to profit from them and break them. Beneath her sagging beauty she still had the power I had once envied, the power to manipulate men.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was something I no longer wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remembered how she screamed, how she brought violence and despair down upon us when she screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was suddenly afraid she would do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just behind Anya I saw a Chinese man gutting a huge fish with one quick stroke. The intestines burst forth inevitably, uncontrollably, there was no way to hold them in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I must be getting home, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She read my face and stepped back, turned to hobble away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to help you, back there, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: I know you did. And now I can offer you my help. If you want it. There are things I can do for you, you only need ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She smiled and touched my arm, said: You know, inside we are not so different, you and I.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could she say that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had disappeared in the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had lost my appetite. My belly felt cold at the spot where she had touched it. The child inside shifted restlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This time when the labor began I was certain Shmuel would respect my wishes to stay away. But instead he removed all furniture and knickknacks from my reach, summoned a doctor, and knelt beside me through the whole process.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to die from the shame of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not one but "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("two")]), _vm._v(" men bearing witness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A bad omen. I kept telling them what evil luck would befall us now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They laughed at me. Come out of the dark, the doctor said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The birth was swift and easy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A healthy baby girl, the doctor said. Do you call this a bad omen?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He held her up by her heels and she bawled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get him out of the apartment, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel saw the doctor out, and when he came back I said: You have killed us all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He thumped his chest and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I held the baby and she spat at me. Her thin hair, her beaky nose, her hands curled like claws. She seemed tainted to me, the past had touched her and dirtied her somehow. She was not pure and new like my sons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was wrinkled and bitter, born old.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later I put her to my breast and she bit down hard with sharp gums.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel put his arms around me. Me and her both.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A daughter, just like we wanted, he said and his face shone with happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to smile with him but I felt uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told myself I would love our daughter for his sake. This was what he wanted, and he was what I wanted. It was an exchange. I would balance it out this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I felt nauseous, because I was thinking the way Anya would, I was thinking of people as pawns, to be moved about and toyed with. The last time I had reasoned this way was the night I offered an officer my company in exchange for my brother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My body clenched then, I gagged and vomited up bile and blood, and Shmuel swept the baby out of my arms just in time, and I felt stinging pain on my cheeks from the tears, tears that burned they were so salty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We named the child Sashie, after my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She never liked to ride on my hip. She did not fit there properly, somehow. She preferred her cradle, or her father’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My boys were men now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In body at least, and their minds were catching up fast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We still lived crammed in the same apartment; Eli and Wolf filled one room, Shmuel and I slept with the stove and the kitchen table, and for Sashie there was the hidden closet we had made into a bedroom for her. We had heaved in a mattress that was too big on all sides and climbed the walls. She plastered every surface with photographs of film actors and actresses, and spent hours in her room stargazing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She kept the door shut. A sulky girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the mornings and evenings the apartment was loud with my sons’ clumsy bulk, their boots the size of wheelbarrows, the banged elbows and slammed doors. Their deep voices, berating each other and teasing their sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel had bought them razors that they cherished, and all three shaved together in the mornings, clustered around the bit of mirror, the black-flecked blobs of lather raining down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf had found work on scaffoldings and cranes, building the skyscrapers of the city. Eli worked down on the docks, loading and unloading and repairing the ships.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One loved the sea, one loved the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One wanted hot tea in the evenings, the other craved cold milk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not understand why people called them identical twins. They did not look at all identical to me. Even from a great distance I could tell them apart; the very shapes of their bodies as they moved were different. They curved distinctly like two different letters of the alphabet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was finally learning to read, you see. But slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were so close, those two, they had a rough bawdy friendship but it ran deep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They began to notice women now, and women began to notice them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the evenings they combed their hair carefully and went out. There was an urgency about them then, a heady impatience and a lightness in their feet as they clattered down the stairs to the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf and Eli no longer did stunts to impress me. Their minds were on other things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was glad. It was the natural way of things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At first I worried. About the women. Because of the power men and women have over each other, the way desire can drive people to ruin their lives, break down the bonds of family. A woman, I thought, might be the one thing that could turn this inseparable pair against each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My sons had always been so competitive, you see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I feared what they might do to each other if they desired the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I soon discovered I had no reason to worry, because their tastes were so different. Wolf adored older women, the motherly ones who were sedate and sturdy and radiated wisdom and smelled like yeast and butter, the ones who would hold him against their large bosoms and kiss him on the forehead rather than the mouth. Eli chased the younger girls, the shrill flighty ones whose eyes were never still, whose hands clutched everywhere at once, who sheltered beneath his great arm like birds from a storm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept forgetting about Sashie. She lived in the shadow of her brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was a strange girl, tall for her age and angular with limp hair that she brushed for hours. From an early age she liked to play at make-believe, at creating worlds of her own to live in. She sat in her room calling herself a princess in a tower, a queen on a throne.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And even when she was not playing, she tended to invent her own version of events around her, twisting the truth to her liking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For example there was a long period when she was convinced that her hair was naturally blond, and that it was merely dirt, or some trickery of her mother’s, that made it look black. She would wash and wash her hair, then rub it violently dry, checking the towel to see if the blackness was rubbing off as she tried to return her hair to its original state, the blond curls of her cinema idols.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her brothers watched her quizzically night after night, scrubbing and rubbing her head, whisking the towel fast as a shoe-shine boy. When I told them what Sashie thought she was doing, they laughed uproariously and she fled to her room red-faced and ashamed for she worshipped her brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("They")]), _vm._v(" had laughed, but afterward she was angry only at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did not give up the hair notion for a long time; she stopped her obsessive washing but told herself the blackness would eventually grow out, and she inspected the roots of her hair carefully using two mirrors, searching for a hint of gold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was something I could not understand, the way she refused to see the truth that was right in front of her eyes, how she lied to herself without knowing she did.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("All this time, all these years Shmuel had continued to write to his parents. Sometimes he lingered over the letters late into the night, head propped in his hand. He still sent them money. They never answered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He received the odd letter, now and then, from his friends in the theater company; they passed along news. From them he heard that his parents were still living in the same house, the house where Shmuel had been born and his father too. He heard that his sister now had seven children who labored in their father’s bakery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The thought of his nieces and nephews plagued Shmuel; he wrote to his sister begging her to send some of her children to us to raise here. He wrote: Your children have no future over there. Surely you can see that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later he wrote: I will pay their passages. We could adopt them. They can have a life here that you cannot even imagine. At least ask the older ones. Let them decide for themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister never responded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of these phantom children, dusted with flour and white as ghosts. They stood around our bed at night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He continued to write to his family, more and more often as we heard the rumors of what was happening over there, the whispered rumblings of the dark tide rising up and threatening to wash over everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The newspapers droned of war with their tiny print and blurred photos of a man in a mustache with his arm outstretched. Newspapers were a reliable source of the truth, apparently. Shmuel and Eli and Wolf read them and argued far into the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Me, I did not trust printed words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Along with the papers there were the rumors we heard, the letters, and the words of frightened travelers who had managed to slip away and sail across the ocean. They came here in their shabby coats, moved in with relatives and disliked to go outside. They shunned daylight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These people with their haunted eyes, casting suspicious glances everywhere, they tried to tell us things but could not find the words. There was no language excessive enough to describe what they had seen. No words wide or deep enough to hold it. Stories so fantastic, so sweeping in their atrocities that no one could believe them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one wanted to believe them. Our neighbors, and even Eli and Wolf, said: They must be mad, these people, seasick and frightened, spewing nightmares and visions. These stories cannot be true, they are fairy tales told to frighten children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That is what people said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I have seen many things. I know that anything is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These stories the new arrivals told, they were too hideous for anyone to have made them up. No mind could twist itself like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have told stories that no one believed. Stories I know in my heart to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel voiced no opinion, but his eyes were sunk deep, lost in shadows, the color muted. His hands shook, the skin worn thin and transparent over his knuckles like trouser fabric worn through at the knees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to hold him, those tensed shoulders. I wanted to comfort him in bed in the dark of night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But lately he did not sleep at all, he sat up through the night at the kitchen table, writing letters to his parents and sister, beseeching them, begging them to save themselves, come over before it was too late. He wrote: You don’t have to forgive me. Come for your own sake, the sake of the children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sent the letters though he despaired of their ever arriving. He sent money. And more money. More than we could spare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the night sometimes he looked up from his writing and I felt his eyes travel over my body and shy away from my face. There was an anger in his look that I had never seen before, an accusation. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("You made me do this. See what you drove me to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister’s identification papers, they hung between us like a shroud.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I will say for him that he never raised his hand in anger, never spoke a word of blame to me. But there was a cloud over our relations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We both thought of home now. I thought of Ari as I had not in years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our life here seemed false and hollow, suddenly. Our children with their vigorous health and appetites were a mockery of something.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("More refugees crept into our neighborhood. One moved in with the elderly couple who lived two floors below us. She was a young woman, the wife of their nephew. Or so she claimed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The old couple had not seen their nephew since he was a child. But they took her in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were too stunned to object.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, she came to their door in the middle of the night, she came pounding and crying out until the entire building was aroused. We all came out in our nightclothes, barefoot, complaining, stood squinting in the hall, on the stairs. Her appearance shocked us all to silence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We could see that she was young, perhaps not yet twenty; her body was starved but still had the pliancy of youth. Her skin un-ravaged. And yet her short-cropped hair was stark white.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spun about and regarded us all. Her eyes were the most frightening thing: the pupils shrunk to pinpricks, utterly cold uncomprehending eyes, unmoving as if they had frozen in a moment of unspeakable horror.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She turned to the old couple then and told them that her husband, their nephew, was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They swiftly took her in their arms, pulled her into their apartment and shut the door. The rest of us slowly drifted back to our beds, to uneasy dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But over the next few days many of us returned to that apartment, to listen to this woman’s tales as she sat dwarfed by an overstuffed chair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spoke of hunger and cold and disease, and these were things we could all understand. The confinement she spoke of, the sudden violence—we all had known that. But she also spoke of a world where logic had gone awry, where babies were taken from mothers, husbands separated from wives, gold teeth drawn from living mouths, bodies piled up like haystacks, hay made into soup, people given numbers because names were an indulgence. A place where great fires burned constantly, black smoke filled the sky yet everyone was dying from the cold. A place of dogs and casual bullets meeting the backs of heads, everything as arbitrary as the made-up rules in a child’s game.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Telling us, she laughed at the absurdity of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her pupils never dilated, not even in dim light, as if they were holding something in; they were the eyes of an animal that feels the cold shadow on its back and looks up to see the hawk coming down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Impossible, my neighbors whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Madness, they said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spoke on and on of these unspeakable things, gasping, babbling, letting out barks of laughter and choking on her breath. She could not get the words out fast enough, an endless stream; she watched us, her hectic eyes jumping from face to face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She inhaled endless slices of bread and cups of tea, seemingly without pausing in her speech. She loaded her tea with sugar, she piled it on bread, she ate it from a spoon, her eyes rolling in a kind of holy ecstasy. She licked her fingers, she could not eat enough sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s mad, people said. Her mind is gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked it, with her fingers in her mouth and sweet dribble on her chin. But even then you could see the beauty in her features, the grace of her thin arms inside the cheap dress. Her beauty clashed strangely with the ugliness etched in her eyes, with the raised scars on her neck and on her scalp beneath the white hair. Like fungus growth on a ripe fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She would not tell us how she escaped from such a place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When we asked she said only: I pretended I was dead. It was not difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She ignored our questions, shook her head violently when we began the litany of names: have you seen … did you know … what happened to … have you heard of …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She droned on and on, shrilly, her hand going from sugar bowl to mouth, again and again the touch of grainy fingers to her tongue like a benediction, and she closed her eyes in bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One by one the neighbors stopped coming to see her. This mad girl whose stories they did not believe, or did not want to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if to acknowledge these things would make them real; whereas denying them would somehow hold them back, keep them confined to the space inside the girl’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had brought the darkness close, brought it into our lives and living rooms and set it loose. People thought she was to blame somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This mad girl stuffing herself with sugar like a child, this girl who would not sleep for fear of her dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat with her long after the others had turned away. I watched her pluck at her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Within weeks her teeth rotted away, and then her face was more jarring than ever, with the white hair and blue gums of an old woman, and the lips and cheekbones and eyelashes of a young one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She ate up her aunt and uncle’s sugar ration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Although they doubted more and more that they really were her aunt and uncle. To doubt her was to believe their nephew was still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I spoke to the reluctant aunt on the stairs, she said softly: If only she had some proof. Something to prove those stories. I would believe her then. How can we be sure? She doesn’t even have a wedding ring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hid my hands when she said that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched her trudge down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Couldn’t they see, the proof was right there, in the girl’s flesh, in those eyes, in that hair gone white from shock. What more proof did they need?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That evening I sent Eli to their apartment bearing the last of our sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stayed there several hours and was silent when he returned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next evening both he and Wolf went down and sat with the mad girl as she lisped through her gums, her tongue thick and coated with sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They returned again and again. They were fascinated by her decaying beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They listened to her stories night after night. They sat on either side of her without speaking. They did not know what to believe. The things she spoke of were beyond their imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like the aunt they too said: If only there, were some proof. If only we could be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In spite of this they were both falling in love with her, for she combined the aspects they both desired. For Wolf she was an older woman, with her white hair and weary knowledge of the world; for Eli she was a sugar-fed child, lost and helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had thought that if the two of them ever pursued the same woman they would be driven against each other, would punch and pummel each other as they had when they were boys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But no, this love had brought them closer together. They puzzled together over the mystery of her. They stood quiet, respectful in the face of this thing they could not understand. They would never touch her. Their love for her was a protective, chivalrous love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They wanted to be heroes, I think, they wanted to place themselves between her and the dark thing that threatened her. But they could not understand what that thing was. They did not believe her description of the beast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One night after they had been with her for several hours, I heard their raised voices, heard their feet pounding up the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They burst into the kitchen and faced us, Wolf with his hair standing on end, Eli pressing his eyes with his fingers. They could not stand still, they rocked and paced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We have to leave, Eli said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now. Tomorrow, Wolf said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We’ve decided, they said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I asked: Are you in trouble?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of the girl, her bones and pointed breasts, and wondered if I had misread their feelings after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No trouble, Wolf said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They began sorting their clothes, making plans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, they had their proof finally. That night the girl had pushed back her sleeve and showed them the evidence. It was written on her flesh, just as I had thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A girl showed them her arm and it was all the proof they needed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They enlisted in the army the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I had known this time would come, but it happened sooner than I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel had told me to expect it. He had warned me they would be drafted sooner or later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Enlisting this way made them feel more decisive, more in control of their destinies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched their broad backs as they folded shirts on the bed. I was inarticulate with grief.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to warn them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I longed to say: Don’t go back there. Don’t go. You have no idea what it’s like there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I touched their shoulders, but they brushed me aside. They were excited, they were boys leaving home for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you go to that dark place, you will never come back to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What’s happening? Sashie said. Where are they going?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ignored her. Shmuel told her the news and she began to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you know that you can cross the ocean only once?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Make the journey more than that and you’re tempting fate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Will you miss your boys? Wolf said, grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t go into the forest. You will never come out again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We’ll write to you, Eli said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie, silly girl, was hugging one then the other, dragging down their necks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can I make you understand? There is no logic over there. Natural laws do not apply. Trees walk on human legs, houses walk on chicken feet, villages and oceans disappear without a trace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should have told you these things before. Now it is too late.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why so quiet, mother? Eli said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s wondering what she’ll do with her time, now that she won’t have to cook twelve hours a day, Wolf laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is the last time I will ever see you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bring warm socks, I said, it’s so cold there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf said: Is that all you can say?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eli said: That’s her idea of giving us her blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They went to their father then, and bowed their heads. He put a hand on each of their crowns and recited a prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I embraced each of them then, they bent and I hugged their necks tightly with my cheek against their ears. I wanted to whisper something wise and final to each of them, but I could think of nothing to say. No words wide enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We’ll take care of each other, Eli said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf promised: I won’t go anywhere without him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eli said: Likewise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Framed in the doorway they were strong shining men, their hair grown too long over their collars, their teeth chipped from childhood fights and accidents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hope you remember the fierceness of your boyhood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You will need it where you are going.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember fierceness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What, no tears, mother? Wolf teased.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then Eli: Don’t you love us?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf said: She’s waiting until we leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I won’t do it, I won’t cry until you leave. I swear. I’ll hold it in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf bowed and Eli gave a clumsy salute. Then they turned and jostled each other good-naturedly, both pushing to be the first one out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched their backs. They clattered down the stairs, racing, neck-and-neck. I wanted to tell them there was nothing at the finish but death and a lonely place. But they raced on, just as they had once battled in my womb, both wanting to be the first out in the new world, the first to draw breath.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Eli and Wolf were at a training camp at first, and they sent letters regularly. Reading was still a struggle for me, so Shmuel read the letters aloud, or Sashie did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The letters were cheerful and chatty but I did not trust them. I did not trust words on paper. Anyone could put words on paper, how could I be sure my sons had written this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew other people trusted printed words; they thought once words were written down and embedded in paper they could not change, they preserved a moment. But I knew better. Words in print are slippery. They can conceal things, they can lie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of those identification papers I still had which declared I was Shmuel’s sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anything that can be manipulated so easily is worthless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel and I had never told our children that we were not married. How could we tell them they were illegitimate? They did not need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As for myself I did not care. We were married in spirit, words did not make it more or less so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I think Shmuel, even after all these years, Shmuel still longed for a document, our union sanctified through official words on paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Sashie loved her brothers’ letters, she took them to her brothers’ room which was now hers, and she read and reread them, sniffed them, tasted them, and squirreled them away. She papered the walls with clippings and photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I heard that my sons had been shipped overseas, I knew they were truly gone. I wore black, I tied my hair with black cord, I covered the mirrors, I refrained from washing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mother, what are you doing? Sashie cried.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Shmuel echoed: What are you doing? Do you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("want")]), _vm._v(" our sons dead? You’re inviting bad luck, mourning people who are still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Funny that he should speak of bad luck, he who had mocked my precautions all these years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I would never see them again. I recalled Sashie’s birth, and how Shmuel and the doctor saw what they should not have seen. A tradition had been violated, and these were the consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the two men who had watched, I had lost my two sons. An even trade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I grieved for them for weeks, sat up rocking in bed through the night. I studied the few photographs I had of Wolf and Eli, though I did not trust even photos to show me the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel grew thin and bent, his eyes were cloudy. One evening he seized my shoulders and shook me till my head rattled, shouting: Why are you doing this? Thousands of people are dying, being killed every day! How dare you sit here grieving for two that are still alive!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s desecration, he said more softly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another time he said: Why are you inviting the worst? Parents should not have to mourn the deaths of their children. It goes against the natural order of things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hastily scrawled letters arrived from overseas. Shmuel and Sashie rejoiced in them. I did not believe the charade for a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel wrote faithfully to them both. One night he said: In their letters Eli and Wolf have asked after the woman downstairs. What should I tell them?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, the week before she had hung herself. Some said she had done it because she was grieving for her dead husband; others said she did it simply because she was mad, and that was what the insane did, they killed themselves, it seemed to be the one thing they were good at.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People gossiped, puzzled over her identity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We would never eat sugar in the same way again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What should I tell them about her? Shmuel asked a second time. How should I put it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It doesn’t matter, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sighed. He said: I’ll tell them she’s peaceful now. I’ll say that she no longer has nightmares. I’ll say that her hair is still white. That is all they need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He bent again over the paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lies again! Lies written down on paper! Even Shmuel used words for lies and dissembling. How could he possibly trust them?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie wrote too, laboring for weeks over a single note to her brothers. It needs to be perfect, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel played his violin for weddings, funerals, whatever work he could find.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hardly went outside. When I did the sky was invariably low and gray; the tangles of pipes and fire escapes clinging to all the buildings reminded me more and more of twisted black trees. I tied a scarf around my head to shut out as much as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat in the apartment watching night fall and dawn break, over and over like a tedious dream. I dug the ornamented egg, now dull and tarnished, out of a drawer and peered through the eyehole. The scene inside was dim and far away, mist covered the magic lake and the swans had their heads tucked under their wings. I thought I saw two new figures, black haired, leaning from the highest tower.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Days and weeks went by, and I hardly noticed my daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie, I called to her one day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She came out of her room and said, Please, I want to be called Shirley now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She twisted a lock of hair around her finger and said: I hate the name Sashie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was my mother’s name, I said. Have I ever told you about my mother?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I had, but she must not have been listening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She blurted: Sashie is so old-fashioned. I’m American, mother, I want an American-sounding name. Call me Shirley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: You can’t change your name. It’s written on your birth certificate, you can’t change it. And you can’t ever get away from where you’re from. Your past stays with you, you can’t make it go away by dressing up in a fancy name and pretending to be someone else. Remember that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I wasn’t born in the old country, I was born right here, she protested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t ever escape your family, no matter how you try, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She glared at me darkly from beneath her brows, and twisted her hair tighter, and for the first time I saw how much she resembled me. It was like looking into a fairy-tale mirror that gave me back my youth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She turned then with her shoulders high and tense and stalked back to her room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not understand her at all. And I suddenly looked around me, at my life, as I had not in years. It had taken a shape I could never have imagined beforehand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought how strange it is, the way the shape of your life grows up around you unbidden, like weeds. In the beginning you do not intend to live any particular way, you think you are living freely, are hardly aware of the subtle choices you are making. But as the years pass your life slowly closes in around you, hardening like a shell, crowding you from all sides, hemming you in with furniture and debts and habits, forcing you into narrower and narrower channels until suddenly you find you have no choices any longer and can only continue in the same direction until the end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought too about love, the different kinds of love. There were people you loved by choice, plunging into it recklessly, headfirst, swallowing it whole, giving in to it without a thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then there were the people you loved by default.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("A man came knocking, with a shabby suitcase and an exaggerated face like a sad clown.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I called for Shmuel, and when he came to the door he and the stranger embraced without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This man was one of the actors from Shmuel’s company long ago, and he sat in the kitchen and I made him tea. I remembered him faintly; the women’s roles often fell to him because he was very thin and thus could be swept up in the arms of the hero without too much trouble. I remembered him in a golden wig and false bosom, I remembered his gentle laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now his cheeks were sunken in, his skin yellow, there were hard sores crusted on those lips that most of his comrades, at one time or another, had been obligated to kiss. Deep creases radiated from his eyes; his hair was falling out, pale strands drifting down to his shoulders. He had just arrived in this country.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How did you get out? Shmuel said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The actor’s face darkened, he started to speak then noticed Sashie listening. He said: I stowed away in a barrel of pickles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He reached behind his ear and produced a pickle. He reached into his mouth and pulled out another and handed them both to Sashie. He drew pickles from his armpit and nose and pocket, he took off his shoe and found one there. He gave them all to Sashie and kept producing them until her hands were overflowing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His face never brightened though Sashie giggled and even Shmuel’s mouth relaxed. He was remembering their days of traveling together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the actor rose, and drew Shmuel aside, and told him the news about his family. Shmuel sagged, and his actor friend held him and I held him but he was too heavy for us all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His parents, his sister and brother-in-law and seven children, all gone. Swept away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He did not speak for the rest of the day and that night in bed he did not weep, there were no tears, but he groaned and swore and beat his fists against the wall and the mattress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought he would hurt himself, I caught his arms and pushed him down flat and held him there, I put my ear to his chest and heard his heart thundering frantically as if wild horses were trapped within.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt his hands then, he touched me as he had not for a long time; and we became reacquainted with each other and took comfort in it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We both wore black now, though he said my unnecessary grief was a mockery of his.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He spoke less and less as the days wore on and he was losing his hearing as well. It had begun the day he heard the news, and every day the noise of the world grew softer and softer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The news of his family had hurt him so badly it seemed he could not bear to hear any more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s like the world is buried in snow, he said abruptly one morning. Everything is hushed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was one of his last speeches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He could no longer work, since he could not hear the other musicians, could not hear himself, could not tell if he was off-key.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He squinted as if that would improve his hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I do not think he particularly missed voices, footsteps, traffic, wind. He could have lived without them. But the loss of his music was a terrible blow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For weeks he stayed in the apartment, sawing away relentlessly at his violin though he could not hear the notes. As if there was a single magical note that would restore his hearing if he could only find it. Finally he put the instrument aside in frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He missed the music so much. Music was the greatest truth to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He would not eat, missed his mouth with the spoon, lost his balance crossing the room. It was as if the deafness had dulled his other senses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He could not speak, his voice was an awkward squawk now. When he needed to communicate he wrote messages on scraps of paper. I struggled to read them, had to ask Sashie for help. I felt like a fool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But he did not really want to talk. Neither out loud nor on paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some feelings are too broad for words. There are some stories that defy telling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We understood each other without speech as people do when they have been together for so long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His hair grew lushly, he hid his face in the thicket. He went about with his face twisted, teeth bared like a madman’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember the day his scowl lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the afternoon that he stood at the window, curtain pulled aside, watching the first snowfall of the season. The flakes fell swiftly, softly, the street below was already blanketed in white. He smiled at me then and held out his arms and I knew he wanted to share this thing, so we could be together in the same white muffled silence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We stood close in the cold white light from the window, and it fell on us like the softest snow, it lay pale on Shmuel’s head and on the tops of his shoulders. And I looked at his eyes, the blue so vivid, and at his teeth shining like a path of stones glowing in moonlight that would lead me through the forest to safety.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And though we were indoors I pictured the snow piling up around us, burying our feet, muffling every step. We waded through the snow to the bed and sat among the white sheets. Shmuel unbound my hair then, and let it fall, and took it up in both his hands and shook it beside his ear. He smiled as if he could hear the bells.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had not heard them for years. I did not hear them now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Or perhaps I did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He lay down then and closed his eyes. I looked at his black hair spread over the pillow, at his nostrils, his eyelashes, his brows. His eyebrows jumped and waggled at me; he was teasing me, he knew I was staring. I lay down beside him and tucked my head beneath his chin and slept.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("In the morning he was cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was because of all that snow, piled up around us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you know how dangerous it is to fall asleep in the snow?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited for him to open his eyes but he did not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew he was teasing me, it was always like this, I would watch his face and wait and wait until I could hardly bear it, until I thought I would go mad or burst into tears, and then at the very last moment he would open his eyes, and smile, and laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I waited beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited a long time. He knew how impatient I was, he was testing me. This time I would prove my faithfulness, I would not let him outlast me. I promised I would not move from that spot until he opened his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited. This was a good joke. In a moment he would sit up and we would laugh and laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When my father died my mother could not believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sat by his bedside for two days, holding his hand. She would not allow anyone to remove the body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’ll be getting up any minute now, she said. In a moment he’ll open his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was only a child then and even I understood that he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’s an actor, she insisted. He’s only acting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That blood on his shirt, it’s only chicken’s blood, she told me though his clothes were clean. She said: They hid rubber bladders filled with chicken’s blood in their costumes. So that when they got pricked during the sword fights the blood spurted out like that. It was only a trick, you see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Any second now he’ll stand up and take his bow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your father, you know how he likes to tease.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another one of his jokes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She repeated these things and would not be convinced until the doctor came, and even "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he")]), _vm._v(" could not convince her until he let her listen to my father’s chest with the stethoscope.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah no, she said then. No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I will say in her defense that my father "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("did")]), _vm._v(" always look more vivid, more alive than other people somehow. Even in death. I remember his eyebrows were poised, his lips pursed as if he were about to say something. His hair on the pillow still black and unruly. He still had a sharp-featured boy’s face; the lines and creases on his cheeks were incongruous, as if he had drawn them on with his stage makeup for a joke.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The apartment was so empty in those days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With my father dead, my brothers far away, it seemed like the rest of the world had broken off and drifted, leaving us alone. We had only each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was not much to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We circled each other like suspicious dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother wrapped herself in black, she sat for hours cradling my father’s violin. Not the beautiful golden one he had bought here, but the old squeak-box he’d brought over from the old country. She enveloped herself in a cloud of grief, and it was as if she had removed herself to an unreachable place, far away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I admit we had never been close.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I treasured the letters from my brothers more than ever. Those letters were far more eloquent company than my mother, though they arrived infrequently and were brief and sloppy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brothers were fighting in Europe. Somewhere over there. Even they could not say where exactly. Wolf and Eli both complained bitterly over the fact that they were not together, in the same company. Brothers were always separated, as a rule, but mine had never been apart before and it affected them. Each wrote, in their separate letters, that he did not feel like a complete person without his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eli wrote: I’m forgetting what I look like without him around. I need to see his ugly mug.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf wrote: I talk to him like he’s here. I hear gunfire and I shout, Eli, look out! The guys think I’m nuts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They missed each other, I think, almost as much as they missed me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew they missed me, though their letters were addressed to my parents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf wrote: I know mother can’t read this, so you must tell her I love her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eli wrote: Knowing her, she won’t believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf wrote: Tell it to her anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("did")]), _vm._v(" read the letters to her, or at least I tried. But as soon as she saw the thin envelopes she would push me away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you care about them? I said. Don’t you want to hear what they have to say?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re dead, she said, you know that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: How can they be dead if they’re sending us letters?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lies, all lies, she said. How can you be so foolish? How can you be so easily duped?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She")]), _vm._v(" was the foolish one. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She")]), _vm._v(" was the one who mourned my father and my brothers equally, treated their memories exactly the same. As if my brothers really were dead, or as if my father really were not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was secretive, always tinkering in the kitchen, lighting candles and brewing herbs into tea. I did not like to go out in the street with her, she did not look like other women. She wore her skirts long, dragging on the ground, no brassiere or girdle. Thick woolen stockings all year round. It was as if she had never left the old country at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even the women in our neighborhood, who were her age and came from the same place, had taken to plucking their eyebrows, trimming their hair, wearing modern clothes that were only a few years behind the fashions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother did not care, or did not notice, she kept to herself. She held photos of my brothers in her hands, staring at them for hours. The few clothes they had left behind she sniffed and smoothed and folded over and over. She ran her fingers across the dark marks on the wall where Eli had kicked his heels; it had been his favorite spot to stand on his head. The marks rose up the wall, marking his growth with the years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The way she spoke of them as dead, it was almost as if she wanted it to happen. As if she were trying to kill them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She seemed to wallow in her sorrow, as if she almost enjoyed it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I wrote to my brothers I wrote: Dear William. And: Dear Edward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These names suited them better, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every time they wrote they asked about the madwoman from downstairs, the one with the white hair who had been found hanging behind a door with her tongue out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like the way they asked about her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They never asked about me in their letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They asked if she was healthy, if her hair was still white, if she had stopped pulling at her dress the way she used to, pulling as if it choked her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("inappropriate")]), _vm._v(" for them to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was a word I had recently learned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wrote to them saying that it had turned out her missing husband was not dead after all, he had reappeared and taken her away with him to a house in the countryside. I wrote that she had gotten fat from all that sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When my father died I wondered how to tell them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I asked my mother and she said: You don’t need to tell Wolf and Eli. They already know, they are with their father, the three of them are all together now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was no help at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the end I could not bear to tell them either. In the end I wrote simply: Father has a cold. He loves you. Mother misses you terribly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was all true, in a way.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("This time when the news came it was in the shape of an official-looking letter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Two letters, actually, that arrived on the same day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brothers were both dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to scream but could get no air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I know that, she said. I’ve been telling you, all this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was calm, resigned. She had accepted it long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She held me as I cried and I felt how hard and strong her shoulders were, beneath her rough clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The letters were identical, typed with a fancy seal at the bottom. The writer praised Eli and Wolf highly, said they had been killed in action, had died courageously while fighting for God and freedom and justice for all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I read the letters to my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I know all that, she said. I don’t need a letter to tell me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To her they were trash. But I treasured those letters. They meant something to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brothers had died hundreds of miles apart, on different battlefields, on the same day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was not until the war was over that we got the other letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One came from a man named Jimmy, somewhere in the Midwest. He had been a buddy of Wolf’s, he wrote, and had been near him when he died. He described how in the thick of fighting, Wolf had suddenly jerked and cried out and clutched his side, and a little blood had dribbled from his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yet he had not been hit, there was not a mark on him. Some strange thing, Jimmy wrote, a near miss, a phantom bullet maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jimmy wrote: Odd things happen in a war, incredible things. Things you would not believe if I told you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He recalled the look that had come over Wolf’s face then, a look of despair, as if he had just lost the one person he loved in the world and no longer wanted to go on living. Wolf had let out a great yell then and dashed out into the open with his mouth gaping wide, and he killed several of the enemy before being torn by bullets, and even then he kept running forward, running impossibly on shredded legs, surging forward with his arms outstretched as if to embrace them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wolf had been a swell guy, Jimmy wrote. The best.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The second letter came from a Nicholas in New England, a comrade of Eli’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The strange thing was that his letter’s tale was nearly identical to Jimmy’s. He wrote: It’s like this. We’re in some thick stuff. All of a sudden barn Eli gets knocked clean off his feet. Goes down. We think he’s a goner. But then he gets up. Not a scratch. He’s laughing, feels lucky I guess, but then he gets this thinking look on his face. Like he’s realized something. His face just breaks like a plate dropped on the floor. My brother’s dead, he says. Then he lets out this whoop and breaks cover and goes running right at them like a mad dog. Gets all ripped up then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Neither Jimmy nor Nicholas could tell me the exact times of their deaths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I read both letters to my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Usually she was loudly scornful of letters, didn’t trust a word. But this time she sat musing, her face dreamy, after I’d finished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We never knew which was the oldest, she said finally. You see, there was such confusion when they were born, they both fought so hard to be first, and no one saw when it happened. Always racing, those two. One always right on the heels of the other. They could never leave each other behind. They bore each other up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I remembered a time years before. The one time I went with my mother to watch my father perform.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was something she had always done alone. She had never invited us children to go along. Not inviting my brothers I could understand, they were wild, rambunctious, always causing havoc with slingshots and wolf whistles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I could not fathom her reasons for excluding me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew how to behave in public.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think I knew how to behave better than she did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Something mysterious happened during her evenings out; she would come home with her eyes alight, shaking her hair out of its tight braids, and when my father arrived later they would he unusually tender with one another.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She never told me the plots of the plays. Or what part my father played. Or even the titles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course her exclusion of me made me all the more eager to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I cornered her one evening as she was slipping out, and I begged to go with her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You won’t like it, she said, you won’t understand it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("please,")]), _vm._v(" I said. I had never been to a theater but I had heard they were like palaces, filled with chandeliers; the seats were red velvet like the insides of jewel boxes and the ushers wore white gloves. At the end people threw roses and stood and shouted Encore! I wanted to sit in the balcony, I had never even seen a balcony but I imagined sitting in one and looking down would be the absolute height of elegance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wheedled, and my mother gave in because she was already late and an argument would delay her even more. I snatched my coat and followed her out into the dark of an early winter evening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To my surprise she headed downtown, rather than northward where all the big theaters were located.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Aren’t you going the wrong way? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did not answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tagged behind her. My mother could walk faster than anyone I knew. She could walk more swiftly than my brothers could run. I had never seen her legs; sometimes I wondered if she had wheels and a little steam engine beneath her long skirts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She waited for me in a doorway, then led me inside and down some narrow stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I smelled snuff, mildew, wet wool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("This")]), _vm._v(" was a theater?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We were in a low-ceilinged basement room, impossibly packed already with women in head scarves, men with untrimmed beards. It was uncomfortably warm, people’s faces were already slick with sweat, they were like oily sardines in a can. The noise was overwhelming: a hundred tongues wagging in the language of the old country. The harsh gutturals filled the air with saliva.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew a word here or there, of course, for my parents still spoke that language at times, usually moments when they forgot themselves, when they were excited or angry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew the words but I felt like a foreigner, I honestly felt like an explorer in some distant land standing among the natives. I was conscious suddenly of the few inches of leg that showed between my hem and high shoes, and I blushed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one noticed. They were too engaged in their conversations, their gesticulations. I saw women nursing babies, right there in the open.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We found seats near the back and I was pressed in on all sides by scratchy wool cloth and damp arms and the smells of cabbage and yellowed prayer books.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The play began and the audience did not cease their gossip but simply lowered their voices a notch. Consequently the actors had to raise their voices, practically scream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not that I understood much of what they said. The lines were in the old language.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could follow it easily enough, because it was the worst kind of melodrama, the sort of predictable story everyone knows, with people contorting their faces like clowns, bawling at the tops of their lungs, gnashing their teeth. Everything was played at full tilt, top volume. True love, utter hatred. The simplest hand gestures originated in the shoulder, so that they became athletic feats.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The story had all the usual ingredients: innocent love, hopeful promises, ill-fated seduction; all followed by betrayal, sword fights, murders, impassioned speeches, and endless moaning death scenes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All that excessive emotion, it was embarrassing to watch. They seemed so naked, the actors, with the emotions spilling out of them sloppy and embarrassing as vomit, loud as a belch. Pure uninhibited feeling, raw as a wound.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The people in the audience all around me were leaning forward, thoroughly engrossed. The action on the stage elicited laughs and gasps, and sniffling perfectly on cue. The people in the audience spoke loudly, and often, they commented on the action, they spoke directly to the characters on stage as if they were old friends, offering them advice or insults.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw my father on the stage but hardly recognized him. My dignified father had the role of the fool, a dim-witted and drunken lout. He staggered and rolled about the stage, eyes unfocused, trousers unfastened. When the lovers’ romantic declarations grew tedious he burst in with bawdy songs, he relieved tense moments with a smirk or hiccough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The audience loved him, they laughed till they wept.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to laugh like the rest of them, it did not seem proper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I did, I couldn’t help it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the tension escalated and the audience leaned even closer, the pale anguished hero seemed on the verge of collapse but the audience’s hot breath buoyed him up, it was all that kept him on his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And later, after the hero had died an anguished writhing death, he returned as a ghost and drifted across the stage and his feet seemed not to touch the boards. He truly levitated, for a minute or more, I saw the empty space beneath his feet. Then the villainous rival appeared and our hero flew across the stage and landed on the man’s back and seized his ears and twisted his head completely around. The audience gasped at the flight, and gasped louder at the loud cracking sounds the villain’s neck made. Red gouts of blood bloomed on his costume, and then the vengeful ghost twisted his head completely off and dropped it with a dull thud on the stage, where the eyes continued to blink and the mouth still issued protests.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I must have dozed off. I must have imagined that part.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I grew tired of straining my neck to see the stage so I watched my mother instead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her hands were clasped, her scarf had slipped unnoticed from her head and lay on the floor behind her. She had her gaze fixed on the stage, not just on my father but on all of it, all the gaudy spectacle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were tears glittering at the inner corners of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw that the play meant something to her, in spite of the chintzy costumes and overblown speeches. It spoke to her somehow; these drunks and witches, and princes and scholars and bankers’ daughters were all real to her, more than real, they were larger than life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She liked it, I think, because they acted out the things she felt inside but did not know how to express.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not see the ending of the play, did not even know if it was happy or sad. I was too busy watching my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The room exploded with clapping and suddenly I was surrounded by bellies and back pockets because the audience had risen all together. The actors bowed again and again and my father got the biggest laugh when he bowed too low and fell drunkenly off the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and I stood outside in the street watching the people walking home arm in arm. The cold night air felt clean and good. My father came outside to join us for a moment. He put his arms around my mother, wiped her cheeks with his thumbs. Now he looked like my father again, the drunken glaze was gone from his eyes, he stood erect and graceful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Was I that bad? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wonderful, my mother said, rubbing her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still wonderful the twelfth time? he laughed. She had her hands on his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Did you like it, Sashie? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He left us then and went back inside to remove his costume and prepare the room for its daytime role as a classroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked home with my mother and she was silent, lost in her thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a way, I think, the play was what was real to her and daily life was a pale charade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother did not ask me to come again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would not have wanted to go anyway. It had made me uncomfortable to sit next to her in the audience. My mother was a private person, she usually kept her thoughts to herself. But during the play I had seen her face unfold like a flower, had seen her thoughts splashed plainly across her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a private moment for her. I felt I had been intruding, to sit and stare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was too much, just to sit there next to her was too much, my thigh touching hers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Too much, too hot, too close.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to get too close to her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would not want her to see me naked and exposed with my heart splayed out, as I had seen her in the dark of the theater.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was only a child then but I could sense what my mother was like; she was capable of anything if provoked, she was like a wild animal, fury-driven and ferocious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew, somehow, that she could tear me to pieces if I let down my guard for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to get too close.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I dreamt a dream night after night that began like my favorite fairy tale and then turned sour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dream always began somewhere dark and close, like a forgotten drawer. There was soft slippery dust that clung to my lips and clothes and when I came out into the light I could not brush it away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the dream was like a film set, with bright lights and director’s chairs, scaffolding, and cameras. I knew I was meant to play the princess, it was written in the script—but no one would believe me. They all laughed, they could not see past the gray film on my face and my dirty dress. You’re no princess, they said. There was a black coating on my hair but I could see out of the corners of my eyes that it was golden underneath, if they would only look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then my mother came toward me in satin hoopskirts with her face like a painted doll’s, and she did not walk, she rolled, as if she had wheels instead of legs. And behind her came my brothers, with ribbons in their hair, in pink and lavender dresses that strained across their chests and left their hairy calves and feet all exposed. When they saw me they pointed and laughed behind their hands, and simpered like evil stepsisters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I realized what the story was, what their roles were and what mine was, and I felt relieved because the good parts of the story, the fairy godmother and the balls and gowns and glass slippers and handsome princes, were still to come. My mother handed me a broom and I swept diligently at the ashes on the floor and a thousand bright lights shone on us and many people, directors and assistants and technicians, seemed to be watching from the shadows. I swept and swept and my mother watched with her arms folded and I thought that the sooner I finished the task the sooner I would be dancing in the arms of the charming prince at the ball.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the dust refused to behave, it rose up and stuck to my skin. I looked at my arm and it was covered with a gray linty fur that I could not scratch off. My brothers laughed and rolled in the dust, kicking up their legs so that I could see the enormous lace knickers they wore underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dust was coating my tongue now, crowding my eyes, I could not blink it away. I looked down and saw that I was entirely black and white and shades of gray like a newspaper photo though my brothers in their dresses were so gaudy colored they hurt my eyes. The cameramen pointed their camera at us and it was shaped like a cannon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the fairy godmother appeared in a ball of light, and waved her wand and said in her flutey voice that her name was Glinda, good witch of the north, and she looked at me "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("so")]), _vm._v(" kindly and seemed "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("so")]), _vm._v(" familiar. But she was swept away by a horde of dwarves before I could remember where I had seen her before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where was my ball gown? And my dancing slippers and pumpkin coach?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It did not matter because we seemed to have skipped over that part of the story, and were already near the end. Here came the prince with the telltale slipper on a silken pillow. It was bright red with a low heel, covered in rubies with a bow on the toe. The prince’s face was bare and featureless as a plate but he had the most beautiful hair, a blond scroll of it like the jack of hearts in a deck of cards.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He knelt and I was glad that this silly charade would soon be over. All I had to do was put on the slipper and then everyone would know who I really was, the dust and rags would fall away and a royal crown would sprout from my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could we have not seen how beautiful she was before, how could we have been so blind, the film directors and the prince and even my mother would say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Printed on the label inside the shoe were the familiar blond boy and his dog, winking and beckoning me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I drove my toes into the shoe’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My foot would not go in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There must be some mistake, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The prince raised the flat blank front of his head to me, but he was no longer dressed like a prince. He was in a dirty soldier’s uniform and I realized he had no face because it had been blasted clean off in battle. He held his lost face, spread out on the pillow he held in his hands. An inverted mask, eyes like hard-boiled eggs and teeth laid out in a grin, a web of blood vessels holding it all together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brothers’ dresses had turned into uniforms, and my brothers now lay facedown and unmoving in the dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And now soldiers began raining from far above, they fell all around and their parachutes refused to open so when the men landed they collapsed, folded up like accordions with cracking snapping sounds. My mother wheeled about trying to catch them before they touched down; she held her skirt out in front of her to bag them, as if they were falling apples.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Pull the red cord, she called to the ones in the air but they did not seem to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried again to jam my foot into the shoe but it would not go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My foot bulged horribly all around, like a fat neck in a too-tight collar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I somehow knew that if I could just get that shoe on my foot, everything would be all right.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pushed and pushed as the men fell heavily all around, grunting as they landed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My fat foot. The stubborn shoe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found a knife in my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sawed at my toe, hacked at my heel. Blood spurted, though I felt nothing. The little nubs of flesh fell in the dust. I tried my foot in the shoe and saw I would need to hew a strip off the side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried again and the shoe finally fit, though it pinched sharply. I stood, I stamped, I clicked my heels together but the rain would not stop and my brothers did not rise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to turn them over, first one then the other, but they were stuck to the ground like scabs and would not budge. Men were piling up everywhere, arms and legs and limp useless parachutes spilling out too late and puffing up like blisters, and I drove my foot farther and farther into that shoe trying to make everything right.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The blood welled up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I always woke with my left foot wedged between the bedpost and the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The movie stars smiled comfortingly down at me. Trapped inside the black-and-white photographs, pinned to the wall, but they shifted and blinked and smiled all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A trick of the light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first time I had the dream I told my mother about it. She listened, nodded sagely. I thought she would have some insight, an interpretation. But she said only: You should clean under your bed more often, maybe. And not eat fruit before bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next time I had the dream I did not tell her. Nor the next time, nor the next.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The shoe never fit, no matter how hard I pressed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the dream I thrust my foot in, again and again, kicking my foot against the wall, night after night. I would kick and then wake to hear my mother calling from the other side of the wall: What’s that knocking? What is it? Is that you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And before I could answer, she would always say: Shmuel? Is that you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lying in the dark, coming out of the dream, listening to her voice on the other side of the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hearing her say: You’re so late.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I’ve been waiting up for you, she would say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would draw my sore foot back under the covers, try to catch my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Be quiet, she would say then. Quietly, Shmuel. Don’t wake Sashie. If she hears you she’ll have bad dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’d say that and then I’d lie awake till morning.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My mother spoke often of my brothers. I listened to her stories and said nothing, but it bothered me that she was so wrong about them. She had missed so many things about Wolf and Eli, had never really seen them clearly. I knew them much better than she did, so it bothered me to hear her speak so authoritatively.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She could not see their flaws. I suppose she was blinded by her love, a fierce instinctive kind of love like what a mother animal feels for her young.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not correct her, I let her babble on. She was wrong about them. But then, she got a lot of things wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment seemed so empty with my brothers and father gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Echoes lingered, like week-old food smells caught in the curtains. I thought I heard their heavy footsteps, their laughter, my father practicing wedding music on his violin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The emptiness, the silence did not go away as months and then years passed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to fix up the place, decorate, but the apartment resisted me, the very walls were stubborn. The pictures I tried to hang slid down the greasy wallpaper and fell on their faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My father and brother were the ones who had brought life and color into the rooms. Now all was dull and faded. I could hardly bear it. When I looked around I wanted to scream at the bareness, the peeling paint. The only break in the grayness was my mother sitting there in her mourning black.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With no men in the house, there was nothing to do. No one to please.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went to school. I met some girls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I grew, I suppose.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The months and years passed like a monotonous dream, like stitching an endless seam.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There is nothing worth telling about those years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is there to tell about a mother, a daughter?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother’s life had stopped when her husband died.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve figured out that interesting things happen only when men are around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Men make life interesting. Men make things happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everybody knows that. All the songs say so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother took in laundry and repaired shoes to make ends meet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was waiting, waiting, in those years, I did not know what for, but I expected it any moment to come and knock at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I should not have let them take him away like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew he would come back to me if I waited long enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He came at night, his teeth glowing in the moonlight. I would hear his footsteps first, tapping on the floorboards, and then see his shadow thrown huge and wavering against the wall and climbing halfway across the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He came and sat at the edge of the bed and I spoke to him though I knew it was useless. He had lost his hearing, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could never see him as clearly as I would have liked, and he never stayed long. I thought it was because we had never been made man and wife in law, as he had wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought that if I had a marriage contract I would have more of a claim on him, could make him stay with me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His parents and his sister were always snatching him back to the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were icicles in his mustache.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He only stayed long enough to remind me of his absence. Like the twinge of pain when you put your tongue in the tender hole where a tooth had been.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He left an imprint of his body on the white sheets, like a snow angel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the mornings it was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps if we had had more children he would be more inclined to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the mornings I looked at the face of my daughter, at the mark between her brows already deep from frowning. She washed her hands, over and over as if to rid herself of something.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want her to repeat my mistakes, I wanted to tell her to get the official papers when the time came with her name and his side by side, to get rings and promises, and to have children to seal the bond so that her husband would never have reason to go away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she stood at the sink and when I drew near she raised one shoulder as if blocking a blow. She rubbed her hands under the cold water, a muscle twitching in her jaw. She scrubbed and scrubbed at some stubborn stain that only she could see.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s time I went and found a nice husband for you, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("no,")]), _vm._v(" mother, you really don’t need to do that, I said. I had just walked in the door, red faced and gasping from the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s time, Sashie, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Call me "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shirley,")]), _vm._v(" I told her for the hundredth time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was autumn, chilly out. My mother was busy with the week’s laundry; she was using a wooden paddle to stir the clothes in an iron pot on the stove. The steam billowed up around her, damp wisps of hair clung to her face. Clotheslines stretched across the kitchen, some already slung low with sodden clothes. I had to push them aside to make my way across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tell me what you want and we’ll find it, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s too soon for me to think about "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that,")]), _vm._v(" I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tomorrow then, my mother said without looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was eighteen now. I was taking courses in shorthand and typing and stenography. I had considered finding an apartment of my own, living the life of a single girl, but I felt I could not leave my mother alone. She was no longer young. She had no one left; I knew she needed me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Also I admit I couldn’t afford to live alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And there was a part of me that didn’t want to leave her to her own devices. I didn’t want to let her out of my sight, not for a minute. Who knew what she could get up to once my back was turned? I thought of my brothers, their faces were hazy but I remembered how she had not wanted them to leave home. And when they did, they had died in a faraway place just as she had known they would. It had been all her fault somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to go away and have the same thing happen to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had killed my brothers, practically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She talked to ghosts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you want to get married? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course, I told her, but not right this minute.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had never discussed marriage with my mother before, although I did notice men. That fall they seemed particularly vibrant, in their bright ties and crisp shirts like birds in mating season. I saw them filling the streets of the city, walking briskly with their shoes polished and their hair sleeked back. I made a game of picking out my favorites as I stood waiting for buses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I certainly did not want my mother’s help. I knew her feelings about thrift and practicality. I suspected her idea of a perfect man was one who would work steadily for sixty years without a break, wear the same suit of clothes day after day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I respected my mother but she had no sense of refinement, no "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("delicacy.")]), _vm._v(" When I accompanied her to the marketplace, I was always shocked by her feinting and thrusting, her swift grabs at dead fish and plucked chickens, her fierce haggling over carrots and cabbage. She liked to stand nose-to-nose with the shopkeepers, jabbing them in the chest with their own produce, until they threw up their hands and gave in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She seldom spoke of my father anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now my mother hoisted the wet clothes from the pot with a grunt and loaded them into the wringer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tomorrow we’ll go, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t, after my classes I’m going shopping with Tessie and Mari anne, I said quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother worked the handle. The clothes twisted in agonized postures, tighter, tighter; water dribbled out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then Sunday, she said through her teeth. Sunday evening we’ll go, no excuses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw one of my dresses pass through the wringer, its sleeves flap ping in protest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All right then, I said. Go where?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ll see, she told me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The following afternoon, as I walked the streets gazing in shop windows with Tessie and Marianne, I wondered what my mother had in mind. I walked between the two of them, we linked arms and stepped in unison. I was so preoccupied I think I would have stepped in front of a streetcar if it weren’t for them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother had only seen my friends once, from a distance, but she disliked them. Those girls, they’re nothing but leeches, she often said. All soft and hungry, sucking the life out of everyone around them. Girls like that, they’ll let their husbands waste away, they’ll lock their children in closets to keep the house clean. You should be careful or they’ll get you too, Sashie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Shirley,")]), _vm._v(" I’d remind her. And she’d say: Remember, a leech’s bite numbs you at first, so you don’t even notice it until it’s stuffed itself with your blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As I walked with my friends, I could not help recalling my mother’s words. She had a knack for doing that: casually painting unappetizing pictures that affixed themselves like halos to everything I held dear. It was true that Tessie and Marianne were unusually plump and healthy looking. They both had long graceful legs, they filled out their dresses generously, they had no corners. Marianne wore her blond hair in a permanent wave; she had a large flat face, rather shovel-like, but still quite pretty. Tessie had auburn hair and freckles which she covered with thick pasty makeup. She talked a great deal, with much waving of hands, and had a sense of style I greatly admired: her jewelry, her scarf flung over her shoulder just so, her hats decked with dried flowers, false fruit, stuffed birds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We strolled along looking at the splendidly dressed mannequins, with their aloof faces and pointed toes. Every now and then I caught a glimpse of our reflection in glass, two pale swans with a dark shadow between. I had grown to be slight and wiry and dark haired like my mother. My mother called me skin and bones; I called it svelte. I also had her probing eyes, although I could not use them as she did. My mother could intimidate young men into giving her their subway seats or drive away salesmen without a word, merely with a glance. I did not. Still, when I studied myself in the mirror and saw my mother’s eyes staring back, I felt a twinge of power, the potential in me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I did not want to be like my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to be a force of nature. I wanted to be a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lady.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I avoided my mother’s ways, her pugilist stance, her out-thrust chin. I’d paced with books on my head for years, practiced enunciation with a pencil between my teeth. I bought high-heeled shoes; I loved that nice clatter on hard floors. The tap-tap of shoes, a pair of gloves, a precise tight-lipped smile with no vulgar teeth showing: these were the hallmarks of a lady.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley, for God’s sake, said Tessie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where’s your head? That cab nearly flattened you, said Marianne.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You ought not moon about like that. Those fellows thought you were staring at "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("them,")]), _vm._v(" Tessie said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know which fellows she meant; the streets were full of men, in groups, in pairs, in suits, in shirtsleeves, leaning against walls with cigarettes. Some touched their caps when we passed, others touched the front of their trousers and smirked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wind whipped our skirts. Tessie’s gossip whirled about in a flurry of shrill words, like dry leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men turned up their collars, cupped matches like secrets between hand and mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We stopped at a drugstore soda fountain. The sudden warmth indoors made me breathless. Tessie and Marianne hoisted themselves up on the only empty stools, their hips overflowing. I stood, my elbow on the counter, and watched as they sucked up their sodas. Ravenously they pulled at the straws, their cheeks drawing in, their mouths so red.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tessie bought some candy in a white paper sack and the two of them dug into it. They daintily licked their fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley? Tessie said, offering the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No thank you, I said. Bad for my complexion, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should try drinking a glass of milk in the morning, with a raw egg mixed in, Marianne offered. That should clear those spots right up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mmm, I said. I’d been avoiding sweets merely to maintain my figure; my skin didn’t "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("need")]), _vm._v(" improvement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How’s your new fellow? Marianne asked Tessie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, that oaf, Tessie said. Took me skating last weekend, told me he was a pro. Helps me on with the skates, offers to hold my hand. And then the minute we’re on the ice there he goes, crashed out, knocking people down like ninepins.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No! How embarrassing!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("him,")]), _vm._v(" yes. I pretended I didn’t know him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You didn’t!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And wouldn’t you know, he gets up, falls right back down again with his trousers completely split up the back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How terrible!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it turned out quite well. I met this fascinating man; when I told him I was alone he bought me coffee and walked me home. He was a charming skater and he could speak French. And "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he")]), _vm._v(" at least could keep his trousers in one piece.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marianne and I digested this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But men are all the same, they’re all fools, Tessie said, sinking her teeth into butterscotch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’d had more experience than us, we could not argue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re all fools, Tessie went on, they go from their mothers to their wives, and if they have any time in between, they don’t know what to do with themselves. It’s single men who cause all the trouble in the world. Look at wars, tavern brawls, tramps—they’re all single men. If men stay alone too long they start touching their private parts, more and more, until they fall off. Then they turn into criminals, or lunatics, or artists.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ve got it all figured out, Marianne said admiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Though I knew it was not what Tessie had meant, I found myself picturing a man’s private parts propped before an easel holding a paintbrush.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ll see, girls, Tessie said wisely and patted our hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my brothers, their broad-shouldered hulking presence throughout my childhood. I recalled their massive shoes, sour socks, the mess of beard stubble and soap scum they left in the sink. Tessie made men sound as flimsy as a handkerchief, to be folded neatly or soiled according to whim; but when I thought of my brothers I thought of glaciers making their massive, inexorable progress, permanently reshaping the landscape as they passed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, shy little Shirley, Tessie said. One day you’ll find a man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She never said such things to Marianne. But then, Marianne was blond.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m not shy, I said automatically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marianne snorted. Daintily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tessie sighed and slouched, resting her bosom softly on the counter. Her breath in my face was heavy with chocolate and cinnamon. She settled her hips more comfortably on the stool, and a passing stock boy turned his head and stared and stumbled, his load of cotton balls and white stationery spraying everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Are you ready? my mother said on Sunday evening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she was. My mother had her own rules of propriety. Her hair was strained back from her face, braided, looped and knotted and tucked away. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Not a hair out of place")]), _vm._v(" was her mantra. She was superstitious about such things: if she noticed stray hairs or eyelashes on her clothes she’d put them in her pocket. She carefully collected her fingernail clippings, burned them in the stove and made me do the same. She had a good figure for a woman her age but refused to flatter it; she wore drab, baggy clothes. Fine clothes, she said, tempt the evil spirits. By this I assume she meant pickpockets. She never carried a purse, kept the apartment keys on a chain at her wrist, her money stuffed down her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As for me, I wore my rust-colored wool dress, new stockings, hat and gloves and the cameo pin. I had bought the pin because Tessie had one like it. When my mother first saw it she asked: Who is that a picture of? When I said I didn’t know, she asked: Why do you want to wear some stranger’s picture?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother wore no jewelry, she did not care about such things, she preferred to collect bits of hair, crushed insects, a ticket stub from ten years ago squirreled away in her pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We walked through the darkening streets. The sidewalks were crowded with men and women, with gangs of children having a last lark before they were called home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you saw us then, strolling arm in arm, talking companionably, you would have thought us the best of friends; you would be surprised when I told you we were not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, we talked, but only of the most mundane things. My mother is not an articulate woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spoke of recipes, of clothes she had mended for me, of pipes she had repaired that day; she had an uncanny knowledge of plumbing. How did you know what to do? I asked, and she shrugged, saying: Have you ever seen the inside of a cow? Next to that, the sink is nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She spoke of the sick people she had visited with her herbal remedies: patients too poor for doctors, or too superstitious, or else they were illegal immigrants who distrusted everyone who did not speak their language. She grew the herbs herself, in pots on our windowsills; they were twisted, skeletal ugly little plants, and she kept their names and uses to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew a good daughter was supposed to take her mother’s arm on the street, to help her over the curbs and puddles, to support her feeble steps. Not so with my mother. When I took her arm, she ended up dragging me, my hand clamped beneath her elbow, my feet hardly touching the ground. She led me through a neighborhood I hated, with the tenements and narrow streets, foreign cooking smells and babies’ cries pouring from the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We turned onto a quieter street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, here we are, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We paused before an apartment building of weathered brick. At street level was a butcher shop, brightly lit. We could see the red-and-white marbled meat in the glass cases, resting on soaked paper, and the ropes of sausage, all different thicknesses, hung on hooks. Behind the cases stood a heavy, jowly man in a stained apron, his arms folded and resting on his protruding stomach. He watched us through the window, tiny eyes sunk deep in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A smell of blood, of spices, of mopped floors hovered in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hung on the wall of the shop facing the cases were photographs, framed and glassed in, photographs of smiling girls in wedding gowns. Even from the window I could see that they must have been his daughters or nieces, they had his embedded eyes, his thick shape. I could see the girls’ meaty pink faces, flushed from excitement or the tightness of their dresses, their fat fingers choking the stems of flowers. No grooms, only the red-faced girls in their identical dresses, lined up like a row of merchandise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The butcher glared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother tugged me away from the display window. My breath had clouded the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What are we doing here? I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This way, she said and steered me to the stairs that led to the apartments above.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the second floor the hallway was narrow, high ceilinged and dark. The paneled walls glistened with varnish, or perhaps condensation. Water dripped and echoed somewhere. I could not see the end of the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother rapped at one of the doors. We heard shuffling feet; the door opened and a large red-haired woman ushered us in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment was close and cluttered; everything seemed out of scale, and awry, as if a dollhouse had exploded. Claw-footed chairs crowded around a coffee table buried under telephone directories and loaded ashtrays. Bookshelves were crammed with trinkets, encrusted teacups, a fishbowl filled with murky scum, photograph albums. Doilies covered every surface. Drapes hid the windows and much of the walls. Great fuzzy piles of knitting covered the sofa and lay in corners like a slowly encroaching moss, like cobwebs or dust balls run amok.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A radio played soft music. There was a smell, both sweet and faintly unpleasant, like food left out too long. The red-haired woman took my coat from my shoulders. She was my mother’s age, with perfectly white, flawless skin; it was soft and sagging with age, but still striking. Her hair was a strident, metallic color that did not match her skin, a botched dye job. She had green eyes, eyebrows painted on in dramatic sweeps, a round, ample body; she wobbled on her feet as if her shoes were too small.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew immediately that this woman and my mother were old acquaintances; they stood silently, giving each other long assessing looks; understanding passed between them in the tightening of a mouth, a tug at a sleeve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The woman turned to me, took my hand between her hot, damp palms. Come in, sit down, she said and her accent was like my mother’s; they were from the same place. I’m Annabelle, she said; I saw my mother flinch at the name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sashie,")]), _vm._v(" my mother said firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley, I corrected, nodding and smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle gave me an understanding look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She hobbled stiffly to the chairs, adjusting cushions, tsking softly in her throat as puffs of dust rose up. She tinkled and rattled as she moved, she wore several strings of beads, and two pairs of glasses on chains around her neck, as well as a third pair hooked in the bosom of her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your mother tells me you’re looking for a man, Annabelle said briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, well, not— I began. Annabelle and my mother both leaned forward intently. And then it all became clear: the photograph albums, the cardboard boxes brimming with letters and pictures, stacked everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t need a matchmaker, I said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She blinked her eyes innocently: Oh, but I’m not—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I snapped: My mother didn’t tell me why we were coming here. I’m sorry to waste your time— I rose, thinking: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("calmly,")]), _vm._v(" Shirley, a lady never loses her temper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle raised her hands. She said: I’m hardly a matchmaker, Shirley dear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s not, Sashie, that’s not why we’re here, my mother told me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t need this, I’m perfectly capable of meeting a man myself; in fact, I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("have;")]), _vm._v(" in fact, I’ve met "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("several!")]), _vm._v(" I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course you have, Annabelle said soothingly. Of course you don’t need a matchmaker. A lovely, talented girl like you? Hardly! She smiled ingratiatingly and said: Look at you! Beautiful! Boyfriends right and left!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Careful, Shirley. Under no circumstances does a lady slap someone in the face, no matter how much she wants to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said this to myself and very slowly sank into my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle leaned forward and clasped my hands. Her breath smelled of cigarettes and dinner, pickled beets and boiled cabbage. She said: There are plenty of men in the world for you, too many, it makes it difficult to find exactly the right one. I’m going to help you with that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ll see, she said and smiled. Shirley, she said, the world is full of fine men, handsome men, but you can’t go out and have them as easy as picking flowers. You find a man, you have to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("wait,")]), _vm._v(" you have to let him "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("notice")]), _vm._v(" you, wait for him to ask. Men get to choose first; a girl can say only yes or no. You can’t approach a man yourself, not if you’re a lady, and I know that you are. Men are dull witted, it takes time, there are always complications. I’m going to save you time, save you the trouble; here "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you’ll")]), _vm._v(" be the one to choose, you’ll get to take home exactly the one you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother said: I don’t want you wasting your time, chasing this one and that one. Find the right one now, spare yourself and me the trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked from one to the other. So you’re "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" going to show my picture to a bunch of middle-aged men and their mothers, and ask them what they think? I asked Annabelle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And you’re "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" going to show me a bunch of men’s photos, men hiding their bald heads under hats, their fat stomachs behind car doors, themselves ten years ago? You’re not going to read me their lists of requirements?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hardly, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No letters? No chaperoned meetings?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed again. I own this building, she said as if that explained everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She stood with a clink and a clatter, my mother stood, I stood, and we all filed out of the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed Annabelle’s stiff hobbling gait down the hall. In a dark corner she stopped, removed a ring of keys from her pocket, and unlocked a door no wider than a single board.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and I followed her up a narrow, grimy staircase and down a narrower passage. At first I heard nothing but the soft fall of dust, the skittering of mice. I noticed smells of soap, of sweat, of bedclothes, and the sounds of living, oblivious behind the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As my eyes adjusted to the dimness I saw that the building had been remodeled at some point; the original rooms had been divided into smaller apartments with flimsy thin walls, and the passage we stood in had been carelessly left over. I followed Annabelle, my right hand brushing cold brick, the left plywood. The newer walls were so thin they faintly glowed with light, and seemed to quiver with noise and breath like the tight head of a drum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hush, someone said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I bumped into Annabelle’s soft back. She had paused before a splinter of light, a peephole in the wall. She peered in, the light slicing across the green glass of her iris. She moved aside, beckoned to me. When I hesitated, she seized my head in her impatient hands and forced it to the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I said. I saw a man, a small drab man sitting on one chair with his feet up on another, his shoes off, wearing trousers over long underwear and eating beans out of a can with a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His socks were all holes, his suspenders hung around his hips, the ends of his straggly mustache fell in his mouth, he chewed beans with a kind of abstracted concentration, his throat working. How he ate those beans, grinding them to mash, his mouth going round and round, as if they were the most important thing in the world!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh no, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We shuffled on. Annabelle beckoned me to another peephole, and I bent to look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I smelled sweat. Then a glistening figure hopped into view, disappeared, hopped in again. He was stripped to the waist, wearing an athlete’s tight short pants, his hands held in fists. He was boxing with himself, dancing lightly on his toes, circling, ducking, hooking and jabbing at the air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sweat dripped from his face, he grunted like an animal, he blotted his face with a towel. The hair spread in an irregular pattern over his chest and stomach and in two fugitive tufts on his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His apartment was bare, only a narrow iron bed and a chair. A long mirror stood propped against the wall. The man abandoned his invisible opponent, bounced to the mirror, punched the air twice, then stopped and looked at himself. He looked a long time, flexing his muscles, looking deeply, lovingly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the next room I saw a man still in the vest and tie he had worn to his work. He sat at a table reading a newspaper, pushing up his glasses with an index finger. Every few moments something he read seemed to anger him so much that he slammed the paper down and swore incoherently. Then he would pick up the paper and resume his reading. Sometimes he grew so incensed that he leaped up from his chair and raged about the room, muttering and spitting and shoving the furniture about. Eventually he would quiet down and pick up the paper again, only to be offended anew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Men are at their truest when they are alone, Annabelle said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We paused at other apartments. Annabelle took a kind of vicious, condescending interest in the men; she looked and smacked her lips, nearly sneered. My mother seemed indifferent; an uninterested zoo visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We climbed another narrow flight of stairs and peeped into a new series of apartments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lingered for a long time at some of the rooms. Annabelle and my mother did not try to rush me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man with a beautiful face, lovely blue eyes and blond curls like an angel, but his body was a broken puppet’s, he was staggering and drunk, the bottle still in his hand, his shirt twisted nearly backward. As I watched he turned toward me, he seemed to meet my eyes, he stumbled forward, clasped his hands, rolled up his eyes in a pious and holy expression. And then as I watched he bent double and began to vomit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man I thought I liked, he seemed sober and industrious, he sat hunched over a desk with papers spread all about him. His brow was deeply furrowed, his fingers ink stained and his lips too, from nibbling the pen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps he was a poet, a composer. Perhaps he was a genius in need of affection.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then I heard him mutter numbers, costs. He was merely doing accounts. Then I saw the thinness of the shirt where it stretched over his shoulders, worn nearly transparent. I saw his too-long hair hanging over his collar, his worn-down shoes, the meanness of his possessions and the careless clutter all around him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could never care for a man who cared so little for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw one man who seemed more alive than the rest. He was shirtless, his arms sinewy and strong. His eyes were wild, he grinned with white square teeth. Then he spoke, he was laughing, he had a beautiful laugh. There was music in the room, and candles. I saw a handsome camel-hair overcoat hung over a chair. I wanted to know his name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw him crouching over the bed at the far side of the room, he was talking and cooing, stroking, I thought perhaps there was a dog on the bed. A cat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I heard soft feminine laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle pulled me along, whispering apologies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked in on every little cell. One room was exquisitely decorated, Oriental rugs on the floor, red leather armchairs, stuffed game birds, a grandfather clock looming in a corner. But the resident was short and fat and triple chinned, pompous and monocled; he strained the seams of his fine clothes. And beneath the veneer there was a whiff of vulgarity: he moved his lips as he laboriously read the paper; he drank his port and belched and chomped a cigar; with those finely manicured hands he scratched himself in ways a gentleman should not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched men eating, reading, sleeping, polishing their shoes with earnest attention. I saw men studying comic books as solemnly as they would the Bible; I saw a swaybacked, pear-shaped young fellow practicing his walk with a book balanced on his head and I had to look away. I saw a man playing the trumpet, and my heart went out to him, a musician, a creative soul. But the sounds he made were terrible, and his neighbors on all sides banged on the walls and shouted at him, and he cursed back at them with a self-righteous anger that was ugly to see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man sitting hunched on the edge of the bed in his underwear, looking at a magazine held two inches from his face, his other arm working like a piston.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man on his knees, eyes closed, a rosary in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man cleaning a disassembled gun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man tentatively removing his hairpiece, then rubbing ointment into the angry rash it had left on his scalp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a man carefully lining up rows of pills in a rainbow of colors, dozens of them in neat regiments. I saw him pour himself a tall glass of water. He had a long horse face, pale lank hair lying across his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We climbed more stairs, I browsed through more men’s lives; they were as wide-eyed and oblivious as fish in an aquarium.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This will never work, I whispered finally. How can I possibly find—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Annabelle hushed me and nudged me to the last flight of stairs. Top floor, I keep the best ones up here, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to go home, I was exhausted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was so handsome, so full of life. His face was a healthy color, his hair thick and dark. As I watched he combed it back and smoothed it until it shone like patent leather. His face was square and sharp cornered, the eyebrows were active little punctuation marks. He was a big man, broad shouldered, but light on his feet as he walked from closet to dresser to mirror. He wore a lovely gray suit that fit him perfectly. I watched as he stood before the mirror knotting his tie. He fixed it once, scowled at it, undid it and tied it again twice more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He did not stop until it was perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He tied his shoes, whistling. Whistling! How can you not like a man who whistles?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment was tidy. Unlike the other apartments which smelled of sweat or medicine or lingering food, his apartment smelled impersonal. Like a coat closet, it smelled of leather, wool, rubber boots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were small photographs hung on the walls, propped on the dresser. The sepia-toned cardboard kind, of the sort my mother kept.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Probably his parents came from over there as well. We had that in common.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stood before the mirror smoothing his shirt. He stuck out his chin, studying one profile then the other. I did not think him vain. He acted like a man with a fine new car: not vain, simply justifiably proud. He looked strong. He looked as if he had a healthy appetite. He moved with dancing steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He reminded me of my brothers, he was like a refined, chiseled version of them. Perhaps if you skinned one of my brothers like a bear, if you peeled off the heavy thick skin, you would find a clean-shaven, well-groomed fellow like this inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He fixed a carnation in his buttonhole. Wearing a flower in November! The audacity!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He put on an overcoat and paused for a final inspection before the mirror. I realized with a sudden sinking feeling that of course he was about to go out to meet a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sighed but could not stop looking at him until he left the room, still whistling. How dear the back of his head looked; the nape of his neck, the backs of his ears were boyish looking and vulnerable. I felt a gush of concern for him, I imagined him cornered in a dark alley, thugs pounding on that sweet unsuspecting neck with a crowbar, mussing the perfectly smooth hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Seen enough? Annabelle said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded. We made our slow way down to Annabelle’s apartment. She hobbled more stiffly than before on her tiny useless feet. They made me think of stories I had read about Chinese girls whose feet had been bound since birth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sat again in the crowded apartment as Annabelle lit a cigarette for herself. She was puffing and haggard from all the walking, but her voice was more intense than before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So, which one? The last one, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, the last one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hmmm, she said. Ten B. Good. His name is Joe. Steady job. Parents are dead so they won’t get in your way. He’s a good one, Shirley, I promise you. Built to last.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked like he was getting ready for a date, I said tensely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle waved her hands. Pay it no mind, he’s all yours, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at my mother. Her face was thoughtful, undecided, the way she looked when she tasted a soup in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What now? How will I meet him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll send him over to your home for dinner. Next Sunday? Some night this week. Thursday? Wednesday? The sooner the better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t understand. He’s never even seen me. What will you tell him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, Annabelle said and brought her face close to mine, smoke drifting from her nostrils. You see, Shirley, some men are bad with money. Most of the men here are behind on their rent, and some owe me for other favors as well, they have debts. I’ve been very generous with them. And if they are disagreeable, I have a special arrangement with the butcher downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She cocked her head, shared a glance with my mother. My tenants, she said, are always willing to return a favor. They’re always glad to oblige. Especially if it means sharing a meal and some sparkling conversation with a beautiful girl like yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m not—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You want to get to know him, don’t you, Shirley? This is your chance. It’s as good as done. Your Joe will be delivered to your doorstep promptly on Wednesday evening. That I can promise. After that it’s up to you and your mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother nodded, her lips pursed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My head was whirling. Joe. His name was Joe. I could not stop thinking of the smooth black hair, the long legs in the trousers, the flat plane of his cheek, the lines around the mouth. Just like the movie star men in the curling magazine photos on my bedroom walls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like a new toy in a shop window, and I was six years old again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley, just wait; when you see him again he’ll seem even more wonderful than before, Annabelle said. Men are at their truest when they’re alone, but they’re at their very best when they’re with a beautiful woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She turned to my mother. It’s true, isn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother nodded, then said: We must be going now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And as I had known earlier, without words, that my mother and Annabelle were old acquaintances, I now saw with equal clarity that they were not friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stay a bit, Annabelle said. I have soup on the stove we could have.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No. We’ll go, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley, ah, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sashie")]), _vm._v(" should really have some, she needs it, Annabelle said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They exchanged glances.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother sat back down. So did I. I felt weak, giddy. Normally I hated beet soup but now I drank down a sweet, spicy, bright red bowlful with shreds of beet hovering at the lightless bottom like seaweed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I set down the bowl, my mouth on fire. I felt very strange. My mother and Annabelle sat watching me; they had decided not to have any after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and I put on our coats. Annabelle clasped my hands and wished me luck. My mother thanked her tersely, then handed her a packet of dried herbs. Annabelle gave her a dark stoppered jar which my mother hid in the depths of her coat pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Words passed between them: the gutturals of the old language. How rude of them to exclude me, I thought, but I was too lightheaded to really care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As we walked home that night my feet wobbled drunkenly beneath me; to walk a straight line seemed an impossible thing so my mother loosened her grip and let me weave all over the street. The cold made the stars seem brighter than usual, closer; I thought I could hear them, a buzzing like fluorescent lights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you sure this is what you want? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Positively.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Good, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Is this how you found my father? I asked, feeling bold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The entire city went quiet, waiting for the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your father was the finest man on earth, my mother said shortly. When they made him they broke the mold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The grim set of my mother’s mouth, the glitter in her eye made me want to take her words literally. How angry she looked; she seemed to think that if someone had not broken the mold, she could have used it to cast a second version of my father, in bronze or iron or some stronger stuff more lasting than the first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In my mother’s world, on my mother’s terms, such things were possible.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My fiancé is coming over for dinner tonight, I told Tessie and Marianne.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shirley! You sly thing! When did this happen?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since when do you have a fiancé?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who is he? Can we meet him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could you keep it from us?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My God, Shirley, are you pregnant?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this time, we thought you were such a shy little mouse—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afraid of men—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What color is his hair?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When did he propose?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When is the wedding?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is his name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For heaven’s sake, Shirley, how can you be so calm?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can we please come by tonight and get a peek at him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew it was unwise to tell them before everything was settled. But I couldn’t resist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went home early that afternoon to set my hair. My mother bustled about the kitchen, among boiling pots and clouds of steam, with her sleeves rolled and her hair plastered to her face. It would have seemed like laundry day if not for the vigorous smells and the sheen of grease.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why does he have to come here? I said. Why can’t he and I go to a restaurant alone? How can I get to know him with "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" here?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" get to know him otherwise? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had no answer for that. I went to my room. The night before my mother had soaked my hair in one of her evil-smelling herb solutions. Today it was strange and downy and full of static electricity. I put my hair in curlers, I varnished my nails. I had bought a girdle for the first time. I put it on underneath my dress; I could hardly breathe but I was pleased with my reflection: for the first time in my life I had a figure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I applied makeup carefully, as Tessie had taught me. I put a drop of vanilla behind each ear. My mother disapproved of perfume.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How strange I felt, then. As if my heart and throat and stomach had got shuffled up. As if a helium balloon were inflating inside my chest, pressing on my rib cage. I could not sit still.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It must have been the girdle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He arrived punctually at seven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I opened the door and there he stood, flowers in his arms and a smile on his face. Our eyes met for the first time. His were blue! I had never noticed before! He took my hand; his was cool and smooth; he smelled of lime aftershave lotion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh his eyes! His manners! Impeccable!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even my mother seemed charmed. He kissed her hand. She dropped him an old-world curtsey. He sniffed the air appreciatively.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took his coat, went to hang it. I trod on it by mistake, stumbled into a wall. I don’t think he noticed. It was so long, his coat. How tall he was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course the conversation was awkward. How could it not be? He thought we were strangers, he and I. He spoke of his late parents, his job in insurance. Insurance! How dependable, how respectable that sounded! He had a lovely laugh; whenever the conversation lagged he turned on his laugh and kept it going, kept unrolling and unrolling it like a never-ending carpet, until I thought of something else to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sat down to eat. My mother lit candles. Everything was going so well. I looked across the table at him, the candlelight making his eyes dark and velvety, his skin golden. I felt I was glowing; I caught my reflection in a spoon and hardly recognized myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How sophisticated I felt, so poised and glamorous. He would never guess that it was the first time I had ever dined with a man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course nothing had been said about love or marriage. But do these things really need to be said? I could feel a bubble of happiness swelling in my chest, ready to burst. His hands! The hair on his knuckles! Cuff links! I wanted him to whistle again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt something new as I looked at him: a feeling of certainty, like bricks being stacked up, mortar slapped in between. A solid, definite feeling. Foundations laid, a future, a firm base. I felt sure of something, for the first time in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother brought in the soup. Borscht again. We drank; it set our mouths on fire, stained our lips red. My head began to spin. The borscht seemed thick, meaty; it made me feel carnivorous and wild. I found myself looking at the fleshy parts of his body: his earlobes, the pads of his fingers, the tender morsel of his chin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe looked at me, his eyes were dancing. I offered to help my mother; she pushed me down in my seat. She poured wine and brought out plates and serving platters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She filled Joe’s plate first, set it before him and paused, serving spoon uplifted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well Joe, she said firmly, so when are you marrying my daughter?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe started, his face froze. Then he started to laugh, or he tried to, he could not seem to get his laugh engine running this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m afraid I don’t—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When are you marrying Sashie? my mother repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He attempted the laugh again; it sputtered and died. You misunderstand, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t think so, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annabelle asked me to come here, and I was glad to, but I didn’t realize—he said and looked at me. We’ve only just met, he added apologetically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother waved her hand dismissively.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But you see—I’m in no position to—I have these debts, you see, I can’t possibly. I have no inheritance—a fondness for gambling—nothing serious, of course. But my hands are tied. And then I already have a young lady friend—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My stomach went cold. The brick wall crumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your daughter’s a lovely girl, but—it’s ridiculous—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His face blurred, my eyes grew hot. I couldn’t be crying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother fixed her fierce gaze upon him. He writhed under her stare. In his embarrassment, he turned to his plate. He shoved a forkful in his mouth, then another, and another. Sweat broke out on his face. I saw a flush spread over his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How handsome he looked even then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rather than meet our eyes, he kept eating, even as the beads of sweat became a sheen. I heard pops, snaps, as he splintered bones between his strong white teeth. His face turned redder and redder and shaded to mahogany; his eyes bulged. My mother must have had a heavy hand with the spices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tears were bubbling in the corners of his eyes, as if his very head were boiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He moaned without pausing in his chewing, so the sound came out of his nose. I could see blue and purple veins in his temples, like rivers and roads, the map of his self.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then he began to choke. His wheezing breath stopped abruptly; all we could hear was a clicking in his throat. He looked at us now, eyes rolling, one hand to his throat, his mouth gaping like a fish’s. He looked at my mother, then at me, his feet kicking and stamping beneath the table.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A dribble of food ran from his mouth and made a black stain on his shirt. Oh, his clean shirt!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He slammed his fists on the table. The silverware danced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother watched him calmly. She sipped her wine and dabbed her mouth daintily. She twisted her napkin, tighter, tighter, between her fingers. Her lips were red stained from wine and beets. Then she moved the bottle of wine closer to her, so Joe would not knock it over with his flailing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stared at her imploringly, stretched out his arms. She lifted her chin in a questioning way. He turned to me. I stared, fascinated. His face was filled with such desperate longing, such desire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He collapsed in the chair, his eyes began to glaze.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother said: Sashie, help him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran to his side, I stood behind his chair. I wrapped my arms around him and squeezed beneath his ribs, as I had been taught. How broad his chest was. I could barely reach. It did no good. Limp and heavy as sandbags, his body tumbled to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother tossed her napkin aside and drank her wine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took his head in my lap (how heavy it was! I had never held a man’s head before). I wiped his mouth, loosened his tie. I parted his pretty lips, reached deep down his throat, and plucked out a tiny fish bone, curved and translucent as a fingernail clipping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I placed the bone on the table, stroked his hair, put my lips to his and breathed into him (my first kiss! how romantic it all was!). He flopped about like a beached fish. I saw his eyes snap into focus, saw them fill with wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wonder at being alive, wonder at being in love, wonder at lying in my arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He clutched at me, sucked greedily at the air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everything was decided right then, without words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I saw my mother reach over to take the fish bone and slip it into her pocket. But I must have imagined it in the confusion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was in love, after all. People in love can never be trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Joe told me later that when he had opened his eyes and seen my face hovering over him, he thought I was an angel. You had light shining all around you like a halo, he said, and a holy look on your face. I thought I was dead, in heaven, I’ve never seen anything so beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After that first dinner, Joe came to see me nearly every day. I don’t know what it is, he said, but I can’t seem to stay away from you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("My angel,")]), _vm._v(" he called me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Silly Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Each time he came my mother made him drink one of her herbal teas to soothe his throat. He regarded her with a mixture of respect and fear, and obediently drank, holding the mug in both hands like a child. The bitterness made him cough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He never again mentioned his lady friend, or his debts, or the other silly things he had spoken of at our first dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We made wedding plans. I dreamed of a white cake decorated with flowers, a dress like a wedding cake, a bouquet of roses like silk and spun sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe prepared to move into the apartment with my mother and me. It made sense, after all; there was so much room since my brothers were gone. And I didn’t want to leave my mother alone. She would be glad to stay near us. She would help take care of Joe, fix her tea for him every day, since his throat never seemed to mend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe often said in those early days that he couldn’t live without me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course he didn’t mean that. It was just love-talk.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was something not quite right about it all, though I could not put my finger on what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told myself it was because I had never had a wedding myself and had never even attended one. I did not know how courting people were supposed to act.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had followed Anya’s instructions, and it all had happened the way she predicted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And yet there was a feeling of unease, it was like a bad smell hovering in the apartment, like an ugly stain on the back of your skirt that no one will mention.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie was happy, but she seemed happier alone, in front of her mirror trying on the hat with the white veil, than she did when she was with Joe. Her conversations with him were strained and formal. And Joe himself did not seem quite real to me, he did not give off the living heat that Shmuel had. I sometimes found myself watching Joe closely to make sure he was breathing. I thought that if he were sliced open he would be bloodless and dry; he would be made of mealy translucent layers like an onion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Sashie was happy, and that was what mattered, wasn’t it? She had never found much happiness with me. I admit this. Now I hoped she would be able to find some kind of happiness away from me. This was my gift to her.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wedding was small, we could not afford much. My mother did not want to waste money on a white dress I would only wear once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I suppose you’re wearing "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that")]), _vm._v(" to the wedding? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was still in her widow’s black.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Black at a wedding is bad luck, I said, and anyway it’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("so")]), _vm._v(" unattractive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t talk to me about bad luck, she said darkly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She wore her black dress but everything was lovely just the same, as elegant as I could make it. There was a small ceremony in an office at the courthouse, we were in a hurry you see, no time to rent a hall and have music and dancing. It was just us, and my mother, for Joe had no family. But he looked fine and dashing in a dark suit, and he smiled at me so charmingly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We were married then, it was all official, written indelibly on paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There they were, our names, side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later we came back to the apartment which I had decorated with fresh flowers everywhere, and drapery (what are you doing with my bedsheets, my mother had said), and Tessie and Marianne came in to eat cake. Annabelle had been invited but declined to come, or so my mother said. Joe brought in some of his friends and they stood in a corner slapping each other on the back and laughing loudly, and it was good to hear the rumble of male voices in the room again after all these years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Right from the start Joe was properly respectful with me in front of other people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He hardly touched me. Only when absolutely necessary. He seldom even met my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was as it should be. We were not like those couples who rubbed and drooled on each other in public. We were better than that. More refined.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When the guests had left the apartment was strangely quiet again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother said softly: Be fruitful and multiply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She swept the floor clean of crumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe drank a last cup of wine. And then another, because the bottle was nearly empty anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We went into my bedroom. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Our")]), _vm._v(" bedroom now; he brought over two suitcases full of his belongings earlier in the day. I had pushed together the two beds that had once been my brothers’.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe smiled at me and began to remove his clothes. When the jacket came off I was slightly disturbed to see the yellow sweat stains at the underarms of his white shirt. I’ll need some bleach, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He removed his shoes and I saw that his socks were full of holes, his toes protruded obscenely. This I did not like, but I told myself: he needs a woman to look after him, that’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The socks came off. His feet frankly repulsed me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked up and noticed me watching then, and I quickly rearranged my face, I did not want him to know what I was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He seemed to misinterpret my expression, mistaking it for an amorous one, because he unfastened his trousers, and let them fall to the floor, and then began dancing, waltzing around me in wide circles with his shirttails flapping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His hair which had been so carefully slicked back now flopped forward in sticky strands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned and turned to keep my eyes on him. He looked narrower somehow, less impressive without his jacket and with the beard growth that had begun on his jaw. And his legs, it was the first time I had seen his legs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("great")]), _vm._v(" deal of hair on them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe would require some polish, I realized.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stopped his spinning and came close and began to tug at my clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh stop it Joe, I said, that’s so uncouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Without stopping it, he said: What on earth do you mean? This is what married people do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I knew this, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew what marriage meant. I had thought about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was just that it seemed so very different now that I was facing the ugly bald fact of it. Now that I was staring down the barrel, so to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed very "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("unsanitary,")]), _vm._v(" this thing we were going to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And undignified.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of my parents standing together, my mother with her hands on my father’s chest. I did the same to Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s right, he said with wine on his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked up at him and wondered where he had spent his childhood, and what his mother’s name was, and whether he was left or right-handed. I hardly knew this man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All that was not so important. It could come later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We went and lay in the bed then, and I felt better once we were between the clean white sheets. He lay against me and I asked him to turn out the lights because I did not like to see him so terrifyingly close, with his amazing profusion of pores and tiny hairs in odd places. He did, and I liked that much better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe did his duty then, he consummated the marriage and it was slightly uncomfortable but not too bad, though he frightened me terribly by gasping and groaning as if he were in pain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And his hair pomade left a mess on the pillow, I discovered the next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As we spent more nights together I learned to accommodate him better, and I even looked forward to the times in bed with him. He worked long days, and these nights in bed were the only time I had alone with him, the only chance I had to discuss private matters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As time went on I discovered that the best time to voice my request and demands was early on in the proceedings. He was alert and impatient then and gave in quickly. And "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("after")]), _vm._v(" the act was the best time to tell him less pressing news, when he was relaxed and purged and half (or wholly) asleep. He would agree to almost anything then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hmmm?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe, do you find me attractive?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course I do. How many times do I have to tell you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know, but … Joe?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you think I look like my mother?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Could you lift your head a minute? My arm’s falling asleep. There.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do I what? Oh, I don’t know. A little bit. There’s a resemblance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you think I’ll turn into her when I get older? "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Much")]), _vm._v(" older, I mean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God, I hope not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why not? Joe? Do you not like my mother?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I like her fine, I guess. It’s just the way she looks at me sometimes, makes my skin crawl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How does she look at you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And the way she talks to herself at night. Haven’t you heard her?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, but "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("how")]), _vm._v(" does she look at you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s that look widows have, I guess. Dried up and lonely, thinking about what they’re not getting anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t talk about my mother like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gives me the creeps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The two beds often drifted apart in the night, and we had to push them back together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the mornings he was bleary-eyed, bloated, I hardly recognized him. But once he had washed and shaved and dressed for work, Joe looked as handsome as ever. This was the Joe I adored.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At night we kept the lights off and when he touched me in the dark I pictured the daytime Joe in my head, in his hat and gloves and fresh-shined shoes. That helped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment seemed much smaller than it ever had before. I could not help noticing the way my mother and Joe brushed against each other in the tiny kitchen, squeezed past each other in the narrow hallway. In the mornings, as Joe tramped back and forth between bedroom and bathroom in various states of undress, I noticed my mother watching him. I’d previously thought she was frowning at the puddles of water he tracked on the floor. Now I wondered if she were looking at something else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One night a bit of paper slipped from Joe’s pocket and as he bent over to retrieve it I saw my mother’s eyes linger on him much longer than the situation demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I was being ridiculous. My mother was an old woman, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yet she climbed the stairs faster than I; and from behind, with her skinny arms and her hair in two long braids, she looked like a little girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to spend as much time alone with Joe as possible. I found myself forever shutting doors, sliding my chair closer. I wondered if my mother noticed, if she felt neglected.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she seemed quite happy with her new privacy. Of course, my mother has her own version of happiness, it is not like other people’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I intended to redecorate the apartment but I was soon distracted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I discovered I was pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I told my mother her face softened as it had not in years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told Joe and he was overjoyed, he picked me up and spun me around. He had never done that before, and it made me want to vomit, but I was glad that he was glad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was so happy for me that he went out with some of his friends to celebrate and did not return until dawn, rumpled and smelling of wine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I do not need to tell you about the pregnancy, about the birth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s a process my mother loves to talk about, she is fascinated by it. I am not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s a story that has been told a thousand times.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s always the same, it does not bear repeating.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Jonathan was a beautiful baby, it was an easy birth though my mother was horrified that I had gone to a hospital and actually enlisted the aid of a doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’ll be cursed, she said, you’ll bring evil luck down on us all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother. After all these years she still clung to those peasant superstitions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She conceded to come to the hospital afterward, where she cradled the baby and crooned wordlessly. Jonathan was perfectly healthy, with dark hair like his father’s and startling blue eyes like his grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe was red faced and bursting with pride. He took the baby in his arms once, and looked terrified, and never picked him up again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I might hurt him, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He went out to celebrate and I did not see him till I came home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan was a beautiful baby, as I kept telling myself and everyone kept telling me. But I was tired and listless in the weeks following and the grayness of the apartment oppressed me. His screams, the odor of him, his needs, they oppressed me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother cared for Jonathan during that time. My milk stopped and I tried to explain to her about formulas and sterilization, but she brushed me away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I never knew how she fed him, but Jonathan was plump and happy. I saw no bottles, no boxes of powder in the kitchen; it was as if she were nursing him herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lay in bed and heard them talking in the kitchen, her voice and Joe’s rising and falling, too close together. Talking about me, I knew, conspiring together. I heard laughter, the baby crying. Wailing, without pause for breath, like a teakettle. What were they doing to make him scream like that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The screaming went on and on, and I was no longer sure if I was awake or dreaming. I could not stand it, I rose and went to the door and peered down the hallway to the lit kitchen which glowed orange like a furnace. I saw Joe sitting in a chair and my mother bending close over him and I was somehow not surprised to see them like that, their mouths so close. I had expected it. My devious mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then my mother shifted, and I saw her hand working and there was the flash of a steel blade dangerously close to his face. She’s going to cut his eyes out, I thought, and this did not surprise me either. My mother was capable of anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran into the kitchen to grab her arm, and I saw the scissors in her hand. I realized she was trimming Joe’s hair, the way she used to trim my brothers’, with newspapers spread over the floor to catch the trimmings. She and Joe both stared at me, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only a haircut, their innocent eyes seemed to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But they looked guilty, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh good, you’re up, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was unbearably hot in the kitchen so I went back to bed without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later my mother’s face hovered over me. She put a glass of water in my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe left me alone all this time. He was considerate that way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother was not. She kept trying to rouse me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s not my place. A child needs his mother, she said to me one day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Was she referring to my son or my husband?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lay in bed, a wet cloth on my forehead. I dreamt of cool things: lace curtains, bone china, crystal goblets, the tinkling of the glass doodads on chandeliers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is not natural, my mother said from the doorway, balancing Jonathan on her hip. I am glad to do this, but it is not natural. Your child needs you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sat on the edge of the bed, the baby against her shoulder. She touched my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had never been especially close, and were not now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Never been close, yet at the same time "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("too")]), _vm._v(" close, I was suffocating, the room was squeezing me like a girdle. Her hip touched me and through the sheets it felt burning hot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had no idea what she was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And as she sat near me, studying my face, I realized for the first time that she found me as incomprehensible as I found her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whatever is the problem? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m unhappy, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But why?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hate this apartment, I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had wanted to say that for years but knew it was futile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps you should move then, she said and abruptly rose and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she would never want to leave this apartment. She had lived here since she came to this country, it was practically a member of the family by now. She would never leave it, and I could not leave her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I was surprised that, when Joe came home one evening announcing he had been given a promotion, my mother said: It’s time to move to a new place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe said he would look for another apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not entirely trust his taste but it did not matter, we would be leaving this dark apartment with its dingy memories, leaving this neighborhood of narrow streets, loud radio music, stray cats, undergarments strung on clotheslines above the street, gutters clogged with unnamable things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I got out of bed. I curled my hair for the first time in months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took my son in my arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And in a matter of days Joe said he had found an apartment he knew I would love.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to go with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This apartment was crammed with memories, stains, the musty clothes of people long absent. I could not imagine leaving. The new place was so far away that people spoke differently, dressed differently. Even the light fell differently, it was paler and colder. It would be like traveling to a new country. Where would I buy my cabbages and cinnamon? Who would sell me the leather scraps to mend my shoes?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And how would Shmuel find his way to bed?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had hoped they would move without me. Sashie needed to learn to care for her own child. She did not need me. She and her husband needed privacy, they needed to get acquainted. After a year of marriage they hardly knew each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I admit that after a lifetime of tending to other people, I was looking forward to taking care of no one but myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie had never enjoyed my company. Yet she insisted I move with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said it was her daughterly duty, but I think it was something more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think she was afraid to be alone with Joe. I had brought their marriage into being, and she seemed to think it would fall apart without me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I also think she was suspicious of me. She was forever peering over my shoulder, bursting into my room unannounced. She wanted me to stay where she could keep an eye on me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I went with them. Partly because Sashie insisted. But mainly for Jonathan. He squeezed my finger in his strong little fist and gave me hope.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We moved into the new apartment when Jonathan was still a tiny baby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was so excited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was so glad to move, not just for myself but for Jonathan. The old neighborhood had gotten so bad, drunks asleep on the doorsteps who didn’t wake up even when you stepped on them to get out, little girls barely out of pigtails prostituting themselves on street corners. I was sure the place would have a bad influence on him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly Jonathan seemed more important than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everything seemed new to me. Shining and different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A fresh start.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I resolved to clear my head, think of nothing but the future.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Six rooms! For just Joe and Jonathan and me. And my mother of course. We couldn’t leave her behind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was an exclusive building. Joe had to go through an interview just to apply for the apartment. Of course I hadn’t been worried about "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that,")]), _vm._v(" Joe was the sort of man people liked immediately. He knew how to talk to people. I told you what a big, fine-looking man he was; such shoulders, such a chin, such wavy hair. Such a shine on his shoes, the handkerchief in his pocket, folded just so. He had impeccable manners. But he was not effeminate, not a bit. Whenever he met men he would give them a crushing handshake, and a little nod, and a look that meant: you know and I know that I could beat you to a pulp if I wanted, but why don’t we act civilized instead?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was such a fine figure of a man. I wanted Jonathan to grow up to be just like him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So we moved in, and our old furniture didn’t half fill up the place. I couldn’t wait to fix everything up. My mother settled into her room and kept to herself there. I didn’t mind. She still embarrassed me; in this fine place I was more aware than before of her accent, and the thick rolled stockings she wore, and her hair which she dyed pitch-black with something that looked like shoe polish. But I was glad to have her with me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I met our next-door neighbor, Mrs. Fishbein, who seemed a respectable sort. She came to the door in pearls and white gloves, lacquered gray curls and spectacles on a chain; she invited me to take tea with her sometime. And our neighbor across the hall, Mr. Mizzer, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he")]), _vm._v(" looked just like Abraham Lincoln, and he was a retired banker, so of course he was all right.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein was the first to tell me about the street cleaners. Our building was in a particularly exclusive neighborhood; there was a private street-cleaning service that came once a week. There were strict rules governing the placement and sorting of garbage. The cleaners came on Tuesday nights and cleared away everything that did not belong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It sounded too wonderful to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lay awake far into the night the following Tuesday. Finally I heard them: a mechanical, scuttling, buzzing sound down in the street, like a hundred brushes and dustpans, or thousands of little forks and knives scraping up the last of dinner. A soothing, restful sound.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning the streets were spotless. They sparkled. I put Jonathan in the perambulator and took him for a walk. Look Jonathan, I said, look at the nice clean streets. But he seemed more interested in the toy my mother had given him: a carved wooden figure, with blunt features and what looked like real hair. The thing was unsanitary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The cleaners do a wonderful job, I told Mrs. Fishbein.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, she said, it’s taken a great deal of effort, but the streets are finally in a decent condition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein, I discovered, owned a young pug dog that liked to bark in the wee hours of the morning. The dog irritated me to no end, but after her kindness to me I felt I couldn’t mention it. Besides I knew better than to antagonize the neighbors right from the start.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe came home from work tired in the evenings. I met him at the door with a drink and a kiss. Isn’t it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("wonderful,")]), _vm._v(" Joe? I must have said this to him a hundred times. I loved pattering to meet him over the handsome hardwood floors. I loved the pure clean light that came in through the tall windows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wonderful, he always said with little conviction. He had to work harder and longer than before; the maintenance fees for the apartment were more than he had anticipated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("incompleteness")]), _vm._v(" of the apartment disturbed him. I knew that once I decorated the place thoroughly he would see how wonderful it was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every Tuesday night I lay awake to listen to the street cleaners. The streets on Wednesday mornings were marvelous. They looked polished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The streets beyond our neighborhood seemed so dull and dirty by comparison. People sitting on stoops half dressed, garbage bags, tin cans and broken bottles, scratchy radio music, dilapidated cars, children dashing through an open fire hydrant—isn’t that illegal? I did not like to leave our neighborhood even to shop. And I certainly never took Jonathan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I discovered catalogs. I ordered curtains, slipcovers, lamps, rugs, end tables. The convenience! I told them all the measurements and colors over the phone, I told them my name in a clear, slow voice, and then ten days later the things arrived in nice clean cardboard boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The deliverymen assembled some of the furniture for me. I did not like the look of them, their black fingernails, but I could not do it myself, and I did not want to ask Joe. I wanted to surprise him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The white gauzy curtains, the new crystal in the cabinets—everything looked wonderful. I picked up the phone and ordered more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But when Joe came home he hardly noticed. He seemed tired, not at all his usual cheerful self. When I gave him a kiss hello he grabbed me and buried his face in my neck as if he needed comfort. I could smell wilted cologne and a sweaty kind of weariness on his collar. I could feel him nuzzling and smacking against my fresh clean dress, and he began to tug me toward the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh Joe, not now, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s not that I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("mind")]), _vm._v(" acting like silly newlyweds. Not a bit. I don’t mind at all, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("now and then.")]), _vm._v(" But Joe wanted to do it so "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("often,")]), _vm._v(" and always at the most inconvenient times. And he messed up the bed so, he wrinkled the sheets, practically pulled them off the bed sometimes. I was hours straightening up afterward. Not to mention what he did to my clothes. The way he tore them up—as if he’d never seen a button before, or a hook-and-eye fastener!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Besides I was afraid of the influence it might have on Jonathan; I was sure overhearing such a thing could have an unhealthy effect on a child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So Joe let me go, and my mother and I fixed the dinner, and we ate and then sat for a time with drinks and magazines. We spoke little. In fact I don’t think Joe said two words. It was a lovely domestic evening. So peaceful and serene. The living room looked marvelous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night the street cleaners sounded smooth and graceful, as if they were ballet dancers pirouetting down the street catching dust on their tutus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning Mrs. Fishbein told me that one of the children who lived upstairs left his bicycle on the stoop overnight. Now it was gone. We could hear him bawling above our heads.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was unfortunate, perhaps, but it was the child’s own fault. He should have followed the rules. Everyone else in the building did. Everyone came home early Tuesday evenings, stayed inside, drew their curtains, locked their doors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A few nights later Joe came home looking brisk and determined. Let’s go out tonight! Come on! he said. He grabbed my arms and swung me around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anywhere you want, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at him. He appeared handsome as usual, but looking closer I saw one tiny hair protruding from his nostril. Once I noticed it, I could not "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("stop")]), _vm._v(" seeing it. I looked around the room. I had ordered new throw pillows for the sofa with tassels on the corners. I had hung new drapes that hid the windows completely. I had polished every surface with a toothbrush and a special abrasive powder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want to stay here, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He threw up his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After that he came home later in the evenings. He said he had to discuss business with clients over dinner. He said he had to meet old friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not mind. I was generous with him, let him spend his time as he wanted. I was not a domineering housewife. Besides, I had so much work to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother kept to herself. She had her own life, she came and went as she pleased. I stayed away from her room; the sight distressed me. I reminded myself that she was born in a country where people bathed once a month and kept their chickens in the kitchen in winter. She had come very far, considering. I never questioned her, and I was glad whenever she took charge of Jonathan. Somehow she never seemed to mind changing his diapers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tuesday nights were my favorite time. The cleaners had a brisk military sound, like marching troops spearing wastepaper on their bayonets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Late at night after they had finished I always felt clean and purged and luxuriously peaceful. Sometimes I felt so good I woke Joe and let him have a little fun with me. But he had to promise not to thrash much or disorder the bedclothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Several weeks later on a sunny Wednesday I came upon Mrs. Fishbein sobbing in the hallway. She said her pug had disappeared; she felt sure he had wandered down to the street the night before. I tried to comfort her, but the dog never reappeared and I cannot say that I was sorry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We received notices in our mailboxes stating that the street cleaners were upgrading their services at no extra charge. They would now come on both Tuesdays and Thursdays.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was thrilled. Now I lay awake two nights a week listening to the cleaners, like low-rumbling clouds rolling through, or a crackling forest fire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein mourned her pug. The days were uncommonly bright. Jonathan grew and thrived. One Thursday I forgot to bring the perambulator up from the street and the next day it was gone. It was a small loss. But Jonathan raged for hours, screaming for the little wooden doll that had been left inside it, under the blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe came home early on Tuesdays and Thursdays like everyone else, but on the other nights, on Wednesdays and Fridays and weekends, he stayed out later and later and came stumbling home in the wee hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then a rather odd thing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the first floor of our building there lived an elderly woman who kept two dozen cats in her apartment. She had moved in long ago, before the screening process was established; she’d lived in the building for years, in spite of people’s polite attempts to dislodge her, and the cats. It was unsanitary; the smell; the very "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("idea")]), _vm._v(" of two dozen cats! Not to mention inhumane to the cats themselves. Not to mention what people might think when they walked past our building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What happened was simply: one Thursday, around twilight, it seems the cat woman stepped outside to empty some litter trays. She apparently locked herself out of her apartment. Now she had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I discussed it with Mrs. Fishbein in the hallway. I’m sure she just wandered off, went into the wrong building, she was senile, that’s all, I told her. But Mrs. Fishbein shook her head with frightened eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What would you do if it had been your mother? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She closed the door between us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had hardly been listening, yet her words stuck in my head for days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("would")]), _vm._v(" I do? The thought of my mother neatly, silently swept away. No one’s fault, no guilt, no one to blame. An extra room. No longer being reminded of what she did to my brothers, or how she felt about Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A clean and empty space.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Terrible thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pushed it away. Though it returned unbidden from time to time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I loved my mother, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the thought lingered sometimes in the night as I lay listening for the street cleaners. The mind has a way of fixing on thoughts of dropping babies from windows or jumping from bridges or pulling triggers—possibilities, accidents you imagine in detail but hope "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("never")]), _vm._v(" actually happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The cat woman did not return. Her apartment was cleaned out, the cats were taken away, and a nice-looking young couple with a grand piano moved in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our neighbors began coming home earlier and earlier on Tuesdays and Thursdays. I still loved the sounds on those nights: a crisp clean scuttling, like those amazon ants in tropical countries that sweep through villages devouring everything in their path.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein clutched at my arm and whispered that one of the children from upstairs had gone for a bike ride near sundown on a cleaning day and had not returned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s like the angel of death passing over, she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her not to be silly. Children like to run away from home sometimes, I said, but they always come back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She shook her head and retreated into her apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was nothing, only talk. Those children were too noisy anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein began leaving strange things out in the street on cleaning days. A lamp, a quilt, a boxed cake, new gloves, bottles of pills. Little offerings for the cleaners, as if she wanted to appease them. As time went on the gifts grew more elaborate: she set up little shrines with lighted candles, incense, handwritten poems, a stuffed turkey, an umbrella, her own dresses and corsets neatly folded and tied with ribbon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All of it gone, swallowed up the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I mentioned her to Mr. Mizzer once, tried to get him to laugh about it. He frowned and shook his head and said: The cleaners can’t go on like this. It has to stop. We have to do something.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was furious, but I managed to keep my voice level as I said: How can we ask them to stop? We "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("need")]), _vm._v(" them. If they stop coming then everything will go back to the way it was, trash piling up, the drunks and prostitutes, the strangers on our doorsteps, crime and disease and horribleness everywhere. We "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("can’t")]), _vm._v(" go back to that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He retreated into his own apartment, which was full of musty books. Dust catchers, I called them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment building was so quiet now. I loved to wander the empty halls, peer out the windows at the sparkling streets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One day Mrs. Fishbein tapped at my door. I don’t wish to upset you, she said, but on a recent evening I saw your husband walking with another woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m sure it was nothing, I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("extremely")]), _vm._v(" close, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It must have been his sister, I said quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were embracing, she said. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kissing, I’m afraid,")]), _vm._v(" she added in a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister’s Canadian, and you know what "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("they’re")]), _vm._v(" like, I told Mrs. Fishbein.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course I did not believe her for a second. Joe would never do such a thing; I knew him too well. He would never do such a thing to our family. I resolved not to say anything about it to him; I did not even want him to see that I was upset; it would worry him. So I concealed the whole incident from him which was easy enough to do since we seldom spoke anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But somehow I could no longer sleep at night, and not even the cleaners could soothe me. And there was the matter of the matchbooks I found in his trouser pockets, taken from various nearby bars.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I finally decided to see for myself. I would do it for Joe’s sake. I would prove that Mrs. Fishbein was blind, and insane, and a babbling fool. I dressed myself carefully, gloves and a hat with a veil, and special galoshes to keep my shoes clean; and I set out that night to find him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had not been outside the neighborhood for so, so long. The streets were strange and frightening. So "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("dark,")]), _vm._v(" and there were "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("puddles")]), _vm._v(" everywhere, and people lounging against walls doing nothing in particular. I walked as quickly as I could; even the air seemed filthy, clammy, it clung damply in my lungs. And the noise: cars screeching, people calling out, the radios—is that what they call "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("music?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I brought the matchbooks in my purse, and strained my mind to find the proper streets. My side was aching, but I was determined.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I found him at the third bar I checked. A dark, smoky place, men and women pressed close together, talking too loud and laughing, and dirty sawdust on the floor. I saw him sitting in a corner with a woman. He had his arm around her, they were both smoking with their faces inches apart, talking and blowing smoke at each other. She had dyed hair, a tired sagging face. And yet they were smiling. Joe smiling! I saw him touch her breast in that public place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fled. Street-corner men called after me, hooting. I ran home as fast as I could. Oh, the relief of the clean bare streets. Oh, the lovely clean hallways, gray and antiseptic as a hospital. And finally the heavenly apartment with the sealed windows, the pure air, the sheets crisp as new paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was distraught for days. I did not know what to do. I did not want anyone to know. Our domestic life was so perfect, I could not understand how he could do such a thing. Our lovely marriage, our lovely home, our lovely child. Joe would surely have a detrimental effect on his development. A broken family would traumatize Jonathan at this stage. I had to protect my child at all costs. I had to preserve our family’s reputation, if only for him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said nothing to Joe. I waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then, in this time of strife, I discovered I was pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was furious. I did not want another child. I wanted to concentrate all my energies on raising Jonathan, I wanted him to become a fine handsome man like his father, but I needed to carefully cultivate in him Joe’s good qualities and weed out the bad ones. I had no "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("time")]), _vm._v(" for a second child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not eat or sleep. I spent hours soaking in scented bath-water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mrs. Fishbein came tapping at my door again. How many sisters does your husband "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("have?")]), _vm._v(" she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I closed the door in her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not bear it anymore. I told my mother everything. She patted my arm, gave me a sharp look, and told me not to worry. I listened to her. I saw a strength, a certainty in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next day, a Tuesday, we again received notices in our mailboxes. The street cleaners were again upgrading their services: they would now come every night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I meant to bring the notice up to our apartment, with the other mail, but somehow or other I lost it. That night I lay awake beside Joe’s dead and distant weight. The street cleaners shrilled like locusts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The following day I lay in bed as usual long after Joe left for work. Then I bathed. I scrubbed the grouting between the tiles in the bathroom, then I bathed a second time. I took a dusting cloth and wandered through the apartment. I could not for the life of me find a speck of dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went into the nursery and lifted Jonathan. He was clean and powdered, his big eyes pure and innocent. He looked so like Joe, he really did. I promised myself that I would work hard to make Jonathan into the kind of man Joe "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("used")]), _vm._v(" to be. The man Joe "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("could")]), _vm._v(" have been if only he had tried a little harder. It would require a great deal of attention to keep Jonathan on the proper path. A great deal of cold baths and toothpaste, rules and tight-fitting shoes and bleach. But it would be worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of the child inside me, and it occurred to me that it might be a boy, and he might look like Joe, and in that case I would have to raise him perfectly as well. If it was a girl, I wouldn’t bother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I laid Jonathan back down, covered him carefully, and dimmed the lights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I came upon my mother crocheting quietly in the living room. I said: By the way, did you happen to tell Joe, the street cleaners will be coming every night from now on, they will be coming tonight, so he should come home early.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t tell him, she said calmly. I must have forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: I must have forgotten, too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night the street cleaners dipped and swooped like birds of prey, they circled like scavengers, they bored in like maggots, and I slept deep and sound.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had only wanted the best for her. I only wanted her to be happy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should have known better. I should not have trusted Anya.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was mostly my mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I thought my daughter was somewhat to blame as well, though I could not have said why. She had handled her husband wrongly, there was something lacking, a coldness between them like a glass wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps it had something to do with that place we lived in, all cold smooth surfaces and high ceilings that made me anxious, too much space all around. We were rabbits in an open field.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was no way to send down roots in such a place; it resisted me like a waxed surface repelling water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was glad to go back to the old neighborhood, where things made sense and I could find work to do with my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were the children, at least.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She could thank him for that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had gotten something out of the bargain.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Back we went, to the old neighborhood, my mother and Jonathan and I.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We found an apartment in a different building on the same street as our old one. It felt just like the old place, same smells of cabbage and onions, same dripping faucets, same shouts in the stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The previous tenant had left behind broken-backed furniture, lamps that did not work. We did not bother to remove it before bringing in our own, so that the rooms were crammed with furniture, barely room to walk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My pregnancy made it doubly difficult to squeeze between the sharp edges of bureaus and davenports and great hulking lumps of furniture I could not even identify. Everything festooned with ugly carved woodworking, carved gargoyles and leaves and enormous bulbous wooden fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I deserved better. I did not belong there. I had more refined tastes, I had hopes and aspirations. I needed gentler conditions, more delicate company.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother retreated and I didn’t care. She folded herself inward, hid her heart away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to keep the place clean, but dust seemed to spring up on surfaces overnight. Even just-washed dishes, drying in the rack, wore films of gray dust in the mornings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I concentrated on myself, on maintaining my clothes, curling my hair, containing the mess and leakages and blooming stains and general untidiness of pregnancy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daughter was born. The details are not worth mentioning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even with the two small children squalling at all hours, the apartment seemed dull, barren, quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By now I knew to attribute this to the absence of any men. Men bring life into a place. Without them there is only working and waiting. There is no story worth telling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a pity Joe had not worked out as I’d hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Luckily there was Jonathan. I had high hopes for him. I watched him grow and become bright and strong and handsome, and my mother watched him too with a kind of hungry anticipation. I knew she was thinking of Wolf and Eli, hearing their voices when Jonathan went running and laughing round and round and deep in the labyrinth of furniture, oblivious to our expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed he went into that forest of furniture a boy and came out a man, so fast do children grow.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I dreamt of a butcher shop on a poorly lit street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It looked familiar, though I could not think where I had seen it before. My mother did all our shopping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The fat butcher behind the counter wiped his hands on his apron, leaving red handprints. On the wall before him hung photographs of thick-bodied blond girls trussed in too-tight white dresses. I opened the door of the shop and entered and a bell tinkled above my head. The mat beneath my feet read "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("WELCOME")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The photographs began to move and shift, the girls in the pictures grew until they filled the frames, they pressed their faces up close, as if the pictures’ surfaces were windows they were trapped behind. They pressed so close their breaths fogged the glass and I could see pimples, and shreds of dinner caught in their teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girls drew pictures with their fingers on the clouded glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tallies, words, messages. To me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What would you like, the butcher asked me. He spoke rudely and impatiently though the shop was empty. I looked outside at the vague dark street. I could not tell if it was late night or early morning, the light was indecisive, and I did not know what to order.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked in the glass case before me. Laid out alongside the cuts of meat and chicken parts on the ice I saw clothes neatly folded, gloves, worn shoes, tarnished jewelry, false teeth, watches, candlesticks, and trinkets as in a pawnshop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well? the butcher said and pulled at his mustache, drawing his upper lip away from his teeth and letting it slap back. You haven’t got all day, missy, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched his lip being pulled again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ve got a narrow window, he said, a narrow window of opportunity here, you see what I’m saying? And your window’s just about shut. This is your last chance, lady.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He leaned closer and I looked past him at the great slabs of meat hanging on hooks behind him, pink and red and larger than men. They dripped into the sawdust on the floor. White joints and long bones and shiny gristle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And as I looked, the carcasses began to writhe on their hooks. They twisted, thrashed, as if trying to free themselves. A long rack of ribs curled up on itself like a caterpillar, like a trapeze artist! A length of tongue flopped obscenely, spraying drops of blood. The more they moved, the more the hooks dug in and tore the flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The butcher, oblivious to the activity behind him, sighed impatiently and waited for my order. Flecks of blood rained down on his bald head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The lengths of entrails on the floor behind him began to untangle themselves; they raised their heads like cobras and tried to crawl back into the cavities they had been torn from.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A chunk of heart muscle behind the glass began to beat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The butcher gave a grunt of disgust and reached behind him, pulling a live chicken from a crate. He held it down on the counter in front of me and I saw its eyes, enormous sad eyes like a man’s, with long lashes. Those eyes rolled here and there in a panic, then they looked straight at me and began leaking tears from their corners.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Halved, or quartered, or cut in parts? the butcher said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the cleaver came down before I could answer. Again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The eyes continued to look at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Too late. Too late to say I had wanted it whole.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told my mother about the dream the next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("imagine?")]), _vm._v(" I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother took my hand and held it tightly. Don’t cry, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hadn’t realized I was crying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It must be because that shopkeeper was so "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("rude")]), _vm._v(" to me, I said. So impatient, so pushy. I can’t bear it when people are rude to me, even in dreams. People are so uncivil these days, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m sorry, she said and held my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afterward I regretted what we had done. I regretted the whole business.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wished I had not meddled in her life in the first place. I was too eager to get her neatly matched up and settled and sent off. I should have let her find her own bumbling way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had placed this man in her hands, and then when he offended us we had thrown him away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had brushed him out of our lives like a speck of dust. It was the first time Sashie and I had united our efforts in anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sharing the guilt certainly did not bring us any closer together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had hardly known Joe. That had made it easier to get rid of him. Yet the thought of him kept me up at night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie was troubled too though she did not admit it. Her remorse came out in her dreams; the consequences of what we had done sprung upon her then. The ugly loss, the gaping holes, the lost opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We never spoke of it. But it bound us together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It nagged at us like stitches in flesh that itch and tug and long to be torn out no matter how much it might hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Watch this, Jonathan said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We were in the back bedroom where the curtains were always drawn and wallpaper peeled from the walls in strips like scales. Our mother lay on the bed, asleep. She slept a lot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come closer, Jonathan said, already on his toes beside the high bed, leaning over it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could see her breasts rising and falling, the black vents of her nostrils. Her breath faintly squeaked somewhere deep in her throat. She slept fully dressed, with her shoes still on, wearing all of her jewelry: a ring on every finger, earrings, strings of beads around her neck, brooches pinned to the front of her dress. She slept with one hand at her throat, as if expecting some disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had always warned me to be sure to wear clean underwear without any tears. You never know when you might get run over by a bus, or fall in the river or something, she said. If the people at the hospital or the morgue discovered torn underpants, it would bring shame down upon the family for generations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now she lay on her back, head in the exact center of the pillow. The room smelled sharply of ammonia, though I could see dust in the corners. The sheets on the bed were starched stiff as paper, and the wall beyond was plastered with photographs of women with strange dreamy smiles and men with smug grins and hair sculpted in waves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother occasionally called me into this room to bring her a glass of water or a magazine. I never came here on my own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Watch this, Jonathan said and bent close to her and blew softly in her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother’s legs kicked and churned the sheets, her head rocked from side to side and one hand flew up and swatted in Jonathan’s direction. Then she subsided, the hand fell down. Jonathan watched her, his dark hair covering one eye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She does the same thing every time, he whispered. He blew in her ear again, and again she went through the same motions like a windup doll. Her skirt rose above her knees. She seemed much bigger lying down than she did standing up. Jonathan was watching her, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He breathed into her a third time, and she mumbled some words deep in her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We ran back to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You act just like her when you’re asleep, he informed me. I’ve done it to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You have not, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have, he said, you just don’t know it ’cause you were asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not dispute that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He seemed so wise to me, he had a way of stating things so you could not argue with them. He had a thin neck I loved, and soft hair that was always falling forward to hide sections of his face so that you never saw all of it at once. And his ears stuck out at the tops like the handles on the sugar bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve seen you when you’re dreaming, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You have not, I said. Though it was true I always felt as if "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("someone")]), _vm._v(" were watching me, at all times, checking my behavior. When I was alone, when I was in bed, when I was in the bathroom. But that someone couldn’t be Jonathan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now you do it, he said. Go blow in her ear. It’ll be funny.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said, I might wake her and then she’ll get mad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not if you do it right, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. We were not supposed to disturb my mother. When she was roused, her anger took the form of vigorous mothering. This meant enforcing ice-cold baths, then digging the teeth of a comb into my scalp as she pulled out tangles, then a week of wearing old-fashioned woolen underwear that itched and chafed, especially in summer. During those times of punishing attention, she would cook greenish, lumpy dinners and give us sudden, ambushing kisses that pinched, that left us sticky and sore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I preferred it when she ignored us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s your turn, Jonathan said. If you won’t do it to her then do it to grandmother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our grandmother was more accessible, not as distant and aloof as our mother. She was closer to our size, she had tiny hands. She could do anything: remove splinters from fingers and eyelashes from eyes, pluck out loose teeth, untangle knots, fix stomachaches, cure hiccoughs. Her touch felt natural, not like my mother’s awkward jabs. My grandmother could pick me up, carry me cradled against her hip as if I were a baby, even though I was so big my feet nearly dragged on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she was more frightening than my mother somehow. She said things that made no sense, she muttered a language that was more like a hacking cough, she spoke to people who were not there. She knew things without needing to be told.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She")]), _vm._v(" was the one I thought was watching me, all the time, even when I slept.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We went into the sitting room where my grandmother sat napping in a chair shaped like a throne. Her hands clutched the pile of knitting in her lap. The window to her left let in a narrow hand of light that fell across her like a seat belt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Go on, Jonathan said and nudged me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her breathing was soft and even, her head tipped back. Her lids were half open and I could see the wet whites of her eyes, like hard-boiled eggs. Was she really asleep? I could feel her breath against my forehead. I looked into the dark chambers of her ear and half expected something horrible and furry to crawl out. I pursed my lips to blow as Jonathan had, but then decided to check once more that she was asleep. I looked close at her blank, lidded eyes and as I did they twitched and swung around. Her pupils met mine and her hand gripped my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I jumped. To keep from screaming I bit my tongue so hard I saw sparks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What do you think you’re doing? she said. I could hear Jonathan laughing somewhere behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought you were asleep, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should always sleep with one eye open, she said. Preferably two. It’s best to be prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said. My tongue was sore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And don’t be sneaking around, you might find out things you’d rather not know, she added.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here, I’m making this for you, she said and held up her knitting. Try it on, she said, to see if it’s long enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She tugged the sweater over my head. It was scratchy and hot inside, dark with pinpricks of light shining through between stitches. Where were the sleeves? I could not find the armholes and the yarn kept snagging on my fingernails. I wanted to get my head out in the open but I could not find the collar. It must have gotten twisted around somehow; I turned and tugged and it was getting hotter and hotter. I thought I found a sleeve and pushed my hand farther and farther, but there was no end to it. I turned around and bumped into a chair. Jonathan was laughing, out there, somewhere, and I thought my grandmother was laughing too but I could not be sure because I had never heard her laugh before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sweater was my own little world, an entire universe with a hot woolly sky and dots of light like stars, and I thought I would never get out of it. I tried to take it off and start over, but it got caught somehow underneath my armpits and would not budge. I had my arms above my head, bent at odd angles, and my fingers found something loose and tugged and tugged at it, but it was only my own hair. The sweater was growing heavier and heavier.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now I felt something sharp, jabbing at my cheeks and ears every time I moved. Her knitting needles? Were they still stuck in the sweater somewhere? I tried to call to them but my voice was trapped inside the sweater with me. I will be here forever, I thought, in this hot tight place all alone, with everyone else on the outside laughing at me. I’ll get old. I’ll die in here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sweater was pressed tight against my face now, sucking in and out with my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had been inside there for hours, it seemed. Weeks. I could feel that summer was ending, there was a cold autumn wind against my legs. I heard dry leaves scraping against the window, the street vendors folding up their tables and the homeless violinist on the corner blowing on his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sweater was like a live thing, clinging to me, a parasite, and I had the idea that if I rammed myself against the wall I would kill it. So I ran, helter-skelter, caroming off corners, sliding on the floor. I heard something crash, and then I fell. I felt hands peeling the sweater off me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took a deep breath. The cool air was nice on my face. I looked around the familiar room, its piles of furniture like a junk shop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan and my grandmother held the sweater between them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stop laughing at me, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We weren’t laughing, my grandmother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What a baby, Jonathan said. Can’t even dress yourself yet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Leave her alone, my grandmother said. She inspected the sweater, which hung limp and inconsequential in her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s a bit too small, she said. I guess you’ve grown.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("My grandmother told me stories sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Usually when I annoyed her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I annoyed her by asking too many questions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pestered her because she would not give me satisfactory answers. I was sure it wasn’t because she didn’t know, but because she wanted to keep the answer from me, for some reason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People were always keeping things from me, it seemed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hoarding their secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One time, when I had asked "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Why?")]), _vm._v(" once too often, she said: Did you know that before a baby is born she knows everything there is to know? An unborn baby knows everything that has happened, and all that will happen, and all the whys and wherefores.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All babies? I said. Even me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even you. But then what happens is, just before a baby is born into the world, an angel strikes her on the mouth, and it makes her forget everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s why babies cry when they are born, she added. They’re mourning all the knowledge they’ve lost. They’re crying because they’ll have to try to learn it all over again. And they know they won’t be able to, a lifetime isn’t long enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She touched the indentation above her upper lip and said: That’s why you have this mark, here, between your nose and mouth. That’s where the angel struck you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course. How else would that mark get there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not have an answer for that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at my face in the mirror, fingering the little groove. I thought I could almost remember the wonderful things I had known before I was born, they teased at the corners of my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mirror-gazing again? Jonathan said. He came up behind me, saying: Mirror, mirror on the wall, who’s the fairest one of all? Not you, that’s for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He leaned against me and dug his pointed chin into the top of my head. It hurt. This was his way of being affectionate. I looked at our two faces, one above the other in the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I gasped then, and choked a little. It was not because Jonathan had flipped his eyelids inside out, spread his nostrils, and stuck out his tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was because above his mouth there was no indentation at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The angel must have missed him.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I did not like school much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once I had learned to read, I decided school had served its purpose and I did not want to go anymore. I wanted to be left alone with my library books.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I had to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you want to grow up ignorant like your grandmother? my mother always said (after making sure my grandmother was out of earshot).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course I did not want to be like my grandmother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother was wrong, though. My grandmother was illiterate, but she was hardly ignorant. Just the opposite, in fact. She knew too much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still, I did not want to be like her, for her mind was always far away, rooted in a foreign country that seemed to exist only in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to belong "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("here.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I wanted to recover all that lost knowledge that angel had knocked out of me when I was born. I wanted to know everything so I would not have to ask questions of anyone ever again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I went to school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The students in my classes seemed like such children, I suppose because I was accustomed to being only with older people: my mother, grandmother, older brother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My school was several blocks from my neighborhood. It had tall windows, clocks with balky hands, that smell of sweat and mildew and sour milk that only schools have. The classrooms were decorated with pictures of Washington, Lincoln, and Roosevelt, with maps of the world, with color posters of vegetables and meat that proclaimed "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YOU ARE WHAT YOU EAT")]), _vm._v("! In the back of the room was a dank corner where you hung your coat and a boy named Freddie waited to twist your arm until you gave up your milk money.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a girl in my class with long yellow hair, and plaid skirts and sweaters of the kind I begged my mother to buy me but she never did. This girl looked at me sometimes, across the room, her eyes wide. As if she were interested in me. Curious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I would not mind, much, if she wanted to be my friend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One afternoon I was heading home from school when she walked up beside me. I smiled at her, a mysterious smile, a smile I had been practicing in the mirror for a moment like this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We walked for a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I held my books in front of my chest, like she did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to think of things to say. I would open my mouth and start to say something, then change my mind and hum a little instead. I don’t think she noticed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God, those shoes, where did you get them? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother made them, I said. She cut up an old pair of my mother’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nobody else has shoes like that, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh really, I said as if I hadn’t noticed and agonized over it already.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: Your grandmother’s a witch. She eats little children. She drinks their blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No she’s not, I said. She does not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She does too, the girl said. My mother told me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s a lie, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s true and you know it. Just look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know what she looks like, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl said: She eats children, that’s why she’s so little herself. You are what you eat, right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s why she has such long black hair. Nobody else that old has hair like that. Long and dark like a little girl’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She dyes it, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No she doesn’t, the girl said. The only reason she hasn’t eaten you yet is because you’re so ugly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She ran off then, and joined her friends who were waiting for her. They all laughed and leaned close together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked home alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had a scar on her knee, that girl, from where a birthmark had been removed. A big purple mark, with a deep root like a turnip. And she had a mole, raised and brown on her thigh. She was a spotted freak in a short skirt. People said birthmarks weren’t catching, but who wanted to find out?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother played stickball in the street with his friends after school. I did not see him till the evenings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you hate school? I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s not so bad, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course things were easier for him because he knew everything already. He had all that knowledge in his head, but he was too lazy to put it to use. My grades were better than his. But he had the better clothes, and the straighter teeth, and could run fast. He knew how to talk to people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night my grandmother made her beet soup. It was bright red, murky. Amorphous shreds of things settled to the bottom. I pushed the bowl away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eat it, my grandmother said. It will make you strong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at her, at the black hair and dark eyebrows. There was something wrong with her, there were not enough lines on her face, I thought. She and my mother looked nearly the same age.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eat it, she said sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw what she was up to, what she was planning. She wanted me to become like her. She wanted someone to tell all her horrible secrets to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would not do it. I would not let her.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had high hopes for Mara.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw something familiar in the stubborn jaw, in her secretive eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I realized I had neglected her mother, and I resolved not to do the same to her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she did not appreciate the attentions. Every story I told her, she managed to twist around until it became a personal affront. She pushed away my offerings, the soup, the tea, the honey pastry. Everything she touched turned sour. The sweaters I knit for her grew thorns, they became hair shirts even before they left my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She cried when I combed her hair, she said I pulled too hard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She always thought I wanted to hurt her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I wanted to teach her to be strong. Not like her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried, don’t you see?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she can be so difficult, you know how she is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How do you reach a girl like that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is like tossing a ball to someone who refuses to catch it, who stubbornly holds her arms at her sides and waits for the ball to strike her in the face. Over and over, until it is not a game anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had dreams about fires, so I wore my jewelry to bed in case the dreams came true and I had to flee the apartment suddenly. I did not want to be caught unawares.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dreams were pleasant, they were warm and slow and orange-lit, and a fireman broke down the door and then carried me down a ladder as the smoke rolled all around us. I could never understand how he could climb down the ladder without the use of his hands, and I could never clearly see his face, but it did not matter. I could see the hair that curled behind his ear, and his Adam’s apple, and his hands and rubber boots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My jewelry melted from the heat, and I felt a burning in my chest that might have been the underwire in my brassiere turning to liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We went down and down, the fireman descending the ladder as easily as walking down stairs, and we never reached the bottom before I woke up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My children seemed to take care of themselves. I did not notice them much. Sometimes I forgot I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("had")]), _vm._v(" children. I would hear Jonathan clattering down the hall and think it was one of my brothers. I would see Mara’s face floating above a book in a dark corner and wonder if she was the little sister I had sometimes imagined but never really wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt like a girl still. After all, here was my mother, unchanged, in the dress she had worn for the past twenty years, still holding conversations with my father that I could not quite catch. Here I was in this apartment where the light fell just as it did when I was a child. Here was a girl who slammed doors and kept to herself, here was a boy who stood on his head in the kitchen with his heels knocking against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dreamed of a line of women walking in the snow, each one stepping in the footprints of the one before. All around them lay vast stretches of smooth snow, unmarked, unexplored.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This life of mine was like a loop of film, no beginning or ending, just the same figures going through the same motions in endless repetition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed inevitable that Jonathan would leave us and never return, that Mara would be with us forever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to avert this somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched Mara in the bathroom studying her own face in the mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should wash your face more carefully, you’ll be getting to the pimples age soon, I told her. She whirled around, startled. Here, let me show you, I said. No, not like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that,")]), _vm._v(" like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("this.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was all knees and elbows suddenly, flailing past me out of the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked ancient, that girl. She was born old. Did not take care of herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every afternoon she slipped away, all alone. One time I decided to follow her. I thought perhaps she was meeting boys. If she was, I would put a stop to it. She was too young for that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I trailed her to the public library, which seemed harmless enough. But perhaps there was someone waiting for her deep within the bookcases, someone waiting with groping hands and a pink tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched as she returned some books and then drifted up and down the aisles, now and then taking a book from a shelf and flipping through it. I grew bored. Books have never interested me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went to the reading room so I could sit and rest my feet. The shoes I was wearing were my favorite pair, they still looked impeccable, but they had grown a bit tight. It must have been because of the weather, I’ve heard the humidity makes the leather contract.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I noticed the man at the table next to mine assiduously taking notes. Books were spread around him in neat stacks. He was wearing a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("bowler.")]), _vm._v(" And a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("cravat.")]), _vm._v(" I had not seen such a well-turned-out person in years. The handkerchief protruded in a perfect point from the breast pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Subtly I glanced beneath the table and noted his cuffs, socks, well-shined shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyes met mine for a long pleasant moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went home then, for a lady does not linger in public places.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I returned the next day and remembered to wear my gloves. He was at the same table, deep in his research. I picked up the nearest book at hand and sat near him. I opened it and tried to read, but the words on the page were so shocking and vulgar that I was embarrassed to read them in this public place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I noticed the gentleman was wearing the exact same clothes as he had the day before. This displeased me somewhat, but he seemed so clean and well groomed that I did not want to give up hope right away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I sat, and I waited, and I tried not to read the book in front of me (is "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("this")]), _vm._v(" the kind of thing people are reading nowadays?). Finally the man closed his books, gathered his papers, and prepared to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed him to the door, and he held it open so I could pass through after him. A gentleman, through and through.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was easier than I thought it would be to speak to him, and he became quite voluble when I asked about his research. And though he was wider in the middle than I would have liked, and though his fingers were ink stained, and though I reflected that the bowler hat was quite out of fashion, even a bit ridiculous, in spite of these things I felt my heart begin to pound in a way it had not in years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He asked if he might walk me home, and I saw his eyes settle on my ring finger. I was glad of the gloves. I took his arm and the masses of people on the sidewalk parted for us in a way they did not when I was alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My companion was going on at length about something but I admit I was not really listening, I was enjoying the sound of four feet stepping in unison, the rumble of a low voice directed at me. From time to time I said: Do you think? and Yes, exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Things have "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("changed")]), _vm._v(" so, don’t you think? he said. Nothing is like it used to be. Especially women. Women seem so "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("brittle")]), _vm._v(" now, they’re not as "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pliant")]), _vm._v(" as they used to be, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ahead of us I saw a girl weaving slowly along, her head bent over a book. My escort had his eyes on me and plowed into her. The book fell from her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My God, he said, look where you’re going. You shouldn’t be walking around with your nose stuck in a book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl crouched over the fallen book as if it had been shot. She squinted up at us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You ought to apologize, the man said. You know, you’d be a pretty girl if you’d wipe that ugly expression off your face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl glared more fiercely. Then she looked at me and her eyes widened. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mother,")]), _vm._v(" she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man glanced from her to me. Something changed in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mother,")]), _vm._v(" Mara said again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Is she yours? the man said but I was already walking ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man hesitated, then followed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you know that girl? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took his arm and said: I must have reminded her of someone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He walked me home, but the rhythm was gone; he looked at me suspiciously the whole time and refused my offer of tea. He never told me his name, and his coat sleeve left a musty smell on my fingertips. He vanished up the street, walking so rapidly I thought he might split his pants.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara came home much later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why did you do that? she said hoarsely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do what? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You know what, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know what you mean. You must have me confused with someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: I know it was you. With some strange man. You pretended you didn’t know me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t see—that is—I wasn’t wearing my glasses—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You don’t "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("have")]), _vm._v(" glasses, she said. And if you want to know, that man comes to the library every single day, I’ve seen him, and he stacks up books all around him so that no one can see that all he’s doing is drawing dirty pictures on little scraps of paper!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She went to her room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not go back to the library.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw the man once more. Much later. It was pouring down rain, and he was dressed in the exact same clothes as before: suit, cravat, wing tips, bowler hat. He was strolling in the park, sheltering beneath an enormous umbrella and sprinkling the trees with a silver-plated watering can.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was summer. I had a game of solitaire spread out across the stoop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like being outside, with children running past and screaming. But the air in the apartment was unbearable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Down the block children jumped in and out of the water gushing from an open hydrant. They stood in the gutter in their soaked shorts and T-shirts, barefoot in the trash and bottles. Soon someone would step on broken glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sweat dripped off my forehead and dotted the steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of the boys straddled the hydrant so that the water spewed from between his legs. The others hooted and shrieked with laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The streets baked. Everything gave up its smell to the air. I could smell garbage, gasoline, exhaust. But I also thought I could smell bricks, asphalt, the bright metallic scent of cars that have sat in the sun until they are too hot to touch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother shot from the door, trampling through my game and scattering the cards. He began racing up the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I chased after him, my eyes on the faded patch on the seat of his trousers. Where are you going? I called.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can’t you hear it? he shouted over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Up and down the street children were pouring from doorways, tumbling down the stoops, dropping down from fires escapes. They all ran in the same direction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is it? I said, catching up to Jonathan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you hear it? he panted. That music, there it is again—da da, dum da da. Hear it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. I searched his face carefully to see if he was teasing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come on then, he said. Come see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took my arm and pulled me along. He never invited me anywhere anymore, so I went. I could see one of my solitaire cards still stuck to his shoe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We rounded a corner and there it was—a white van, a clown’s face painted on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s all? I said, disgusted. The ice cream truck?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But children were streaming past us, and Jonathan broke away from me and elbowed his way to the front of the wave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a panel sliding back and a pair of hands emerged, collecting coins, distributing Popsicles and shaved ice in paper cones already gone soggy. The children came, little ones and older ones my brother’s age, all of them oddly bright-eyed and eager, their mouths half open.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those hands were large, a man’s hands, but carefully manicured, the nails polished and square. The nail on the left pinky finger was nearly an inch long. I thought the backs of the hands were covered in dark curly hair, until I came closer and saw that it was really swirls of dark tattoos.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Isn’t it great? my brother said. He had a green Popsicle jammed halfway down his throat, a second one melting in the pocket of his shirt just over his heart. The clamor around us had died down; all I heard now were sucking sounds. The crowd of children, fifty or more, stood rooted to the spot. Licking and swallowing. The ice cream truck pulled away from the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sun beat down but no one moved toward shade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can I try some? I asked, my voice loud in the silence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("No,")]), _vm._v(" my brother said and took a step back. Get your own, he said. The last bit of ice was about to slide from the stick; he caught it and licked his palm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come on, I said and reached for him. All around me children cupped their hands protectively over their cones. Half of them had vanilla or chocolate smeared across their faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He’ll be back, my brother said reassuringly. The other children nodded, glassy-eyed. The little boy next to me had vanilla ice cream plugging one nostril, and red juice in his hair, and he smiled blissfully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ice cream’s for little kids, I told my brother, but he would not be provoked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re missing out, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next afternoon I saw my brother dashing down the stairs. Can’t you hear it? he cried.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed him again though I heard nothing. Again we joined the stream of children that filled the street. I had money in my pocket this time. I pushed and wormed my way toward the window of the white van, where the hands dipped in and out. I drew closer and closer, holding the dollar bill above my head but just as I thought I might be noticed, the hands retreated and the van pulled away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bald black-toothed clown painted on the side seemed to be jeering at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sun baked my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked around, at wide eyes and Popsicles sliding in and out of mouths. The ices were of colors I had never seen before, vibrant unnatural colors like neon tubes. Inedible colors. Like the colors of certain poisonous fish and insects. The children’s mouths were stained with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Isn’t it the best? my brother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t get any, I said but he did not seem to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the stifling hot nights I crept into his room and watched him sleep. A milky drool leaked from his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The heat wave did not seem to bother my grandmother. She did not sweat, and wrapped herself in more layers of clothes than she did in winter. It was as if her layers could keep the heat out, just as they could keep the cold out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you can’t sleep, she said, you and Jonathan should sleep on the fire escape, there might be some breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So we did that. The sky never really got dark at night, it never turned black, it stayed a deep twilight blue til dawn. It reflected the glow of the city’s lights. I never saw a single star.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lay on my side and watched my brother sleep. He slept with his head flung back and his mouth open as if he were surprised. I tried the trick of blowing in his ear but he did not stir. He was a deep sleeper, oblivious to the sirens and garbage trucks in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One night, however, his eyes popped open. There it is! he whispered. I saw his teeth shining.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("what")]), _vm._v(" is? I said though I could guess.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stood against the sky in his pajamas, skinny chest thrust out. Then he clattered down the steps of the fire escape, down four floors and then swung from the last landing and dropped to the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fell asleep waiting for him to come back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Early in the morning I found him asleep and peaceful beside me with a cool minty smell drifting from his nose and mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Night after night he heard the music and disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stay here, I told him one night as he was getting up to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t, he said, it’s so loud. That music. I have to. Can’t you hear it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t go, I said. I’ll tell mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She won’t care, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll tell grandmother then, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That made him pause a moment. Then he clattered away and I saw his dark figure darting up the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At dawn I woke and found him sleeping with a smile on his face and something sweet and sticky smeared on his mouth. I wanted to know what it was. I bent over him and tasted it. It was cherry flavored at first but bitter underneath, like cough syrup. I tasted it again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyes opened then. What are you doing? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God, you look scary this close up, he said. Get away, he said and gave me a push. But it was a gentle push, he was laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next night I went to bed in my clothes and shoes, like my mother. When my brother got up to leave, I followed him down the fire escape. The drop to the street was much farther than I had thought. My shoes smacked on the pavement and I fell over with a grunt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara, what are you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("doing?")]), _vm._v(" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hear it now, I said. I swear I do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He gazed at me, smiling. Isn’t it beautiful? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Beautiful, he said, his head lifted and alert like a deer’s. It’s like bells, isn’t it? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Exactly, I said. He turned and ran and I followed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The streets were quiet, deserted. We ran down the center of the streets and the traffic lights clicked through their colors above our heads. The shops were covered with iron grills, and the windows of the apartments above were all dark. The only sound was the patter of our feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And soon we heard the patter of other feet, slowly building and increasing like raindrops. Children joined us from all sides, in pajamas and underpants and their fathers’ cast-off undershirts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We ran, and everyone seemed to know the way except me. We ran down toward the river and I could not understand why, I could not see the white van anywhere. The others ran tirelessly, like a dream, they seemed to float above the ground. But I felt very much awake, and very tired, my breath was raw in my throat and I had a stitch in my side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s louder then ever, isn’t it? my brother said breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said though I was falling behind. They were all running like characters in a cartoon, their legs an indiscernible blur. I’m coming, I said as they passed me, all of them in a pack, and soon outdistanced me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wait up, I said but they were gone, I could just barely see their pale shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed at a slow trot. Soon I could see the river, the water shining. It looked solid enough to walk on. Lights twinkled faintly on the far side. There was a sweet, burnt smell in the air from the sugar factory on the opposite shore. And then I saw the ladder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It touched the ground and reached high into the night sky. It hung there, taller than the tallest skyscraper. I could not see where it ended, it vanished in the clouds. The rungs glowed faintly and I could see children steadily climbing upward. Some sucked their thumbs as they climbed, some slipped and missed rungs but did not seem to care. The older ones helped the smaller ones along, shielding them from falling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked up, craning my neck, and I thought for a moment I saw a white van, floating in the sky. I was not sure. But I swear I heard something, the faintest musical whine that came close and then receded like a mosquito buzzing past my ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard that music, I did!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I started toward the ladder. But as I gripped the lowest rung it seemed such a far way to go, and looked so high, and I was so tired. I did not trust it; how could I be sure of what was at the top?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anyway I have never liked heights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I turned and walked homeward. I did not look back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to know what I was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was dawn by the time I reached home. I knocked on my mother’s bedroom door, and my grandmother’s, and told them Jonathan had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re imagining things again, aren’t you, Mara? said my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where did he go? my grandmother said. She seemed to have shrunk; her nightgown pooled around her ankles and her hair trailed behind her on the floor. She looked like a child playing dress-up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pointed toward the river.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother dressed and bustled down the stairs. She came back several hours later with my brother stumbling and dozing against her shoulder. She said she had found him sleeping beneath the bridge, surrounded by crumpled paper cones and splintered Popsicle sticks. He still wore a sticky brown beard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’ll sleep inside from now on, she said. The both of you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So we did, and my grandmother made sure the windows were tightly closed before she went to bed, though the heat was stifling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother had trouble sleeping in the weeks that followed. He often came and woke me up in the middle of the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How did it go? he said. The music? How did it go? I’m forgetting it. Sing a little of it for me, will you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just hum it then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You never really heard it, did you? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You didn’t. You’re lying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What was at the top, Jonathan? What did you see up there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You wouldn’t understand, he said. His forehead was sweaty, his hair sticking up in spikes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He never would tell me, and soon the heat broke, and then it was autumn and he began high school. He grew a soft mustache on his lip, seemingly overnight. I searched his bed for evidence of further night excursions, and I found a dried stain on his sheets but it did not seem to be ice cream. When I asked him about the ladder he said he could not remember it anymore. At first he was just saying it, but soon I knew he meant it. His memory had always been poor and now he really had forgotten it all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was one more thing that I had missed out on, one more thing I would wonder about forever afterward. One more thing that was kept from me.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told Sashie: I don’t like what is happening to your children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re doing just fine, she said. Jonathan is getting to be so handsome, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara is very strange now, I don’t like it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie said: She has always been a little sulky. She just does it for attention. She’ll stop if we ignore it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her: You’re wrong. Watch her. She walks as if the floor is thin ice. She checks beneath the cushion of a chair before sitting down. She looks behind doors. Yesterday I made her an egg and she would not eat it unless I tasted it first. Then I found her counting the knives in the silverware drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie said: There is nothing wrong with being fastidious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Looking at me out of the corners of her eyes. I don’t like it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She would look nice if she would only take better care of herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She is all contrary, all twisted around the wrong way like an ingrown hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mother, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("please,")]), _vm._v(" Sashie said. You’re more paranoid than she is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: She is too much like me, I think. We repel each other like magnets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan is fine, though, don’t you think? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He is too flimsy, too loose in the joints, or something. He needs a father, he needs a man in the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He is the man of the house now. You leave my son alone. He has turned out just fine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: I should do something. There must be something I could do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Haven’t you meddled enough? These are my children, not yours. You had your chance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had nothing more to say, then. I went to my room and shut the door and sat on the bed. I felt the bed creak and settle as Shmuel sat down on the other side, with his back to me. I did not turn around to look because if I did he would hurry away too quickly to be seen. It was better to sit like this, and sense him over my shoulder, and know he was there. To know that I could turn and catch a glimpse of him was enough. I did not have to actually do it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should have known this would happen. My granddaughter is too like me. My daughter too. Sometimes holding something too tightly, trying to guide it too closely will only make it turn against you. Like a river bursting through the dikes and dams and flooding over the fields.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daughter did not seem to hear me anymore. She could blot out my voice with her own. I did not know when it had happened, it was a gradual thing, her voice rising and rising up to drown out mine. And soon Mara would add her voice too, soon the sound would rise up on all sides and wash over me and I would not even be able to hear myself anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Listen to this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is the story of my brother and the woman he wanted to marry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I love my brother dearly, and I admire him and respect his judgment, but I will say that this woman was not one of his wiser decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother and I were very close when we were growing up. For years we shared the same room. My mother and grandmother adored Jonathan. He was the spitting image of our dead father, everyone noticed this and told him so. When my mother was watching, he walked slowly and sat quietly at a time when other boys his age were jumping off furniture and making tommy-gun noises. At the time he explained to me that his brains were soft and runny like applesauce, and if he fell down they would all spill out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was younger than he was, but I always felt the urge to take care of him. In my earliest games I cooked imaginary dinners for him, poured imaginary coffee, washed and ironed his imaginary shirts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he grew up and began to make something of himself. He started medical school, he wanted to become a doctor. My mother was thrilled, she thought this would be just the thing for him. My brother was so fine and bright and handsome, he would heal people and cure diseases and bring babies into the world. He would be famous, everyone would love him, he would have a magic touch. It made my mother almost weep just to think about it: this shining future of his. She also talked about how much money he would make, how rich and successful he would be. He will support us all in our old age, she liked to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the truth of the matter was: I was the one expected to take care of them in their old age. I had thought about leaving home when I turned eighteen, I planned to travel somewhere and learn how to fly airplanes, to hunt elephants on the African plains, to dance in a chorus line; oh, any number of things. But eighteen came and went, and I was still at home, making tea for my grandmother in the fashion of the old country: strong, in a glass, with sugar cube on the side. Years passed and I was still preparing the Epsom salts for my mother to soak her feet in, still taking meat out of the icebox so it could defrost overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And my brother still lived at home while he went to medical school, to save money, so I got to make his dinner and coffee and iron his shirts in reality, as I had once played. I suppose this should have made me happy. My mother and grandmother were glad to have him near, they were delighted when he showed them his white doctor’s coat, his stethoscope. He brought home his instruments, he examined their eyes and ears and throats and told them how healthy they were. They laughed and admired his beautiful hands. And even when he didn’t notice them at all, when he was studying or shaving before the mirror, they would watch him proudly. As if it were an accomplishment, to shave his own face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As I said, I loved my brother dearly, but we were not as close as we had been as children. Now he was hardly home, and seldom alone, and my mother constantly fawned over him because each passing day made him resemble more closely our dead father. At least that is what my mother said. I knew my father only from pictures. When I looked at my brother all I could see was his resemblance to me, I could see myself in him, I could see what I could have been if circumstances had been different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because, you see, I had always been the cleverer one; though he was two years older I had always made up our games. I learned to tie my shoes first, how to count and how to read. I was jumping off the roof of the shed in the courtyard while he was still sitting in a flowered armchair with his chin in his hands trying to keep his brains from spilling on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not that I was jealous. Not in the least. They needed me, they were my family. My grandmother would not admit it but she would soon grow frail, she would need my help more and more. And my brother, the great medical student, he could hardly take care of himself. He would come home from the hospital in the evenings, fling himself onto his bed, and groan. So I would bring him coffee, read to him from his textbooks, remind him of exams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not like to look at myself in the mirror. I had become so tall, my face was a stranger’s, and I had a red rash on my hands and arms from working. In my thoughts, I pictured myself as a child still. I saw that bold-faced girl, saw her jumping from roofs and fire escapes, and then marching home dry-eyed, defiant, with her knees full of gravel and broken glass. The day’s experiment had been successful: I had discovered that if I didn’t look at the wounds and didn’t think about them, I wouldn’t feel them. They did not exist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I did not feel jealous of my brother. I only felt a bit—fatigued, I suppose, it was only natural. There was a touch of claustrophobia, which is to be expected when four full-grown adults share an apartment built for two. And there was the relentless tugging of my grandmother’s crochet hook as she spun out afghans and scarves and bulky socks in her corner of the living room—it’s a small thing, I suppose. But, although you might not guess it, I am a sensitive person. Imagine the dim light of evening, early winter. My grandmother’s eyes are half-closed, she’s barely breathing, and the metal hook is twitching and jerking its way through the mounds of hairy wool with a rasping sound, the hook catches the light like a beetle, it moves insistently all by itself like some horrible insect burrowing into some poor creature’s hide, I look at her sitting there and it’s like a large hairy dead animal crawling with maggots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s a small thing, but it affected me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I kept my eyes on the work in front of me, and looked forward to the day when my brother would complete his studies and become a famous surgeon. I imagined him sewing up people’s insides with a golden needle, as easily as darning up socks, everything bloodless and smooth, and the patients would leap from the tables and embrace him and bring him sacks of money. Yes, I knew it would not be so simple. But still I envisioned money, great amounts of money, our mother and grandmother taken care of, and my brother and me free to fly to a distant place and begin our real lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then my brother met the woman he wanted to marry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her name was Chloe and he met her at the hospital swimming pool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, the hospital where he worked was one of these new, progressive hospitals where they liked to try out the latest therapies and experiments. The pool had been built very recently, in a big frosted-glass room added on to the back of the hospital, and it was for patients who were paralyzed or otherwise injured, so they could get in the water and float about like children and learn to use their bodies all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother was not terribly strong, but he was proud of his body and liked to exercise. He got permission to use the pool and he began to swim often. He described it all to me one evening. He said the water was heated, and also the air so that it felt tropical and strange, like a greenhouse; the water was an improbable blue color and the winter light that filtered through the frosted windows was violet-tinged and mysterious, and people’s voices echoed about weirdly, they sounded round and melodious and hardly human, and when you sank underwater there was no sound at all, only a square blue room made of tiles, silent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The patients clung to the edge of the pool, they cried out or paddled feebly at first; they did not trust themselves. But my brother liked to dive deep and look up at their dangling feet, their bellies, and the wavering light on the surface. He also swam laps across the pool, back and forth, very fast with a lot of splash and style, and all the patients and nurses and doctors admired him. Not because he was particularly good, I think, but because he is the sort of person who is always admired.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He told me about the pool, his voice drifting in and out of focus. His eyes and nostrils were pink, his hair wet and sleek, he reeked of the chlorine. My mother touched him and said: Oh you’re soaking, oh you’ll catch your death of cold coming home wet in this weather. My brother brushed her away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were using the hospital pool for other therapies as well. The doctors had invited pregnant women to come and swim in the pool. The doctors wanted to see how the unborn babies would react, they wanted to see if the babies would remember, and not be afraid of water, after birth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The day my brother met Chloe the pool was full of pregnant women. Full of their pale, bulbous bodies, bobbing and gliding about in a graceful, languorous way. My brother sank to the bottom of the pool and watched them rising and falling. They seemed translucent against the light; he thought he could see the babies somersaulting around inside them. They trailed veils of bubbles behind them, they floated in close groups like whales. Light fell in sparkling shafts through the water. And then suddenly a sleek dark shape darted among them, dispersed them, and then dove down next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was Chloe. They hit it off immediately, my brother told me later. She was a much faster swimmer than he, and very smart, he said. He smiled at me with all his teeth. I told him he looked feverish, told him he ought to give up the swimming for a few days, as a doctor he should think of the risks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had been seeing her for three months before he brought her home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had invited her to dinner with us. I tried to fix up the apartment. But what could I do? The furniture had not been moved in years. The table legs had sunk into the carpets and taken root. The doilies on the chairs and sofa had yellowed and stiffened; I could not scrape them off with my fingernails. The tabletops and cabinets were filled with my mother’s fussy figurines and the strange dark things my grandmother collected. Dried herbs and thick liquids in jars. My grandmother would not let me touch them, even to dust them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did what I could, covered the kitchen table with the sheet from my bed, dimmed the lights and lit candles. We waited; my mother wrung her hands, while my grandmother worked her hook, frowning. I searched through cabinets and found a bottle of wine. I opened it. It had gone sour, it stank like old cheese. Then my brother walked in the door with the girl on his arm and the room was full of noise and uproar though no one had said a word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now, I am an ordinary person. I am not superstitious, I am not religious. I only believe what I can see and hear and understand. But I tell you—the moment I saw her I knew something was not right about that girl. Something about her was wrong, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("off,")]), _vm._v(" like the wine. I can’t explain how I knew. But with one look at her pointed little face I knew she could bring only grief and disgrace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What kind of name is Chloe? A silly frivolous name. She had a small, fine-boned face, masses of hair lying over her shoulders, painted nails. A cheap little thing. She had a high, nasal voice like the neighing of a pony. A gap between her teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was talking to my mother, explaining how she worked at the hospital, like Jonathan; no, she was not a nurse, only a nurse’s aide, mainly her work was to keep the patients comfortable, give them sponge baths and so forth. Jonathan jumped in, saying: The patients love her, she’s very gentle. My brother was smiling strangely. I had never seen him like this before, he looked ill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at her suspiciously. To me the words "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("sponge bath")]), _vm._v(" were like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("massage:")]), _vm._v(" a euphemism for something lurid and tasteless. I looked at her more closely and noted her dark veiled look. Then I saw her eyes distinctly and they were dark and light all at once, iridescent and lifeless as fish eyes. I saw her for what she was, a deep knowing creature with designs on my brother. I knew, and she looked at me and saw that I knew, and she stepped more closely into the lee of my brother’s body, protected in his shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I saw that she had gained some kind of hold on my brother, some unnatural bond, for why else would he speak so frenetically, smile so wildly while avoiding my eyes? He was sweating, he made the whole room feel warm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So we had the dinner but I cannot recall a minute of it, I was conscious only of her small hand clutching my brother’s sleeve, and the look in her eyes which was old and ancient and evil and had nothing to do with her high whinnying voice as she and Jonathan laughed and talked about their swims in the pool and the patients in the hospital, ill people miraculously cured, brain surgery that gave people new personalities, drugs and microbes and invisible rays that were going to change the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afterward my brother took her home, returned to us, and told us he planned to marry her. As soon as possible, he announced, and then they would live together in some new place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother wept; she was sorry to think of losing him. But she was not overly upset; she had not seen what I saw. My mother was happy in my brother’s happiness and could see nothing else. Even my grandmother, usually so perceptive, uncannily so, voiced no objections.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want to see my brother sucked down into some dark place with this strange girl. I wanted to warn him. But he would not give me a chance; he did his hospital work, took swims, spent his evenings with her, came home at odd hours bright-eyed and distracted. She smoked cigarettes, so whenever he had been with her I could smell it. This disgusted me more than anything else. The smell of her, so blatant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally one evening I trapped him, forced him to listen, asked him, begged him: How can you do this? Don’t you see how wrong it is?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He laughed as if I had made a joke. He reeked of her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can you go away and leave me like this? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, come now, he said, I’ll never leave you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am serious, I told him. You can’t do this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m serious too, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could tell he was hardly listening. I told him: You need me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course I do, he said smiling. You’re my sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said, you really need me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I reminded him of the thing we never spoke of, and he finally stopped smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, years earlier I had taken his entrance examinations for him for medical school. The examinations then were not regulated as strictly as they are now. It was a simple thing for me to take the exams and sign our last name. He could never have passed them himself. I love my brother dearly, but his mind is like a sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Since that time I had helped him with his classes whenever I could, prepared him for exams. Occasionally, in a show of pride, he would reject my help. But I was certain he would never be able to finish medical school without me. I reminded him of this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought he would give in when I delivered this blow. But he only looked at me strangely, as if he were seeing me for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wanted to marry her immediately, but then he was invited to spend a month training with a famous doctor in another city. He decided to seize the opportunity, and he would marry Chloe as soon as he returned. He set about preparing for his departure; he was very excited; it was the first time he had ever left home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The day before his departure he came to our mother and asked if Chloe could stay with us while he was gone. She could use his room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Apparently she had been turned out of her apartment suddenly and had nowhere to go. Apparently she had no family close by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It will give you a chance to get to know her, my brother explained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The whole situation seemed suspicious to me, but no one else seemed to notice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother agreed enthusiastically, my grandmother crocheted and said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother left. And the strange girl Chloe moved in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now I had no peace. She seemed to fill the apartment. My initial impression of her was not disproved, no, it was heightened by the close quarters. My mother enjoyed her company, she suspected nothing. The girl was crafty that way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her smell, the cigarettes, a nauseating lilac perfume—she permeated the apartment. And her eyes never lost their cold amphibious stare. Even while chattering to my mother or arranging her hair before the bathroom mirror, I would see in her eyes a deviousness, a secret intelligence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew why she had come. She wanted my brother, she wanted to wrest him from me. She knew I was the only one who understood what was happening and would stand in her way. She was plotting and planning, trying to catch me unawares.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not eat. I could not sleep, I feared she would come and smother me in the night with a pillow. She was like a cat, a cat who rubs against your legs, purring, in the day, and then lies on your face as you sleep to drown you in the night. I would not meet her eyes, I knew if I did she would hypnotize me without a word, lead me to jump from a window or swallow my tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, I understood who she was. I had found her out. She was one of those dark sea creatures who lure men to their deaths for sport, like the mermaids that call out to sailors in the moonlight and then drag them to the ocean floor trapped in their long scaly hair; like the sirens with their irresistible yammering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she was one of these underwater beings, with their strange bodies and cold blood. I knew because of the way she took long baths, every night she stayed with us. I watched her through the keyhole, luxuriating in the water, smoking a cigarette. I could not see all that she did; there were strange sounds, strange smells, I knew she was metamorphosing behind the door, growing fins and scales. I saw her hair floating in the steamy air, undulating like seaweed moving with the current.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew because of her teeth: rows and rows, needle sharp, like a carp’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew because of the way she first came to my brother: through the water, silent, unsuspected, darting like a snake past the pale innocent pregnant women wallowing on the surface like cows in deep grass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had to save my brother, but I did not know how to get rid of her. I wanted to ask my grandmother, she was considered an authority on these matters. But she would know nothing about a sea creature like Chloe; my grandmother knew only the imps and goblins of the old country. She claimed she knew how to drive out the household spirits that extinguished cookstove fires and soured the milk, said she once brought a stillborn baby to life by blowing in one ear, causing the angel of death to flee out the other. Her little rituals involved candles, hair, whispered words. I had never truly believed in her stories, but it did seem that whenever I displeased her in some way I would later find myself afflicted with indigestion, chancre sores, hangnails, sties, dreams of falling, menstrual cramps like a crochet hook in the belly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I spoke to no one, I watched and waited, I listened at night as Chloe splashed in the bathtub, I knew she was thinking of my brother, my brother swimming, perhaps she was imagining his head suddenly appearing, rising up dripping and disembodied from the bathwater between her legs, his head held between her hands like John the Baptist’s on a plate. She churned the water about, gurgled; steam crept beneath the door and drifted through the cold apartment, advancing and touching and recoiling like a live thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The days passed, soon my brother would return. Soon they would be married, out of reach. I heard Chloe tell my mother: a small wedding, I’m an orphan you see, I have no family, so just a ceremony for us, and afterward we’ll take a trip to the seaside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew I had to act. I thought of my brother, my poor brother, his body lying on the ocean floor plastered with starfish and sea urchins sucking out his juices, hermit crabs creeping in and out of his eye sockets, eels gliding in and out of the secret grottoes of his body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There came an afternoon when I heard an incredible sound: silence. My grandmother’s relentless hook had stilled; it slipped from her grip and clattered to the floor. She was asleep, enveloped in her latest creation: an afghan, white and blue, large enough for a double bed. She was nearly finished with it, nearly buried by it. All I could see of her were her crabbed fingers, and a hank of her hair, greasy jet-black: she dyed it herself with her own secret concoction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched her sleep; her breath hissed in and out with a regular ticking in the throat, like the click of a valve, as if she were made of machinery inside. Softly, softly, how the floorboards moaned, I reached past her, opened the door of the glass-front cabinet and took one of her forbidden bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a square bottle, heavy, the dust on it an inch thick. It was filled with a dark, viscous liquid, dense and shiny. I knew Chloe would like it. You know how fish are so oily. She could use it on her scales. I put a ribbon on the bottle, presented it to her that night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s for your bath, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She took it and thanked me, but I did not dare look at her, for fear my eyes would give me away. We stood in the narrow hall together for a moment, toe to toe. I was aware more than ever before of her smell, a rank fish-market smell. My brother would be coming home the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said she was sorry we had not become better friends. She said she knew we had one thing in common: we both loved Jonathan very much. She thanked me again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her voice sounded perfectly natural, but I knew it was a ruse and she was growing more and more monstrous even as she spoke. I would not meet her gaze, it would turn me to stone. I said good night, walked down the hall, waited until I heard her start her bath, and then turned back to watch her through the keyhole.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched her pour the black liquid into the bathwater, saw it froth up. The bathroom was already filled with steam. I watched her step into the tub, one foot then the other, then she lowered herself into the water. I saw her face, damp with sweat, cigarette between her lips, eyes closed. I held my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought my gift would drag her down the way oil spills can smother seals and fish and waterbirds. I thought she might thrash around and slowly sink down like the weary dinosaurs in tar pits. But she did not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited, blood pounding in my ears and the doorknob pressing into my forehead. I saw the speck of ash linger at the end of her cigarette, quiver, fall. A spark. The bathwater burst into flame. A roar of air, and the fire shot up; the shock of light and a blast of air made me fall back and lean against the wall. It was so beautiful. I couldn’t see anything for a moment; then I saw beautiful green flowers blooming against the backs of my eyelids. I warmed my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later, later I stood on the sidewalk in front of the building, hugging my mother and grandmother to me as we stood among sirens and flashing lights, and handsome firemen offered us blankets and hot chocolate. Our neighbors huddled around us in their nightshirts. They all clutched their valuables: jewel boxes, insurance policies, tiny yipping dogs with bows in their hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Afterward everyone said the worst thing about it was the scream—the piercing, keening shriek of agony and despair that woke them all from sleep. They all agreed it was the most horrible thing they had ever heard, like fingernails on a chalkboard the size of the sky, yet a human sound, the sound of a child being dragged under the wheels of a train, a sound that made their hearts shrivel up and die inside them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course they were exaggerating. The sound was not as bad as they said. It was a sound you may have heard yourself, if you are familiar with seafood. If you have ever cooked a lobster.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should have known this would happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara. It was inevitable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had watched her view of the world narrow and skew like a fun-house mirror over the years. I’d seen her crash into corners of furniture, and try to place her foot on a phantom stair as if she lived in a house invisible to the rest of us. I had watched her feelings for her brother sharpen and bloom into jealousy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I did not think it would come to this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I never thought she would act.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I feel it is my fault. I should not have left my things where she could get at them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, I had grown careless. I thought she was not interested in my work, so I had not guarded it carefully. She had always laughed at it, called it quackery and superstition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But apparently she believed in it enough to use it for her own purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had found the bottle, uncorked and empty in the smoky apartment. I knew what she had done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There’s a streak of violence in her. I see it now. Sometimes she can barely contain it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where did she get it, I wonder?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother returned from the distant city; he went to see Chloe in the hospital; he came home speechless and heartbroken.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to comfort him. I knew it was upsetting for him to finally see the true Chloe, as I had seen her all along. I had glimpsed her myself in the clean white hospital bed, her hair singed off, her eyelids and ears gone, her body covered in stiff, shiny scales. The webbing between her fingers and toes. I thought she looked beautiful, so pure and natural.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother would not be comforted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our apartment was intact, though damp and smoky. No one could understand how the fire started, and everyone praised me for helping my mother and grandmother to safety.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother moved back into his room. I thought everything would return to normal. I had never been so happy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But my brother abandoned his medical studies. He visited the hospital but spent most of his time in the apartment. All the starch had gone out of him. Slumped shoulders and a bruised face like a defeated boxer. He did not speak to us, or wash himself. He shuffled around the rooms in bedroom slippers, staring out of windows, jingling the change in his pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He sat for long afternoons with our grandmother. Close together in her dark corner. I cannot imagine what they had to say to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wandered the apartment at all hours, oblivious to the weather outside. He brushed past me in the hallways without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew what he was feeling. I have always known, without him needing to tell me. I knew he would come to me. In time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One day I found him at the living-room window, holding the drape back with one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s raining, Jonathan, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s raining, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, he said, sunlight reflecting on his glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next day he ran away to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and grandmother and I, we all missed him dreadfully. We waited, days and weeks, for some word from him. I was certain he would come for us, any day now he would come, with a pirate ship and a chest full of treasure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother’s afghan, the double-sized one she had nearly finished, was destroyed in the fire. She was very agitated about it, glaring and silent for days. Then she took up her hook and began something new.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is it going to be? I asked her the other day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This one, she said, is for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at me, her eyes were very clear and measuring. The hook wormed its way into the wool.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Sasha.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was my mother’s name. All her life she’d wanted an American-sounding name; as a child she’d chosen Shirley. I can imagine her then, pinning her hair in curling papers, prissing up her mouth in front of the mirror, begging: Shirley, call me Shirley, mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For years my grandmother ignored her, played deaf; nights she whispered "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sashie")]), _vm._v(" in my sleeping mother’s ear; days she wrote "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sasha")]), _vm._v(" with salt in the bread before she baked it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eventually my mother gave up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was born (or so I am told, and I have no reason to doubt it) my mother was determined to give me an American name. The most American-sounding name she could think of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mary. That was what she wanted to call me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Blond curls, little lambs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother went livid at the news: You can’t name the child that! You can’t name her after the mother of the Christian god. We’ll be cursed forever. You’ve already cursed the child by giving birth with all those men watching. Why do you want to make it worse?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can picture them in the hospital room after my birth: my mother lying tense and furious under the sheets (she had wanted a boy anyway), her back ramrod-straight, as if the bed were some kind of torture device and any minute she expected a pendulum to swing, a blade to fall; my grandmother hovering near, nimble and birdlike in her black clothes, flapping and croaking like a raven; and the nurse, white-capped and befuddled, offering the birth certificate to first one and then the other, waiting for them to answer her question about the baby’s name; and the baby herself, a forgotten lump in the corner, swaddled and screaming at the top of her lungs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They argued. This I know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A gentile name, she’ll be cursed all her life!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want her to fit in, an American girl!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wonder if they slapped and spit like schoolgirls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wonder if my grandmother hiked up her skirts, climbed right up on the bed, pinned down my mother, knelt on her chest and twisted her hair, smothered her with pillows, demanding "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("holler ’nuff!")]), _vm._v(" like a bullying street boy while my mother kicked and screeched, churning the bedclothes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can picture this so clearly that I don’t think I’m imagining it; it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("must")]), _vm._v(" have happened this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eventually they compromised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mara,")]), _vm._v(" my mother wrote on the birth certificate (with my grandmother’s hand on her wrist, I imagine).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara. It means bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I kept his room clean for him. I knew he would be coming back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tucked the sheets smooth and tight. Wiped the dust off the windowsills. I bought him new pencils, sharpened them, put them in the mug on his desk. Every few days I tested them, sharpened them again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The weather was warm, damp, and strange; there was a wet film on everything. The heat settled in starting early in the morning and hovered over the city all day. My scalp pricked, my palms were slick. My hair smelled of mildew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara, wash your hair for God’s sake, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, I did not like to go into the bathroom. I did not like the thought of water falling on my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother stayed in her dark corner, her fingers working and lips drawn tight. Whenever I came near she tried to hide her work, shielding it with her arms, burying it in her lap, with furtive glances.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if she could hide anything from me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if it weren’t obvious she was beginning her umpteenth afghan, or scarf, or wretched sock.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if I cared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother went often to visit Chloe in the hospital. She felt it was her duty, she said, the girl had no family, no one at all. So several days a week she put on a lace collar and a hat and gloves and went to sit by the bedside of a crisp hollow shell of a girl, whose eyes were sealed with scar tissue, whose mouth was a round hole outlined with charcoal. Why did she bother?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went with her once. Chloe’s skin looked shiny, hard, burnished, like a shell; in places it had cracked and split; you could see a wet dark jelly inside. No longer the Chloe I knew; not even a person, just a messy little smear on the white sheets of the hospital bed, like the congealed remains of someone’s lunch left on a napkin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She never stirred, hardly breathed. She was hooked by the arm to a bag of fluid above her bed; a saline solution dripping into her veins, to remind her of the ocean, no doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Chloe’s doctor stopped in and spoke to my mother for a few minutes. He was very tall, with a red pompous face and wavy silver hair. My mother sat up straighter and raised her chin and smiled, and I knew the reason for the lace collar and hat. They spoke softly, confidentially, with many solemn nods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I decided not to go to the hospital again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I spent much of my time in Jonathan’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a photograph on his dresser, taken the day he graduated high school. In the picture he smiles with his mortarboard tilted at a rakish angle, he pushes his lower lip out with his tongue in an odd grimace, his brown hair glows auburn in the sun. I am standing closer to the camera, hulking in the foreground, half my body cut off by the edge of the picture. I’m frowning, a deep furrow between my brows, my mouth open; my hands clutch my program in a fussy, frantic gesture, I look like a lost tourist. The outline of my brassiere is clearly visible through my dress. It was a modest dress, I bought it because it was on sale, I had no idea it became transparent in direct sunlight until that graduation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan is flanked by his best friend, Martin, and his girl of the moment. One of a long series of insubstantial girls, her name was Amy but she insisted on spelling it Aimee, and dotted the i with a little heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan has his arms around their shoulders, all three appear to be laughing at something that may or may not be me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had always hated that picture, but it was the most recent one with the two of us together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had played under his bed together as children. We used to inch along on our stomachs beneath the low box spring, until we reached the far wall. Our mother had once been a fanatical cleaner but gave up when she moved to this apartment that seemed to cultivate dust like a crop. The forgotten space beneath the bed was thick with dust. It was our own private world, a musty gray kingdom. We breathed and sent the dust balls rolling; we could pretend they were tumbleweeds blowing across the main street of a Western town like the ones Jonathan read books about. The dust was pixie dust, it would make us fly. It was moondust, the Sahara, the surface of Mars. We were kings of it, the entire realm; and I used to think, as we lay belly-down in that small coffinlike space, with nothing but our faces close together and the miniature landscape taking shape, I used to think that it was all I wanted in the world, I wanted to stay there forever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan with his chin on the floor, dust on his eyelashes, eyes bright in the dimness, his hand nudging mine. How beautiful he was back then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara, what on earth are you doing? my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was on my hands and knees, my head beneath the bedspread. Checking for dust, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have some news, she said. She sounded as if she were strangling. I sat back on my heels and looked up. Her face was all knotted with suppressed emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed her into the living room. My grandmother looked up expectantly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The doctors say Chloe is pregnant, my mother announced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother said: Ah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Whose?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother said: That’s the thing. You don’t think "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jonathan")]), _vm._v(" would—they weren’t married yet, Jonathan would "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("never")]), _vm._v("—he was a man of honor, he respected her, I’m sure he was waiting—saving himself for marriage—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: Then the baby must be someone else’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another man? But how "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("could")]), _vm._v(" Chloe?—they were going to get married—they still might—when Jonathan comes home—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: It would not surprise me. She was a tramp, a floozy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You really think—another man?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: I’m positive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother finished her tea, smacked her lips, and studied the dregs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thank God Jonathan "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("didn’t")]), _vm._v(" marry her then, my mother said. This would have broken his heart, to find this out. Thank God things worked out this way. I’m not saying I’m glad about the fire—certainly not, the poor girl—but I must say, every cloud has a silver lining—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m glad we’ve found out the truth. Before it was too late. Now, when Jonathan comes home, he can start fresh, finish medical school, find a nice new girl—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said. My face hurt; the muscles were straining in an unaccustomed way. I realized I was smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother looked up from her tea leaves. She said: Sashie, when that child is born you must bring it home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Haven’t you been listening? my mother said. It’s not—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is,")]), _vm._v(" my grandmother said firmly. Your grandchild, my great-grandchild. When it is born, you must bring it home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can you be sure?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m sure, said my grandmother and fixed her with a stare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother hesitated, torn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s impossible, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you want a grandchild, Sashie? my grandmother said softly. You won’t get another chance. Your son’s not coming back. And "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that")]), _vm._v(" one won’t be giving you any grandchildren, not unless she mends her ways.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She jabbed her finger at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother’s face softened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan’s child, my grandmother said. It will look just like him, you wait and see. A beautiful child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother was nodding, nodding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you see, she’s a tramp, Chloe’s a tramp, the child can’t possibly be Jonathan’s, I said desperately. I thought I’d gotten rid of Chloe, for good, and now here she was, creeping back into our lives, stretching out her tentacles. The thought of Chloe’s brat growing up in our home made me ill. Just imagine: we would have to buy it a fishbowl, later an aquarium, plastic seaweed and a fake diver blowing bubbles.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Since Chloe was unconscious, unable to give birth, the doctors had to cut the baby from her prematurely by cesarean section.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not there, but I imagine it was like gutting a fish, a nice clean cut and a scooping out of the wet sloppy stuff.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They said that when she was plucked from her mother’s waters the baby opened her mouth and a stream of bubbles flew from her lips; they drifted around the room, hovered around the lights like moths before popping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The baby was kept at the hospital for weeks, inside a glass meat case, hooked up to wires and rubber plumbing. She was shriveled and sickly, with a cross expression. Perhaps that had to do with the tubes up her nose. The nurses had put a tiny knitted hat on her head, which, together with her wrinkled face, made her look like the caretaker of our building, a bald toothless old man who wore ribbed watch caps winter and summer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s beautiful, my mother breathed. She spent hours in the nursery touching the tiny hand with a rubber-gloved finger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s a tough old bird, my grandmother said. She had actually left the neighborhood, for the first time in months, to see the baby. For some reason she did not squawk this time about men in the delivery room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The baby did in fact look like a pale boiled chicken, skimpy meat sliding from the bones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looks just like Jonathan did. Except Jonathan was much bigger. But the same eyes, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at the infant and my worst fears were confirmed. I could see the marks on her neck, where the gills had only recently closed up. She kicked her legs as if swimming. And there was the look on her face, when she opened her mouth, as if she could not understand this strange new element, air, that she suddenly found herself in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother put aside her secret project, stuffed it between the sofa cushions. She bought soft angora yarn and set to making baby blankets, baby sweaters. And ridiculous booties and tufted bonnets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How do you like your niece? she asked me. She looked happier than she had in years; she had loosened her hair from the severe braid, it was still oily black but looked softer and gentler hanging around her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" my niece, I said. I don’t like the mother, I can’t imagine who the father is, and she’s just a pathetic stunted little thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother’s hand darted out. I thought she was going to slap me; instead she held my chin and studied my face carefully. You’re jealous, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Me! Of what?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of Chloe, she said. This girl, Chloe, burned up, half alive, gives birth to a beautiful child. And what have you done? Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll have children, wonderful children, someday. I’m stronger than her, smarter than her, my children will be tall and healthy and clever, not scrawny like hers. Mine will grow up to change the world. And I’ll have them when I’m good and ready, not before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t make them by yourself, you know. Not even in this day and age, my grandmother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How do you plan to find a father for those babies?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I will find someone. Someday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re jealous of Chloe because she made a child with your precious Jonathan, my grandmother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("No,")]), _vm._v(" I said. No, I’m not. No, she didn’t. No. No.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Apparently Chloe had no family, no close friends, no one who knew anything about her. After some discussion with doctors and social workers, my mother was given permission to bring the baby home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She and my grandmother prepared Jonathan’s room for the baby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jonathan’s room!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But what if he comes back? I protested weakly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he’ll find his daughter right here waiting for him, my mother replied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fortunately they changed little in the room, simply brought in a cradle and set up the desk to use as a changing table. I could not help smiling to think of soft baby skin lying right where I had kept Jonathan’s carefully sharpened pencils.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now for privacy I kept to my own little closet of a room. At night I thought of what my grandmother had said. I removed my clothes and stood before the mirror. My own body was like a stranger to me, I so seldom thought of it. Most days I felt like merely a pair of eyes floating through the world, a pair of eyes and a mouth that occasionally spat out remarks, and a tightly knotted brain that constantly twisted in and in on itself like two mating slugs. The rest of my body felt like something I used but that did not really belong to me, like the clothes I put on in the morning. It was all so much machinery, puppet limbs attached with strings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now I looked at my body as I had not for years. There was so much of it. I stroked my skin, soft and alive, not like Chloe’s insect shell. I touched my belly, where children would be made. I imagined tiny workmen inside, shouting orders, assembling babies from the food I had eaten. I thought of the amazing potential lurking in my body, the countless perfect children waiting to be born. I would not have to do a thing, my body would be able to produce these wonders unbidden.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once I performed the initial step, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother brought the baby home from the hospital one rainy evening. She carried the small sulking bundle through the apartment, cooing and burbling. My grandmother hovered nearby. I kept in corners, did not want to get too close. That smell babies have, so frank, so demanding, it filled our home in minutes. They brought her into Jonathan’s room, laid her in the cradle. She was whimpering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps babies were desirable assets, and perhaps I was beginning to want one for myself; but this particular one I did "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not")]), _vm._v(" like, she was too much like Chloe, it turned my stomach to look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother hushed her, rocked and rocked her, dimmed the lights and rocked the cradle like the rocking rise and fall of ocean waves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The chores began: the cries in the middle of the night, the diapers, the formula to be heated and the bottles sterilized, the attentive baths, the burping, the descent into baby talk, the murmured discussions about reflexes, fontanels, sleeping positions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and grandmother shared the duties, did not ask for my help.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How is the navel healing? they asked each other. How does her breathing sound to you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As she did on all significant occasions, my grandmother busied herself with her herbs, crushed and brewed them, made us all drink the bitter tea, even a sip for the baby, who squalled. She snipped bits of the downy baby hair for some private ceremony, and tied a red string around the little wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was impossible to ignore the baby. She dominated the apartment. I hated her cries, and her bleary, half-closed eyes; she seemed to be watching me slyly, as if she knew all about me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At night as I lay in bed I thought of Jonathan, wondered where he was, when he would return. I remembered our games. One night I could not sleep for hours. I rose quietly and went to his room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A night-light cast an orange glow. I sat softly on the bed. Then I lay, sniffed the pillow and the coverlet for traces of him. Of course I smelled only soap and cleanness. He had been gone for so long. The cradle rocked softly all by itself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knelt by the cradle and studied her. She lay on her back, head to one side, hands curled in little fists. She heaved a sigh, a sigh as deep and world-weary as an old woman’s. The brows puckered in a frown, then smoothed themselves. I touched one of her balled-up fists, and she immediately clutched my finger. So tightly, a monkey grip. My heart twisted. Yes, I knew it was only a reflex. I knew. And yet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at her, and with a start I saw Jonathan there. Unmistakably, I saw my beautiful brother in that round baby face. I saw, and I knew that she was his daughter. I knew. Without a doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I lifted her and held her, I expected her to scream out since I had never held a baby in my life, but she didn’t, merely settled herself against my shoulder and lapsed back into sleep. How comforting and right her weight felt against my chest, her breath in my ear. She fit so perfectly in my arms, as if she were made for them. I supported her head with one hand, her padded bottom with the other; I stroked and joggled and rocked; I found myself humming under my breath a tune I’d never heard before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The moon drifted free of the clouds just then and the room was flooded with silver light. I pressed my cheek against the downy head and then I knew, as abruptly as I had realized that this was Jonathan’s child, I now knew that she was also mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew. Any fool would be able to tell, from the way the baby settled into my arms, that I was this child’s mother. She belonged to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would tell her so. As soon as she was old enough to understand. And she would have no reason to believe anything different.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Chloe died in the hospital, her burnt-out shell crumbling to dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt my grandmother’s eyes on me when we heard the news. I struggled not to smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother mourned for the girl, but then she had never stopped her mourning; as long as I had known her she had worn black and thought more about the dead than the living.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a new baby in the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes when her crying woke me in the night, I started up from sleep thinking: Eli? Wolf?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So many babies had passed through my arms that I could not always distinguish among them. I thought of other girl babies I had held, tiny girls just like this one with the heavy brows marring the soft baby features.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remembered Sashie struggling discontentedly in my arms, Mara spitting up on my shoulder. I forgot, sometimes, which came first. It did not matter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In spite of all that had come before, this new baby gave me hope. I wanted to mold the soft plates of her skull, rub her gums as the teeth burst forth, tell her all the things I had never been able to articulate before.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It became more and more clear to me as time went on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This daughter was mine. Perhaps not in flesh but in spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was the child we might have had, Jonathan and I, if circumstances had been different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I held her in my arms hour after hour. The small mouth sought out my breast, came away disappointed. That gave me a peculiar feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her face always puckered up when I held her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe I gripped her a bit too tightly. Perhaps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I had to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those other two were always trying to snatch her away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and grandmother were battling me for the baby. Couldn’t they see that she was mine?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was a constant, subtle thing. A silent war the three of us waged. One would sterilize and prepare a bottle, and then another would pluck it from her hand and run to the nursery. We all hovered over the cradle as she slept, all wanting to be the first face she saw when she awoke. We elbowed each other aside at the changing table. Even my mother, usually so fastidious, dipped her hand in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We all wanted her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was not fair. My grandmother had given birth to a daughter she hadn’t wanted, my mother borne a daughter she hadn’t wanted. Now it was my turn. Why did they want to take this one from me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This was my last chance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the last chance for all of us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The last chance for what?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To make a connection, perhaps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To fill these empty arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We named her Naomi. I chose it and the other two consented. We all thought of the old story: Ruth and Orpah and Naomi standing on the open road, Orpah the coward going home weak and sniveling, and then Ruth turning to Naomi and promising her devotion with words like a song: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Entreat me not to leave thee … for where thou goest I will go, and there will I be buried.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A promise to lay down one’s life for another, and to do it gladly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was exactly what we offered this child. That kind of devotion was what we felt for her, though we could not articulate it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("None of us I admit are particularly eloquent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We all held her, we passed her from hand to hand, each of us crooning in her ear: Know that I will never leave you. Know that I am here forever. I will teach you everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We passed her along, from hand to hand. It made me think of disasters, of long lines of men passing buckets of water from hand to hand at a fire, or men heaving along sacks of sand during a flood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Naomi soon became Nomie on our lazy tongues.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie, we called her.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("She brightened the apartment. We watched her grow. All three of us tried to mother her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought, surely once she starts to walk and talk, she will point out her rightful mother, she will call my name, run to me, and those two will be forced to retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she did not. She was a grave, quiet child and she treated us all equally, held us all at a distance. As she grew older she withdrew even more. Her hair grew long, she would not let us cut it, she hid behind it like a veil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew she favored me over the others but did not want to hurt the feelings of the other two. She was a considerate child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She liked to play in the dark maze of furniture in the front room, just as her father and I had once played there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That had to mean something.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes she vanished in the jumble for hours; I would plow through the cobwebs and stacked chairs looking for her but I could never find her until she wanted to be found. Sometimes she vanished for hours. I did not like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her looks developed into a familiar pattern, the long black hair and dark eyes and lips a shade too wide for her face. Just like me. Just like all of us, in fact, though my mother’s hair was now touched with gray, and my grandmother’s was an unnatural metallic black.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother and grandmother noted that Nomie did not have her father’s blue eyes, blue like the remarkable eyes of my grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was sick of hearing about those eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought Nomie was beautiful. She could not be improved.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then mothers always want to think their children are perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There! You see what I said, without even thinking? This was further proof that Nomie was my child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought that once she was old enough she would declare her loyalties. I would wait until she was ready. I dreamt sometimes of taking her away from the other two, leaving this apartment where I had spent my entire life, leaving this city. But I could not think how, or where to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then of course I had to wait for Jonathan. I couldn’t leave. He would be coming back here sometime. I needed to be here when he did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When he came I would bring Nomie to him and say: Isn’t she beautiful? Haven’t I done a fine job with her? Can’t you see how there is not a trace of Chloe in her? Haven’t I suffered long enough for you? And he would agree, and we would go away together, with Nomie, and build our castles in the dust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I would wait.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Until then there was so much to do. I had to choke out any hint of Chloe that bubbled to the surface of Nomie’s skin. I had to shield her from my grandmother’s grisly incoherent tales, my mother’s delusions of grandeur. I needed to keep her on the true path.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She grew so quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed to happen in an afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She staggered into the furniture maze as a babe in training pants, and then an hour later out came this long-legged scowling girl asking about the blood in her underwear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I swear it seemed to happen that fast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I needed to hold her tightly, tightly.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They have followed me here, those three.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I left them behind long ago and they have found me again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one else seems to notice them, they have disguised themselves so cleverly. But I can see through their little ruse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to tell my daughter and my granddaughter: Look. Them. You see. There.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I used the simplest terms so they would be sure to understand. I tried to keep the panic out of my voice. They only patted my hands, nodded and smiled like idiots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am living in a madhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At least the sky knows something is amiss. It is gray, overcast, sagging down low to be propped up by the tips of buildings like a water-soaked tent. The city is full of sour pockets of air that you walk into unsuspecting and suddenly find yourself choking and vaguely embarrassed as if you had somehow caused it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There is dust everywhere in this room. I sweep it into little piles with the side of my hand, then leave them there for someone else to deal with. Such a tangle of hair there is in the dust: black and brown and gray. A stranger would wonder what kind of piebald molting creature lived here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This girl sits near me sometimes, her face looks so familiar it might be my own. I looked like that once; I still do when I close my eyes. Mirrors are a cruel trick, they show you only one point in time when the truth lies elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Talking to her is like talking to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She crouches near me, this girl with my face which she twists into bitter shapes around the gum she chews. Never speaks. Sometimes she has the portable radio and sits with the earpieces burrowed deep in her ears and her eyes far away. Other times she looks at me in such a knowing way that it frightens me. She reminds me of babies born in the village where I grew up, babies whom people said were born old, babies who did not cry and watched us all with world-weary eyes and died within days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This girl is like that. She looks as if she might understand if I tried to warn her, tried to explain, tried to tell her about the three of them.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Those three.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, I traveled so far to escape them. I traveled to this place, where their kind do not exist, where the world obeys different rules. Here where the future is uncertain and the past is far away and you can make both up as you go along if you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought I had left them far behind. I stopped hearing them in my head, I had not even dreamt about them for years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But now suddenly after all this time they have found me. I have begun seeing them again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They have changed, certainly. They are crafty. But I can see through their disguises, I recognize their voices. The trouble is that this city is so full of noise I cannot hear their words clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw them first in the Laundromat. Three women, gossiping nonstop, sorting socks. They had smooth black skin and lush hair; one had three gold teeth, one had gold earrings, one had a gold loop in her nose. I watched them through the window, between the letters painted on the glass, and I heard their voices drifting through the open door on clouds of sweet detergent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not understand most of what they said; their voices were soft and thick, velvety and low. But I heard a few words that made me start, words in a language I had not heard in years; and one of them turned and looked at me, a sly unblinking stare, so that I knew, beyond a doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw them a second time; three women, waiting for the bus, shopping bags at their feet. The bags reeked of fish, wetness leaked from them and crept into the pavement making ancient designs. Their mouths, constantly talking. Their hands never still. The roar of the bus drowned out their words. But I knew it was them; they did not board the bus when it came, they were waiting there for something else. They held their bench and watched the oblivious people passing by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to be sure. I edged close to the back of their bench, I bent low, I sniffed softly and caught their smell, that distinctive smell, the sweetness and rot. No one else in the world had that smell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their ears twitched; I knew they had sensed me. I turned, I wanted to run, to fly away as I had long ago, but now I could not, I was earthbound, I could only put one foot in front of the other, with nightmarish slowness, fearing their breath on my neck at every step. With the clarity of vision that comes with panic I watched a golden beetle scuttle past my feet on the pavement, traveling faster than I. I saw my shadow change with the incremental movement of the sun, cringing in anticipation of a blow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this I saw in that moment of longing to run, sandbagged by flesh, waiting to feel their fingers. But just then another bus arrived, and the gush of people that burst from the gates rushed between me and them; it broke their hold, hid me from their view. The traffic light changed; the press of people carried me across the street to the opposite shore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The air was full of the hum of autos, moving shoulders. An elaborate baby carriage, two children riding inside like royalty, rolled over my foot. A man in heavy boots plowed past, a long loaf of bread held against his shoulder like a rifle. A boy stumbled and fell against me, his head was close shaven, the shape of the skull clear and vulnerable beneath the skin. His hands moved over me swiftly, expertly, delving into pockets and cuffs and coming up empty. I felt his fingers on my wrist, his body pressing close then shouldering on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a long time I watched the back of his head bobbing and weaving in the currents of the crowd, a head delicate as eggshell, shining with the secrets it held.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Did you know that if you hold an egg up to the light you will be able to see the merest faintest shadow of the creature curled up inside?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned and looked back at the bus stop. I thought I saw three figures still sitting on the bench, I thought it was the same three, but I could not be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have trouble seeing lately.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The trouble is not in my eyes; my vision is as sharp as ever. It is the world that has become more blurred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is the air here, they talk of pollution, ions, electricity, ozone, something. The air is limp, greasy, it blunts the senses. No one sees clearly anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("So I got away from the three messengers that time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But soon I was seeing them everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the buses, on the steps of churches and hospitals, sitting on park benches. Always three women, similar enough to be sisters, always talking, always casting conspiratorial sly glances all around. I spied them in the market, waiting on corners for the light to change, standing together flagging a taxi, sitting together all sharing the same newspaper, and once for a brief fantastic moment on the public basketball courts engaged in a game of three-on-three with some tall black youths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When they appeared in the alley behind our building I tried to tell Sashie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She nodded and patted my hand then placed a cup of tea in it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked down at them from the window. They lingered in the alley, pretending to be occupied. They had slipped into the alley, all three of them, under the pretense of placing a single scrap of paper in the trash can. But I knew why they were there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They rattled the lids, chattered casually. They knew I was watching.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I had been silent so long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had shut myself off in a small dark place, away from the stream of events. Safe in this apartment, impervious as a tomb. I had shut myself away just as my grandmother had a lifetime ago, walling herself in with bricks of stale bread. I had watched the city rise up around me, watched my daughter and then my grandchildren from a distance so that they seemed tiny, nothing more than ants in an anthill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now suddenly I felt alive again; the arrival of those three had given me a vicious jolt. Suddenly I was thrust again into the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where had these enormous buildings come from? These fantastic lights? What is this music? Everything was beautifully, terrifyingly vivid, and enormous, and much too loud. Cars passed in a blur. I had never seen such colors, they dazzled my eyes. These people of all different colors, their thick muscles and beautiful skin. Where had these magnificent people come from? Where were their wings?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt alive again, and all was beautiful, and all was fraught with danger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those three women would find me sooner or later, I knew, and they would tell me the things I did not want to hear. Their ugly gossip, their dire predictions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They would bring me back to that place I had fled so many years ago. They would take away everything I had done and been until I was only a hollow shell in the center of a vast barren plain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If I go away from this place and leave nothing behind, then it will be as if I had never existed at all.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The only way to stave them off was to tell someone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I needed to beat them at their own game, drown out their story with mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought suddenly of that girl who listens, that girl with my face, the only one who listens to me now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was afraid for you. I feared they would notice you, recognize my features on your face. They will drag you back with them and force you to repeat it all, go through the motions over and over, a treadmill life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The only way to protect you is to warn you. That is what I am trying to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Please listen. Please do not pat my hand or offer me tea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If I tell you what I know then perhaps you will be able to evade them. Mara and Sashie have already failed without knowing it, they have fallen into the ruts long ago; they are treading in circles in their in-looking lives, circles within circles, getting smaller and smaller until soon they will be spinning in place. But you, I want to teach you to break away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is a paradox, isn’t it? To make you learn about history and its patterns in the hope that you will rebel against the lesson, escape those patterns and go your own way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Will you listen? Or will you cover your ears, run from the room, drown me out with your own voice?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You are listening, aren’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I came home today and found them at it again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother telling tales with silent Nomie curled beside her, rapt, chin on knee. Worse than a neighborhood gossip, my grandmother is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With gossip, at least, you know to take it with a grain of salt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother tells stories as if they are the gospel truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood quiet in the doorway a minute, listening to that voice that seems more familiar than my own, it is the voice my conscience takes on these days, she echoes my own inner chiding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This can’t go on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I listened, and then broke in: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("That")]), _vm._v(" story? Again? If you’ve told that story once, you’ve told it a thousand times.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked up at me. Well then, this time will make it a thousand and one, she said calmly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie said nothing, played with the fringe on my grandmother’s shawl, counting the strands, knotting, braiding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The stories are what keep us alive, my grandmother said in her significant way that brooked no argument; she bowed her head and resumed her story in tones only Nomie could hear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A thousand and one of her rotten tales; how could Nomie stand it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother seems determined to talk herself to death.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is taking quite a while.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I have long ceased to be intimidated by those knowing looks of hers, her way of divining people’s thoughts from their eyes or the nape of their necks, her air of holding a dark mysterious knowledge the rest of us are too imbecile to grasp. I have begun to see those things for what they really are: the false grandiosity of old age.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I have ceased to be afraid of her. I left the room, quickly, when she glared at me—but only because I did not want to hear any more of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those stories of hers, I do not want Nomie listening to them. They are not fit things for an impressionable young girl to hear. They are not fit for anyone, really, neither scholars nor madmen nor insomniac Arabian kings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What bothers me most about her stories are not the naked and bloody details; it is that she calls them the truth, gives them the stamp of history. She dresses up her lies like kings in rags, or wolves in sheep’s clothing. No one in their right mind would be fooled. Seeing Nomie at her knee I had wanted to say: What great eyes you have, grandmother, what big teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was Nomie’s age I too wanted to believe in certain things, and when I discovered they were false it felt like the worst kind of betrayal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want to spare Nomie that feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have never listened carefully to my grandmother’s stories, but I don’t need to; those stories from the old country are all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truth is, her stories are lies. Every one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, this can’t go on.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These days I think about Ari.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wonder if he is still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If he is, I wonder how he has satisfied his appetite all these years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How many hundreds of thick-necked officers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He must be an old man now. The hair on his shoulders must be silver.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wonder if he is angry at me for leaving him behind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That splash in the water. I would not look at it, did not turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you see, it wasn’t you I wanted to leave behind, it was everything else about that place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And now it has turned out to be futile, I have left nothing behind, it all has followed me here. I thought I could raise my children differently here. But I look at my daughter, and her daughter, and I see in them the same fierceness and singleness of purpose that people had over there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you remember our mother and father?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps one day long ago, by chance, walking in the forest, you might have met my dear ones, my sons. Perhaps one day as you glided along the ocean floor you might have seen my grandson. He loved to swim.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of these days I know I will step outside the door and find myself again in a city of dust, crumbling and empty, clocks broken and silent in the gutters, and ships like the carcasses of great fallen birds lying on the floor of a vast dry seabed.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lately my mother has been babbling about three old women she has seen, women who have been following her everywhere. They have come for her, she says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now every time she comes home she darts into the apartment, slams the door, leans against it and locks it. Out of breath, her head scarf askew, hair wild.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What will people think of me, letting my mother wander the streets looking like this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s stubborn. I can’t do a thing with her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She keeps insisting that these old women are plaguing her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She doesn’t seem to realize that she is an old woman herself, and that the sight of her probably frightens people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lately she has been taking Nomie aside and telling her things, I don’t know what exactly but I can guess. I know her mind is full of darkness, nastiness, things best forgotten or left unmentioned. She is giving Nomie strange ideas about her heritage, about us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These days when I look for Nomie I always find her with her great-grandmother, sitting together in a corner of the dark room among the old furniture, both wrapped in my mother’s moldy shawl. Nomie, usually so sulky (that is natural: she is fourteen) now sits gazing at my mother as if she is in love ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that")]), _vm._v(" is not at all natural).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is unhealthy. It will taint her young mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve read newspaper articles about things like this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know where my mother gets her grotesque stories. Mara and I have wondered if she’s picked them up from something she has read, or seen on television. But we’ve never seen her open a book, and she treats the television set like an unwanted guest: when one of us switches it on in the evenings she turns her back to it and lets out affronted little sniffs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course we’ve suspected senility; she must be well into her nineties, after all. She does not know exactly how old she is, she does not know the exact date and year of her birth. It’s not that she’s forgotten it—she never knew. No one kept track, in that backward place where she was born. Can you imagine? How can someone not know her own birthday?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But her mind seems as sharp as ever. She has the bus schedules memorized, for instance. Any time of day or night, when she hears the rumble beneath the window, she’ll say something like: There’s the three-thirty-seven express, or: That’s the one-seventy-six, Arthur’s driving, he’s always a little late.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I worry that she will fall down, break a hip, get knocked down and robbed in the street. She doesn’t seem to realize she is an old woman, she continues to work like a horse, wanders the city on her mysterious errands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe it is that, after a lifetime of hard labor, her body does not know how to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I cannot even call her an old woman, exactly. She is at the next stage, something "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("beyond")]), _vm._v(" an old woman. Whatever that might be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" am an old woman now. I admit this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The idea that we are colleagues is a frightening thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whenever she starts in with the stories, I tell her (gently, of course): That’s impossible, mother. It never happened like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And she says: Yes it did. How do you know about it, I don’t remember "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" being there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I tell her: Of course I wasn’t there, I wasn’t born yet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then how can you know, she says triumphantly. I was there, I saw it all, I remember exactly what happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would like to ask her for proof, for photographs, newspaper clippings, love letters. But I know she has no such thing, only these pictures in her head. And anyway, I know better than to press her. She is an old woman at the end of her life, trying to dress up a drab past in shocking colors, in sequins and armor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And she is my mother. So I try to let her be. It is only for the sake of Nomie that I question her at all. I think Nomie should know the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I get the chance I will take Nomie aside and tell her my version of things. I will explain to her about my mother, how she twists things. I think I will tell Nomie to continue to humor my mother, pretend to swallow her stories. For her sake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That would be the kindest thing to do, I think.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So now when I see them, see my mother’s tongue wagging, I try to keep my mouth still. My mother clings fiercely to her stories. She is childishly stubborn. I will leave her to these castles made of dust and barnyards and enchanted forests, this ramshackle past she has built with her hands and hovers over like a sandbox king.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("But I could not stop puzzling over where she got these stories. And why she told them, what pride or shame drove her to it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I suspected she was hiding something. The stories were her way of disguising something she did not want to face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to know what was hidden behind her shabbily fantastical peasant past.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And finally one day I couldn’t bear it any longer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited till she left the house on one of her scavenging strolls through the neighborhood. (I have seen her digging through trash cans, seen her pulling people’s wet clothes off laundry lines, casually palming lemons and apples off grocery stands and strolling away. She lives by her own laws, my mother.) I went into her room and unearthed the truth, and proof.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Quite literally unearthed: I had to dig down under the spreading debris in her room, under old molding blankets, cardboard boxes, pots of tired-looking plants, the spent matches and rolling papers and plastic bags of marijuana she buys from the boy in the hooded sweatshirt on the corner (she calls it a medicinal herb and says it is good for her cough. I simply look the other way). The curtains at the windows, yellow with age, gave the light an antique sepia evening color, though it was barely midday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know it was wrong to do, invade her privacy. But look what I found.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A Fabergé egg, the genuine article, just like the ones you see in museums. It was covered with jewels on the outside; I tested them against my teeth, scratched them against the window. There was a cunning little diorama inside, impossibly detailed. I did not have time to look carefully, I was too excited. And anyway, the outside of the egg, the jeweled surface, captivated me more. The thing was priceless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And to think she had it buried beneath the bed, like trash. How could she have gotten it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Right then I realized the truth, after all this time, the mystery of her family. They hadn’t been peasants at all, they must have been very wealthy. Part of the aristocracy, even. One of the old noble families. Here was the proof, right here in my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Funny, how in a way I had always known. Or at least suspected. I had sensed that I was something special; noble blood cannot be denied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered: did they have an estate? A country home? Servants, horses, elaborate many-syllabled names? Why had she given all that up? Had they been forced to flee the revolution?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I found something more. In the fourth cardboard box I looked through, filled with crumbling yellow papers and small brown spiders scurrying from the light, I found the documents, bluntly scrawled in a foreign language. I was able to translate, roughly, and I saw that they were identification papers. My mother’s and father’s, folded together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I gasped then, inhaled dust and choked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My parents were brother and sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My own parents? Living in incest all these years?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I squatted there, squinting in the dust studying the two papers so brittle with age they seemed on the verge of cracking rather than tearing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Brother and sister? Perhaps it was a mistake, a deception born out of confusion or convenience or simple ignorance. But the more I studied on it, the more it seemed to make sense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Brother and sister. A forbidden love. No wonder they had fled their home, moved to a new country where no one knew them. No wonder they had to leave the family estate, the servants and carriages and elaborate balls (I had already begun imagining my lost birthright). They had come here with their sinful love, to live secretly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother? I asked myself. Living in sin with her brother? Incest?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look at those eyes. She’s capable of anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("was")]), _vm._v(" looking, for there she stood above me, her head still wrapped in a scarf, staring as I squatted on my heels beside the bed. Those eyes. She snatched the papers from my hands, gave me a nudge with her foot so that I fell sprawling backward. I looked past her then, at the dust motes hanging in the sunlight, glinting, floating in the air, never settling, like those Bible-era wasps you see in museums, frozen for centuries, suspended in amber.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her eyes were frozen like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I scrambled from the room like a chastised child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But satisfied. I had found out the truth, her royal family, her incestuous desires.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No wonder she wanted to disguise it all in fairy tales and magic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood in the bathroom studying my face. I thought of velvet gowns, jewels in my hair, painted portraits. I turned to see the profile. I definitely saw traces of nobility, a Hapsburg chin, it belonged on a cameo pin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, it did occur to me that my brothers and I were the products of incest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the realization did not trouble me overmuch. It’s historical fact, you know, that royal families often married within themselves to keep the blood pure. It had been done for centuries. My parents’ union was not such a tawdry illicit thing; to me it was the height of refinement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had uncovered her secret. And there was proof, incontestable proof that you could hold in your hands. Tangible evidence, that was the only way to be sure of anything. Tangible evidence that you could wave in someone’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt I understood her better than I ever had before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would not tell her I knew her secret. I would let her continue to hide her past in shadows, in poverty and death and fairy tales.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Nomie, I thought, Nomie should hear the truth. Nomie should be allowed to know.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I went to the museums quite often now. Almost every day. I would put on my gloves, and my pearls (faux, but you could not tell), and the small violet hat, and I would go to the museums and wander the endless huge rooms full of antique furniture and paintings in thick elaborate frames.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at the bed where a king had strangled his seventh wife. I looked at the portraits of sickly angelic heirs, propped up stiffly like dolls, who would die before they inherited their thrones. Paintings of ladies in bejeweled gowns, men in stiff ruffled collars or brocade waistcoats.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mostly I went to the rooms of the Fabergé-style eggs. I basked in their glow, I could dream there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was happier than I had been in years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Joe? He had been a weak man, a common man. I had intimidated him. He had not been worthy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The museum rooms were vast and echoing, like churches, like ballrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The line would continue, I thought. An indelible line continuing into the future.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of certain sections of the Bible, the endless dull passages of who begot whom, and who then begot whom, down and down through the generations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed important, now. Having children had never seemed such a lofty thing to me before. Now it did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I saw the portrait and nearly fainted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Truly, I did, I wavered on my feet and a kind museum guard leaped forward and grabbed my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A portrait of my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("swear")]), _vm._v(" to you. Hanging in a museum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the portrait she was much younger than I had ever known her, she must have been close to Nomie’s age. But I recognized her immediately, it was unmistakable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The features. It had to be her. The girl in the portrait had my mother’s birthmark next to her mouth, a pink smear like misapplied lipstick. That mark had a very peculiar shape, very distinctive, I had been staring at that mark on my mother’s mouth for all my life, and now here it was on the face in the painting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were other distinguishing marks too, bumps and scars. My mother had many. As a child I’d once asked her to tell me about them; she’d said only that she’d had a rough childhood. From looking at her face you’d think a rough childhood meant tumbling down stairs several times a day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the most decisive thing was the eyes staring out of the paint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those were her eyes, there were none other like them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frozen in time, a wasp in amber.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those eyes, fierce and fearless, capable of anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the portrait she wore a dress like I had never seen before, embroidered and jeweled all over the bodice, long full sleeves. Her hair—there had been so much of it then—had been arranged in loops and ringlets and flounces, an elaborate dark mass atop her small head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hardly need to add that the girl in the portrait had her jaw clenched, her hands curled into fists. Both were habitual, unconscious gestures of my mother’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t you see, it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("had")]), _vm._v(" to be her? Women in brocade dresses simply do not pose for portraits with their fists clenched. There was not a single other portrait, in that entire museum filled with hundreds, with hands like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wandered for hours, seeing nothing, my head floating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I went home that evening and there was my mother, peeling potatoes in the kitchen with Nomie beside her. There it was, the same mark on her mouth. The same crooked scar at the corner of her eyebrow. Those hands, so tight around knife and potato, as if the potato needed to be subdued.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know what to say to her. I felt a kind of awe, different from the kind I had felt for her before. I had always sensed that she had some kind of power hidden away, but I had always assumed it was dark and conniving rather than a tragic noble sort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Watching her I had an ugly feeling then. I was jealous of her, I admit, jealous of the shining elegant past she had had, the kind of elegance I had always longed for and never found. And I was angry, too, that she had not shared it, had not shared the treasures of her past with me. Not just the tangible things, but the wonderful memories she must have had of that time. She’d kept them all to herself, selfish woman. She’d been silent so long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And now when she opened her mouth it was to spew rubbish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She put on this charade of peasants and poverty just to taunt me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not angry for myself. Oh no. I was angry for Nomie’s sake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie who sat there fingering potato peelings as my mother withheld the truth, the magnificent shining truth, and fed her up on unwholesome make-believe and lies.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Ilana")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Today I was telling about my parents’ courtship. I was remembering how my mother’s face looked when she was possessed by the dybbuk, so weirdly slack and empty. I remembered the hoarse foreign voice forcing its way out of her throat, and the way everyone in the village drew away from her and even my father with his scarred cheeks looked afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was remembering how the chickens followed her, and the worms sprang up from the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later, on their wedding day, she wore a blue dress and flowers in her hair and I had never seen anyone so beautiful. She and my father fed each other wedding cake, and his mouth was so wide she could place her entire hand inside with ease.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I remembered Shmuel’s parents, how their faces lit up when their daughter married the baker. The daughter had a walleye, and prematurely graying hair, so she felt blessed to be getting married at all. The baker was painfully shy and stuttered when he spoke, so he felt equally blessed. I remembered how happy we were for them, how we all joined hands and danced the minute he crushed the glass with his heel. I remembered how their children came so quickly, one after the other. Seven children all smeared with flour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remembered how they died, their bodies stacked with others high as a haystack. The sight was familiar. My family had been piled up the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Today I was telling the story of my grandmother’s wedding night. She was still a child then, my grandmother. She still wore her hair in braids and had nothing sticking out of her chest but ribs the night she knelt before my grandfather’s chair and washed his feet for the first time in a bowl of milk. She kept her head bowed and shivered when he drew one finger slowly along the shining white part in her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could see it so vividly, as if it had happened the night before. My grandfather’s chair, his emptied boots, the shutters drawn against the cold, the red blanket on the wide low bed that waited ominously in the shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I finished telling these stories, and others, and then went to bed feeling content.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was not until hours later that I started awake and realized I could not possibly have witnessed these things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I could picture them all so clearly! As if I had been there!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It frightens me that I can no longer tell which tales have been told to me by others and which I have witnessed myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They all have the ring of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Nomie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have been having these dreams lately.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the dreams there is a ladder that reaches from the ground to the stars, with children climbing up and down and the smell of burnt sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dream of a dress shop where all the salesgirls wear large oval mirrors attached to their hats. They stand in a circle as I try on the dresses, so that every direction I turn I see myself, framed above their fawning faces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the dreams there are men raining from the sky and crumpling to the ground, cursing their commanders and the war and the manufacturers of their faulty parachutes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dream of a ship at sea, of sheets piled up like snowbanks, of a black-haired man whose shoulders are so broad he cannot fit through the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dream about things I have never seen, only heard about, but they are more real to me than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("People say you should believe none of what you hear and half of what you see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To live by that you would end up with nothing to believe in, and what would be the use of that? You might as well lie down and die, because that will be the only sure thing left you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can believe anything. For a little while.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I have no mother, or three, depending on your point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There’s Mara, who when I was younger would hold me too tightly, press my face against her bony hip. She used to say: You can call me mama, if you want. It’s almost the same word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She told me endless stories about my father and showed me postcards he had sent her from various port cities: Lisbon, Sidney, Miami. In her stories my father was sometimes a sailor, sometimes a doctor, and always on his way back to us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later I looked at those postcards, saw that they were blank on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was dark and angular, her eyes so deep-set they were always in shadow. Her hair was coarse and long and she left bits of it everywhere: black hairs in the sink, on the seats of chairs, clinging to her clothes, stuck between the pages of books.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then there’s Sashie who always told me to behave, to walk with my spine straight and ignore the boys on the street. You’re special, she told me, you’re not like them, they’re rabble. Different blood runs in you. Hold your head up, for God’s sake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She touched me sometimes but in an awkward way, as if she was not sure how to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had gray in her hair and arranged it in an upswept stiff way. She wore collars like doilies and always lipstick, lipstick that bled into the lines around her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then there’s Ilana, whom I could not bear to call my great-grandmother because saying that word is like trying to shout across a canyon, across endless distance. And she did not seem far away at all, she gave me conspiratorial glances and told me secrets, and our hands when we pressed them together to measure were exactly the same size.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was small she made me a cape and a hood all in red, and I wore it for years whenever I went outside; and she told me a story about a girl who wore a hood made of a wolf’s hide.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was reserved, not pushy like the other two. I had to seek her out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had to walk into the dark room that terrified me when I was younger, walk into the mess of dark ramshackle furniture, precariously stacked so it seemed it might fall any moment and crush you. There were spiders, and an unidentifiable scuttling that might have been mice, and a strange sickening dust that was soft and sticky as pollen. But if I braved the forest, I would find the treasure in the center of it: Ilana, with her knitting and her hands that were hard and at the same time soft like clothes laundered a thousand times.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not think it unusual, when I was younger, to have three mothers. I assumed everyone did.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Mara used to have a job in a hospital. She was not supposed to bring me but sometimes she did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was not a doctor, or even a nurse, though I think she would have liked to be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She did a lot of cleaning: making up beds and mopping and wheeling carts around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I liked to knock on doors and pay visits to strangers while she worked. I met a man with tubes in his nostrils and a blue cast to his face. He had a large beaky nose and the strong sunlight from the window shone through it, making it pinkly translucent, I could see the veins threading through it. He gave me the most beautiful smile when I came in, though his teeth were in a glass by the bed. We played cards all afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw the room where babies lay in rows, in glass cases, like meat at a butcher shop or expensive jewelry arrayed on velvet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I met a woman who ate pills like candy, all different colors, and she offered me some. Her face was kind though her eyes moved loosely in two different directions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I talked to a woman with very little hair. It was soft and downy like a baby chick’s. She told me she had had her breasts removed. I did not understand what she meant (I was much younger then). Removed? Removed to where? Where were they now?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw a dead person for the first time. I did not know he was dead at the time. I thought he was very shy and did not want to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One time I was sitting in a waiting room with a man who was waiting for something. His eyes were leaking, and he was wiping his face with wadded tissues. First he was telling me about his wife, and what had happened to her and what the doctors said and what they were doing to her and about every asshole he was going to sue for malpractice if anything went wrong. Then he was snuffling into the tissues some more and drinking from a small bottle and sweating out of every pore in his face. And then he was sitting beside me and then he was wiping his face on my shirt and I sat very still and told myself he was only doing it because he had used up all his tissues. No other reason. Later on the bus ride home Mara asked me what I had gotten all over myself. I did not tell her. I did not want to touch it with my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara left the hospital job not long after that. She told me she had quit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Sashie told me she had been fired for breaking the rules. She had been caught in the nursery, cradling other people’s babies.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("At mealtimes all three of them would try to slip the choicest bits from their plates to mine. Take this, Ilana would say, it will make your blood strong. This will clear up your skin, Sashie would say, directing a forkful toward my mouth. Mara would say little, would simply transfer most of her meal to my plate with an expression of stern martyrdom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eat it, they all said. Eat it, I didn’t want it anyway. Really.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" don’t need it, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" don’t matter anymore, they seemed to say. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("You’re")]), _vm._v(" the one who needs to grow up big and strong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Looking at my loaded plate and their bare ones was usually enough to make me lose my appetite.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mother, I said sometimes, just to see the way all three raised their heads expectantly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was always pulled in three directions as I was growing up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was used to it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the spring I was fourteen it got much worse, so that I thought they would tear me to pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It started when something happened to Ilana.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She came home one day with a wild light in her eye. Her hands shook as they stroked my hair. Hours after she had returned she was still out of breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Please tell me, I said, please tell me, whatever it is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She told me then, about the three women whom she had left behind long ago, who had crossed oceans and years to find her again. She repeated her stories of how they cackled and scratched themselves and picked the fleas from each others’ hair, and how they spoke of things she did not want to hear but could not shut out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How they unspooled the thread and measured it and cut it. How some lengths of thread were short and others long; and once the thread had been cut it could not be changed, neither the short threads made longer nor the long threads made shorter. No matter how much people might want the pieces to be different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The threads had been cut. There was no hope of it being any other way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said: I have told you once and I will tell you again—I came to this country from a land far away because I thought here I might be able to cut my own thread as I chose.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said that at one time she thought she had succeeded, but now she was not so sure. She was no longer sure if she was cutting her own thread, or if it was being cut for her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These things sound strange. But I understood with one part of my brain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She began telling me other things that she had kept inside a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes she spoke a language I had never heard, and seemed surprised that I did not understand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Ilana began her telling, Sashie and Mara noticed and began their own. Theirs consisted of drawing me aside, whispering in my ear with their eyes rolling suspiciously all around. Mara even came in my room at night to mutter words over me when she thought I was sleeping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They accused and denied, each told me she was telling me the truth and everyone else was lying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt as if I were being courted, as if they were all trying to gain favor. As if I were some kind of sleepless king, and they were telling stories, desperately telling stories as if it was their last chance, as if they would die in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their voices all sounded the same. Sometimes when they were telling their stories I closed my eyes and could not tell who was speaking. The same voice, in varying degrees of brittleness. The same inflections, same gestures of speech.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother, all three said, with a mixture of love and fear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My brother, they said with adoration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daughter, they said, their voices fearful and uncertain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mother. Brother. Daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you did not look you would think it was the same person every time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That is heredity, I suppose: passing along the same eyes and hair, the same tenacity, same style of speaking. The same voices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My voice, I suppose, sounds like theirs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And perhaps we all sound alike because Ilana taught Sashie to speak, Sashie taught Mara, and they all taught me. So that people tell me I have a touch of a foreign accent, something they can’t place, though I have never been out of this city. It is Ilana’s voice, passed down and diluted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Our conversations must sound like a person arguing with herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their faces looming over me, the features were all the same. Same but different. Sashie’s neck looked strained from constantly lifting her chin, her eyes tired from always looking down her nose. Mara’s face looked bloated, congested with secrecy, with suppressed thoughts and mucus and yearnings she could barely hold in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Ilana. Her face was covered with lines, not deep, the thinnest of lines like threads lying on the surface of her skin. And she had the mark I loved, a smear of red next to her mouth, that drew your eyes to her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie woke me in the middle of the night to tell me the things she had forgotten to mention during the day. Mara offered to braid my hair, and when I sat before her she wrapped her hands in my hair and held tight for hours, telling me more stories about my father, how fine-looking he was and how he loved her and how much she had done for him, with her breath hot and wet in my ear. Sashie came to my school one day, took me out of class and brought me to a museum where she showed me jeweled eggs and gloomy paintings. Once when Ilana was out, Sashie took my hand and drew me into Ilana’s room, showed me crumbling documents and told me about blood and nobility and a lost fortune. Her eyes shone, her spit flew. She dabbed at her mouth with a lace handkerchief.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ilana’s tales were the only ones I wanted to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How can you stand to listen to her? Mara said to me. It’s all lies and foolishness. Do you really believe all that? She probably told you she walked across the Atlantic in a pair of magic boots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She can’t prove anything, Sashie said. She has no proof, all she has are these words and pictures in her head. How can you trust that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I just do.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Ilana lived in the largest room in the apartment, and she kept it so dim you could hardly see its boundaries. Sashie’s room was smaller, the walls entirely covered with yellowed pictures of starlets from generations ago. Mara’s room was smaller still, it was the room that had once been my father’s and she slept there among outdated medical textbooks and pencils she allowed no one to use. My room was the smallest of all, it was encircled by the others, a windowless closet in the heart of the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The rooms were like a series of nesting boxes. Each could fit inside the next. They were like those hollow wooden dolls that can be opened to reveal smaller ones, which can be opened to reveal another. And so on and so on forever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rooms within rooms and stories within stories.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I did not have many friends at school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not have any, in fact.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not mind, I had too much company already, with Sashie and Mara constantly hovering like vultures. It was a relief to go to school, push my way through the crowded hallways, read books, and ignore everyone around me. People spoke to me and I did not know what to say to them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stayed indoors most of the time, which kept my skin very white. And my hair was as black as Ilana’s. I wore black clothes all the time, just as she did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was in elementary school the other girls had called me a witch, scratched me with their nails, giggled behind their notebooks. But now I was in high school and suddenly everyone wore black and had pale skin and cultivated a disheveled haunted look. Now I blended in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still I had nothing to say to anyone. They were like a strange foreign tribe, with their own catchphrases and rituals. I let my hair flop forward to cover my face. I felt safe in there, a black forest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I met Vito by nearly stepping on him one day on my way home from school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was sprawled out across the front stoop of my building, blocking the way. He had his head tipped back, hands clutching his chest. I did not know if he was hurt or asleep or dead. I thought I should check his throat for a pulse. Then I thought I should pull down his T-shirt where it had ridden up to expose his belly. Then I thought I would just step around him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked too young to be a homeless person. His clothes were too clean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I raised my foot to step over him when he suddenly opened his eyes, sat up, and grabbed my ankle. Finally, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to pull away. Finally what? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve been waiting for you all afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve seen you at school, he said. Come sit here a minute, he said and patted the stoop beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I shifted from foot to foot. I wanted to dash inside and up the stairs. But I could not stop looking at him, at the metal studs that pierced both his cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You go to my school? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve never seen you before, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well, you’re missing out, baby, he said and I saw the flash of a stud in his tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What do you want?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Want to get to know you, he said. You’re one of those quiet types I bet, he said, look like you’ve got something going on. And I want to know what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He put out a hand and tugged at my skirt. Sit down a minute and talk to me, he said. Little ol’ Vito isn’t going to hurt you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one had ever expressed an interest in what I had to say before. People were always too busy making me listen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He put his hand on my thigh. The nails were close-bitten. His hair was bleached a harsh, unnatural color and he wore a string of tiny red beads around his neck. I could see that he was just a little older than me, but his face already had the beginnings of creases around the eyes and mouth. Tired skin. His eyes were strange and dilated, but they fixed on me and stayed there and waited. I liked that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not stop staring at the metal in his cheeks, on his tongue, piercing his eyebrow. I ached for him, the kind of pity you feel for a run-over animal in the street. I had the urge to protect him from whatever it was that had abused him like this, worn him down and punched him full of holes like a sieve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I remembered he had "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("chosen")]), _vm._v(" these things, he had inflicted them on himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you sure you go to my school?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yeah, yeah, he said. Do you want a cigarette?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I took one and held it and did what he did. I sucked in and blew. My lungs hurt. I watched him, hoping to see smoke leak out of the holes in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie! someone gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked up to see Mara at the bottom of the steps with her raincoat wrapped tightly around her though it was spring. Her forehead was shiny with sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What are you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("doing?")]), _vm._v(" she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The smoke drifted out of my mouth, floated in front of my face like a veil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh my God, Vito said, who the hell is "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie, get upstairs right now, Mara said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood. Vito leaned back against the step behind him. His shirt had ridden up again; I could see a patch of skin, a stripe of hair, a strip of underwear. Is that your mother? he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at Mara, who was waiting for my answer. I looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God no. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("That’s")]), _vm._v(" not my mother, I said and clattered up the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I thought of what Ilana had told me once, that Mara had something twisted and bitter in her, something that had started out right but then doubled back on itself and gone wrong like an ingrown hair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of that hair, growing rampant within her, spreading all through her body, twining around her bones like vines, branching and climbing around her heart and liver, weakening the structure from within.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stood in the bathroom and looked at my face in the mirror, at my birthright hair, this hair that had been passed down from generation to generation, binding us all together. Suddenly I did not want to be like them anymore. I took the scissors and cut. And cut again. Like severing an umbilical cord. I cut it in big heavy handfuls that fell to the bathroom tiles and lay there like dead animals. I kept at it, liking the crisp sound, until there was nothing left to cut.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My skull had such an interesting shape. A part of myself I had never seen before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie let out a shriek when she saw me. Oh, Nomie, your beautiful hair!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I hoped Mara would cry out too. I wanted her to be angry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I like it, you look so much more like your father now, she said and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ilana looked at me and her lips trembled and she said: You look like that girl from downstairs, the one who escaped the camps. The one who hung herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No she doesn’t, Sashie said quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What are you talking about? Mara said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ilana had her hands over her ears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not stand the pain in her face. It will grow back, just like before, I swear it will, I told Ilana over and over but she would not meet my eyes and closed the door to her bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("It’s cool, Vito said, running his hand over and over my scalp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We were sitting on the roof of my building, in a forest of television antennas. The tar was melting, sticking to the seat of my pants, the palms of my hands. The traffic on the street sounded far away and the sky was patched with bruised spots that might have been clouds or pollution.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It felt like the building was swaying, very slightly, with the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The roof was flat and had no walls or railings enclosing it. Pigeons landed and watched us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sat as close to the edge as possible, to prove we were not afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vito gave me a cigarette he had made himself. It tasted different from the regular ones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This kind is much better, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fortified with vitamins. New and improved, he added and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Have you always lived here? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nah, he said. My mom and me, we move around a lot. Lots of one-year leases. She’s cool. She doesn’t care what I do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She doesn’t care? That sounds so nice, I said. I couldn’t even imagine that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I said: What about your father?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Poppa was a rolling stone, he said and laughed shortly. He took the cigarette from me and sucked in the sweet smoke. The smell made me think of Ilana.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What about your folks? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know. I don’t know where they are. I never met them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh … I get it. You’re adopted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No … my mother’s dead. It’s complicated. You see, she was this kind of mermaid-woman that couldn’t live out of water, and my father was a doctor but never finished school, and he’s busy traveling around the world and hasn’t had time to make it home yet but he will.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh.… So who was that crazy-lookin’ lady we saw the other day?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s my aunt. But she thinks she’s my mother. Although the one who’s more like my mother than anyone is my great-grandmother. But I don’t like to call her my great-grandmother. And she doesn’t even know who I am, exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whoa, he said admiringly. You’re living with a bunch of freaks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And for all I know I’m not even related to them! Maybe there was a mistake, a mix-up, and my real parents are out there looking for me right now! I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I blurted this out without thinking. But then I thought about it and the idea appealed to me. Maybe I was not their daughter at all. They told me I was, but why should I believe them? Why should I believe their far-fetched stories about people I had never seen? Where was their proof?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could be anyone, I thought. Anyone. I was a person of mystery and possibilities. My life, which had always seemed so narrow, now burst open and scattered all around. The sky seemed so bright, and I smoked more of the cigarette and looked at Vito and he seemed to have three arms, then four, then six and all of them were beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I liked to feel his metal stud in my mouth when we kissed, liked to feel it clicking against my teeth. Getting our bodies to line up was more difficult. I kept landing a knee in his stomach, my chin in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you want to do it? he said, his hands at the waistband of my pants.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why not?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everybody does it. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Everybody.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m too young.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, come on. I bet all your friends have done it already.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Admit it, they have. I bet you can’t even name one friend who hasn’t done it yet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One name. Give me just one name. See, you can’t. They’ve all done it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s not why.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come on, it’s normal. Everybody does it. Don’t you know that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know, I said because I didn’t want to tell him I had no friends and had no idea what other people did. He was like an ambassador from that world, sent to educate me about their customs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come on, he said, you’ll like it. You’ll thank me later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Okay, I said because I believed him. Or I wanted to believe him. It was ingrained in me. For so long I had been taught to believe what people told me. It was hard to break the habit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you ready?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You want to do it right here?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why not?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Someone might see us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who? The pigeons?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was moving with quick determination, his eyes hugely dilated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Wait, I said. And "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("oh,")]), _vm._v(" I said, and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("stop")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("slow")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("not there.")]), _vm._v(" I looked at the sky and felt him rubbing in that sensitive place and it felt wrong, like when you rub your eye too hard with your knuckles. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("No,")]), _vm._v(" I said, and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("please")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are you finished?")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are you finished?")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are you finished yet?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I lay back and waited and watched his body rise and fall in an eager desperate way until he said he was done. How do you feel? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to say: Why didn’t anyone tell me it would be like this? Why didn’t anyone prepare me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had known the facts, but the reality of it was quite different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt something hot trickle down my leg and I lay back on the hot black tar and wished more than anything that it would snow, I wanted snow to come down and cover everything.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Late that night Mara came into my room. Stood by the bed in her white robe, her hair falling down her back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re awake, aren’t you? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Closer she came.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Can’t sleep? she said. Something bothering you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sat down on the edge of the bed. The mattress sagged and I slid toward her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can tell me, you know, she said and stroked my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered if she knew something, if she had seen us on the roof. I could not make out her face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know you’re lonely, she said, you don’t have to be ashamed to admit it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The heavy medicinal smell of her hand ointment hung all around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, all right, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sighed as if giving in to something and said: All right then, if you want. I’ll stay with you until you fall asleep if you want me to, I don’t mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I didn’t … I said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You don’t have to be afraid of anything, she went on as if she had not heard me. There’s nothing to be afraid of, you’re just imagining things. I’ll stay here until you fall asleep. So you don’t have to lie awake alone. I know how terrible that can be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Those voices, she said, they’re not real, they’re in your head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to move away from her but the bed was too narrow; there was nowhere to go. Her sticky warmth crept under the covers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I won’t ever leave you, she said. Not like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("some")]), _vm._v(" people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pressed closer to the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited and waited and it did not come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("School had let out so I had plenty of time to concentrate on waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soon I was checking the blank white crotch of my underpants every hour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited some more and when I was sure I told Vito.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("what?")]), _vm._v(" he said. How can that be?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We were sitting together on my stoop. I could not sit still, kept knocking my knees together. I was keeping an eye out for Mara, Sashie, Ilana—all of them. I was smoking his cigarettes as fast as I could, one after the other, thinking maybe they would kill it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sorry, man, he said, I thought you were on the pill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You did not, I screamed. Why would you think "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("that?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did, I swear. I guess I got you mixed up with someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at him and wanted to run a string around all the studs in his face and then pull it tight suddenly to make his face shut up like a drawstring bag.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Who?")]), _vm._v(" I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I mean … I didn’t mean it like that, he said and tried to kiss me. I bit his neck as hard as I could.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Leave me alone, I screamed, but all that came out was a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment was suffocating. I was sure all three of them could tell. Surely they could smell it, even see it. Wasn’t it obvious? My body was reeking, it was transparent, blatantly proclaiming its condition to the world. Surely Ilana could tell?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she said nothing, ran her fingers over my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could never tell her my secret. I knew how she felt about children, they were a blessing, she would never understand if I said I wanted to get rid of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I couldn’t have a baby. Could I? Now? It was impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could not bring a baby into this apartment. This series of boxes, these rooms nesting within one another. Where would we put a baby? In a box small enough to fit inside the smallest room, so that we could all surround it, enclose it, smother it with attentions?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of the pictures I had seen of fetuses, showing the progression. The thing that started as a tiny dot and progressed in stages until it swelled into a newborn. Those embryos of different sizes, they reminded me of wooden nesting dolls. Unborn babies were like the smallest of dolls, the very innermost ones, the thing that lay inside the belly of each of them, the heart of them all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew what would happen if the baby were born. I could see that Sashie and Mara were already beginning to give up on me; I was not the model daughter they had hoped for. I knew they would pounce on the child and try to start over, begin anew. Pull her this way and that, try to mold her in their hands. No child deserved that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The pattern repeating. An endless procession of women following a single set of footprints in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What were the alternatives? Vito was no help. It was to be expected; all men died or disappeared and left you alone. That was something I had learned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why had I listened to him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why hadn’t anyone warned me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why hadn’t they told me what might happen?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt so angry at all of them: Mara, Sashie, Ilana.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why hadn’t they prepared me for this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of how Sashie’s stories always seemed to avoid any mention of intercourse and conception; she did not think these things worth dwelling on, they were not suitable for a lady’s lips or my ears, they were best skimmed over.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Mara had nothing to say about the matter. She only muttered words too low to hear, glared out of the corners of her eyes, pressed her knees tight together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I thought of Ilana.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All at once I remembered Ilana telling me about Baba’s twisted wire and her nighttime visitors, not the men but the frightened women who came to the back door; and about the army officer with the thick neck and shiny boots; and about my great-grandfather placing his hands on her belly and imploring her to be fruitful and multiply. Ilana "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("had")]), _vm._v(" warned me, I realized. But I had not been paying attention in the right way. I had thought her stories were only about "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("her;")]), _vm._v(" I had not thought they had anything to do with "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("me.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was too late to ask her for advice now. But the thought of her stories had given me an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I pressed the doorbell and heard a muffled chime deep within the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard the slow shuffle of footsteps, the rusty scrape of locks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was much smaller than I expected, hobbling on two canes and her back so bent that her chin rested on her bosom. But she still wore heavy jewelry: ropes and ropes of pearls, and earrings that dragged down her earlobes, and rings on every finger. And like Ilana she kept her hair dyed its once-upon-a-time original color: a fiery orange with yellow streaks like false gold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I didn’t think you’d still be here! I blurted out when she came to the door. I could not stop staring at her feet, those stiff unnatural carved things in high-heeled red mules.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Were you hoping I was dead? she said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No … I …")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She lifted her glasses to her nose and peered at me. Then she lifted a second pair of glasses and placed them over the first and looked again. She placed a third set on the tip of her nose before the other two and studied me through the triple lenses. Her eyes widened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ah, I know who you are, she said. I mean, not "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exactly,")]), _vm._v(" but I’d know that face anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I explained: I found your address in among Sashie’s things. It was written on an invitation. An invitation to her wedding party. I guess she forgot to send it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed at that; I saw the shiny white of her teeth, the bright pink of perfect plastic gums. She said: That was Ilana’s doing, I’m sure. I’m sure Ilana was supposed to give it to me and never did. She did not want me there, didn’t want me near her family, she thought I was bad luck. Always did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You remember, then? I said, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course, she said. And you are—what? Ilana’s granddaughter?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Great-granddaughter, I said. And you’re … "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Annabelle,")]), _vm._v(" I said carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya, she said. It’s back to Anya now. I’ve realized I can’t ever get away from it, so why pretend? Come in, come in, don’t stand in the hallway like a salesman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I followed her through a room so layered with dust it looked like an archaeological excavation, and then we stood in her kitchen, which looked lived-in and tidy. All the cans and pots stood on the lower shelves where she could reach them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let me heat up some beet soup for you, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, that’s all right, I said, my great-grandmother makes it for me all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her face stiffened. Well, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" don’t have anyone to make it for, she said stubbornly and shifted a pot to the stove.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t want to bother you, I said, I just wanted to ask you something.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her my problem.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought … you might … do that sort of thing. Or know someone who would, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What? she said. Just because it was done to me, once, that makes me an expert?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, that’s not what I meant. I just thought you would know … how I would go about having it done, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was pressing close to me, peering in my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you want to know, it’s true that I have helped women in trouble. When they had no choice. Many women. Right here in this kitchen! she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could pay you, I said. Not a lot, but—")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No! No more! she cried and her spit landed on my face. No more! There are doctors and hospitals for that sort of thing. They can do it right. I may look like an ignorant old woman to you, but I know that much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You won’t help me, then? I said, looking at the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would only hurt you, you foolish child, she said. These things are dangerous. Don’t you think there’s a reason I never had any children? It was not by choice, I tell you. I went to that old herb woman for help and she damaged me forever, and I was only a little girl then. About your age. Are you listening?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes I wish I had never gone to her at all, I wish I had stayed at home and had the child. My life would have been completely different. I was always so jealous of Ilana. She had everything I didn’t. Everything I wanted and would never have. And no, I’m not talking about feet! she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked up from her wooden nubs. She put her thumb beneath my chin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She has children, grandchildren, great-grandchildren. Now maybe great-"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("great")]), _vm._v("-grandchildren even! And me, what do I have? Nothing. Other people’s children plaguing me, soup that no one eats. Little girl, you should think carefully about what you do next. Don’t make the mistake I did. Do you want to end up like me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said nothing. She had backed me into a corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed. You look just like Ilana, trying to plot your escape, she said. She reached up and stroked my head. She said: Your eyes are like hers. But your hair! How did this happen? Was it an accident?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I like it this way, I said. It’s different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Did Ilana ever tell you how she cut off my hair? At the time we were both desperate to leave, and she said it was holding us back. But I think she secretly wanted to do it all along. She enjoyed chopping it off. She was jealous of me, I think. We were jealous of each other, what a pair. We might have been friends if things were different.…")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anya poured a bowl of the beet soup and tried to make me eat it, but the deep redness of it turned my stomach. She grasped my arm with sharp fingers and pulled herself closer. Her false teeth suddenly frightened me, they were too white and much too large for her face. And there was nothing more for us to say to each other (though she did not think so: she had plenty she still wanted to tell me) so I left.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I went to the hospital. I tried to keep my mind white and blank. I did not want to think about what I was doing, I just wanted to get it over with.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vito came with me but he was no help at all. We wandered the white halls, sat waiting on blue plastic chairs, got chased out of forbidden areas by nurses in ugly white shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not know what to do, where to go, whom to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I just want to get it over with, I said and held my stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The lights buzzed above our heads. We heard footsteps, endless footsteps tapping along the hallways. Approaching, receding, approaching again. Never appearing. There was a brown puddle spreading on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t think they can do it right away, anyway, Vito said cheerfully. I think they make you sign stuff and come back in a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I think you have to get parental permission too, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at him. The harsh light had drained all color from his face, his nostrils were rimmed with pink and his pupils gaped. He looked worse than I felt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Don’t cry, he said. Man, don’t do that. Listen, I have an idea. I know a place, a clinic, I have this friend whose girlfriend works there. We could go there, they would take us, they wouldn’t give you any shit. The only problem is it’s kind of far away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. No, I’m not leaving this place until they take it out of me. I’m not leaving. I’ll sleep here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He scratched his head, dry skin snowfalling on the shoulders of his black T-shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I might have sat there forever if I had not seen something at the end of the hall. Something that set my teeth on edge, that sent me flying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hey, Nomie, wait up, Vito panted. Hey, where are you going?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hush, I breathed as we skidded around corners and slid on newly mopped floors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie! What’s the rush?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shut up, I hissed and suddenly we were in the emergency room dodging around mobs of people in red-spattered blue scrubs and doctors shouting out medical terms that sounded lewd and obscene. And then a whole fleet of stretchers rolled in, people strapped to boards and wrapped in blankets and raising their hands up to the sky calling out to their gods and their mothers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie, Vito called and I said: Quit screaming my name! and then we were back out on the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sunlight felt good and calming and I stopped running.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What happened? What did you see? he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Someone I thought I knew, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It had been Mara, in a pink uniform and rubber gloves, her dark brows slicing across her face. Had she seen us?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara. Somehow she had gotten her job back.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I knew this would happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie has disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother is beside herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother says nothing. I’m sure she knows, she knows where Nomie is but she won’t tell us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After all the yapping she’s been doing lately, now she won’t open her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is all her fault, I know it. She’s been telling those stories, giving Nomie ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Outside the snow tumbles down. A freak flurry in the middle of July.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My grandmother won’t tell us a thing, just sits there muttering about three old women following her. She doesn’t care about what could happen to Nomie at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could she just vanish like this? my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She didn’t just vanish; she ran away. She’s at that age, I told her. I did not want to worry her unduly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s mother, my mother whispered. Mother made her do this, I know it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So you see I was not imagining things. My mother had come to the same conclusion about my grandmother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We should put her in a nursing home, I said as casually as I could. For her own good, I said, her own safety. She’s blind as a bat, one of these days she’ll be hit by a car. Her room, it’s a fire hazard. This can’t go on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could see she liked the idea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We really aren’t able to take care of all her needs you know. Much as we love her, I said. Much as we’d like to. And this place, so many sharp edges, those steep stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother was nodding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How I hated her then, her pursed-up mouth, her sucked-in cheeks as if she were constantly posing for a picture. But I needed her as an ally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We need to put her where she can’t do any more harm, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We leaned together, whispering. We did not want my grandmother to overhear us. It would upset her unnecessarily to hear what we were planning. She would not want us to waste money on such a thing, that’s what she might say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had saved some money over the years from my hospital jobs, it lay in a drawer beneath piles of dull sensible underclothes. I had been saving it for when Jonathan came back, for when we went away together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the nursing home was much more important. For my grandmother’s own good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of the apartment without her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was the cause of the oppressive, claustrophobic feel of the place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Without her it would be so much pleasanter. Only me and Nomie, together. Nomie would be sure to listen to me without my grandmother distracting her every minute.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just me and Nomie. Nomie and I.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And my mother, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would worry about that later.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For now I wanted only to remove my grandmother. To a better place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I loved her, I was willing to make sacrifices for her. I was giving up my entire future, my chance to leave this apartment and go elsewhere—all so that her last days would be more comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother, as it turned out, also had a bundle of money hidden away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From your father, she explained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My father? She never, ever spoke of my father who had died before I was born. She had never even told me how he died. I assumed it had been something pedestrian, hit by a streetcar maybe, or a sudden heart attack while crossing the road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had long whispered discussions, made inquiries. My mother and I were closer than we had ever been, we were united in a common purpose. We heard of a place that sounded promising, I went to visit it. It was not beautiful, a tall stark building, but it seemed very secure. The residents were not allowed to wander about unattended. And when residents became too excited or too loud, they were gently sedated, gently restrained. There was a small cement yard—no messy flowers, harmful insects. I particularly liked the high iron fence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It seemed perfect, and I wanted to move my grandmother there right away, but I was told that the place was full, and we would have to wait for an opening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The secretary I spoke with did not say it, but I understood we would have to wait for someone to die.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This seemed inconvenient. I wondered if there were any way to remove this obstacle, hurry the process along.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to move my grandmother out of the apartment before Nomie came back. I did not want the two of them to have any more time together. It had occurred to me that my grandmother might be telling her all sorts of lies about Chloe, and my brother, and me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not want that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told my mother all about the home and we were both satisfied. We needed only to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We sat together companionably hunched over our cups of tea in the kitchen. In the dark front room in the middle of her labyrinth my grandmother sat knitting sweaters. Knitting her brow, knitting her fingers together. I don’t know how she found her way among the jungle of furniture; I wondered if she unrolled a ball of yarn as she went in, to help her on the way back. Perhaps she left a trail behind her, the breakfast crumbs dribbling from her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stared out the window and let my mother drone on and on about country estates, inheritances, precious jewels, royal blood, secret journeys, forbidden love, incest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not listening carefully. What was she babbling about, I wondered. She knew nothing about love. Or incest, for that matter. She had never loved her brothers as I had loved mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this time, of course, we were waiting for Nomie to return. The strange snow kept falling and the city seemed grimier than usual. Darkness gathered at four o’clock, the buildings swayed and leaned threateningly as if they were about to topple over and bury us all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had informed the police, of course. There did not seem to be much else we could do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just like her father, she was. Going off like that. Impetuous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When she came back I would make sure she never went away like that again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where could she go? She had never lived away from the apartment, she knew no one. Only that boy with little bits of metal embedded in his face like shrapnel. And I had forbidden her to see him anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When she got cold enough out there she would come back. And when she came back I would be waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I will be waiting for you, Nomie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I will be waiting, sweet one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just inside the door.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Nomie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where did you get this car?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I borrowed it, Vito said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From who?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You stole it, you mean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, he said, it’s not stealing. I’m not going to keep it, so it’s not stealing. We’re just borrowing it for this trip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The car was wide and slow and dignified. Foam oozed out of the tears in the seat and the floor was littered with newspapers and coffee cups. It was the first car I had ever been in aside from cabs. That made it seem luxurious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dawn was just breaking when we left, a baby-pink light in the sky. We drove through parts of the city I had never seen before, that I had not known existed. Buildings rose up with points and curved spires, and gargoyles leaned from the eaves sticking out their tongues. The streets were deserted, metal grills covered the storefronts. The sun rose bright orange, a ball of fire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should have been excited to be leaving the city for the first time. I was setting out just as Ilana had at my age. I would get to see the world firsthand, instead of hearing about it filtered through the stories of other people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I did not care, I was cold, I sat with my knees pulled to my chest and stared at the little snow globe stuck to the dashboard of the car, watched the little white bits swirl around in the water. It hovered straight in front of me, as if it were a mirage we were driving toward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh man, I don’t believe it, it’s snowing, Vito said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not bother to look up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t believe it. In the middle of summer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept my eyes on the snow inside the globe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hey, it’ll cover our tracks, he said and forced out a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was enjoying himself, his eyes still crusted with sleep and a big bottle of soda nestled up against his crotch. I did not ask him how he learned to drive, when he learned to steal cars. I did not care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We drove over bridges and along dull gray highways. My body felt numb and heavy, a sackful of ball bearings. I watched the snow swirling around in the oval of glass. Inside was a forest, and a tiny Santa, and a little house all cozy and safe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you sure you want to do this? Vito said. Are you sure you want to kill it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m trying to save it, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Save")]), _vm._v(" it? he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could I explain?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at the people in the other cars around us. People sealed in behind glass, like tropical fish in aquariums. As if they would die if the outside air touched them. People seemed so fragile to me suddenly, so easily broken. Not just those people in the cars. All people. Vito, me, the child inside me. Any of us could be snuffed out in an instant. Arbitrarily. Or on a whim. A sudden tug on the steering wheel to send the car flying. A decision made on the spur of the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to crawl inside that tiny house within the globe and hide, and listen to the waves and white snow beat against the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The town was on the coast; there were neon-lit bars and long low strips of motels. It was like an enchanted city, so quiet, utterly asleep. It was a summer place, and when the sudden snow had come down it had muffled everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We walked along the empty beach. Snow covered the sand and the waves were slate-colored and rough. There was an amusement park, deserted, spread out along the boardwalk. We passed by the stalls and shooting galleries, all shuttered. Dingy tents sagged beneath loads of snow. The wooden horses on the calliope wore mantles of white. The rickety framework of a roller coaster loomed above us like a dinosaur skeleton. I was wearing Vito’s jacket over my own and still I was cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There were faded posters of freaks: Siamese twins joined at the head, a man in a tiger skin and a necklace of skulls, a woman with gills, a man with a long furry tail. An enormous painted clown leered at us from a billboard. Red hair, enormous teeth. I thought of Anya.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We got back in the car and drove to the bar where Vito was supposed to meet his friend. Wait here, he said as he got out of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I’m coming in, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll just be a minute, he said. You can’t come, you look too young. You’ll get kicked out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I just have to talk about something with him, real quick. Here, keep the heat on, I’ll be right back, I promise, he said and tossed me the keys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I waited ten minutes for him, then twenty, and then I went in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was dark inside, lit by orange-and-blue beer signs and the glow of cigarettes. I could feel the noise from the jukebox pulsing through the floor. Heavyset men sat hunched over tables and the bar, their heads hanging low as if they were too heavy to hold up. I did not see Vito. I sat on a stool and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What you doing here, anyway? the man sitting next to me said as if he were continuing an old conversation. He had a bleary face, three empty glasses before him, a big red porous nose.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You must be doing something, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t stand this, I said. People keep telling me things, making up stories and lying, and I don’t know what to believe anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh yeah? he said, interested, his tongue lolling out of his mouth. I think I can help you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Really? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: You say you’re looking for the truth? I’ll tell you where to find it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The music was giving me a headache. Where was Vito?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He said: You’re looking for the truth? The truth is in my pants.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He laughed loudly then, and the man beside him laughed, and the laughter was wet and sloppy, it spilled all over the counter and onto the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The friend leaned over toward me, his eyes were little five-pointed stars, spinning, and he said: Maybe it’s something you can’t quite "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("put your finger on.")]), _vm._v(" Right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first man said: The answer’s right there, just reach in and grab it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They laughed and laughed and though I didn’t want to, my eyes kept falling on their pants, coarse ill-fitting pants that were tight in the thighs and lumpy over their crotches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard catcalls, wolf whistles—a whole menagerie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then Vito came up out of the dark and I turned to him in relief but he was glaring, his teeth clenched, and he spat out: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I thought I told you to wait in the car.")])]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("We spent the night curled up on the peeling vinyl of the backseat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I could hear the waves pounding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you want to do it? Vito said, his hands on my shoulder blades. We might as well, he said, you won’t have to worry about getting pregnant this time, right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His breath was sour as old cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get away from me, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fell asleep shivering and woke up sweating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Most of the snow had melted in the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He drove me to the clinic. It was a small square white building with shrubs along the front and a crowd of people by the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll come pick you up in a few hours, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You’re not coming with me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve got to talk to Russell some more. Just business. He wants me to bring some stuff back to the city for him. Just go in there, ask for Stephanie, she’ll help you out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What? You want me to go in there alone?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The people by the door screamed at us. They held up enormous bloody photographs and spat at the car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why are they screaming at me? They don’t even know me, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their faces pressed up close to the window. It was the same face, over and over, men and women, old and young, but the same chanting mouths, same frenzied eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t do this, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re just protesters, he said. Just a bunch of stupid people. Don’t listen to them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know, I said and looked at them and they were just a mass of movement, an ignorant mob, hardly human at all. I could ignore that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then I saw that one of them held a baby and everything stopped. She balanced the baby on one hip, carelessly. She was swept up in the chanting like the rest and bouncing up and down, her fist in the air. But the baby looked at me, he met my eyes with a wide curious gaze. He rode calmly up and down on his mother’s hip as if she were a horse on a merry-go-round, his hair ruffled up all over his head. Those eyes held me. He was beautiful. He was shaking his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How could I do this?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can’t, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can, Vito said. It’s for the best. And we came all this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said. But in one quick motion he reached past me, opened the door, and pushed me out of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They were all around me, shouting in my face. They pressed up against me and held their horrible pictures in front of my eyes, pictures of tiny hands and feet and eyes sealed closed and mouths open in terror. And as the shouting went on and on and hands tugged at my clothes everything blended together til I could not tell the difference between the red sweating faces of the protesters and the hideously enlarged bloody faces in their obscene photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I closed my eyes and someone took my arm and led me firmly and insistently through the red sea. I opened my eyes when it was quiet again and I took a deep breath thinking I was far away from it all but then I realized I was inside the building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not see who had brought me in. I could hear the chanting, very faintly, outside the doors. I could not go back out there just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would wait a little while. And then go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In here everything was clean and brisk and efficient. Green tile covered the floors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat in an orange plastic chair with uneven legs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who are you here to see? a nurse asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stephanie, I said automatically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s busy right now, the nurse told me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sat and waited. And waited. Women came and sat in the other chairs. Some came with men, some came with their mothers. Some looked frightened, but most looked as if they were shut completely within themselves, struggling with a private puzzle that no one could help them with. None of them looked pregnant, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Most of them were holding their bellies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I realized I was holding mine and quickly sat on my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was not like them, I thought. I was different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The women came and went, but there was one man who sat and waited as long as I did. He had long legs stretched out before him, a windbreaker with the hood pulled up over his head. I could see the cross hanging around his neck, but I could not see his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wondered how he felt, sitting here waiting for his wife or girlfriend or sister or mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wished Ilana were with me. If Sashie were here she would pretend it was not happening, that was her way of coping with things. She would talk brightly about the decor, the artificial plants. The weather. And Mara, Mara would see it all as a plot, a conspiracy directed at her. I think she has always had secret plans of her own, and that is what makes her so suspicious of everyone else. Her paranoia taints her view of everything. One day she will grow suspicious of herself, and she will drive herself mad chasing herself in circles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Only Ilana saw things clearly. I realized this now. She did not even know my name, but she was the only person who knew me as I really was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here’s Stephanie, someone said and I looked up to see a woman in white walking down the hallway at the side of a gray-haired man in a white coat with a folder in his hand. I stood up and the man in the windbreaker rose too and his hand came up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned and looked at him, thinking: what is he doing? Who is he greeting? What kind of handshake is that? And everyone else in the room was looking at him too but for a different reason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a sort of spark in the vicinity of his hand, and I did not hear the noise, only the echo which went on and on as the gray-haired man fell toward me, the folder falling from his hands. For a long moment I looked at the ugly red splotches blooming on his coat, like beet soup on a white tablecloth when you spill it by mistake, and I saw the look in his eyes which was not frightened or pained but only surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he was collapsed on the floor with blood pooling around him, it pulsed out of him rhythmically, like the rhythm of waves, it bubbled out of his mouth, and I was thinking idiotically: get this man to a hospital! And then: he’s in one already, how lucky! There were screams, a flurry of motion as nurses ran to him and the gunman had already disappeared somehow, like a magic trick and I did not know what to do so I ran. Not the way I had come, but down a hallway and through door after door until I found one marked "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("emergency exit,")]), _vm._v(" and I burst through it to the screaming of sirens thinking: yes, that’s exactly what this is.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The sand was wet and the waves rolled in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The amusement park had shed its coat of snow and now looked more ramshackle than before. You could see the nails and paste and strings that held it all together. Families in small clusters drifted here and there. No one seemed to be controlling the rides, they ran by themselves, their old clockwork grinding away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The scaffolding shuddered ominously every time the roller coaster made its rounds. The passengers screamed as they flew downhill—not because they were frightened, but because they thought they were supposed to be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You could see now how chipped and faded the calliope horses were. The music that poured out was painfully off-key. But the children who rode them did not care. They rode shouting, rearing, bucking, rocking back and forth, stroking the wooden manes. In their eyes it all was beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And so it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("was")]), _vm._v(" beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked by the ocean and watched the waves rise up closer and closer. I looked at that dark line where the ocean met the sky, and Ilana was right, it was like nothing I had ever seen before in my life. The meeting of water and air. Like a long thread drawn tight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It divided but it also joined.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thought of the man’s blood pushing out of him and spreading on the floor. Drops of it had dried on my hands, on my shirt. Dark little dots, almost black. And as I thought of him I began bleeding, as if the sight of him made my own blood want to jump out of my body and join his. I bled and bled, soaking my underpants, first a trickle and then a stream, as if my insides were weeping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s my period, I said to a seagull. My period is just late, that’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s all it is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this fuss and worry just because my period was a little late, I chided myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This blood, it couldn’t be anything else but that. Could it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It could not be the other thing. It couldn’t be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I did not even want to think the word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Somehow I would not be able to bear it if it was.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Later I saw Vito and some newfound friends traipsing along the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here you are, he said, we’ve been looking for you. Is it all done? Are you all taken care of?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why not?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A man got killed, I said, right in front of me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No way, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to tell them what had happened. The man with the gun and the blood spreading.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh come on, Vito said. You’re kidding, right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look at the blood on my shirt, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well, sure, he said, of course, you were in a hospital, there’s hurt people and blood and stuff all over the place in a hospital. That’s the whole damn point, right?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men he was with all laughed in an ugly way but I did not look at them, not once, I looked only at Vito.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Come on, he said, admit it. You chickened out. You don’t have to make up a crazy story like that to cover it up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I saw it all. I was there. It was horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told them over and over what I had seen but it did not help, no one believed it. They told me I watched too much television. They told me to shut up and grow up and quit crying wolf.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vito, I said, you believe me, don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smiled, looked away, dug his toe in the sand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get away from me, I said, don’t touch me, don’t ever speak to me again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran, and he called after me: Aw, come back, Nomie, come have a good time with us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I kept running, and heard his friends laughing and him, and he called out: That’s right, you big baby, go crying home to mama.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yes, I thought, I will, I will, but not before I’m good and ready.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I ran and my footprints followed behind me in curving and dancing lines, helter-skelter in branching patterns all over the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Something washed up on the shore one day. A dark slumped shape as large as a horse. Seaweed clung to it in great soggy skeins, barnacles clutched at its sides. The waves touched its edges and slid away. Touched and slid. Touched and slid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked closer and saw black hair, an outflung arm. I saw the edge of a face bloated with seawater. The skin was white, mottled, stretched tight. In spots it was scaly, iridescent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I saw an eye, a brow that I thought I knew. But before I could be sure the waves drove up and pulled him back into the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("I had money that I had borrowed (no, stolen) from Mara’s drawer. I walked and I ran and I rode buses next to old women who fell asleep with their heads on my shoulder. I went a long way, and I looked all about me, and I saw ugliness and wonders that you would not believe if I told you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I walked through snow and I sailed on water, and I went down below to the dark incredible colonies where people made their homes in deserted subway tunnels, and I went to another hospital and saw a baby the size of a jumbo shrimp living and breathing with the aid of machines, and I met a woman who had cut off her own foot because she heard voices that told her to do it and she was much at peace afterward, and I saw a child with the eyes of a saint and a head the size of a beach ball, and I saw another man shot and killed, this time for a tiny bit of white powder that everyone wanted because it could give them magical visions and the power to forget everything.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Ilana")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am trying to remember how I met Shmuel. I remember him falling out of a tree and lying in the snow, frozen and cold, his eyes like chipped blue glass and red beads at his throat where it had been torn open.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My son was a beautiful boy. He hung from the fire escape to impress me and could finish off a gallon of milk all by himself. Sometimes we called him Wolf and sometimes Eli, but I cannot remember why we gave him two names.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yesterday I saw a harpy in the kitchen, a wild-haired harpy just like the ones we used to see back home, circling above the forest. This one was perched at the table, sipping from a glass and tipping her head back to let it slide down her throat. Tearing at the hunk of bread she gripped in her claws. She paused in her chewing to glare at me, and I saw that she wore my granddaughter’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But how can that be? The harpies steal faces only from the dead, not the living. And Mara is not dead. Is she?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps she is dead, and I have forgotten about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have not seen a harpy for so long. They do not come here, I think it is because they have no room to fly with these tall buildings all around. All these shiny, reflective surfaces would drive them mad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What is my mother’s name? Did I ever know it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are so many things I cannot see clearly anymore, only catch glimpses of out of the corner of my eye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I feel frightened these days. I am not sure why. It is not a thing that frightens me, but the absence of a thing. A sense of things spilling, rolling away from me, out of my grasp like beads of mercury skittering across the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know something is missing, though I cannot place what it is. What could be missing? Everything is right here where I put it: the bed, the chair, the candles, the pot of herbs on the windowsill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shmuel still comes and sits by the bed. He tells me not to worry. But I’m afraid to look at him, afraid I will not recognize his face anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It weighs on me sometimes, this burden of remembering everyone’s name. When I misplace a name I feel such panic, as if I had killed someone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But there are so many names, they are crushing me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes I think that if I could share the load it would not he so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Or have I already found someone to share it? Sometimes I think I have.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Other times I suspect it is only wishful thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie has come home, thank heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We had been out of our minds with worry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She had been gone almost three weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She seems fine, perfectly healthy and fine except for her clothes and shoes which were unspeakably filthy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That was easily mended, I threw them out, bought her some new clothes, but she refused to wear them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And she refused to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When she came home she said not a word, ran straight to my mother and took her hands, buried her face in my mother’s lap. My mother said nothing either, just bent over her and stroked her head, the short bristly hairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie will not tell us where she has been, what she has been doing, why on earth she wanted to run away from us like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I tried to put my arms around her but I miscalculated and struck her in the face instead. She must have grown, or shrunk, in the weeks she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara and I suspected that she talked to my mother when they were alone, though we were not able to catch them at it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We did not tell her about our plans for my mother, we did not want to spoil her homecoming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The nursing home was good news, of course, but perhaps Nomie would not see it that way. She is contrary sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The other night I cornered my mother alone and told her about the nursing home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Isn’t it wonderful? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s the luckiest thing, I added, the secretary there just called and said that someone had died! So you can move in right away!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She cried out as if I had struck her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s a wonderful place, I told her, all nicely heated, and you’ll have a pretty little room with a nice roommate to keep you company, and the nurses will keep their eye on you and you’ll never have to go outside. Won’t that be wonderful?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Never, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s what you need, I told her. You don’t realize it, but you can’t manage on your own anymore, and Mara and I aren’t able to do it all for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t shut me in, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s for your own good, I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Barbed wire, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I told her she was being stubborn. I told her she was acting like a child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know that place, she said. It has no doors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What are you saying? Of course it does, I told her, they are automatic, you don’t even need to touch them, they fly open by themselves, and there are nice ramps for the wheelchairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are no doors, she insisted, I have seen it. And the roof is covered with sticky tar so that when the pigeons land on it they stick fast. They starve to death, the roof is covered with bones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All this time I was careful not to meet her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not even the pigeons escape, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later I saw her clinging to Nomie and Nomie clung to her. It seemed more urgent than ever that we get her out of the apartment as soon as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Nomie heard about our plans she broke her silence to scream at us: You can’t do this. You can’t take her away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We have to, I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And Mara pulled Nomie aside and said softly: She doesn’t know it yet, but she’s sick, very sick. She’s losing her mind, she has no idea what she’s saying anymore. It’s obvious. Surely you can tell. It’s obvious to everyone but her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie glared at us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara said: The best thing you can do for her, the best way to help her, is to help us take her to a place where they can take care of her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I said: It’s not like she’ll be gone forever. You can visit her there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No she can’t, Mara blurted and then flushed darkly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie stared at both of us. You can’t do this, she said again and fled the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After witnessing such behavior from Nomie, Mara and I were more convinced than ever that my mother had to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sooner the better.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have become more and more convinced that it is the right thing to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know it is. It is for her own good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I know that she wants this too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, after all these years I have finally learned how to listen to her, how to hear the truth behind her words. She "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("wants")]), _vm._v(" help but her pride won’t let her admit it. She does not want to admit how weak and helpless she has become, doesn’t want to admit she needs the home. So she puts up this vigorous protest, this false swagger. It is all an act.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She says she doesn’t want this but I know she does.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Inside she is begging for help.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s obvious to me now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And there is another reason why she should go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think that moving away will bring her peace, it will help her escape those women she keeps talking about who plague her so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She keeps talking hysterically about three women who follow her everywhere and oppress her. I thought at first she was imagining them. Now I have finally realized who those three women must be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara. And Nomie. And me.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Nomie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I came home Mara and Sashie picked and tugged at me but all I wanted was to see Ilana and look in her eyes. I wanted to say that I believed it all. I wanted to ask her to tell me more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But when I saw her I did not need to say a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She understood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She reached into her skirt, then, and in her cupped hands she showed me the egg that she had told me about. It was jeweled on the outside, like the ones Sashie had showed me in a museum once. But it had gone all rotten and neglected; the stones were dull, with dirt caught between them, long hairs and bits of lint clinging.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Look inside, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I looked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There it was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you see? she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh yes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Good, she said and took it from me, hid it away in her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We put our hands together, as we always did, and for the first time mine seemed a bit larger, my fingertips edging over hers, I must have grown. She took her hands away, smoothed them over my hair, again and again. I heard a strange sound.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’re coming for me soon, those three, coming to take me away, she said. I can tell. Each time I see them they come a little closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then she told me about the nursing home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I can’t go there, she said. I can’t be boxed in, those three will corner me for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can’t go in there, I said. I won’t let them do it, shut you up like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ilana held my hand so tightly it hurt. I have to go away, she whispered, somewhere they will never find me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Far away, she said, over the canyons and across the seas. To the very edge of the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then what? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I will pierce right through it, she said, it’s only a painted paper backdrop after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Are you sure? I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sashie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s the strangest thing. Yesterday I found a notice that had been slipped beneath our door. The logo at the top and the type were familiar though I could not remember where I had seen them before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The notice stated that the building management had decided to engage a cleaning service to improve all apartments, at no cost to the tenants. The cleaners would come once a month and in addition to ordinary tasks they would shampoo carpets, repaint walls, and wash windows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am thrilled. And this is an especially convenient time for them to come. With my mother moving out, there will be an entire room to be cleared and redone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am so excited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This news makes me forget all our petty little troubles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps I will buy some new curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We need to start living in a way more befitting our station, after all. We are not ordinary people like our neighbors; we are of nobler blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some of this furniture might actually be quite pretty, once it’s dusted off and arranged properly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It does seem a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("little")]), _vm._v(" strange, though, when I stop to think about it. The management has never taken much of an interest in us before. Our kitchen faucet has dripped for years, and the superintendent repeatedly brushes off my complaints about a rat in the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And it is strange that the notice did not mention "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("when,")]), _vm._v(" exactly, the cleaners will be coming. I want to know. I want to be ready for them, I do not want them to catch me unawares.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the day wore on I began listening for them, several times I thought I heard their brisk steps in the street. The rattle of their cleaning machines.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Several times I heard the scrape of a broom in the hall, and swung the door open to look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Last night I lay awake, eagerly listening to their scuttling, scratching. I heard them coming closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Closer and closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Too")]), _vm._v(" close, perhaps. It seemed they were scrubbing and rasping just on the other side of the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But is it possible to get "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("too")]), _vm._v(" clean? I don’t think so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They are coming. They are coming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They do not like slovenliness. I must get up early, set my hair, polish my shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I must be ready for them when they come.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Nomie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Where is she? says Mara.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What have you done with her? cries Sashie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She can’t just disappear like this, Mara says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You know, don’t you Nomie? I know you do, says Sashie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You helped her, didn’t you? Mara says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why won’t you tell us anything? Don’t you want to help? Don’t you know your mother could be out there freezing to death in the snow right this second? squawks Sashie, not noticing her slip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your mother could be lying under a bus right now, Mara says to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They discovered her absence this morning. Her bed made, the room neat. The window open, curtains flapping, snow already piling up on the floor. It is the second freak snowfall of the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They both leaned out the window. She couldn’t have made it down the fire escape, not at her age, Mara had said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment feels different without her. Unmoored. All of us feel it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I go into the front room and look at the mass of furniture and it is just that, furniture. Nothing more. Chairs and tables and hassocks, a breakfront with its glass broken.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My hair keeps making this funny sound when I shake it, I say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara shouts: Wash your hair, for God’s sake. And tell us where she is, you filthy girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sashie says: Don’t speak to her like that. It’s not her fault mother’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She pauses, glances from Mara to me, and says: Is it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They pace and mutter in the kitchen, their voices a disturbed cooing like anxious pigeons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If she does not turn up soon they will have to forfeit her spot at the nursing home, allow someone else to take it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They keep asking me where she is. They seem to think I helped her, perhaps arranged for a journey.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Could Nomie have done that, they wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is true that I spent time on the docks, among the sailors and coils of rope as thick as your arm. I have seen those great ships. I have seen deals being made. I have a bundle of money. I know the way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I won’t say anything one way or the other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It doesn’t matter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know she is not coming back.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Mara")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nomie refuses to give up any information. But we will find my grandmother sooner or later. I know it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We will find her and put her in a safe place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My mother is useless, fluttering and fussing and pausing every few moments to listen at the window or the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hush Mara, she says with one finger uplifted in her idiotic way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you hear that? she says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just the usual noise, I tell her. I say: Actually it seems much quieter around here, now that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("she’s")]), _vm._v(" gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But my mother’s face is strained and tense, she is not hearing me at all, she is listening for something else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I give up on her and go to my room. Here I find a sweater, neatly folded on my bed. How did I not notice this before? It is my grandmother’s work, I can tell. I shake it out, hold it up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Foolish woman. Does she think this one little gift will appease me now, after I’ve had to endure a lifetime of her selfishness?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is")]), _vm._v(" rather nice, though, beautifully soft, the yarn a mixture of black and gray with tiny threads of red and brown running through it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And it is strangely cold today, what will all the snow. I will put it on, not because I forgive her, oh no, only because it is cold and all my other sweaters are packed in the bottom of the drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I pull it over my head but cannot find the neck hole right off. I try to find the sleeves but they must have gotten twisted or tucked under in some way. I pull harder, waiting for my head to pop through the collar but it doesn’t happen and the sleeves have gotten turned inside out. The sweater is very warm, a little too warm and it traps my own stale breath next to my face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I decide to start over, but now I can’t seem to pull it off. I turn around and the sweater shrinks tighter, pulls in closer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I suddenly remember the sweater I put on years ago, and how I barely escaped from it with my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I was a silly hysterical girl then. I was imagining it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turn about and turn about. The room is full of sharp corners I never noticed before. And the sweater has become so scratchy inside, like a pricker bush, it has little pointed teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s getting damp now with my sweat. It is too warm in here. Not enough air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It hugs me so closely now, as if it is a part of my own body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think I will lie down on the bed for a minute and collect my thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I can feel my heart pounding a quick panicky beat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As if I were actually foolish enough to think I will never get out of here.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Nomie")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A little while ago I went into Ilana’s room. It was cold, the snow was covering everything because no one had bothered to shut the window. I sat on her bed and was surprised to find her jeweled egg nestled beneath her pillow. I wondered why she had not taken it with her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I held it in my hands. I thought: it should not be whole, it should have shattered when she left, it should have broken open to let all the wonders inside come flying out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I held it up to my eye and looked inside at the castle and the lake and the darkly sparkling city, and I thought I saw, in among the crowds of finely dressed people, a girl with hair to the floor and a fiddler with his bow raised, and two young men leaning recklessly from windows, and a man the size of a horse rolling over like a dog, and a dozen children clinging to the skirts of a woman who in turn clung to a black-bearded man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then I looked again and saw that the egg was empty, the inside surface was all reflective, a curved mirror, and I was looking at my own pupil and inside it a thousand tiny points of light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She is not coming back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember something she said before she left. I had asked her where she wanted to go, what she would like to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She said that more than anything she wanted to lie down in the snow next to her husband, two black marks on a white page.")])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781466835658',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(88)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(90);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 90 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.7224e52409197d14c6d8.js